import engagementDE from 'features/engagement/locales/engagement.de';
import publicChatDE from 'features/public-chat/locales/public-chat.de';
import feedbackDE from 'features/feedback/locales/feedback.de';
import { wizardDE } from 'features/co-pilot/campaign-wizard/locales/wizard-de';

const localeDE = {
  awdefaultmessage: 'Hier entsteht Augmented Writing',
  cidefaultmessage: 'Hier entsteht Customer Intelligence',
  jointPosAchieve: 'Leistungsmotiv',
  jointPosAffil: 'Beziehungsmotiv',
  jointPosPower: 'Führungsmotiv',
  authenticity: 'Authentizität',
  emotionality: 'Emotionalität',
  regFocus: 'Gewinnorientierung',
  abstractness: 'Abstraktheit',
  gender: 'Femininität',
  chartHoverTooltipTitle: 'Ausdruck von',
  chartLabelPower: 'Einfluss',
  chartLabelAffil: 'Beziehung',
  chartLabelAchieve: 'Leistung',
  chartLabelAuthenticity: 'Authentische Sprache',
  chartLabelAbstractness: 'Abstrakte Sprache',
  chartLabelOrientation: 'Risiko',
  chartLabelEmotion: 'Emotionale Sprache',
  chartLabelGender: 'Feminine Sprache',
  yellow: 'Erregung',
  red: 'Verbundenheit',
  green: 'Sicherheit',
  blue: 'Autonomie',
  male: 'Maskuline Sprache',
  female: 'Feminine Sprache',
  profileRemoveConfirmation: 'Möchten Sie dieses Profil wirklich entfernen?',
  profileWillNoLongerBeAvailable: 'Diese Aktion ist irreversibel. Dieses Profil ist danach nicht mehr verfügbar.',
  proceed: 'Weiter',
  profileName: 'Profilname',
  vlow: 'Sehr niedrig',
  low: 'Niedrig',
  medium: 'Ausgeglichen',
  high: 'Hoch',
  vhigh: 'Sehr hoch',
  vformal: 'Sehr formell',
  formal: 'formell',
  informal: 'informell',
  free: 'Frei',
  vfree: 'Sehr frei',
  vrisk: 'Sehr risikoorientiert',
  risk: 'Risikoorientiert',
  reward: 'Gewinnorientiert',
  vreward: 'Sehr gewinnorientiert',
  vabstract: 'Sehr abstrakt',
  vconcrete: 'Sehr konkret',
  vfem: 'Sehr feminin',
  fem: 'Leicht feminin',
  masc: 'Maskulin',
  vmasc: 'Sehr maskulin',
  das: 'Das',
  profileCreation: 'Profil erstellen',
  profileUpdate: 'Profil aktualisieren',
  whatMeans: 'Was bedeutet das?',
  manageRights: 'Rechte verwalten',
  visibleToMe: 'Für mich sichtbar',
  visibleToCompany: 'Für Firma sichtbar',
  moreInfo: 'Weitere Informationen',
  profileWizard: 'Profilassistent verwenden',
  update: 'Aktualisieren',
  neutral: 'Neutral',
  selectProfile: 'Profil auswählen',
  genderNeutral: 'Text wirkt geschlechtsneutral',
  directedToWomen: 'Text wirkt feminin',
  directedToMen: 'Text wirkt maskulin',
  manual: 'Anleitung',
  contact: 'Kontakt',
  userProfile: 'Benutzerprofil',
  contactDetails: 'Kontaktdaten',
  firstName: 'Vorname',
  lastName: 'Nachname',
  telephoneNumber: 'Telefonnummer',
  changePassword: 'Passwort ändern',
  confirmPassword: 'Dein neues Passwort wiederholen',
  activatesuccess1: 'Vielen Dank für Dein Interesse an unserem Service.',
  activatesuccess2: 'Du erhältst in Kürze eine Bestätigungsmail, mit einem Link zur Authentifizierung Deines Kontos.',
  activatesuccess3: 'Du kannst die Produkte testen.',
  forgetpass: 'Du erhältst in Kürze eine Mail, mit einem Link zur Zurücksetzung Deines Passworts.',
  withRegards: 'Viele Grüße',
  yourTeam: 'Dein SAIA Team!',
  registration: 'Registrierung',
  resendActivation: 'Aktivierung erneut senden',
  register: 'Registrieren',
  repeatEmail: 'E-Mail-Adresse widerholen',
  repeatPassword: 'Passwort widerholen',
  pleaseEnterEmail: 'Bitte gib Deine E-Mail-Adresse ein',
  invalidEmail: 'Diese E-Mail ist nicht gültig',
  emailLooksGood: 'Diese E-Mail sieht gut aus',
  pleaseEnterPassword: 'Bitte gib Dein Passwort ein',
  pleaseRepeatPassword: 'Bitte wiederhole Dein Passwort',
  passwordLength: 'Die Länge des Passworts muss zwischen 6 und 50 Zeichen liegen',
  passwordNoEdgeWhitespace: 'Passwort darf nicht mit Leerzeichen beginnen oder enden',
  firstNameLength: 'Der Vorname darf nicht länger als 128 Zeichen sein',
  lastNameLength: 'Der Nachname darf nicht länger als 128 Zeichen sein',
  cityNameLength: 'Die Stadt darf nicht länger als 128 Zeichen sein',
  invitingUserLength: 'Der Nutzer (Vor- und Nachname) darf nicht länger als 128 Zeichen sein',
  passwordLooksGood: 'Dieses Passwort sieht gut aus',
  changesInNewVersion: 'Änderungen in der neuen Version',
  requests: 'Anfragen',
  lastRequest: 'Letzte Anfrage',
  blocked: 'Gesperrt',
  copied: 'kopiert',
  apiRemoveConfirmation: 'Möchten Sie dieses API Key wirklich entfernen?',
  apiWillNoLongerBeAvailable: 'Diese Aktion ist irreversibel. Dieses API Key ist danach nicht mehr verfügbar.',
  changeActiveConfirmationTitle: 'Möchten Sie diesen Nutzer wirklich entfernen?',
  changeActiveConfirmationText: 'Diese Aktion ist irreversibel. Der Nutzer kann sich nicht mehr anmelden oder die Anwendung verwenden',
  deleteUserDataTitle: 'Benutzerdaten löschen?',
  deleteUserData: 'Möchten Sie auch alle Daten dieses Nutzers löschen?',
  changesWillTakeEffect: 'Änderungen werden sofort wirksam.',
  blockToggle: 'Möchten Sie den Blockstatus wirklich ändern?',
  updateRequestsLimit: 'Anforderungslimit aktualisieren',
  users: 'Nutzer',
  price: 'Preis',
  createAPIKey: 'Erstellen Sie einen API-Schlüssel',
  manageAPIKeys: 'API-Schlüssel verwalten',
  jobProfiles: 'Job-Profile',
  brandProfiles: 'Markenprofile',
  country: 'Land',
  paymentData: 'Zahlungsdaten',
  generalData: 'Allgemeine Daten',
  accountNumber: 'Kontonummer',
  accountOwner: 'Kontoinhaber',
  createCompany: 'Neue Firma erstellen',
  companyRemoveConfirmation: 'Möchten Sie diese Firma wirklich entfernen?',
  companyWillNoLongerBeAvailable: 'Diese Aktion ist irreversibel. Diese Firma ist danach nicht mehr verfügbar.',
  wizardExplanation: 'Wählen Sie für jede der folgenden Aussagen die geeignete Wichtigkeitsstufe aus, wobei 1 unwichtig und 5 sehr wichtig ist',
  wizardExplanationYesNo: 'Wählen Sie für jede der folgenden Aussagen aus, ob die Aussage von großer Bedeutung ist oder nicht',
  profileTitle: 'Profile',
  cantRemove: 'Ein Profil, das an eine Analyse angehängt ist, kann nicht entfernt werden',
  creationDate: 'Erstellungsdatum',
  creator: 'Ersteller',
  numberOfanalyzes: 'Anzahl der Analysen',
  numberOfUsers: 'Anzahl der Nutzer',
  general: 'Allgemein',
  packageRemoveConfirmation: 'Möchten Sie dieses Paket wirklich entfernen?',
  packageWillNoLongerBeAvailable: 'Diese Aktion ist irreversibel. Dieses Paket ist danach nicht mehr verfügbar.',
  packageDetails: 'Paket-DetailsView',
  package: 'Paket',
  startDate: 'Anfangsdatum',
  endDate: 'Enddatum',
  statusChangeConfirmationTitle: 'Möchten Sie den aktuellen Status wirklich ändern?',
  bookings: 'Buchungen',
  newBooking: 'Neue Buchung',
  bookPackage: 'Paket buchen',
  bookPackageNow: 'Paket jetzt buchen',
  packageName: 'Paket-Name',
  statistics: 'Statistiken',
  analyzesUsed: 'Analysen bisher verbraucht',
  analysisLeft: 'Verbleibende Analysen',
  january: 'Januar',
  february: 'Februar',
  march: 'März',
  april: 'April',
  may: 'Mai',
  june: 'Juni',
  july: 'Juli',
  august: 'August',
  september: 'September',
  october: 'Oktober',
  november: 'November',
  december: 'Dezember',
  bookingMade: 'Die Buchung war erfolgreich',
  userManagment: 'Nutzerverwaltung',
  lastLogin: 'Letzer Login',
  userLanguage: 'Benutzersprache',
  choosePrimaryLanguage: 'Wählen Sie Ihre Hauptsprache',
  updateAccount: 'Konto ändern',
  total: 'Gesamt',
  admin: 'Admin',
  agencyadmin: 'Agentur Admin',
  agency: 'Agentur',
  bindToAgency: 'An Agentur binden',
  noAgencyAssigned: 'Keine Agentur zugewiesen',
  selectAgency: 'Agentur auswählen',
  notGettingData: 'Daten konnten nicht abgerufen werden. Versuchen Sie es bitte später noch einmal.',
  notSubmittingData: 'Daten konnten nicht übermittelt werden. Versuchen Sie es bitte später noch einmal.',
  changesSaved: 'Änderungen gespeichert',
  requestError: 'Leider kann die Anfrage nicht ausgeführt werden',
  optOutSuccess: 'Ihre E-Mail wurde erfolgreich abgemeldet',
  optOutRequestError: 'Die angeforderte E-Mail konnte nicht abbestellt werden',
  loginToOptOut: 'Bitte melden Sie sich an, um Ihre E-Mail abzubestellen',
  tagCreated: 'Sie haben Ihren Ordner erfolgreich hinzugefügt',
  analysesUploadedSuccess: 'Alle Analysen wurden erfolgreich hochgeladen',
  addToTagSuccess: 'Sie haben {{ name }} erfolgreich hinzugefügt.',
  tagDeleteSuccess: 'Sie haben {{ count }} Analyse erfolgreich entfernt.',
  tagDeleteSuccess_plural: 'Sie haben {{ count }} Analysen erfolgreich entfernt.',
  tagEdited: 'Sie haben Ihren Ordner erfolgreich aktualisiert',
  newTag: 'Neue Stellenausschreibung',
  deleteTagDialogTitle: 'Stellenausschreibung löschen',
  deleteTagDialogText:
    'Sind Sie sicher, dass Sie die Stellenausschreibung "{{name}}" löschen möchten?\r Sie verlieren die dafür kalkulierte Analyse.',
  deleteTagDialogText_plural:
    'Sind Sie sicher, dass Sie die Stellenausschreibung "{{name}}" löschen möchten?\r Sie verlieren alle {{count}} dafür kalkulierten Analysen.',
  tagDeleted: 'Sie haben den Ordner erfolgreich gelöscht',
  analysesMoved: 'Die Analyse wurde erfolgreich verschoben',
  method: 'Methode',
  products: 'Produkte',
  changelogHeadline1: 'Verbesserung unserer Formel',
  changelogContent1: 'Genauere Persönlichkeitsmessung, insbesondere bei kurzen Texten',
  changelogHeadline2: 'Neue Kategorie',
  changelogContent2: 'Messung der "Abstraktheit" der Texte',
  changelogHeadline3: 'Löschvorschläge',
  changelogContent3: 'Verbessern Sie die Wirkung von deutschen Texten',
  changelogHeadline4: 'Abkürzungen',
  changelogContent4: 'Erkennung von nicht-definierten Abkürzungen',
  changelogHeadline5: 'Verbessertes Sprachmodell',
  changelogContent5: 'Mehr und bessere Wortvorschläge erleichtern das Schreiben von Texten',
  changelogHeadline6: 'Italienisch',
  changelogContent6: 'Unterstützung von italienischen Texten und Italienisch als Sprache der Benutzeroberfläche wählbar',
  analyzeText: 'Text analysieren',
  analyze: 'Analysieren',
  entireSampleCompare: 'Vergleich mit gesamter Stichprobe',
  currentSampleCompare: 'Vergleich mit aktueller Stichprobe',
  results: 'Ergebnisse',
  pending: 'ausstehend',
  newSurvey: 'Neue Umfrage',
  professionalMotivation: 'Berufliche Motivation',
  professionalMotivationIntro:
    'Motive und Bedürfnisse sind ein wichtiger Aspekt im menschlichen Verhalten und Denken. Sie treiben uns an und geben unserem Handeln Richtung. Der Competence-Monitor misst diese Motive. Sie gehen zurück auf die Need Theory von D. McClelland (1987). Er postulierte die Bedürfnisse nach Führung und Status, beruflichem Erfolg und Weiterentwicklung sowie gute Beziehungen zu anderen Menschen als grundlegende Motive bei uns allen.',
  leadershipIntro:
    'Führungsmotiv geht mit dem Wunsch einher, anderen vorzustehen und diese anzuleiten. Das Führungsmotiv geht zurück auf die Need Theory von McClelland und bildet mit den anderen beiden Motiven „Erfolg“ und „Beziehung“ die drei Grundtendenzen menschlichen Strebens.',
  achievementIntro:
    'Leistungsmotiv geht mit dem Wunsch einher, insbesondere beruflich neue Erfolge zu erzielen und sich ständig weiter zu entwickeln. Das Erfolgsmotiv geht zurück auf die Need Theory von McClelland und bildet mit den anderen beiden Motiven „Führung“ und „Beziehung“ die drei Grundtendenzen menschlichen Strebens.',
  affiliationIntro:
    'Beziehungsmotiv geht mit dem Wunsch einher, guten Kontakt mit anderen Menschen zu pflegen und Gemeinschaft zu erleben. Das Beziehungsmotiv geht zurück auf die Need Theory von McClelland und bildet mit den anderen beiden Motiven „Führung“ und „Erfolg“ die drei Grundtendenzen menschlichen Strebens.',
  characterTraits: 'Charaktereigenschaften',
  characterTraitsIntro:
    'Die folgenden Merkmale beschreiben überdauernde Eigenschaften des Bewerbers, wie sie im Bewerbungsschreiben zum Ausdruck kommen.',
  thinkingStyle: 'Denkstil',
  spontaneous: 'Spontan',
  concrete: 'Konkret',
  deliberate: 'Überlegt',
  abstract: 'Abstrakt',
  thinkingStyleIntro:
    'Menschen unterscheiden sich auch in ihrer Art des Denkens. Intuitiv denkende Menschen entscheiden oft nach Gefühl. Sie machen sich im Vorfeld oft nicht so viele Gedanken, sondern vertrauen auf ein gutes Ergebnis. Genauigkeit ist ihnen nicht so wichtig. Analytisch denkende Menschen legen großen Wert auf Genauigkeit und geben sich nicht mit dem Ungefähren zufrieden. Für Entscheidungen brauchen sie Fakten, die sie gründlich abwägen.',
  authenticityIntro:
    'Die Authentizität erfasst, wie persönlich und direkt Bewerber im Anschreiben wirken. Es werden zwei Ausprägungen gemessen: Förmlichkeit (wenn die Sprache eher unpersönlich und formal wirkt) und Frei-Heraus (wenn die Sprache persönlich und frei-heraus wirkt)',
  socialCompetence: 'Sozial-Kompetenz',
  socialCompetenceIntro:
    'Hier wird erfasst, wie dominant Bewerber in ihren Schreiben wirken. Die Verwendung verschiedener Funktions- und Inhaltsworte (insb. Personalpronomen) geben Aufschluss über die Dominanz einer Person',
  domination: 'Dominanz',
  dominationIntro:
    'Die Dominanz beschreibt, wie sich Menschen in eine Gruppe einfügen. Das Merkmal Dominanz weist die beiden Ausprägungen „Nachgiebig“ und „Durchsetzungsstark“ auf.',
  yielding: 'Nachgiebig',
  assertive: 'Durchsetzungsstark',
  clickToUploadEML: 'Ziehen Sie eine EML Datei in das Feld\n oder klicken Sie,\n um E-Mails zur Analyse hochzuladen',
  clickToUploadPDF: 'Ziehen Sie eine PDF Datei in das Feld oder klicken Sie, um eine Bewerbung zur Analyse hochzuladen',
  explanationJointPosPower:
    '<b>Streben nach Prestige und Anerkennung sowie Übernahme von Verantwortung</b><br><br/>Personen mit einem Führungsmotiv:<ul><li> nehmen <b>Einfluss</b></li><li><b>leiten</b> gerne an</li><li>sind <b>konkurrenzfreudig</b></li><li>haben gerne die <b>Kontrolle</b></li><li>verfolgen <b>hohe Standards</b></li></ul>',
  explanationJointPosAchieve:
    '<b>Auseinandersetzung mit bzw. Erreichen von selbstgesteckten Leistungszielen.</b><br><br/>Personen mit einem Leistungsmotiv:<ul><li>sind <b>ehrgeizig</b></li><li>sind <b>kompetitiv</b></li><li>sind <b>eigenständig</b></li><li>streben <b>Weiterentwicklung</b> an</li><li>stellen sich <b>Herausforderungen</b></li></ul>',
  explanationJointPosAffil:
    '<b>Starkes Bedürfnis nach Geselligkeit, sozialem Kontakt und harmonischen Beziehungen.</b><br><br/>Personen mit einem Beziehungsmotiv:<ul><li>pflegen <b>Beziehungen</b></li><li>arbeiten <b>gerne im Team</b></li><li>legen Wert auf <b>Rückmeldung und Anerkennung</b></li><li>versuchen <b>Konflikte zu vermeiden</b></li><li><b>vermeiden Isolation</b></li></ul>',
  explanationAuthenticity:
    '<b>Drückt aus wie offen, direkt und persönlich der Schreibstil ist.</b><br><br/>Authentische Texte:<ul><li>wirken <b>ehrlich</b></li><li>wirken <b>„gerade-heraus“</b></li><li><b>lockern</b> die Sprache <b>auf</b></li><li>schaffen eine <b>persönliche Verbindung</b></li></ul>',
  explanationOrientation:
    '<b>Unterschiedliche Ausrichtung der Aufmerksamkeit auf ein Ziel. Entweder Aufmerksamkeit darauf Gewinne zu erzielen oder Verluste zu vermeiden.</b><br/><br/>Personen mit Gewinnorientierung:<ul><li>gehen auch mal ein <b>Risiko</b> ein</li><li>schätzen <b>Fortschritt und Leistung</b></li><li>lösen Aufgaben auf <b>kreative Art</b></li><li>gehen <b>neue Wege</b></li></ul><br/>Personen mit Verlustorientierung:<ul><li>vermeiden <b>Misserfolge</b></li><li>schätzen <b>Verantwortung und Sicherheit</b></li><li>lösen Aufgaben auf <b>bewährte Art</b></li><li>bevorzugen <b>stabile Verhältnisse</b></li></ul>',
  explanationAbstractness:
    'Das Ausmaß an Abstraktheit in der Sprache verrät etwas darüber, wie Menschen die Welt um sie herum konstruieren: In einer abstrakteren oder konkreteren Weise. Mit Adjektiven lassen sich Dinge beschreiben, die nicht objektiv messbar sind (z. B. Eigenschaften von Menschen). Oder es lassen sich damit Merkmale beschreiben, die über das konkret Beobachtbare hinausgehen. Mit Verben können dagegen konkrete Sachverhalte (wie etwa Verfahrensabläufe, z. B. das Backen eines Kuchens) erklärt werden. Das Konzept der sprachlichen Abstraktheit steht in Verbindung mit der Wahrnehmung von Chancen und Risiken. Je nach dem, was Menschen erwarten, verwenden sie eine andere sprachliche Abstraktheit. Eine abstrakte Sprache wird häufiger verwendet, wenn Menschen Ziele verfolgen und Hoffnungen ausdrücken. Auf der anderen Seite wird die Sprache konkreter, wenn es um Pflichten und Risiken geht.',
  explanationGender:
    '<b>Sprache kann dahingehend unterschieden werden, ob sie feminine oder maskuline Eigenschaften betont.</b><br/><br/>Feminine Sprache wird in Verbindung gebracht mit:<ul><li><b>emotionale Wärme</b></li><li><b>Gemeinschaftlichkeit</b></li><li>Ausdruck von <b>sozialen Beziehungen</b></li><li><b>Ausgeglichenheit</b></li></ul><br/>Maskuline Sprache wird in Verbindung gebracht mit:<ul><li><b>Nüchternheit</b></li><li><b>Individualität</b></li><li>Ausdruck von <b>Konkurrenz</b></li><li><b>Pragmatik</b></li></ul>',
  explanationEmotionality:
    'Die Emotionalität fasst die Gesamtheit positiver und negativer Formulierungen im Text zusammen. Positiv konnotierte Worte wie „freundlich“, „glücklich“, „optimistisch“ drücken meist eine positive Sichtweise, gute Stimmung und Freundlichkeit aus. Negative Worte wie „Ärger“, „Enttäuschung“, „Trauer“ können Bedauern, Ärger oder generell eine schlechte Stimmung ausdrücken. Ziel sollte es sein, dass Sie die emotionale Verfassung Ihrer Kunden aufgreifen. Das kann auch bedeuten, dass Sie negative Emotionen benennen, wenn Ihr Kunde diese ausdrückt. Das schafft ein Gefühl von Verstandenwerden.',
  explanationTalentIntelligence:
    'Menschen werden von Motiven geleitet. Zu wissen, was Bewerber antreibt, ist gerade im Berufskontext wichtig, weil es Aufschluss darüber gibt, welcher berufliche Weg der passende ist. Zunächst aber, was sind Motive? Motive sind interne Handlungsanleiter. Sie veranlassen einen Menschen, in eine bestimmte Richtung zu denken und sich zu verhalten. Sie drücken ein Streben aus: „Ich möchte gerne sein“. Es werden drei Grundmotive unterschieden. Das Motiv nach (1) Verantwortung und Führung, nach (2) Leistung und Weiterentwicklung und nach (3) harmonischen Beziehungen zu anderen Menschen. Diese Motive wurden von dem Sozialpsychologen D. McClelland formuliert und erforscht. Sprechen Sie wie Ihr Bewerber! Wenn Sie leistungsmotivierte Bewerber in Ihrer Ausschreibung besonders ansprechen wollen, verwenden Sie leistungsbezogene Worte und eine hohe Ausprägung auf diesem Merkmal beim Anlegen des Berufsprofils. Gleiches gilt für die anderen Motive entsprechend.',
  explanationBlue: 'Autonomie: Rational, analytisch, zahlenorientiert, durchsetzungsstark, faktisch.',
  explanationYellow: 'Erregung: Kreativ, überraschend, offen für Neues, experimentierfreudig, individuell.',
  explanationGreen: 'Sicherheit: Disziplin, zuverlässig, pragmatisch, traditionell, planend.',
  explanationRed: 'Verbundenheit: Einfühlsam, kommunikativ, kooperativ, zwischenmenschlich, vertraut.',
  explanationBrandsync:
    'Nur, wenn bei allen am Markenprozess Beteiligten und der Zielgruppe ein einheitliches Markenverständnis herrscht, trifft die Markenbotschaft den entscheidenden Punkt: mitten ins Herz. Die wichtige Voraussetzung dafür ist: Ein klares Markenverständnis, eine zielgerichtete Synchronisierung aller Ebenen Ihres Marketings. Damit werden Sie wesentlich effizienter, effektiver. Mit den Dimensionen Autonomie, Erregung, Sicherheit und Verbundenheit haben Sie die wesentlichen Merkmale in der Hand, um genau den Ton zu treffen, der zu Ihrer Zielgruppe passt.',
  explanationBrand:
    '„Wer auf andere Leute wirken will, der muss erst einmal in ihrer Sprache mit ihnen reden.“ Dieser Satz von Kurt Tucholsky drückt schon alles aus, was wichtig ist in der Kommunikation von Unternehmen. Wie das Zitat vermuten lässt, geht es um Nachahmung. In der Psychologie wird das auch als Social Mimicry bezeichnet. Nachahmung findet auf verschiedenen Ebenen statt, so auch auf sprachlicher. Zahlreiche Studien haben den Einfluss von Nachahmung untersucht und fanden z. B. eine Veränderung des Akzents, des Sprachrhythmus oder der -geschwindigkeit. Besonders relevant im Marketingkontext ist die Nachahmung, da es Einfluss auf das Konsumverhalten von Menschen hat. So ist z. B. die Überzeugungskraft von Botschaften höher, wenn sie zur Sprache der Zielgruppe passen. Nutzen Sie die folgenden Kategorien, um Ihre Sprache Ihrer Zielgruppe anzupassen.',
  explanationCustomer:
    'Im Customer Intelligence Augmented Writer dreht sich alles um Ihre Kunden. Genauer gesagt geht es darum, wie die Kundenbindung und die -zufriedenheit aufrecht erhalten bzw. verbessert werden können. Dabei bietet die Sprache ein wichtiges Werkzeug, wie die psychologische Forschung gezeigt hat. Zentral ist die Theorie des Regulatorischen Fokus. Danach können Menschen Ziele über zwei verschiedene selbstregulative Systeme erreichen, indem sie zwei unterschiedliche Foki einnehmen. Entweder den Promotion Focus (Bedürfnis nach Selbstverwirklichung und Maximierung positiver Ergebnisse) oder den Prevention Focus (Bedürfnis nach Schutz und Sicherheit und Vermeidung von Verlust). Eng verbunden damit ist das Konzept des Regulatorischen Fit, der bei einer Passung von Regulatorischem Fokus und anderen Variablen zustande kommt. Besteht regulatorischer Fit, so führt das besonders häufig zur Umsetzung einer Intention - im Kontext der Kundenkommunikation zu besserer Bewertung des Unternehmens / Produkts / der Marke. Im Folgenden finden Sie die wichtigsten sprachlichen Mittel um einen regulatorischen Fit herzustellen.',
  writeAnswer: 'Antwort schreiben',
  analyzedCustomerProfile: 'Analysiertes Kundenprofil',
  analyzedJobProfile: 'Analysiertes Jobprofil',
  affiliation0:
    'Personen mit einer sehr niedrigen Ausprägung macht es nichts aus, wenn sie nicht Teil einer Gruppe sind. Ihnen sind andere Dinge wichtiger als enge Beziehungen zu anderen Menschen. Sie arbeiten gerne <b>für sich alleine</b>.',
  affiliation1:
    'Personen mit einer niedrigen Ausprägung können es aushalten, wenn sie <b>nicht Teil einer Gruppe</b> sind. Ihnen sind andere Dinge wichtiger als enge Beziehungen zu anderen Menschen. Wenn sie nicht im Team arbeiten, sondern alleine, macht ihnen das wenig aus.',
  affiliation2:
    'Bei Personen mit einer hohen Ausprägung stehen gute Beziehungen zu anderen Menschen im Fokus. Sie fühlen sich gerne als Teil einer Gruppe. Sie unterstützen andere und arbeiten gerne im Team. Ihnen ist es wichtig, <b>Rückmeldung und Anerkennung</b> von ihrer Gruppe und von einzelnen, ihnen wichtigen Personen, zu erhalten.',
  affiliation3:
    'Personen mit einer sehr hohen Ausprägung sind gute Beziehungen zu anderen wichtig und sie brauchen regelmäßigen Kontakt zu ihnen. Besonders gut fühlen sie sich, wenn sie <b>Teil einer Gruppe</b> sind. Sie unterstützen andere und arbeiten sehr gerne im Team. Ihnen ist es besonders wichtig, Rückmeldung und Anerkennung von ihrer Gruppe und von einzelnen, ihnen wichtigen Personen, zu erhalten.',
  leadership0:
    'Personen mit einer sehr niedrigen Ausprägung haben kein Problem damit, wenn sie an zweiter Stelle stehen. Sie definieren sich nicht über Statussymbole und sie streben nicht nach Macht über andere und suchen nicht nach der Zustimmung durch andere. Sie sind <b>kompromissbereit</b> und geben auch anderen den Vorzug.',
  leadership1:
    'Personen mit einer niedrigen Ausprägung fühlen sich auch in einer nachgeordneten Position wohl. Sie definieren sich weniger über Statussymbole und es ist ihnen weniger wichtig, Macht über andere zu haben. Sie sind <b>kompromissbereiter</b> als Personen mit einer hohen Merkmalsausprägung.',
  leadership2:
    'Personen mit einer hohen Ausprägung neigen dazu, Macht über andere auszuüben. Ihnen gelingt es, <b>Einfluss auf andere</b> zu nehmen und ihnen fällt es nicht schwer, mit anderen in Konkurrenz zu treten. In Positionen, in denen sie andere führen, fühlen sie sich eher wohler als in solchen, in denen sie geführt werden.',
  leadership3:
    'Personen mit einer sehr hohen Ausprägung ist es wichtig, <b>Macht</b> über und <b>Loyalität</b> von anderen zu erhalten. Sie haben die Fähigkeit, Einfluss auf andere zu nehmen und kein Problem damit, mit anderen in Konkurrenz zu treten. In Positionen, in denen sie andere führen, fühlen sie sich wohler als in solchen, in denen sie geführt werden.',
  achievement0:
    'Personen mit einer sehr niedrigen Ausprägung arbeiten gerne <b>nach Vorschrift</b> und es macht ihnen nichts aus, wenn sie immer wieder gleiche Aufgaben bearbeiten müssen. Weiterentwicklung im Leben steht nicht an erster Stelle. Sie setzen sich selten ambitionierte Ziele. Wenn doch, müssen sie oftmals von außen dazu motiviert werden.',
  achievement1:
    'Personen mit einer niedrigen Ausprägung arbeiten <b>eher nach Vorschrift</b> und es macht ihnen wenig aus, wenn sie ähnliche Aufgaben wiederholt verrichten. Weiterentwicklung im Leben ist eher ein untergeordnetes Ziel. Sie setzen sich seltener ambitionierte Ziele. Wenn doch, müssen sie oftmals von außen dazu motiviert werden.',
  achievement2:
    'Personen mit einer hohen Ausprägung <b>engagieren sich gerne</b> für selbst gesteckte Ziele und sie sind darum bemüht, sich weiter zu entwickeln. Ihnen ist Eigenständigkeit wichtig und erzielte Erfolge schreiben sie sich selbst zu. Die Erfolgsmotivation kommt aus ihnen selbst; Lob und Anerkennung anderer ist weniger wichtig.',
  achievement3:
    'Personen mit einer sehr hohen Ausprägung sind bereit, sich bei der Verfolgung ihrer Ziele <b>stark zu engagieren</b> und sind darum bemüht, die eigene Leistung kontinuierlich zu verbessern. Ihnen ist Eigenständigkeit wichtig und erzielte Erfolge schreiben sie sich selbst zu. Die Erfolgsmotivation kommt aus ihnen selbst; Lob und Anerkennung anderer ist ihnen nicht wichtig.',
  abstractness0:
    'Personen mit hoher Ausprägung in Richtung spontanem und intuitivem Denkstil entscheiden oft <b>nach Gefühl</b>. Sie machen sich im Vorfeld oft nicht viele Gedanken, sondern vertrauen auf ein gutes Ergebnis. Genauigkeit ist ihnen oft nicht wichtig. Aufgaben, die Genauigkeit und Gewissenhaftigkeit erfordern, machen diese Personen nur ungern. Ihnen liegen kreative, nur grob umrissene Aufgaben mehr.',
  abstractness1:
    'Personen mit Ausprägung in Richtung spontanem und intuitivem Denkstil entscheiden oftmals nach Gefühl. Sie machen sich im Vorfeld oft weniger Gedanken, sondern vertrauen eher auf ein gutes Ergebnis. Beim Problemlösen gibt es für sie <b>wichtigere Aspekte als Genauigkeit</b>.',
  abstractness2:
    'Personen mit Ausprägung in Richtung analytischem Denkstil legen Wert auf Genauigkeit und Präzision. Sie treffen ihre <b>Entscheidungen mit Bedacht</b>. Sie geben sich nicht mit dem Ungefähren zufrieden. Für Entscheidungen brauchen sie Fakten, die sie mehrmals abwägen.',
  abstractness3:
    'Personen mit hoher Ausprägung in Richtung analytischem Denkstil gehen ihre Arbeit sehr <b>genau und präzise</b> an. Sie geben sich nicht mit dem Ungefähren zufrieden. Erst wenn alle Kleinigkeiten korrekt sind, gilt für sie eine Aufgabe als erledigt.',
  selfConfidence0:
    'Personen mit hoher Ausprägung in Richtung formeller Sprache sagen nicht direkt, was sie denken und fühlen. Sie sind zurückhaltend in ihren Formulierungen und <b>achten genau darauf</b>, was sie sagen. Dadurch wirkt die Sprache des Bewerbers formell.',
  selfConfidence1:
    'Personen mit Ausprägung in Richtung formeller Sprache drücken sich gewählter aus. Sie sind <b>zurückhaltender in ihren Formulierungen</b> und achten darauf, was sie sagen. Dadurch kann die Sprache des Bewerbers weniger lebendig wirken.',
  selfConfidence2:
    'Personen mit Ausprägung in Richtung „Frei-heraus“ fällt es nicht schwer, <b>offen über sich</b> zu sprechen. Sie werden als direkter und persönlicher wahrgenommen. Sie sorgen sich weniger um den Eindruck, den sie bei anderen hinterlassen.',
  selfConfidence3:
    'Personen mit hoher Ausprägung in Richtung „Frei-heraus“ sagen, was sie denken und fühlen. Sie werden häufig als <b>direkt und persönlich</b> wahrgenommen. Sie sorgen sich nicht um den Eindruck, den sie bei anderen hinterlassen.',
  contact0:
    'Personen mit hoher Ausprägung in Richtung „Nachgiebig“ meiden es, andere zu dominieren und sich gegen andere durchzusetzen. In Auseinandersetzungen <b>geben sie rascher auf</b> und passen sich der Mehrheitsmeinung an, auch wenn sie diese nicht teilen.',
  contact1:
    'Personen mit Ausprägung in Richtung „Nachgiebig“  neigen nicht dazu, andere zu dominieren und sich bedingungslos durchzusetzen. In Auseinandersetzungen geben eher sie als andere auf und <b>beharren nicht</b> auf ihrem Standpunkt.',
  contact2:
    'Personen mit Ausprägung in Richtung "Durchsetzungsstärke" sind <b>eher dominant</b> und setzen sich für ihre Ziele ein. In Auseinandersetzungen können sie immer wieder ihren Standpunkt durchsetzen. Sie verstehen sich eher als Vertreter einer Gruppe und verwenden deswegen oftmals das Pronomen „Wir“, dafür weniger Worte, die Unsicherheit ausdrücken (wie z. B. „ein bisschen“, „vielleicht“).',
  contact3:
    'Personen mit hoher Durchsetzungsstärke sind dominant und setzen sich für ihre Ziele nachhaltig ein. In Auseinandersetzungen können sie oftmals ihren <b>Standpunkt durchsetzen</b>. Sie verstehen sich oft als Vertreter einer Gruppe und verwenden deswegen oftmals das Pronomen „Wir“, dafür weniger Worte, die Unsicherheit ausdrücken (wie z. B. „ein bisschen“, „vielleicht“).',
  noProfilesFound: 'Keine Profile gefunden',
  createProfileFirst: 'Bitte erstellen Sie zuerst ein Profil.',
  createProfile: 'Profil erstellen',
  whatAreProfiles: 'Was sind Profile?',
  switchTag: 'Analyse verschieben',
  comparedWith: 'verglichen mit {{profile}}',
  confirmSwitchTag: 'Sind Sie sicher, dass Sie {{ count }} Analyse von "{{ source }}" nach "{{ dest }}" verschieben möchten?',
  confirmSwitchTag_plural: 'Sind Sie sicher, dass Sie {{ count }} Analyses von "{{ source }}" nach "{{ dest }}" verschieben möchten?',
  moreDetails: 'Mehr Details',
  lessDetails: 'Weniger Details',
  more: 'mehr',
  less: 'weniger',
  how: 'Wie?',
  fileName: 'Dateiname',
  fit: 'Übereinstimmung',
  analysisOf: 'Analyse von {{ analysisName }}',
  saveProfile: 'Profil speichern',
  dismissProfile: 'Profil schließen',
  downloadAsPdf: 'Als PDF herunterladen',
  savePdfFileAs: 'Speichere PDF Datei unter:',
  print: 'Drucken',
  fileUploadFolder: 'Wählen Sie einen Ordner, in den die Dateien geladen werden sollen.',
  textToAnalyse: 'Zu analysierender Text',
  analysisName: 'Name der Analyse',
  directEnterText: 'Text direkt eingeben',
  folderRename: 'Benennen Sie den Ordner um',
  chooseName: 'Bezeichnung eingeben',
  chooseJobProfile: 'Bitte wählen sie eine Berufsgruppe aus',
  saveTextProfile: 'Geben Sie einen Namen für Ihren zu speichernden Text ein',
  loadTextProfile: 'Text und Profil laden',
  chooseLoadTextProfile: 'Wählen Sie einen Text aus, um diesen zu laden',
  name: 'Name',
  loadTextConfirm: 'Sind Sie sicher, dass Sie diesen Text laden möchten? Der aktuelle Text im Editor geht dadurch verloren',
  registrationDate: 'Registrierungsdatum',
  customValue: 'Benutzerdefinierter Wert',
  passResetSuccessfully: 'Passwort erfolgreich zurückgesetzt',
  clearAWButton: 'Hervorhebungen entfernen',
  updateAWButton: 'Analysieren Sie den Text',
  saveAWButton: 'Aktuellen Text speichern',
  loadAWButton: 'Laden Sie einen gespeicherten Text',
  videos: 'Videos',
  videoCmId: 'rQsJ8zgLLfU',
  videoProfileId: 'dEeUtA-kccU',
  videoTiAwId: 'wk2Db1mNok4',
  videoCiId: 'pB2-cuQm0zA',
  videoCiAwId: 'w-89g2gn75o',
  videoBiAwId: '6QbpBnrTqnE',
  videoMotivesId: 'M2MONEmaHoc',
  profileVideoName: 'Profile anlegen',
  motivesVideoName: 'Die Motive erklärt',
  welcome: 'Willkommen im SAIA Dashboard!',
  search: 'Suche...',
  noLogin: 'Kein Login',
  chooseMore: 'Bitte wählen Sie mehr der folgenden Wörter',
  createNew: 'Erstelle neu',
  updateExisting: 'Update verfügbar',
  chooseTextOverride: 'Bitte wählen Sie einen gespeicherten Text aus, um dessen Inhalt zu überschreiben',
  manageAWButton: 'Texte verwalten',
  savedTextProfile: 'Gespeichertes Profil',
  savedTextName: 'Name des gespeicherten Textes',
  chooseEditTextProfile: 'Wählen Sie einen gespeicherten Text zum Bearbeiten oder Löschen',
  awManual: 'Augmented Writing Handbuch',
  teamManual: 'Team Match for Talent Handbuch',
  ciManual: 'Customer Intelligence Handbuch',
  talenAWManual: 'Augmented Writing Talent Handbuch',
  brandAWManual: 'Augmented Writing Brand Handbuch',
  notEnoughContent: 'Um ein zuverlässiges Ergebnis zu erhalten, sollten die einzelnen Textproben mindestens {{number}} Worte enthalten!',
  scientificBackground: 'Wissenschaftlicher Hintergrund',
  helpCenter: 'Hilfe Center',
  connectionFailure:
    'Es liegt ein Problem mit Ihrer Internetverbindung oder der Verbindung zum Server. Sie können Ihre Arbeit fortsetzen sobald die Verbindung wiederhergestellt wurde',
  connectionFailureTitle: 'Problem mit Ihrer Internetverbindung',
  checkConnection: 'Bitte überprüfen Sie Ihre Internetverbindung, um eine Analyse durchführen zu können',
  EnterTextHere: 'Bitte geben Sie hier Ihren Text ein...',
  contactSales:
    'Danke für Ihre Registrierung. Sie haben zur Zeit keine Produkte aktiviert, wenden Sie sich bitte an unser Verkaufsteam um eine kostenlose Testversion zu erhalten.',
  viewTour: 'Tour ansehen',
  sureLeaving: 'Sind Sie sicher, dass Sie die Seite verlassen möchten? Änderungen wurden unter Umständen nicht gespeichert.',
  closeDialog: 'Schließen',
  change: 'Ändern',
  load: 'Laden',
  switch: 'Verschieben',
  cmUploadTitle: 'Hochladen & Analysieren\nvon neuen Bewerbungen',
  cmViewTitle: 'Bereits hochgeladene Bewerbungen\nund Ergebnisse ansehen',
  soHints:
    '- Erstellen Sie neue Umfrage-Ordner.\n- Senden Sie Umfragen an eine oder mehrere Email-Adressen.\n- Sie sehen direkt, ob eine Umfrage bereits beantwortet wurde. Falls sie beantwortet wurde, können Sie sich das Analyse-Ergebnis anschauen.\n- Der Umfrageschlüssel mit Link zur Umfrage kann in die Zwischenablage kopiert werden.\n- Umfragen können gelöscht und bearbeitet werden.\n- Analysen können per Drag & Drop bewegt und gelöscht werden.',
  hints: 'Hinweise',
  showHints: 'Zeige Hinweise',
  hideHints: 'Verstecke Hinweise',
  comparisonWith: 'Vergleich mit Profil: ',
  newProfile: 'Neues Profil',
  viewResultsCM: 'Ergebnisse anzeigen',
  surveyStartPageTitle: 'Informationen zur nachfolgenden Potenzialanalyse',
  startSurvey: 'Starten',
  sendSurvey: 'Abschicken',
  contactMotif: 'Kontaktmotiv',
  powerMotif: 'Machtmotiv',
  achievementMotif: 'Leistungsmotiv',
  surveyStartPageGreetingTitle: 'Willkommen bei der Potenzialanalyse',
  surveyStartPageGreeting:
    'Liebe Teilnehmerin, lieber Teilnehmer!\n\nVielen Dank, dass Sie an der Potenzialanalyse teilnehmen.\nEs folgen zwei psychologische Tests. Bitte seien Sie ganz Sie selbst und verstellen Sie sich nicht, wenn Sie die Tests bearbeiten.\n',
  surveyStartPageInfo:
    'Sie sehen nachfolgend eine Reihe von Bildern. Bitte schreiben Sie zu jedem Bild eine Geschichte über die auf den Bildern gezeigten Leute. Versuchen Sie sich vorzustellen, was dort vorgeht. Dann erzählen Sie, was zuvor passiert ist, worüber die Leute nachdenken, was sie fühlen und was als Nächstes passieren wird. Versuchen Sie, über jedes Bild eine Geschichte zu schreiben mit einem Anfang und einem Ende.\n\nSie werden folgende Fragen auf der Bildseite platziert finden, die Ihnen beim Schreiben der Geschichte helfen sollen:\n\nWas passiert? Wer sind die Leute?\nWas passierte zuvor? Wie beginnt die Geschichte?\nWorüber denken die Leute nach und wie fühlen sie sich?\nWas wird passieren? Wie endet Ihre Geschichte?\n\nDiese Fragen sind nur Leitlinien für Ihre Geschichten; Sie müssen nicht jede einzeln beantworten.\n\nWichtig: Bitte schreiben Sie ganze Geschichten. Wenige einzelne Sätze sind nicht hinreichend.\n\nSie haben ungefähr fünf Minuten Zeit für jede Geschichte.\n\nDie gesamte Potenzialanalyse wird in etwa 30 Minuten dauern.\n\nEs gibt keine richtigen oder falschen Geschichten. Schreiben Sie, was immer für Geschichten Ihnen einfallen.',
  pictureStoryTodo1:
    'Bitte schauen Sie sich dieses Bild als Anregung für Ihre Geschichte nur wenige Sekunden an. Sobald Sie ungefähr wissen, was Sie schreiben wollen, klicken Sie unten auf "Weiter".',
  pictureStoryTodo2:
    'Nachfolgend finden Sie einige Fragen als Leitlinien. Statt jede einzeln zu beantworten, schreiben Sie bitte ganze Geschichten auf Deutsch mit einem Anfang und einem Ende.',
  pictureStoryQuestion1: 'Was passiert?',
  pictureStoryQuestion2: 'Wer sind die Leute?',
  pictureStoryQuestion3: 'Was passiert zuvor?',
  pictureStoryQuestion4: 'Wie beginnt die Geschichte?',
  pictureStoryQuestion5: 'Worüber denken die Leute nach und wie fühlen sie sich?',
  pictureStoryQuestion6: 'Was wird passieren? Wie endet Ihre Geschichte?',
  enterTextHere: 'Schreiben Sie Ihre Geschichte hier',
  surveyCompletedAlready: 'Die Potenzialanalyse wurde bereits beantwortet.',
  surveyNotFound: 'Die Potenzialanalyse wurde nicht gefunden. Bitte prüfen sie Ihre URL und den darin befindlichen Schlüssel.',
  questionnaireTitle: 'Fragebogen',
  questionnaireInfo1: 'Es folgen mehrere Aussagen, denen Sie mehr oder weniger zustimmen können.',
  questionnaireInfo2:
    'Bitte kreuzen Sie dafür eine der dargestellten Möglichkeiten zwischen "trifft überhaupt nicht zu" (1) bis "trifft vollkommen zu" (6) an.',
  questionnaireInfo3:
    'Es gibt dabei keine „richtigen“ oder „falschen“ Antworten und Sie erfüllen den Zweck der Befragung am besten, wenn Sie die Fragen so wahrheitsgemäß wie möglich beantworten.',
  questionnaireInfo4: 'Es folgen nun mehrere Aussagen zu Zielen, die Sie mehr oder weniger wichtig finden können.',
  questionnaireInfo5:
    'Bitte kreuzen Sie für jedes Ziel an, wie wichtig Ihnen dieses Ziel in Ihrem Leben ist, von "nicht wichtig" (1) bis "außerordentlich wichtig" (6).',
  surveyQuestionnaireMissingAnswersError:
    'Bitte beantworten Sie alle Fragen vor dem Abschicken. {{count}} Frage(n) sind noch unbeantwortet.',
  surveyQuestionnaireSubmitError:
    'Ihre Antworten konnten nicht abgeschickt werden. Bitte prüfen Sie Ihre Angaben und versuchen Sie es erneut.',
  beginQuestionnaire: 'Fragebogen starten',
  surveyQuestionnaireContactOne: 'Ich versuche, so oft wie möglich in der Gesellschaft von Freunden zu sein.',
  surveyQuestionnaireContactTwo: 'Zusammentreffen mit anderen Menschen machen mich glücklich.',
  surveyQuestionnaireContactThree: 'Ich verbringe viel Zeit damit, Freunde zu besuchen.',
  surveyQuestionnaireContactFour: 'Ich bemühe mich, andere Leute kennen zu lernen. ',
  surveyQuestionnaireContactFive: 'Oft wäre ich lieber mit einer Gruppe von Freunden zusammen als alleine.',
  surveyQuestionnaireContactSix: 'Ich entscheide mich meist für Freizeitbeschäftigungen, die ich zusammen mit anderen Leuten ausüben kann.',
  surveyQuestionnaireContactSeven: 'Ich schließe gern so viele Freundschaften, wie ich kann. ',
  surveyQuestionnaireContactEight: 'Wenn ich neue Leute kennenlernen kann, fühle ich mich voller Energie.',
  surveyQuestionnaireContactNine: 'Viel mit anderen Menschen zusammen unternehmen.',
  surveyQuestionnaireContactTen: 'Einen großen Bekanntenkreis haben.',
  surveyQuestionnaireAchievementOne: 'Ich fühle mich zu Arbeiten hingezogen, in denen ich die Möglichkeit habe, meine Fähigkeiten zu prüfen.',
  surveyQuestionnaireAchievementTwo: 'Ich habe mir vorgenommen, wenigstens etwas mehr zu leisten als irgendjemand vor mir.',
  surveyQuestionnaireAchievementThree: 'Meine Leistung stets auf einem hohen Niveau zu halten.',
  surveyQuestionnaireAchievementFour: 'Arbeit von hoher Qualität zu leisten.',
  surveyQuestionnaireAchievementFive: 'Projekte, die mich bis an die Grenze meiner Leistungsfähigkeit bringen.',
  surveyQuestionnaireAchievementSix: 'Mich ständig verbessern.',
  surveyQuestionnaireAchievementSeven: 'Ständig neue, interessante und herausfordernde Ziele und Projekte.',
  surveyQuestionnaireAchievementEight: 'Verantwortung für schwierige und herausfordernde Aufgaben und Ziele zu übernehmen.',
  surveyQuestionnaireAchievementNine: 'Eigenverantwortlich etwas besser machen zu können als es bisher gemacht wurde.',
  surveyQuestionnaireAchievementTen: 'Etwas Neues schaffen zu können.',
  surveyQuestionnairePowerOne: 'Ich habe gern das Sagen. ',
  surveyQuestionnairePowerTwo: 'Ich strebe nach Positionen, in denen ich Autorität habe.',
  surveyQuestionnairePowerThree: 'Ich habe Interesse daran, andere zu führen.',
  surveyQuestionnairePowerFour: 'Ich fühle mich in meinem Element, wenn es darum geht, die Tätigkeiten anderer zu leiten.',
  surveyQuestionnairePowerFive: 'Ich versuche, andere unter meinen Einfluss zu bekommen, anstatt zuzulassen, dass sie mich kontrollieren.',
  surveyQuestionnairePowerSix: 'Über eine Gruppe oder eine Organisation Kontrolle ausüben zu können.',
  surveyQuestionnairePowerSeven: 'Einfluss ausüben können.',
  surveyQuestionnairePowerEight: 'In einer Führungsposition zu sein, wo andere für mich arbeiten und von mir Anweisungen erhalten.',
  surveyQuestionnairePowerNine: 'Andere Menschen beeinflussen zu können.',
  surveyQuestionnairePowerTen: 'Eine Stellung mit Prestige und Ansehen.',
  surveyEndThanks: 'Vielen Dank für die Teilnahme an unserer Potenzialanalyse!',
  surveyEndSuccess: 'Die Potenzialanalyse wurde erfolgreich abgeschlossen. Die Auswertung wird nun an den Ersteller der Potenzialanalyse gesendet.',
  surveyEndGreetings: 'Viel Erfolg auf Ihrem weiteren Karriereweg wünscht Ihnen das SAIA Team!',
  notImportant: 'nicht wichtig',
  littleImportant: 'ein wenig wichtig',
  somethingImportant: 'etwas wichtig',
  important: 'wichtig',
  veryImportant: 'sehr wichtig',
  extremelyImportant: 'außerordentlich wichtig',
  notApplyAtAll: 'trifft überhaupt nicht zu',
  notApply: 'trifft nicht zu',
  ratherNotApply: 'trifft eher nicht zu',
  ratherApply: 'trifft eher zu',
  quiteApply: 'trifft ziemlich zu',
  appliesPerfectly: 'trifft vollkommen zu',
  AWTalentQuestion1: 'sich gegen andere durchzusetzen?',
  AWTalentQuestion2: 'Verantwortung zu übernehmen?',
  AWTalentQuestion3: 'Einfluss auf andere zu nehmen (z. B. andere von etwas zu überzeugen)?',
  AWTalentQuestion4: 'Andere anzuleiten und zu führen?',
  AWTalentQuestion5: 'bessere Leistungen zu erzielen, als andere?',
  AWTalentQuestion6: 'sich besonders anzustrengen?',
  AWTalentQuestion7: 'Misserfolge möglichst zu vermeiden?',
  AWTalentQuestion8: 'sich mit anderen zu vergleichen?',
  AWTalentQuestion9: 'eine freundschaftliche und harmonische Beziehung zu Kollegen zu pflegen?',
  AWTalentQuestion10: 'zusammen mit anderen zu arbeiten?',
  AWTalentQuestion11: 'mit anderen Zeit zu verbringen (und nicht alleine zu arbeiten)?',
  AWTalentQuestion12: 'anderen zu helfen?',
  AWTalentQuestion13: 'Dass Sie mit Ihrem Unternehmen persönlich in Erscheinung treten, z. B. „Ich von …“, „Bei uns…“, „Mit uns…“?',
  AWTalentQuestion14: 'Dinge ohne Zweifel und vorbehaltlos benennen und sich festzulegen?',
  AWTalentExample1Left: 'Wir sollten den anderen den Vortritt lassen.',
  AWTalentExample1Right: 'Die können wir sicher schlagen.',
  AWTalentExample2Left: 'Ich will die Verantwortung dafür nicht tragen.',
  AWTalentExample2Right: 'Her damit, die Verantwortung übernehme ich.',
  AWTalentExample3Left: 'Andere zu beeinflussen, das liegt mir nicht und das will ich auch garnicht.',
  AWTalentExample3Right: 'Ich bin ein Meister darin, andere vom richtigen Kurs zu überzeugen.',
  AWTalentExample4Left: 'Ich kümmere mich lieber um meine Dinge.',
  AWTalentExample4Right: 'Nur wenn du das so machst, dann funktioniert es.',
  AWTalentExample5Left: 'Auf dem Podest zu stehen, ist ihm nicht so wichtig. Er hat nichts davon, wenn er besser ist als andere.',
  AWTalentExample5Right:
    'Er ließ alles stehen und liegen, auch die Bitte um Unterstützung seines Kollegen, um sein persönliches Ziel zu erreichen und um als Bester abzuschneiden.',
  AWTalentExample6Left: 'Die Arbeit ist wichtig, aber auch andere Dinge im Leben zählen.',
  AWTalentExample6Right:
    'Sie hat sich in letzter Zeit beruflich so ins Zeug gelegt, dass sie seit drei Wochen nicht mehr zum Sport ging, obwohl sie gerne zum Sport geht.',
  AWTalentExample7Left: 'Scheitern gehört dazu.',
  AWTalentExample7Right: 'Es war eine Katastrophe für ihn, dass Internetprobleme die Fertigstellung seiner Aufgaben zunichte machten.',
  AWTalentExample8Left: 'Für mich ist es nicht wichtig, wenn ich besser bin als meine Kollegen.',
  AWTalentExample8Right:
    'Unter allen Mitarbeitern erzielte Diane das beste Ergebnis bei den Jahreszielen, dafür machte sie auch einige Zugeständnisse in ihrem Privatleben.',
  AWTalentExample9Left: 'Ihm ist es garnicht wichtig, über das notwendige Maß hinaus, freundschaftliche Beziehungen zu seinen Kollegen zu haben.',
  AWTalentExample9Right: 'Um für gute Stimmung zu sorgen, organisiert er jede Woche ein Frühstück mit seinen Kollegen.',
  AWTalentExample10Left: 'Ich arbeite am liebsten für mich alleine.',
  AWTalentExample10Right: 'Mir fällt es echt schwer, wenn ich mal einen Tag ohne Kollegen arbeiten muss.',
  AWTalentExample11Left: 'Arbeit ist Arbeit, in meinem Privatleben hat die Arbeit nichts zu suchen.',
  AWTalentExample11Right: 'Auch nach der Arbeit treffen wir uns regelmäßig um gemeinsam etwas zu unternehmen.',
  AWTalentExample12Left: 'Ich unterstütze meine Kollegen. Von mir aus gehe ich aber nicht auf sie zu.',
  AWTalentExample12Right: 'Ich liebe es, wenn ich meinem Kollegen helfen kann. Das ist mir ein richtiges Bedürfnis.',
  AWTalentExample13Left: 'Es geht nicht um uns sondern um die Stelle.',
  AWTalentExample13Right: 'Um das Gegenüber anzusprechen, sollten wir auch persönlich in Erscheinung treten.',
  AWTalentExample14Left: 'Es ist menschlich, wenn man nicht alles weiß.',
  AWTalentExample14Right: 'Natürlich, die Bewerber brauchen Klarheit und deswegen sollten wir die Dinge klar und vorbehaltlos benennen.',
  AWTalentQuestionHeader1: 'Wie wichtig sollte für Ihren zukünftigen Mitarbeiter / Ihre zukünftige Mitarbeiterin sein',
  AWTalentQuestionHeader2: 'Wenn Sie an Ihr Unternehmen denken, wie wichtig ist dann',
  AWBrandQuestionHeader1: 'Wenn Sie an Ihre Zielgruppe denken, wie wichtig ist dann',
  AWBrandQuestionHeader2: 'Wenn Sie an Ihr/e Unternehmen/Marke denken, wie wichtig ist dann',
  AWBrandQuestion1: 'Misserfolge zu vermeiden?',
  AWBrandQuestion2: 'in stabilen Verhältnissen zu leben?',
  AWBrandQuestion3: 'Risiken und Veränderungen zu vermeiden?',
  AWBrandQuestion4: 'Probleme auf bewährte Art zu lösen?',
  AWBrandQuestion5: 'den eigenen Weg zu gehen?',
  AWBrandQuestion6: 'keine fremde Anleitung zu haben?',
  AWBrandQuestion7: 'sich Fehler zuzugestehen?',
  AWBrandQuestion8: 'Probleme auf kreative Art zu lösen?',
  AWBrandQuestion9: 'dass Sie mit Ihrem Unternehmen/Marke persönlich in Erscheinung treten, z. B. „Wir von …“, „Bei uns…“, „Mit uns…“?',
  AWBrandQuestion10: 'Dinge ohne Zweifel und vorbehaltlos benennen und sich festzulegen?',
  AWBrandQuestion11: 'sich gegen andere durchzusetzen?',
  AWBrandQuestion12: 'einen hohen Status zu haben?',
  AWBrandQuestion13: 'Status anderen zu zeigen?',
  AWBrandQuestion14: 'immer hohe Leistung zu erzielen?',
  AWBrandQuestion15: 'von sich und anderen hohe Ziele zu fordern?',
  AWBrandQuestion16: 'sich im Wettbewerb mit anderen zu vergleichen?',
  AWBrandQuestion17: 'harmonische Beziehungen zu anderen zu haben?',
  AWBrandQuestion18: 'mit anderen zusammen zu sein?',
  AWBrandQuestion19: 'Auseinandersetzung zu vermeiden?',
  AWBrandQuestion20: 'sie sachlich und mit wenig Emotionen anzusprechen?',
  AWCustomerQuestionHeader1: 'Wenn Sie an Ihre Kunden denken, wie wichtig ist dann',
  AWCustomerQuestionHeader2: 'Wenn Sie an sich in Ihrer Funktion als Agent/indenken, wie wichtig ist dann',
  AWCustomerQuestion1: 'Misserfolge zu vermeiden?',
  AWCustomerQuestion2: 'in stabilen Verhältnissen zu leben?',
  AWCustomerQuestion3: 'Risiken und Veränderungen zu vermeiden?',
  AWCustomerQuestion4: 'Probleme auf bewährte Art zu lösen?',
  AWCustomerQuestion5: 'den eigenen Weg zu gehen?',
  AWCustomerQuestion6: 'keine fremde Anleitung zu haben?',
  AWCustomerQuestion7: 'sich Fehler zuzugestehen?',
  AWCustomerQuestion8: 'Probleme auf kreative Art zu lösen?',
  AWCustomerQuestion9: 'dass Sie mit Ihrem Unternehmen/Marke persönlich in Erscheinung treten, z. B. „Ich von …“, „Bei uns…“, „Mit uns…“?',
  AWCustomerQuestion10: 'Dinge ohne Zweifel und vorbehaltlos benennen und sich festzulegen?',
  AWCustomerQuestion11: 'sich gegen andere durchzusetzen?',
  AWCustomerQuestion12: 'einen hohen Status zu haben?',
  AWCustomerQuestion13: 'Status anderen zu zeigen?',
  AWCustomerQuestion14: 'immer hohe Leistung zu erzielen?',
  AWCustomerQuestion15: 'von sich und anderen hohe Ziele zu fordern?',
  AWCustomerQuestion16: 'sich im Wettbewerb mit anderen zu vergleichen?',
  AWCustomerQuestion17: 'harmonische Beziehungen zu anderen zu haben?',
  AWCustomerQuestion18: 'mit anderen zusammen zu sein?',
  AWCustomerQuestion19: 'Auseinandersetzung zu vermeiden?',
  AWCustomerQuestion20: 'sie sachlich und mit wenig Emotionen anzusprechen?',
  AWBrandExample1Left: 'Wer nicht wagt, der nicht gewinnt.',
  AWBrandExample1Right: 'Misserfolge machen mir sehr zu schaffen und lassen mich an mir zweifeln.',
  AWBrandExample2Left: 'In stabilen Verhältnissen zu leben, bedeutet Langeweile.',
  AWBrandExample2Right: 'Es gibt mir ein Gefühl von Sicherheit, wenn mein Leben eine feste Struktur hat.',
  AWBrandExample3Left: 'Wenn ich nie ein Risiko eingehe, komme ich auch nicht voran.',
  AWBrandExample3Right: 'Veränderungen bergen die Gefahr, dass sich etwas zum Schlechten entwickelt.',
  AWBrandExample4Left: 'Gerade die neue Lösungen sind es doch, die uns voran bringen.',
  AWBrandExample4Right: 'Neuen Entwicklungen stehe ich erst einmal skeptisch gegenüber. Haben sie sich schon bewährt?',
  AWBrandExample5Left: 'Ich schau mir die Dinge erst mal bei den anderen an.',
  AWBrandExample5Right: 'Unabhängig und frei zu sein, das ist mir viel wert.',
  AWBrandExample6Left: 'Ich mag es, wenn andere mich führen und anleiten.',
  AWBrandExample6Right: 'Ich finde gerne selbst meinen Weg, ohne andere.',
  AWBrandExample7Left: 'Fehler zu machen ist peinlich und ich versuche sie zu vermeiden.',
  AWBrandExample7Right: 'Nur durch Fehler kann man lernen.',
  AWBrandExample8Left: 'Kreativität ist etwas für Künstler.',
  AWBrandExample8Right: 'Wirklich Neues entsteht nur durch kreative Ideen.',
  AWBrandExample9Left: 'Es geht nicht um mich als Person, sondern um die Sache.',
  AWBrandExample9Right: 'Der Kunde spricht ja mit mir, deswegen will ich auch persönlich in Erscheinung treten.',
  AWBrandExample10Left: 'Es ist menschlich, wenn man auch mal Zweifel einräumt und zurückhaltend ist.',
  AWBrandExample10Right: 'Natürlich, die Kunden brauchen Klarheit und deswegen sollte ich die Dinge klar und vorbehaltlos benennen.',
  AWBrandExample11Left: 'Ich muss nicht in der ersten Reihe stehen.',
  AWBrandExample11Right: 'Für mich ist es wichtig, dass ich vor allen anderen dran komme.',
  AWBrandExample12Left: 'Ob Markenprodukt oder nicht, Hauptsache es funktioniert wie gewünscht.',
  AWBrandExample12Right: 'Ich mag es, wenn die Dinge, die ich besitze, ein gewisses Prestige ausdrücken.',
  AWBrandExample13Left: 'Anderen zu zeigen, was ich habe, bedeutet mir nichts.',
  AWBrandExample13Right: 'Marken sind dazu da, getragen und gezeigt zu werden.',
  AWBrandExample14Left: 'Ob meine Handykamera die Beste auf dem Markt ist, ist mir herzlich egal.',
  AWBrandExample14Right: 'Natürlich sollte der Prozessor meines neuen Smartphones unter den Top 3 sein.',
  AWBrandExample15Left: 'Zu ambitionierte Technik ist instabil und fehleranfällig. Daher kaufe ich ungern das neuste Modell.',
  AWBrandExample15Right: 'Weil für mich Leistung wichtig ist, liebe ich auch Produkte, die technische Spitze sind.',
  AWBrandExample16Left: 'Ich kaufe Dinge für mich und daher vergleiche ich mich auch nicht mit anderen.',
  AWBrandExample16Right: 'Es macht mir Spaß, mich mit meinen Freunden zu vergleichen. Es entsteht dann oftmals eine Konkurrenz.',
  AWBrandExample17Left: 'Wenn jemand zu freundlich ist, werde ich skeptisch.',
  AWBrandExample17Right: 'Eine freundliche und persönliche Atmosphäre ist mir sehr wichtig.',
  AWBrandExample18Left: 'Wenn die Verkäuferin auf mich zukommt, stresst mich das. Ich brauche niemanden.',
  AWBrandExample18Right: 'Beratung und guter Service muss sein, das gehört einfach dazu.',
  AWBrandExample19Left: 'Wenn mir das Essen nicht schmeckt, dann sag ich das dem Kellner auch.',
  AWBrandExample19Right: 'Ich bin zurückhaltend und will die gute Stimmung nicht gefährden.',
  AWBrandExample20Left: 'Die Fakten sollen auf den Tisch. Da lenkt zu viel Gefühl nur ab.',
  AWBrandExample20Right: 'Ich brauche eine positive Ansprache um mich wohl und angenommen zu fühlen.',
  AWCustomerExample1Left: 'Wer nicht wagt, der nicht gewinnt.',
  AWCustomerExample1Right: 'Misserfolge machen mir sehr zu schaffen und lassen mich an mir zweifeln.',
  AWCustomerExample2Left: 'In stabilen Verhältnissen zu leben, bedeutet Langeweile.',
  AWCustomerExample2Right: 'Es gibt mir ein Gefühl von Sicherheit, wenn mein Leben eine feste Struktur hat.',
  AWCustomerExample3Left: 'Wenn ich nie ein Risiko eingehe, komme ich auch nicht voran.',
  AWCustomerExample3Right: 'Veränderungen bergen die Gefahr, dass sich etwas zum Schlechten entwickelt.',
  AWCustomerExample4Left: 'Gerade die neue Lösungen sind es doch, die uns voran bringen.',
  AWCustomerExample4Right: 'Neuen Entwicklungen stehe ich erst einmal skeptisch gegenüber. Haben sie sich schon bewährt?',
  AWCustomerExample5Left: 'Ich schau mir die Dinge erst mal bei den anderen an.',
  AWCustomerExample5Right: 'Unabhängig und frei zu sein, das ist mir viel wert.',
  AWCustomerExample6Left: 'Ich mag es, wenn andere mich führen und anleiten.',
  AWCustomerExample6Right: 'Ich finde gerne selbst meinen Weg, ohne andere.',
  AWCustomerExample7Left: 'Fehler zu machen ist peinlich und ich versuche sie zu vermeiden.',
  AWCustomerExample7Right: 'Nur durch Fehler kann man lernen.',
  AWCustomerExample8Left: 'Kreativität ist etwas für Künstler.',
  AWCustomerExample8Right: 'Wirklich Neues entsteht nur durch kreative Ideen.',
  AWCustomerExample9Left: 'Es geht nicht um mich als Person, sondern um die Sache.',
  AWCustomerExample9Right: 'Der Kunde spricht ja mit mir, deswegen will ich auch persönlich in Erscheinung treten.',
  AWCustomerExample10Left: 'Es ist menschlich, wenn man auch mal Zweifel einräumt und zurückhaltend ist.',
  AWCustomerExample10Right: 'Natürlich, die Kunden brauchen Klarheit und deswegen sollte ich die Dinge klar und vorbehaltlos benennen.',
  AWCustomerExample11Left: 'Ich muss nicht in der ersten Reihe stehen.',
  AWCustomerExample11Right: 'Für mich ist es wichtig, dass ich vor allen anderen dran komme.',
  AWCustomerExample12Left: 'Ob Markenprodukt oder nicht, Hauptsache es funktioniert wie gewünscht.',
  AWCustomerExample12Right: 'Ich mag es, wenn die Dinge, die ich besitze, ein gewisses Prestige ausdrücken.',
  AWCustomerExample13Left: 'Anderen zu zeigen, was ich habe, bedeutet mir nichts.',
  AWCustomerExample13Right: 'Marken sind dazu da, getragen und gezeigt zu werden.',
  AWCustomerExample14Left: 'Ob meine Handykamera die Beste auf dem Markt ist, ist mir herzlich egal.',
  AWCustomerExample14Right: 'Natürlich sollte der Prozessor meines neuen Smartphones unter den Top 3 sein.',
  AWCustomerExample15Left: 'Zu ambitionierte Technik ist instabil und fehleranfällig. Daher kaufe ich ungern das neuste Modell.',
  AWCustomerExample15Right: 'Weil für mich Leistung wichtig ist, liebe ich auch Produkte, die technische Spitze sind.',
  AWCustomerExample16Left: 'Ich kaufe Dinge für mich und daher vergleiche ich mich auch nicht mit anderen.',
  AWCustomerExample16Right: 'Es macht mir Spaß, mich mit meinen Freunden zu vergleichen. Es entsteht dann oftmals eine Konkurrenz.',
  AWCustomerExample17Left: 'Wenn jemand zu freundlich ist, werde ich skeptisch.',
  AWCustomerExample17Right: 'Eine freundliche und persönliche Atmosphäre ist mir sehr wichtig.',
  AWCustomerExample18Left: 'Wenn die Verkäuferin auf mich zukommt, stresst mich das. Ich brauche niemanden.',
  AWCustomerExample18Right: 'Beratung und guter Service muss sein, das gehört einfach dazu.',
  AWCustomerExample19Left: 'Wenn mir das Essen nicht schmeckt, dann sag ich das dem Kellner auch.',
  AWCustomerExample19Right: 'Ich bin zurückhaltend und will die gute Stimmung nicht gefährden.',
  AWCustomerExample20Left: 'Die Fakten sollen auf den Tisch. Da lenkt zu viel Gefühl nur ab.',
  AWCustomerExample20Right: 'Ich brauche eine positive Ansprache um mich wohl und angenommen zu fühlen.',
  sendInvitations: 'Einladungen verschicken',
  exportInviteLinks: 'Einladungslinks exportieren',
  exportSelectedInviteLinks: 'Ausgewählte Einladungslinks exportieren ({{count}})',
  send: 'Senden',
  sendInvitationsAt: 'Einladungen für Persönlichkeitstest versenden an:',
  classic: 'Klassisch (4 Bilder)',
  modern: 'Modern (4 Bilder)',
  extended: 'Erweitert (6 Bilder)',
  expertSample: 'Expertenstichprobe',
  leadershipSample: 'Führungsstichprobe',
  surveyType: 'Art der Umfrage: ',
  surveyTypeNotSupported: 'Es sind Probleme mit dem Umfrage Typ aufgetreten',
  addAnother: 'Weitere hinzufügen',
  allEmailsSent: 'Email wurde versandt',
  allEmailsSent_plural: 'Alle {{count}} Emails wurden versandt',
  allSurveysCreated: 'Umfrage wurde erstellt',
  allSurveysCreated_plural: 'Alle {{count}} Umfragen wurden erstellt',
  keyCopied: 'Link inkl. Schlüssel {{key}} in Zwischenablage kopiert.',
  copyKey: 'Schlüssel kopieren',
  infoAboutAI: 'Information zu unserer KI finden Sie <1>hier.</1>',
  soWordCount: '{{words}} / {{minWords}} Worte',
  soWordHint:
    'Die Anzahl der Worte dient zur Orientierung, das Ergebnis der Potenzialanalyse wird jedoch genauer, je mehr Text Sie uns zur Verfügung stellen.',
  consentForm: 'Einwilligungserklärung',
  surveyStartPageLegalInquiry:
    'Die Potenzialanalyse nutzt die Analysetechnologie der <1>SAIA Sprachanalyse GmbH</1> zur Analyse Ihrer impliziten und expliziten Motive.<3></3><4></4>Dabei werden ggf. Daten erhoben, verarbeitet und gespeichert, aus denen ein individuelles Profil erstellt wird. Die erhobenen Daten, die auch personenbezogene Daten beinhalten können, werden an SAIA übermittelt und auf deren Servern verarbeitet.<6></6><7></7>Sie können die Erfassung Ihrer Daten durch SAIA verhindern, indem Sie es uns <9>hier</9> mitteilen.',
  surveyAgree: 'Ich bin einverstanden und möchte an der Potenzialanalyse teilnehmen.',
  yes: 'Ja',
  no: 'Nein',
  SEOButton: 'SEO Analyse',
  SEOExplanation: 'Geben Sie ein Stichwort ein, um es im Hinblick auf Suchmaschinenoptimierung zu untersuchen.',
  enterTextInEditorFirst: 'Bitte geben Sie zuerst einen Text in den Editor ein',
  keyword: 'SEO Keyword',
  readTermsAndPrivacy:
    'Indem Sie fortfahren, stimmen Sie den 100W <1>Nutzungsbedingungen für Kunden</1> und der <2></2><3>Datenschutzrichtlinie</3> zu.',
  termsOfUse: 'Allgemeine Geschäftsbedingungen (AGB)',
  privacyPolicy: 'Datenschutzrichtlinien',
  dataProcessingAgreement: 'Auftragsverarbeitung',
  acceptTermsAndPrivacy: 'Ich habe die AGB und die Datenschutzerklärung gelesen und stimme ihnen zu.',
  andThe: 'und der',
  readTerms: 'Ich habe die <1>Allgemeinen Geschäftsbedingungen</1> gelesen und stimme diesen zu.',
  readPrivacy: 'Ich habe die <1>Datenschutzerklärung</1> gelesen und stimme dieser zu.',
  surveysMoved: 'Umfrage (n) wurden erfolgreich verschoben',
  switchTagSurveys: 'Umfrage (n) zwischen Tags wechseln',
  confirmSwitchTagSurveys: 'Sind Sie sicher, dass Sie {{ count }} Umfrage von "{{ source }}" nach "{{ dest }}" verschieben möchten?',
  confirmSwitchTagSurveys_plural: 'Sind Sie sicher, dass Sie {{ count }} Umfragen von "{{ source }}" nach "{{ dest }}" verschieben möchten?',
  uploadCSVFile: 'Sie können mehrere Personen hinzufügen, indem Sie eine CSV-Datei mit dem folgenden Format hochladen',
  uploadCSVFileContacts: 'Du kannst mehrere Kontakte hinzufügen, indem Du eine CSV-Datei mit dem folgenden Format hochlädst',
  uploadCSVFileContactsManual: 'Du kannst E-Mail-Adressen manuell eingeben und sie dem Profil hinzufügen.',
  upload: 'Hochladen',
  uploadExample: 'Format: E-Mail, Nachname, Vorname',
  uploadEmailsExample: 'Format: E-Mails',
  uploadHint:
    'Hinweis: Bitte gib keinen Header für die Daten an (d. h. beginne mit dem ersten Empfänger im oben genannten Format direkt in der ersten Zeile)',
  uploadHint2: 'Lade eine CSV-Datei hoch und klicke danach auf "Speichern"',
  csvUploadAction: 'Klicken, um eine CSV-Datei auszuwählen',
  csvUploadLoading: 'CSV wird importiert...',
  csvUploadDownloadTemplate: 'Vorlage herunterladen',
  csvUploadResetList: 'Liste zurücksetzen',
  csvUploadHintHeaderOptional: 'Eine Header-Zeile ist optional. Unterstützte Spalten: E-Mail, Nachname, Vorname.',
  csvUploadImportedRows: '{{count}} Zeilen aus {{file}} importiert.',
  csvUploadNoRows: 'In {{file}} wurden keine gültigen Zeilen gefunden.',
  csvUploadHeaderDetected: 'Header-Zeile erkannt und automatisch übersprungen.',
  csvUploadInvalidEmails: '{{count}} Zeilen enthalten ungültige E-Mail-Adressen. Bitte vor dem Senden korrigieren.',
  csvUploadDuplicatesIgnored: '{{count}} doppelte Zeilen wurden ignoriert.',
  csvUploadRowsIgnored: '{{count}} leere oder unvollständige Zeilen wurden ignoriert.',
  csvUploadLimitReached: '{{count}} zusätzliche Zeilen wurden wegen Upload-Limit übersprungen (max. 1000 Zeilen).',
  csvPreviewTitle: 'Import-Vorschau',
  csvPreviewRow: 'Zeile',
  csvPreviewLimitHint: 'Es werden die ersten 200 Vorschau-Zeilen angezeigt.',
  csvStatusValid: 'Gültig',
  csvStatusInvalidEmail: 'Ungültige E-Mail',
  csvStatusDuplicate: 'Doppelt',
  csvStatusIgnored: 'Ignoriert',
  csvStatusTruncated: 'Übersprungen (Limit)',
  focus: 'Fokus',
  emotion: 'Emotion',
  motive: 'Motiv',
  contactInfo: 'Kontakt Informationen',
  lastUpdate: 'Letzte Aktualisierung',
  wordsShared: 'Worte analysiert',
  addNewContact: 'Neuer Kontakt',
  contactName: 'Kontakt Name',
  sortBy: 'Sortieren nach',
  searchForContact: 'Nach Kontakt suchen',
  contactsPerPage: 'Kontakte pro Seite',
  searchNameOrLinkedInUrl: 'Nach Name oder LinkedIn-URL suchen',
  profileId: 'LinkedIn-Profil',
  connectionDegree: 'Vernetzt',
  dayMessagesTitle_one: '{{step}} am {{date}} · {{count}} Nachricht',
  dayMessagesTitle_other: '{{step}} am {{date}} · {{count}} Nachrichten',
  dayMessagesEmpty: 'Für diesen Tag sind keine Nachrichten im Verlauf.',
  connectionRequestNoNote: 'Kontaktanfrage (ohne Nachricht)',
  visitProfile: 'Profil besuchen',
  checkReply: 'Antwort prüfen',
  checkIfGeneratedEmailAddress: 'E-Mail-Adresse prüfen',
  footerNote: 'Tipp: Klicke auf einen Namen, um Details und den Interaktionsverlauf zu sehen.',
  footerNotePlaceholder: 'Tipp: Klicke auf einen Namen, um Details und den Interaktionsverlauf zu sehen.',
  deleteContact: 'Profil löschen',
  contactDeleteDialog: 'Sie sind dabei, das Profil {{firstName}} {{lastName}} zu löschen. Dieser Vorgang ist nicht umkehrbar, trotzdem löschen?',
  makeVisible: 'Sichtbar machen',
  makeInvisible: 'Unsichtbar machen',
  editContactName: 'Kontaktnamen bearbeiten',
  newText: 'Profil erweitern',
  seeDetails: 'Zur Detailseite',
  notAnalyzed: 'kein Profil vorhanden',
  ascend: 'Aufsteigend',
  descend: 'Absteigend',
  updateDate: 'Änderungsdatum',
  notSet: 'nicht festgelegt',
  emailLong: 'Email (lang)',
  textLang: 'Textsprache',
  inconsistentLang: 'Es wurden Texte unterschiedlicher Sprachen analysiert, dies kann die Genauigkeit der Analysen negativ beeinflussen.',
  tooFewWords: 'Das Profil enthält zu wenig analysierte Worte, um aussagekräftige Analyse-Ergebnisse liefern zu können.',
  de: 'Deutsch',
  en: 'Englisch',
  es: 'Spanisch',
  fr: 'Französisch',
  it: 'Italienisch',
  pageLoadError: 'Beim Laden der Seite ist ein Fehler aufgetreten',
  successNewContact: 'Der Kontakt {{firstname}} {{lastname}} wurde hinzugefügt',
  contactDeleted: 'Der Kontakt wurde erfolgreich gelöscht',
  successCustomerEdit: 'Der Kontakt wurde erfolgreich bearbeitet',
  successAddText: 'Neuen Text zur Kontakt-Analyse hinzugefügt. Profil wurde aktualisiert.',
  customerLoadingError: 'Beim Laden der Kontaktdaten ist ein Fehler aufgetreten',
  analyzeNewText: 'Neuen Text zur Profil-Analyse hinzufügen',
  analyzeNewTextExplanation: 'Durch das  Hinzufügen weiterer Texte wird das Profil des ausgewählten Kontaktes verfeinert.',
  noAssessment2: 'Bitte Daten hinzufügen oder Profil manuell einstellen.',
  noAssessment3: 'Damit Analyse-Ergebnisse angezeigt werden können, müssen Sie zuerst einen Text über den Button "{{button}}" hinzufügen.',
  uploadEmail: 'Email hochladen',
  chooseEmailParticipant: 'Zu analysierenden Gesprächsteilnehmer auswählen',
  participants: 'Teilnehmer',
  choose: 'auswählen',
  noContactInfo1: 'Willkommen bei {{product}} von SAIA.',
  noContactInfo2: 'Es sind nur noch zwei Schritte zu Ihrer ersten Kundenanalyse:',
  noContactInfo3: '1. Erstellen Sie mit dem Button "{{button}}" einen neuen Kontakt.',
  noContactInfo4: '2. Fügen Sie diesem Kontakt einen oder mehrere Texte über den "{{button}}" - Button hinzu.',
  moreInfoCi: 'Weitere Informationen zu {{info}}',
  title: 'Name',
  public: 'Für Firma sichtbar',
  options: 'Optionen',
  enterEditingMode: 'Bearbeitungsmodus',
  exitEditingMode: 'Bearbeitungsmodus verlassen',
  moveToFolder: 'in den Ordner verschieben',
  textMovedSuccess: 'Text erfolgreich in Verzeichnis verschoben',
  moveToRoot: 'In das Stammverzeichnis wechseln',
  selectExistingFolder: 'Bestehenden Ordner auswählen',
  folderSelection: 'Ordner auswählen',
  saveEditorText: 'Editortext speichern',
  searchForText: 'Nach Text suchen',
  textTitle: 'Text Name',
  folderTitle: 'Ordnertitel',
  successDeleteText: 'Der Text "{{title}}" wurde erfolgreich gelöscht',
  successDeleteFolder: 'Der Ordner "{{title}}" wurde erfolgreich gelöscht',
  confirmDeleteTitle: 'Löschwarnung',
  warning: 'Löschwarnung',
  SettingForAutomaticDeletion: 'Einstellung zum automatischen Entfernen von analysierten Daten von Kontakten in Jahren:',
  confirmDeleteText: 'Möchten Sie den Text "{{text}}" wirklich löschen?',
  confirmDeleteFolder: 'Möchten Sie den Ordner "{{text}}" und alle seine Texte wirklich löschen?',
  confirmChangeNumberOfYears:
    'Sind Sie sicher, dass Sie automatisch analysierte Daten von Personen die älter sind als {{numberOfYears}} Jahre löschen wollen',
  confirmOverwriteTitle: 'Text wird überschrieben',
  confirmOverwriteText: 'Möchten Sie den gespeicherten Text wirklich mit dem aktuellen Text aus dem Editor überschreiben?',
  confirmOverwriteTextNoText: 'Der Editor enthält aktuell keinen Text, trotzdem überschreiben?',
  successOverwriteText: 'Der Text wurde erfolgreich überschrieben',
  successOverwriteFolder: 'Der Ordner wurde erfolgreich überschrieben',
  successPutNewText: 'Der Text {{name}} wurde erfolgreich gespeichert',
  successPutNewFolder: 'Der Ordner {{name}} wurde erfolgreich gespeichert',
  successEditExistingText: 'Der Text {{name}} wurde erfolgreich bearbeitet',
  successEditExistingFolder: 'Der Ordner {{name}} wurde erfolgreich bearbeitet',
  confirmCloseDialogTitle: 'Editiervorgang nicht gespeichert',
  confirmCloseDialogText: 'Wollen Sie den Dialog wirklich schließen, ohne die Änderungen zu übernehmen?',
  confirmLeaveEditingModeText: 'Wollen Sie den Bearbeitungsmodus wirklich verlassen, ohne die Änderungen zu übernehmen?',
  leave: 'verlassen',
  notOwnText: 'Nicht eigener Text',
  notOwnFolder: 'Nicht Ihr eigener Ordner',
  profileNotCompanyWide: 'Nicht für Firma sichtbar',
  addNewText: 'Neuen Text hinzufügen',
  addFolder: 'Ordner hinzufügen',
  saveText: 'Text speichern',
  searchText: 'Text suchen',
  enterTextName: 'Bitte geben Sie einen Namen für den neuen Text ein',
  removeAnalyzedProfile: 'Analysiertes Profil verwerfen',
  searchVolume: 'Suchvolumen',
  searchCompetition: 'Konkurrenz',
  searchCPC: 'Kosten pro Klick (cpc)',
  SEOResult: 'SEO Ergebnisse',
  pdfCreate: 'PDF wird erstellt',
  noTextsAvailable: 'Keine Texte verfügbar',
  notes: 'Notizen',
  noKeywords: 'Keine verwandten Suchworte gefunden',
  startPageWelcome: '<0>Herzlich Willkommen bei</0> <1></1> <2>SAIA, {{firstName}} {{lastName}}</2>',
  startPageInfo: 'Hier sehen Sie alle Produkte, die für den Account "{{username}}" aktiviert sind.',
  selectAwProfile: 'Profil auswählen',
  startPageAWTI:
    'Verfassen Sie Stellenanzeigen, in dem Ton, die Ihrer Bewerber attraktiv finden. Prüfen Sie, ob Sie einen relevanten Titel gewählt haben.',
  startPageCM:
    'Analysieren Sie Ihre bestehenden Teams auf Diversität und Homogenität. Finden Sie heraus, welche potenziellen Kandidaten am Besten in dieses Team passen.',
  startPageBAR: 'Nocht nichts.',
  startPageBS: 'Optimieren Sie Ihre Marketingtexte nach den BrandSync-Kategorien.',
  startPageSegmentation: 'Analysieren Sie die Verteilung Ihrer Kunden',
  startPageCI:
    'Analysieren Sie eingehende Nachrichten Ihrer Kunden und erhalten ein individuelles Kundenprofil. Verfassen Sie Antworten, die zum persönlichen Kundenprofil passen.',
  startPageAWB: 'Verfassen Sie Webseitentexte, Blogbeiträge, Broschüren und Verkaufsmappen auf Basis einer Buyer Persona.',
  startPageAWC:
    'Verfassen Sie Newsletter, Erstansprachen in der Neukundengewinnung für die unterschiedlichen Direct-Messaging Kanäle auf Basis einer Buyer Persona.',
  startPageSurvey:
    'Erfassen Sie grundlegende implizite und explizite Motive. Bekommen Sie Handlungsempfehlungen im Umgang mit Ihren Motiv-Ausprägungen in der täglichen Arbeit.',
  startPageProfiles: 'Erstellen und verwalten von Sollprofilen.',
  startPageAdmin: 'Verwaltung von Benutzerrechten, Buchungen, etc.',
  questionnairePagination: 'Seite {{page}} von {{pagesCount}}',
  infoTextCi:
    '- Neue Kontakte können über den + Button hinzugefügt werden.\n- Kontakte können gesucht und sortiert werden.\n- Kontakte können bearbeitet oder gelöscht werden.\n- Durch Anklicken der Kontakt-Karte wird auf die jeweilige Einzelanalyse-Seite für mehr DetailsView weitergeleitet.\n- Durch Klicken von "{{reply}}" wird zum Augmented Writer weitergeleitet, in dem das aktuelle Kontakt-Profil geladen ist.\n- Durch Klicken auf "{{extendProfile}}" können weitere Texte entweder direkt oder durch eine .eml-Datei dem Kontakt-Profil hinzugefügt werden.',
  infoTextAw:
    '- Es können direkt im Augmented Writer neue Profile erstellt werden.\n- Bereits erstellte Profile können über Autovervollständigung gesucht und in den AW geladen werden.\n- Ist ein Profil ausgewählt und Text im Editor, kann die Analyse über den Button gestartet werden.\n- Analysierter Text aus dem Editor kann zum Kopieren von den Hervorherbungen befreit werden.\n- Texte können geladen, gespeichert, überschrieben oder gelöscht werden.\n- Je Höher der Score, desto besser passt der Text aus dem Editor zum ausgewählten Profil.\n- Diagramm-Felder filtern Hervorherbungen beim Hovern.\n- Mehr Informationen zur Ausprägung durch Klicken des jeweiligen Diagramm-Feldes.\n- Vorschläge sind nach Wichtigkeit sortiert.\n- Vorschläge mit mehr Informationen sind gekennzeichnet und damit klickbar.\n- Hervorhebungen geben beim Hovern zusätzliche Informationen.\n- Eine schwarze Umrandung weist auf einen Ersetzungs-Vorschlag hin',
  infoTextCm:
    '- Stellenangebote können über den Plus-Button erstellt werden.\n- Stellenangeboten kann beim Erstellen ein Team, ein Profil oder keines von beiden hinzugefügt werden.\n- Stellenangebote können gelöscht, gesucht und alphabetisch nach Namen sortiert werden.\n- Teams können im Team Dialog erstellt und verwaltet werden.\n- Teams können gelöscht, gesucht und alphabetisch sortiert werden.\n- Der Team Name ist auch im Nachhinein änderbar.\n- Teammitglieder können einem Team hinzugefügt werden, man kann sie auch wieder davon entfernen.\n- Der PDF Umfrage Report eines Mitarbeiters steht zum Download verfügbar.\n- Die Detailseite eines Stellenangebotes bietet Informationen zum aktuell hinzugefügten Team und dessen Bewerbern.\n- Teams und Job Profile eines Stellenabgebotes sind auch im Nachhinein änderbar.\n- Bewerber können entweder über Umfragen oder über Freitext und PDF Uploads der Bewerbungsschreiben hinzugefügt werden.\n- Wurden Bewerber per Umfrage hinzugefügt können keine Bewerber mehr über Freitex und PDF hinzugefügt werden und umgekehrt.\n- Von Bewerbern, die über eine Umfrage hinzugefügt wurden, kann der Umfragestatus eingesehen werden, und falls abgeschlossen, ist der PDF Umfrage Report zum Download verfügbar.\n- Bewerber können von dem Stellenangebot entfernt werden.\n- Umfragen können erneut an den Empfänger gesendet werden.\n- Der Umfrage Link kann in die Zwischenablage kopiert werden.\n- Das Team Diagramm zeigt die Aufstellung des aktuell ausgewählten Teams an und gibt Empfehlungen, welche Motivausprägung am besten in dem Stellenausschreiben addressiert werden soll.\n- Das ausgewählte Profil wird bei Klick auf den Button "{{button}}" in den Augmented Writer Talent Intelligence eingebunden.\n- Falls bereits ein Text für das Stellenangebot gespeichert wurde, wird auch dieser in den Augmented Writer Talent Intelligence eingebunden.',
  done: 'fertig',
  addProfile: 'Profil hinzufügen',
  editProfile: 'Profil bearbeiten',
  deleteProfile: 'Profil löschen',
  copyApiKey: 'Kopiere API Key ID',
  awManualLink: 'Anleitung_SAIA_Augmented_Writing.pdf',
  customer_intelligence: 'Communication-Analysis for Customer',
  customer_segmentation: 'Segmentation-Analysis for Customer',
  augmented_writing_customer: 'Augmented Writing for Customer',
  augmented_writing_talent_intelligence: 'Augmented Writing for Talent',
  competence_monitor: 'Team-Match for Talent',
  augmented_writing_brand: 'Augmented Writing for Brand',
  augmented_writing_brand_sync: 'Augmented Writing Brand Sync',
  brand_awareness_radar: 'Brand Awareness Radar',
  seo: 'SEO',
  api: 'API',
  support: 'Support',
  administration: 'Administration',
  adminSectionOverview: 'Übersicht',
  adminNavMonitoring: 'Monitoring',
  adminNavQueue: 'Warteschlange',
  adminNavLinkedinSession24h: 'LinkedIn-Session (24h)',
  adminNavCampaignTimeline: 'Kampagne–Kontakt-Timeline',
  adminNavFeedbackTickets: 'Nutzer-Feedback',
  adminBackToOverview: 'Zurück zur Administrationsübersicht',
  startPageSEO: '',
  startPageAPI: '',
  removeHeader: 'Bitte entfernen Sie den Header aus der CSV-Datei und laden Sie ihn erneut hoch',
  surveyDelete: 'Analyse Löschen',
  surveyDeleteWarning: 'Sind Sie sicher, dass Sie {{surveyName}} löschen möchten? Sie werden die dafür berechnete Analyse verlieren.',
  surveyDeleteWarning_plural:
    'Sind Sie sicher, dass Sie {{surveyName}} löschen möchten? Sie werden alle {{count}} dafür berechneten Analysen verlieren.',
  jobOffersPerPage: 'Stellenangebote pro Seite',
  teams: 'Teams',
  team: 'Team',
  cmManualProfile: 'Manuell erstelltes Profil',
  successAddJobOffer: 'Das Stellenangebot "{{tagName}}" wurde erfolgreich hinzugefügt',
  deleteJobOffer: 'Stellenangebot löschen',
  successDeleteJobOffer: 'Stellenangebot gelöscht',
  deleteJobOfferText: 'Sie sind dabei, das Stellenangebot "{{tagName}}" zu löschen',
  pdfReport: 'PDF Report',
  applicants: 'Bewerber',
  addApplicant: 'Bewerber hinzufügen',
  selectVariant: 'Variante auswählen',
  selectVariantText: 'Wählen Sie die Variante, mit der Sie den oder die Bewerber zur Liste hinzufügen möchten',
  survey: 'Motiv\nAnalyse',
  lead: 'LEaD\nEvaluation',
  text: 'Freitext',
  pdf: 'PDF-Datei',
  audio: 'Audio-Datei',
  successAddApplicant: 'Bewerber {{firstname}} {{lastname}} wurde erfolgreich hinzugefügt',
  successAddApplicantSurvey: 'Der Bewerber wurde hinzugefügt',
  successAddApplicantSurvey_plural: 'Es wurden {{count}} Bewerber hinzugefügt',
  motiveForm: 'Motiv-Ausprägung',
  variant: 'Variante',
  selectedProfile: 'Ausgewähltes Profil: {{profile}}',
  writeJobOffer: 'Stellenangebot schreiben',
  amountIndifferent: 'Ein Teammitglied kann keiner der oben stehenden Ausprägungen zugeordnet werden',
  amountIndifferent_plural: '{{count}} Teammitglieder können keiner der oben stehenden Ausprägungen zugeordnet werden',
  newTeam: 'Neues Team',
  teamName: 'Team Name',
  editTeam: 'Team {{teamName}} bearbeiten',
  teamMember: 'Teammitglied',
  changeTeamName: 'Team Namen ändern',
  viewTeam: 'Team ansehen',
  newTeamMember: 'Teammitglieder hinzufügen',
  deleteTeam: 'Team löschen',
  confirmDeleteTeamMember: 'Möchten Sie {{firstname}} {{lastname}} wirklich aus dem Team entfernen?',
  successDeleteTeamMember: 'Teammitglied erfolgreich gelöscht',
  confirmDeleteTeam: 'Möchten Sie das Team {{teamName}} wirklich löschen?',
  successDeleteTeam: 'Das Team {{team}} wurde erfolgreich gelöscht',
  successEditTeam: 'Das Team {{team}} wurde erfolgreich bearbeitet',
  teamManagement: 'Team Verwaltung',
  addMembersToTeam: 'Mitglieder zu Team {{teamName}} hinzufügen',
  searchJobOffer: 'Stellenangebot suchen',
  searchTeam: 'Team suchen',
  viewJobOffer: 'Stellenangebot ansehen',
  instructions: 'Instruktionen',
  newJobOffer: 'Neues Stellenangebot',
  resendSurvey: 'Mail erneut senden',
  noTeamMembersAvailable: 'Keine Teammitglieder verfügbar',
  removeEmployeesFromTeam: 'Mitarbeiter aus dem Team entfernen',
  authGmail: 'Bitte melden Sie sich an, um Ihre Gmail-Anmeldedaten zu speichern',
  jobProfile: 'Job Profil',
  chooseProfileType: 'Wählen Sie den gewünschten Profil Typ',
  confirmDeleteApplicant: 'Möchten Sie den Bewerber wirklich entfernen?',
  applicantSurveysDisabled: 'Es wurden bereits Bewerber per Freitext oder PDF hinzugefügt, daher ist kein Hinzufügen über Umfragen mehr möglich.',
  applicantTextAndPdfDisabled: 'Es wurden bereits Bewerber über Umfragen hinzugefügt, daher ist kein Hinzufügen über Freitext oder PDF mehr möglich.',
  noTeamAdded: 'Noch kein Team hinzugefügt.',
  successApplicantRemoved: 'Bewerber wurde erfolgreich entfernt',
  recommendations: 'Empfehlungen',
  teamProfileSwitch: 'Team Profile',
  noApplicantsAvailable: 'Keine Bewerber verfügbar',
  share: 'Teilen',
  successResendSurvey: 'Die Umfrage wurde erneut an {{firstname}} {{lastname}} gesendet',
  amountTeamMembers: 'Anzahl Teammitglieder',
  surveysPending: 'Umfragen offen',
  showOnlyWonContacts: 'Zeige nur eigene Kontakte',
  notOwnGlobalContactTooltip: 'Der Kontakt wurde für Sie freigegeben und kann nur vom Ersteller bearbeitet oder gelöscht werden.',
  globalContactTooltip: 'Sie haben diesen Kontakt für Ihr Unternehmen freigegeben.',
  shareWithCompany: 'Mit Ihrem Unternehmen teilen',
  saveJobOfferToCm: 'Stellenanzeige speichern',
  searchSpace: 'Suchraum',
  moreInfoSEOResultsTitle: 'Legende',
  seoInfoDialogSearchVolumeContent:
    'Das Suchvolumen ist die Anzahl der Suchvorgänge pro Monat, die für ein bestimmtes Keyword oder einen bestimmten Begriff durchgeführt werden.',
  seoInfoDialogCompetitionContent:
    'Gibt an, wie schwierig es wäre, SEO auf einer neuen Webseite zu verwenden, um die Webseiten, die derzeit auf Suchmaschinen-Ergebnisseiten einen hohen Rang einnehmen, hypothetisch zu übertreffen. Ein Wert von 100% bedeutet z. B., dass zu 100% mindestens ein Konkurrent auf einem höheren Rang ist.',
  seoInfoDialogCpcContent:
    'Cost-per-Click (CPC) ist ein Begriff aus der bezahlten Werbung, bei dem ein Werbetreibender einem Publisher für jeden Klick auf eine Anzeige die Kosten zahlt. CPC wird verwendet, um die Kosten für die Schaltung von Nutzeranzeigen in Suchmaschinen, im Google Display-Netzwerk für AdWords, auf Social Media-Plattformen und bei anderen Publishern zu ermitteln.',
  timeToWrite: 'Zeit zum Schreiben',
  existingMembers: 'Mitglied aus bestehendem Team kopieren/verschieben',
  selectVariantTextTeamDialog: 'Wählen Sie die Variante, mit der Sie den oder die Teammitglieder hinzufügen möchten',
  intoTeam: 'in das Team "{{team}}"',
  fromTeam: 'Von Team',
  move: 'verschieben',
  copy: 'kopieren',
  addWithSurvey: 'Neues Mitglied über Umfrage zum Team hinzufügen',
  addMailThreadTexts: 'Neue Emails aus dem Verlauf zu Profil hinzufügen',
  noContactOutlook: 'Bitte legen Sie einen Empfänger für die Email fest und laden Sie neu',
  noProfileOutlook1: 'Kein Profil für diesen Kontakt gefunden.',
  noProfileOutlook2: 'Analysiere zuerst eingegangene Emails von dieser Adresse oder wähle ein bereits vorhandenes Profil aus.',
  loadTextFromOutlook: 'Text aus Outlook Editor importieren',
  sendTextToOutlook: 'Text an Outlook Editor zurück senden',
  ciApikey: 'CI API-Schlüssel',
  awApikey: 'AW API-Schlüssel',
  enterApiKeys: 'Bitte API-Schlüssel eingeben',
  ciKeyNotValid: 'CI API-Schlüssel ungültig',
  awKeyNotValid: 'AW API-Schlüssel ungültig',
  noTextFoundToAnalyze: 'Keine Textinhalte vom gewählten Absender zur Analyse im geöffneten Mail-Verlauf gefunden.',
  allTextsAnalyzed: 'Alle Emails aus diesem Verlauf wurden bereits analysiert',
  hashError: 'Fehler beim Verarbeiten des Absenders',
  mailHandlerError: 'Fehler beim Verarbeiten des Mailverlaufs',
  customerTagCreationError: 'Fehler beim Erstellen des Profils',
  mailTextAddError: 'Fehler beim Hinzufügen des Textes',
  warningNoEmailSent: 'Es wurde keine automatische Email versandt',
  notSendEmail: 'Keine Email versenden',
  achieveResults: 'Ergebnisse\nerzielen',
  manageChanges: 'Veränderungen\nmanagen',
  shaping: 'Vision &\nStrategie gestalten',
  competencies: 'Kompetenzen',
  creativePersonality: 'Als gestaltende\nPersönlichkeit wirken',
  develop: 'Mitarbeitende &\nTeams entwickeln',
  loadingSentences: 'Lädt Sätze...',
  improvesScore: 'Verbessert den Score',
  scoreIndependent: 'Score unabhängig',
  triggerAutocompleteOneLanguage: 'Autovervollständigung für Texte der Sprache: {{language}}',
  triggerAutocompleteMultipleLanguages: 'Autovervollständigung für Texte der Sprachen: {{language1}} und {{language2}}',
  sentenceGenerationKeys: 'mit UMSCHALT + LEERTASTE',
  cancelSuggestion: 'abbrechen mit ESC',
  successAddApiKey: 'API-Schlüssel erfolgreich hinzugefügt',
  generationLanguageNotSupported:
    'Wir arbeiten daran die Autovervollständigung auch für andere Textsprachen zu aktivieren. Momentan wird nur Englisch unterstützt',
  emptyInputText: 'Bitte geben Sie Text ein um diese Funktion zu nutzen',
  noSentencesGenerated: 'Keine passenden Sätze gefunden',
  notRecognizedContent: 'Der analysierte Text enthält Textpassagen, welche keiner der unterstützten Sprachen zugeordnet werden können!',
  analysisSelected: 'Eine Analyse ausgewählt',
  analysisSelected_plural: '{{count}} Analysen ausgewählt',
  confirmDeleteSurveys: 'Sind Sie sicher, dass Sie die ausgewählte Analyse löschen möchten?',
  confirmDeleteSurveys_plural: 'Sind Sie sicher, dass Sie alle {{count}} ausgewählten Analysen löschen möchten?',
  enterPlaceholder: 'Platzhalter eingeben',
  amount: 'Menge',
  username: 'Nutzername',
  roleInCompany: 'Rolle im Unternehmen',
  branch: 'Branche',
  branches: 'Branchen',
  roles: 'Rollen',
  branchOfCompany: 'Branche des Unternehmens',
  editName: 'Name bearbeiten',
  saveName: 'Name speichern',
  addRole: 'Rolle hinzufügen',
  addBranch: 'Branche hinzufügen',
  successAddNewTag: 'Neuer Tag {{tag}} wurde erfolgreich hinzugefügt!',
  errorAddNewTag: 'Es ist ein Fehler beim Hinzufügen des Tags aufgetreten!',
  successDeleteTag: 'Der Tag {{tag}} wurde erfolgreich gelöscht!',
  confirmDeleteTag: 'Sind Sie sicher, dass Sie den Tag {{tag}} wirklich löschen möchten?',
  errorDeleteTag: 'Es ist ein Fehler beim Löschen des Tags aufgetreten!',
  successAddNewBranch: 'Neue Branche {{branch}} wurde erfolgreich hinzugefügt!',
  errorAddNewBranch: 'Es ist ein Fehler beim Hinzufügen der Branche aufgetreten!',
  successEditNewTag: 'Der Tag wurde erfolgreich bearbeitet!',
  errorEditNewTag: 'Es ist ein Fehler beim Bearbeiten des Tags aufgetreten!',
  editTag: 'Tag bearbeiten',
  searchFor: '{{item}} suchen',
  successDeleteBranch: 'Die Branche {{branch}} wurde erfolgreich gelöscht!',
  errorDeleteBranch: 'Es ist ein Fehler beim Löschen der Branche aufgetreten!',
  successEditNewBranch: 'Die Branche wurde erfolgreich bearbeitet!',
  errorEditNewBranch: 'Es ist ein Fehler beim Bearbeiten der Branche aufgetreten!',
  editBranch: 'Branche bearbeiten',
  confirmDeleteBranch: 'Sind Sie sicher, dass Sie die Branche {{branch}} wirklich löschen möchten?',
  whatHappenToEmails: 'Was möchtest Du mit der/den bereits im Profil vorhandenen E-Mail(s) machen?',
  keepThem: 'behalten',
  replaceThem: 'ersetzen',
  phaseName: 'Name der Phase',
  companyAdministration: 'Unternehmensverwaltung',
  customerIntelligenceStatistics: 'Customer Intelligence Statistics',
  editRolesAndBranches: 'Rollen & Branchen bearbeiten',
  emailAlreadyExists: 'Die E-Mail wird bereits in einem anderen Konto verwendet',
  triggerAnalysis: 'Starten Sie die Analyse',
  analysisKeys: 'mit ALT + ENTER',
  tooMuchContent: 'Um ein zuverlässiges Ergebnis zu erhalten, sollten die einzelnen Textproben maximal {{number}} Worte enthalten!',
  reduceWords: 'Verringern Sie die Anzahl der Worte im Text, um die Analyse zu starten',
  wordCount: '{{words}} Worte',
  licenses: 'Lizenzen',
  passChanged: 'Passwort geändert',
  makeSurePasswordCorrect: 'Stelle bitte sicher, dass das eingegebene Passwort korrekt ist',
  infoUpdated: 'Ihre Daten wurden aktualisiert',
  'user(s)': 'Nutzer',
  expiresOn: 'Läuft aus am',
  trial: 'Versuch',
  licenseRemoveConfirmation: 'Lizenz löschen',
  licenseWillNoLongerBeAvailable: 'Soll die Lizenz für <strong>{{license}}</strong> mit <strong>{{count}}</strong> Nutzern wirklich gelöscht werden?\n\nDer Vorgang ist nicht umkehrbar und sie steht danach nicht mehr zur Verfügung.',
  changeActiveLicenseConfirmationText: 'Dadurch wird der Lizenzstatus geändert. In der Anwendung können nur aktive Lizenzen verwendet werden.',
  newLicense: 'Neue Lizenz',
  expDate: 'Ablaufdatum',
  isTrial: 'Testlizenz',
  apiKeyCopied: 'API-Schlüssel kopiert',
  noCompany: 'Keine Firma',
  editLicense: 'Lizenz bearbeiten',
  addExistingUser: 'Bestehenden Nutzer hinzufügen',
  addNewUser: 'Zusätzlichen Nutzer hinzufügen',
  noAnalysisPossible: 'Wählen Sie ein Profil aus und schreiben Sie Text in den Editor',
  noData: 'Zu Deiner Auswahl gibt es noch keine Daten',
  noProfile: 'Wähle ein Profil aus',
  noText: 'Schreibe einen Text in den Editor',
  fontText: 'Schriftauswahl',
  boldText: 'Fett',
  italicText: 'Kursiv',
  underlineText: 'Unterstrichen',
  numberedList: 'Nummerierte Liste',
  bulletList: 'Aufzählung',
  indentForward: 'Einrückung vorwärts',
  indentBackward: 'Einrückung rückwärts',
  diversity: 'Gendervielfalt',
  yourCustomer: 'Dein Kunde',
  performanceProfitOriented: 'leistungsorientiert und gewinnorientiert',
  are: 'bist',
  you: 'Du',
  relationshipQuality: 'Ihre Beziehungsqualität ist',
  relationshipTendency: 'Die Tendenz Ihrer Beziehungsqualität ist',
  relationshipQualityStrong: 'Sehr gut, Beziehungen über 80% Imitation haben bis zu 25,7% höhere Abschlusswahrscheinlichkeit.',
  relationshipQualityOK:
    'Lassen Sie sich besser auf das Gegenüber ein. Mit einem Score über 80% hätten Sie bis zu 25,7% höhere Abschlusswahrscheinlichkeit.',
  relationshipQualityBad:
    'Weniger als 60% Imitation verringert Ihre Abschlusswahrscheinlichkeit dramatisch. Gehen Sie besser auf Ihr Gegenüber ein und erhöhen damit Ihre Abschlusswahrscheinlichkeit signifikant.',
  relationshipTendencyIncrease: 'Sehr schön, Ihr Gegenüber baut Nähe zu Ihnen auf. Damit erhöhen Sie Ihre Abschlusswahrscheinlichkeit.',
  relationshipTendencyDecrease: 'Ihr Gegenüber geht auf Distanz zu Ihnen. Steuern Sie mit der richtigen Wortwahl dagegen.',
  averageImitationScore: 'Durchschnitt – Content-Engagement-Score',
  averageWorkTime: 'Durchschnitt – Bearbeitungszeit',
  averageImitationImprovements: 'Durchschnitt – Verbesserung Content-Engagement-Score',
  genderScoreImprovement: 'Durchschnitt - Gender-Diversity-Score - Verbesserung',
  averageGenderScore: 'Durchschnitt - Gender-Diversity-Score',
  imitationAnalytics: 'Analytik - CES/GES',
  category: 'Kategorie',
  relationshipTendencyNeutral: 'Es gibt keine Veränderung in Ihrer Beziehung zum Gegenüber.',
  noRelationshipQuality: 'Wir haben noch keinen Gesprächsverlauf für die Analyse der Beziehungsqualität',
  clickHereToImport: 'Bitte hier klicken um Text zu holen.',
  tooInformal: 'Zu informell',
  tooFormal: 'Zu formell',
  showAll: 'Alle anzeigen',
  hintsForSpeech: 'Tipps für die Ansprache',
  emailTemplates: 'E-Mail-Vorlagen',
  pitchViaEmail: 'Pitch via Mail',
  invitationCall: 'Einladung Call',
  mailAfterCall: 'Mail nach Call',
  offerMail: 'Angebotsmail',
  followUpAfterOffer: 'Follow Up nach Angebot',
  thankYouForAcceptance: 'Dankesmail für Annahme',
  customizeTemplates: 'Templates anpassen',
  editTemplates: 'Templates\nverwalten',
  selectAssessment: 'Wähle einen Typ aus',
  emailTemplateName: 'Name der E-Mail-Vorlage',
  selectTemplateToCustomize: 'Wähle die Phase aus, bei der du das Template verändern möchtest:',
  orCreatePhase: 'Oder erstelle eine neue Phase',
  createNewPhase: 'Neue Phase erstellen',
  editOrCreatePhase: 'Phase bearbeiten oder erstellen',
  selectTypeAndCustomizeText: 'Typ auswählen und Text anpassen',
  selectTypeOfCustomer: 'Wähle den Kundentyp aus, auf den du das Template anpassen möchtest',
  yourTemplateIsAvailable: 'Dein neues Template steht ab Sofort zur Verfügung',
  editAnotherTemplate: 'Weiteres Template bearbeiten',
  before: 'Vor',
  after: 'Nach',
  firstPosition: 'Erste Position',
  editText: 'Text bearbeiten',
  templates: 'Templates',
  loadTemplate: 'Template laden',
  order: 'Reihenfolge',
  hintForSpeechHeadline1: '„Welches Denken und Handeln prägt Ihr Gegenüber?“',
  hintForSpeechHeadline2: '„Beantworten Sie diese Fragen für Ihr Gegenüber und Sie haben schon so gut wie gewonnen:“',
  hintForSpeechHeadline3: '„Starke Wörter für mehr Erfolg“',
  idealFormality: 'Formalität ideal getroffen',
  profileSelection: 'Profil Wählen',
  profileChange: 'Profil wechseln',
  welcomeTo: 'Willkommen bei',
  selectExistingProfile: 'Bestehendes Profil wählen',
  newProfileCreation: 'Neues Profil erstellen',
  newProfileGroupCreation: 'Zielgruppe erstellen',
  onlyOwn: 'Nur eigene Kontakte sichtbar',
  welcomeTo100w: 'Willkommen bei 100W',
  textgenre: 'Textgenre',
  websiteText: 'Websitetext',
  augmentedWriting: 'Augmented Writing',
  outlookPlugin: 'Outlook Plugin',
  days: 'Tage',
  chooseProfile: 'Profile wählen',
  addData: 'Daten hinzufügen',
  manageTexts: 'Texte verwalten',
  date: 'Datum',
  words: 'Wörter',
  score: 'Score',
  profileTextsAppear: 'Texte des Kontaktes wirken',
  targetGroupTextsAppear: 'Texte der Zielgruppe wirken',
  outlookFooterDialogTitleAw: '100W Analyse',
  outlookFooterTextAw: '100W Analyse',
  outlookFooterText: 'Mit 100W antworten',
  outlookFooterDialogTitle: 'Wie mit 100W antworten?',
  outlookFooterDialogContent:
    'Um das 100W Plugin auch bei der Antwort auf eine Mail verwenden zu können, klicken Sie im Outlook-Tool auf Antworten. Klicken Sie dann wieder auf das SAIA Logo.',
  changesTakeTime: 'Bitte beachte, dass Änderungen in der Lizenzbuchung einige Minuten benötigen, bis sie wirksam werden.',
  changingToSmallerPlan: 'Der Wechsel zu einem kleineren Plan kann zu Datenverlusten führen, wenn die aktuellen Daten das neue Lizenzkontingent überschreiten.',
  analyseTextFirst: 'Analysieren Sie zuerst einen Text im Textfeld',
  userOrEmail: 'Nutzer oder E-Mail-Adresse',
  orSelectProfile: 'oder wählen Sie ein bereits vorhandenes Profil aus',
  useSelectedProfile: 'Ausgewähltes Profil nutzen',
  inviteUser: 'Nutzer einladen',
  createBranch: 'Branche erstellen',
  updateBranch: 'Branche aktualisieren',
  createRole: 'Rolle erstellen',
  updateRole: 'Rolle aktualisieren',
  branchRemoveConfirmation: 'Möchten Sie diese Branche wirklich entfernen?',
  branchWillNoLongerBeAvailable: 'Diese Aktion ist irreversibel. Die Branche "{{branch}}" ist danach nicht mehr verfügbar.',
  tagRemoveConfirmation: 'Möchten Sie diesen Tag wirklich entfernen?',
  tagWillNoLongerBeAvailable: 'Diese Aktion ist irreversibel. Der Tag "{{tag}}" ist danach nicht mehr verfügbar.',
  mergeProfiles: 'Profile zusammenfügen',
  reallyWantMerge: 'Möchten Sie die folgenden Profile wirklich zusammenfügen?',
  processNotReversible: 'Dieser Vorgang ist nicht umkehrbar, die ursprünglichen Profile sind danach nicht mehr verfügbar.',
  enterNameMergedProfile: 'Geben Sie einen Namen für das zusammengefügte Profil an',
  mergeSuccess: 'Die Profile wurden erfolgreich zusammengefügt.',
  mergeError: 'Es ist ein Fehler beim Zusammenfügen der Profile aufgetreten!',
  rolesAndBranches: 'Rollen & Branchen',
  improvesOverallScore: 'Das Entfernen dieses Wortes verbessert den Gesamtscore.',
  addTag: 'Tag hinzufügen',
  targetGroupProfile: 'Zielgruppenprofil',
  expression: 'Ausprägung in %',
  loadingChart: 'Lade Diagramm...',
  noTextAnalyzedYet: 'Es wurde noch kein Text analysiert',
  selectTags: 'Tags Auswählen',
  addEmails: 'Emails hinzufügen',
  firstAddTextToProfile: '* Fügen Sie zuerst einen Text zum Profil hinzu',
  createProfileManually: 'Profil manuell einstellen',
  understood: 'Verstanden, weiter',
  manualProfileWarning:
    'Es ist besser, Texte einzufügen, damit die AI arbeiten kann. Es wird empfohlen, dass nur erfahrene Nutzer Profile manuell einstellen.',
  tags: 'Tags',
  tag: 'Tag',
  successProfileEdit: 'Das Profil wurde erfolgreich bearbeitet',
  successProfileAdd: 'Das Profil wurde erfolgreich hinzugefügt',
  successTagAdd: 'Der Tag wurde erfolgreich hinzugefügt',
  successAddEmails: 'Die E-Mail(s) wurde(n) erfolgreich hinzugefügt.',
  errorAddEmails: 'Beim Hinzufügen der E-Mail(s) ist ein Fehler aufgetreten!',
  wordsAnalyzedForProfile: 'Für dieses Profil wurden durchschnittlich <strong>{{amount}} Wörter</strong> analysiert.',
  pleaseSelect: 'Bitte auswählen',
  addText: 'Text hier einfügen',
  motivationAnalysis: 'Motivationsanalyse',
  deleteAnalysis: 'Analyse löschen',
  confirmDeleteAnalysis:
    'Sind Sie sicher, dass Sie die Analyse wirklich löschen möchten? Dieser Vorgang ist nicht umkehrbar, die Analyse ist danach nicht mehr verfügbar.',
  writeAText: 'Schreibe einen Text…',
  selectOperatingVersion: 'Betriebsversion wählen',
  outlookManualIntroduction:
    'Das SAIA Outlook-Plugin kann auf verschiedene Arten installiert werden. Dies ist abhängig von der Anzahl der Nutzer und deren Berechtigungen. Nutzer können, wenn die internen Berechtigungen dies erlauben, das Plugin jeweils selbst auf ihrem eigenen System installieren. Alternativ dazu kann das Plugin zentral von einem Administrator des Mailservers für alle oder eine Gruppe von Nutzern im Unternehmen installiert werden.',
  pdfManual: 'PDF Anleitung',
  yourPersonalApiKey: 'Ihr persönlicher API Key: ',
  download: 'Herunterladen',
  downloadAddin: 'Download Add-in',
  downloadRuntime: 'Download Runtime',
  authenticateAddin: 'Hier klicken zum Authentifizieren des Add-ins.',
  installationO365FirstPart: '2. Laden Sie die Datei herunter. Speichern Sie diese ab.\nFalls Sie den Safari-Browser benutzen:\n',
  installationO365ListItemOne:
    'Gehen Sie in die Einstellungen von Safari, wählen Sie unter „Websites" in der linken Leiste „Pop-Up-Fenster" und wählen Sie „erlauben bei outlook.office.com in der Mitte des Fensters.',
  installationO365ListItemTwo:
    'Gehen Sie in die Outlook-Webanwendung und loggen Sie sich aus Outlook aus. Schließen Sie danach auch Safari vollständig.',
  installationO365SecondPart:
    '3. Öffnen Sie bitte Ihr Outlook und klicken Sie auf "Add-Ins abrufen".\n' +
    '4. Starten Sie Ihre Outlook-Webanwendung und wählen Sie bitte "Meine Add-ins auswählen", anschließend auf "+ Benutzerdefiniertes Add-in hinzufügen" und "aus Datei hinzufügen" - Bitte wählen Sie hier die heruntergeladene Manifest-XML-Datei aus.\n' +
    '5. Anschließend installiert sich das Add-in automatisch.\n' +
    '6. Schließen Sie bitte einmal Outlook und starten es danach neu.\n' +
    '7. Sie können das Add-in nun im Reiter unter "SAIA" öffnen.\n' +
    '8. Melden Sie sich dort mit Ihrem 100W Account an.',
  installationVsto:
    '1. Laden Sie die Datei herunter. Speichern Sie diese ab.\n' +
    '2. Stellen Sie sicher, dass Outlook geschlossen ist.\n' +
    '3. Bitte führen Sie die heruntergeladene Datei 100W-Outlook-Add-In.exe aus.\n' +
    '4. Anschließend installiert sich das Add-In automatisch.\n' +
    '5. Starten Sie Outlook.\n' +
    '6. Sie können das Add-in nun im Reiter unter "SAIA" öffnen.\n' +
    '7. Geben Sie dort bitte Ihren persönlichen API-Key ein.',
  manualProfile: 'Manuelles Profil',
  outlookVersion: 'Outlook Version',
  loadingProfiles: 'lade Profile...',
  searchForProfile: 'Nach Profil suchen',
  optional: 'optional',
  newVersionAvailableTitle: 'Neue Version verfügbar',
  newVersionAvailableText: 'Laden Sie die neueste Version des Add-ins herunter.',
  hide: 'ausblenden',
  qualityAnalytics: 'Analytics - Beziehungsqualität',
  lastSevenDays: 'Letze 7-Tage',
  lastMonth: 'Letzter Monat',
  lastYear: 'Letztes Jahr',
  selectDurationForAnalysis: 'Wählen Sie einen Zeitraum für Ihre Analysen aus',
  totalScore: 'Score Gesamt',
  tendency: 'Tendenz',
  mostCommon: 'Häufigstes Profil',
  good: 'GUT',
  okUpper: 'OK',
  bad: 'UNTERDURCHSCHNITTLICH',
  upward: 'STEIGEND',
  same: 'UNVERÄNDERT',
  downward: 'SINKEND',
  all: 'Alle',
  sessionExpired1: 'Die Sitzung ist abgelaufen',
  sessionExpired2: 'Bitte melde dich erneut an.',
  subscription: 'Abonnement',
  services: 'Leistungen',
  forSmallTeams: 'Für kleine Teams',
  forMediumTeams: 'Für mittlere Teams',
  forLargeTeams: 'Für große Teams',
  amountUsers: '{{amount}} Nutzer',
  paymentOutlookDescription1: 'Analyse der Bedürfnisse von Kunden / Kandidaten',
  paymentOutlookDescription2: 'Analyse der aktuellen Beziehung zum Kunden / Kandidaten',
  paymentOutlookDescription3: 'Anpassung eigener Emails an die Bedürfnisse des Kunden / Kandidaten',
  profileManagement: 'Profilverwaltung',
  paymentProfileManagementDescription1: 'Bilden Sie automatische Zielgruppen von den analysierten Kunden',
  paymentProfileManagementDescription2: 'Bilden Sie automatische Zielgruppen aus gut performanden Anschreibetexten',
  paymentProfileManagementDescription3: 'Bilden Sie Zielgruppen auf Basis Ihrer eigenen Personas',
  paymentAugmentedWriterDescription1: 'Optimierung von Mailings und Social Media Nachrichten auf die Bedürfnisse der Zielgruppe',
  paymentAugmentedWriterDescription2: 'Optimierung von Stellenanzeigen / Webseitentexten auf die Bedürfnisse der Zielgruppe',
  amountOfRequests: 'Anzahl Requests',
  paymentPeriod: 'Zahlungsintervall',
  paymentUsers: 'Nutzer',
  unlimited: 'unbeschränkt',
  yearly: '1 Jahr',
  monthly: '1 Monat',
  priceYearly: 'Preis bei jährlicher Abrechnung',
  priceMonthly: 'Preis bei monatlicher Abrechnung',
  test: 'Test',
  buyNow: 'Jetzt kaufen',
  preregisterNow: 'Jetzt vorregistrieren',
  specialPlanContactIntro: 'Du brauchst einen speziellen Plan für dich oder dein Unternehmen? Melde dich gerne direkt bei uns:',
  modificationDate: 'Änderungsdatum',
  and: 'und',
  or: 'oder',
  significanceTest: `
    Bedeutungstest.

    Ihre Auswahl ist noch nicht signifikant.

    Fügen Sie zwischen {{ from }} - {{ to }} weitere Texte hinzu, um Bedeutung zu erreichen .`,
  significanceExample1: 'Beispiele:',
  significanceExample2: '"TAG 1" UND "TAG 2": Es werden nur Daten gefiltert, die beide Tags aufweisen. ',
  significanceExample3:
    'Beispiel: Filterung nach Vertriebsleitern in einer Region. „Vertriebsleiter UND Deutschland" gibt alle Vertriebsleiter aus Deutschland zurück.',
  significanceExample4: '"TAG 1" ODER "TAG 2": Daten filtern, die entweder das eine oder das andere Tag haben.',
  significanceExample5:
    'Beispiel: Filterung nach Vertriebsleitern und Marketingleitern. "Vertriebsleiter ODER Marketingleiter" gibt alle Vertriebs- und Marketingleiter zurück.',
  significanceExample6: '"TAG 1 UND TAG 2 ODER TAG 3 UND TAG 4".',
  significanceExample7: 'Filtere Daten, die entweder TAG 1 und TAG 2 oder TAG 3 und TAG 4 aufweisen.',
  significanceExample8:
    'Beispiel: Filterung nach Vertriebs- und Marketingleitern aus Deutschland. "Vertriebsleiter UND Deutschland ODER Marketingleiter UND Deutschland" gibt alle Vertriebs- und Marketingleiter aus. Deutschland.',
  marketingExample:
    'Hallo lieber Nutzer,\n' +
    'wir freuen uns über Dein Interesse zu präziser emotionalisierter Kommunikation. Dieser Text ist bereits im Editor gespeichert, um Dir die einzelnen Funktionen näher zu bringen.\n' +
    'Du kannst diesen natürlich gerne direkt mit einem eigenen Text Deiner Landingpage ersetzen.\n' +
    'Folgende Features bietet der Augmented Writer:\n' +
    '- Aufbauend auf der Auswahl Deiner Zielgruppe analysiert die SAIA im Hintergrund, wie gut Du den aktuellen Ton dieser Zielgruppe triffst. Je höher der Score auf der rechten Seite ist, desto präziser triffst Du den Ton. Ziel ist es dabei einen möglichst hohen Score zu erreichen.\n' +
    '- Um Dir die Arbeit zu erleichtern, bietet Dir der Augmented Writer „blau unterstrichene" Vorschläge an. Die Dicke des Unterstrichs gibt an, welche Stärke der Vorschlag hat. Fokussiere Dich zuerst auf die dickeren Vorschläge und klicke danach auf die dünneren.\n' +
    '- Zusätzlich dazu bietet Dir unser Augmented Writing noch Rechtschreibverbsserungen an. Diese findest Du mit einer „grau unterstrichelten Linie".\n' +
    '- Falls Du alleine durch die Vorschläge keinen hohen Score erreichst, was die Ausnahme sein sollte, bieten wir Dir zusätzlich noch Listen mit erfolgsversprechenden Worten an. Diese findest du auf der rechten Seite bei den Empfehlungen. Baue diese in Deinen Text ein und erziele damit eine bessere Wirkung bei Deiner Zielgruppe.\n' +
    'Aktuell ist das Textgenre {Website} ausgewählt. SAIA ist auf verschiedene Kommunikationskanäle geeicht. Du findest diese unter der Auswahl des Textgenres. Dadurch stellen wir einen noch besseren Fit zur Tonalität Deiner Zielgruppe wieder. Beispielsweise für Newsletter, Outreach oder eben Websiten.\n' +
    'Und nun viel Spaß beim Optimieren.' +
    'Tausche diesen Text gerne mit einem anderen Text Deiner Wahl aus dem spezifischen Genre aus.',
  hrExample:
    'Hallo lieber Nutzer,\n' +
    'wir freuen uns über Dein Interesse zu präziser emotionalisierter Kommunikation. Dieser Text ist bereits im Editor gespeichert, um Dir die einzelnen Funktionen näher zu bringen.\n' +
    'Du kannst diesen natürlich gerne direkt mit einer eigenen Stellenanzeige ersetzen.\n' +
    'Folgende Features bietet der Augmented Writer:\n' +
    '- Aufbauend auf der Auswahl Deiner Zielgruppe analysiert die SAIA im Hintergrund, wie gut Du den aktuellen Ton dieser Zielgruppe triffst. Je höher der Score auf der rechten Seite ist, desto präziser triffst Du den Ton. Ziel ist es dabei einen möglichst hohen Score zu erreichen.\n' +
    '- Um Dir die Arbeit zu erleichtern, bietet Dir der Augmented Writer „blau unterstrichene Vorschläge an. Die Dicke des Unterstrichs gibt an, welche Stärke der Vorschlag hat. Fokussiere Dich zuerst auf die dickeren Vorschläge und klicke danach auf die dünneren.\n' +
    '- Zusätzlich dazu bietet Dir unser Augmented Writing noch Rechtschreibverbsserungen an. Diese findest Du mit einer „grau unterstrichelten Linie.\n' +
    '- Falls Du alleine durch die Vorschläge keinen hohen Score erreichst, was die Ausnahme sein sollte, bieten wir Dir zusätzlich noch Listen mit erfolgsversprechenden Worten an. Diese findest du auf der rechten Seite bei den Empfehlungen. Baue diese in Deinen Text ein und erziele damit eine bessere Wirkung bei Deiner Zielgruppe.\n' +
    'Aktuell ist das Textgenre {Stellenanzeigen} ausgewählt. SAIA ist auf verschiedene Kommunikationskanäle geeicht. Du findest diese unter der Auswahl des Textgenres. Dadurch stellen wir einen noch besseren Fit zur Tonalität Deiner Zielgruppe sicher. Beispielsweise für Active Sourcing oder eben Stellenanzeigen.\n' +
    'Und nun viel Spaß beim Optimieren.\n' +
    'Tausche diesen Text gerne mit einem anderen Text Deiner Wahl aus dem spezifischen Genre aus.',
  extendLicense: 'Lizenz verlängern',
  exportToJson: 'In .json-Datei exportieren',
  noProfileAW:
    'Es sind noch keine ausreichenden Analysen zu dem ausgewählten Profil vorhanden. Bitte fügen Sie zuerst Daten hinzu oder wählen Sie ein anderes Profil.',
  tagExplanation: 'Definiere durch Auswahl der Tags oder dem Erstellen neuer Tags Deine Zielgruppe.',
  dataExplanation:
    'Füge Texte (Beispielsweise Emails, Websites, Blogbeiträge etc.) von repräsentativen Personen hinzu, um unserer AI die Sprache Deiner Zielgruppe zu trainieren.',
  duration: 'Dauer',
  createdAt: 'Erstellt am',
  highlights: 'Höhepunkte',
  sidebarNotes: 'Hinweise zur Seitenleiste Side',
  tenant: 'Tenant',
  phoneNumber: 'Telefonnummer',
  phoneNumberRequired: 'Telefonnummer ist erforderlich',
  enterPhoneNumberHere: 'Telefonnummer hier eingeben...',
  phoneNumberLooksGood: 'Telefonnummer sieht gut aus',
  reportProblem: 'Problem melden',
  abort: 'abbrechen',
  giveFeedback: 'Feedback geben',
  feedbackTitle: 'Super, dass Sie uns unterstützen besser zu werden.',
  optionalComment: 'Fügen Sie gerne noch einen optionalen Kommentar hinzu.',
  savingFeedbackData: 'Um diesen Fehler künftig auszuschließen, speichern wir folgende Daten zwischen:',
  feedbackData: 'User-Id, Fehlermeldung, ausgewählte(n) Vorschlag(e), Ihren Text und Kommentar.',
  selectFeedbackSuggestion: 'Wählen Sie mindestens einen Vorschlag aus.',
  usersFeedback: 'Nutzer-Feedbacks',
  feedbackSubmitted: 'Vielen Dank, Ihr Feedback wurde erfolgreich übermittelt.',
  succeeded: 'Erfolgreich',
  true: 'Wahr',
  false: 'Falsch',
  timeToNextPicture: 'Zeit bis zum nächsten Bild',
  selectUserToTransferData: 'Wählen Sie eine Nutzer auf den die Daten transferiert werden:',
  noOtherUsersInTenant: 'Es gibt keine anderen Nutzer im Mandanten, um die vorherigen Daten zu verschieben.',
  transferUserData: 'Möchten Sie die Daten eines Nutzers auf einen anderen Nutzer übertragen?',
  domain: 'Domain',
  getUsersFeedback: 'Holen Sie sich Nutzer-Feedback',
  doYouWant: 'Sie möchten:',
  higherSales: 'MEHR\nVERKAUFSABSCHLÜSSE',
  moreEffectiveMarketing: 'WIRKSAMERES\nMARKETING',
  hrCommunication: 'MEHR\nBEWERBER:INNEN',
  wowEffectClicks: 'Sie sind nur 3 Klicks von Ihrem persönlichen "Wow"-Moment entfernt',
  theSalesTool: 'Das Tool für effektiveren Vertrieb',
  whatYouGet: 'Was Sie erhalten:',
  salesToolFirstParagraph: 'Verstehen Sie die Qualität Ihrer Kundenbeziehung durch eine E-Mailanalyse mit nur 6 Clicks.',
  salesToolSecondParagraph: 'Passen Sie Ihre E-Mailsprache an die Ihres Kundens an und erhöhen damit das Vertrauen und stärken die Kundenbeziehung.',
  nextStep: 'Nächster Schritt',
  installOutlookAddIn: 'Installieren Sie das Outlook Add-in',
  bookACall: 'Buchen Sie einen Call',
  theMarketingTool: 'Das Marketing Tool',
  marketingToolParagraph: 'Verstehen Sie die Wirkung Ihrer Botschaften an Ihre Buyer Persona und verbessern Sie Ihre Wirkung.',
  whoYouNeedInTeam: 'Welche Persona ist interessant für Sie?',
  forIndividualConsultation: 'Für eine individuelle Beratung:',
  talentTool: 'Das Talent Tool',
  talentParagraph: 'Verstehen Sie die Wirkung und den Genderbias Ihrer Stellenanzeige für Ihre Persona und verbessern Sie Ihre Wirkung.',
  checkTextImpact: 'Wirkung verbessern',
  tabAnalyses: 'Analysen',
  tabManage: 'Verwalten',
  setup: 'Einrichtung',
  dataAnalysisInstruction:
    'Bitte wählen Sie die Kontakte aus, über die Sie mehr erfahren wollen. Fügen Sie zusätzlich die Tags für die Zielgruppenbildung hinzu.',
  selectAll: 'Alle auswählen',
  activateAllContactsDisabled: 'Niemand auf dieser Liste kann aktiviert werden — Blacklist, gelöscht oder gesperrt.',
  newSinceLastUpdate: '<strong>Neu</strong> seit dem letzten Update',
  new: 'neu',
  needs: 'Bedürfnisse',
  processing: 'Verarbeitung',
  qualityFactor: 'Qualität',
  trend: 'Trend',
  reallySelectAll: 'Wirklich alle Kontakte auswählen?',
  reallyUnselectAll: 'Wirklich alle Kontakte abwählen?',
  selectAllWarning: 'Die aktuelle Auswahl geht dabei verloren. Dieser Vorgang ist nicht umkehrbar.',
  writing: 'Schreiben',
  newEmails: 'Sie haben neue Nachrichten',
  analyzeNewEmails: 'Möchten Sie die neuen Nachrichten analysieren?',
  textAnalysisStarted: 'Sie erhalten eine Email, wenn die Analyse für die Kontakte fertig ist.',
  analyzeAgain: 'Noch einmal analysieren?',
  alreadyAnalyzedThisSession: 'Sie haben in dieser Sitzung bereits Ihre ausgewählten Kontakte analysiert.',
  removeContact: 'Kontakt von der Analyse entfernen',
  createReport: 'Bericht erstellen',
  installExtension: 'Analysieren Sie den Text hier oder installieren Sie die passende Erweiterung:',
  createYourFreeAccount: 'Erstelle Deinen kostenlosen Account.​',
  accountFeaturesOne: 'Keine Kreditkarten-informationen​\n',
  accountFeaturesTwo: '14 Tage kostenfrei testen​',
  signInGladTitle: 'Schön, dass Du zurück bist.\nBitte logge dich jetzt ein.',
  // Auth Marketing Panel
  authMarketingHeadline: 'Outreach, das konvertiert — in Recruiting & Lead Gen',
  authMarketingSubheadline: 'Intelligente & automatisierte Ansprache.',
  authMarketingBody:
    'Die KI-gestützten Agenten von SAIA helfen Recruiting- und Wachstumsteams, Erfolge zu skalieren – ohne zusätzliche Komplexität. Ob Top-Talente einstellen oder neue Kund:innen gewinnen: SAIA übernimmt die Fleißarbeit, damit du dich aufs Gewinnen konzentrieren kannst.',
  authMarketingPillRecruiting: 'Recruiting SAIA',
  authMarketingPillLead: 'Lead SAIA',
  authMarketingStat1: '2x mehr Antworten',
  authMarketingStat2: '3x schneller\nTime-to-Hire',
  authMarketingStat3: '100% personalisierte Ansprache basierend auf Persönlichkeitsprofilen',
  authSignupTeaser: 'Nur wenige Klicks bis zu deiner Outreach-Revolution',
  authSigninHeadline: 'Schön, dass du zurück bist',
  authSignupHeadline: 'Jetzt registrieren und deine Outreach-Revolution starten',
  communicateEffectively: 'Kommuniziere noch erfolgreicher.',
  resetPasswordStartAgain: 'Setze Dein Passwort hier zurück und starte sofort wieder durch.',
  videoManagement: 'Video Verwaltung',
  noContactsSelected: 'Keine Kontakte ausgewählt. Bitte wählen Sie Kontakte aus dem Verwalten Reiter aus und starten Sie die Analyse.',
  installExtensionShort: 'Installieren Sie die passende Erweiterung:',
  'percentage share': 'Prozentualer Anteil',
  getStarted: 'Los geht\'s',
  outlookTutorialAnalysisTitle: 'Verstehen Sie die Beziehung zu Ihrem Gesprächspartner',
  outlookTutorialAnalysisText1: 'Eingehende Nachricht anklicken',
  outlookTutorialAnalysisText2: 'Beziehungsqualität und Motivprofil erhalten',
  outlookTutorialAnalysisAllTitle: 'Verstehen Sie die Beziehung zu Ihren Gesprächspartnern',
  outlookTutorialAnalysisAllText1: 'Bei Settings alle Kontakte auswählen',
  outlookTutorialAnalysisAllText2: 'Nach Analyse Bild der Beziehung für Ihre Kontakte erhalten',
  outlookTutorialAwTitle: 'Verbessern Sie die Beziehung zu Ihrem Gesprächspartner',
  outlookTutorialAwText1: 'Vor absenden Ihrer E-Mail-Plugin anklicken',
  outlookTutorialAwText2: 'Wortvorschläge und Rechtschreibverbesserung für bessere Beziehung erhalten',
  createNewTag: 'Neuen Tag erstellen',
  tagName: 'Tag Name',
  updateOfficeVersion:
    'Unser Add-in wird in Ihrer installierten Microsoft Office Version nicht untersützt. Bitte updaten Sie Ihr Microsoft Office mindestens auf die Version 16.0.11629, um das Add-in nutzen zu können.',
  analyzingCommunication: 'Ihre Unterhaltungen werden analysiert...',
  longTextError:
    'Die große Textmenge kann von unserem Core nicht verarbeitet werden. Bitte teilen Sie den Text auf und analysieren Sie die einzelnen Teile getrennt voneinander.',
  'Against Types': 'Qualität Kundentypen',
  actionGrammar: 'Korrigiere den Grammatikfehler.',
  actionParaphrase: 'Verbessere Deine Sprache',
  saveDataTitle: 'Information zur Datenspeicherung',
  savingDataReason: 'Ignorierte Vorschläge werden in unseren Review-Prozess aufgenommen, dafür werden folgende Daten zwischengespeichert:',
  savedData: 'User-Id, Fehlermeldung, Vorschläge und Ihr Text.',
  ignoreSuggestion: 'Vorschlag ignorieren',
  chooseTextGenre: 'Wähle das passende Textgenre aus',
  toAddinStore: 'Zum Add-in Store',
  hideAssistant: 'Assistent ausblenden',
  assignContacts: 'Kontakte zuordnen',
  contactsToAdd: '{{count}} Kontakte werden dem Profil hinzugefügt.',
  contactsToAddLimit:
    'Die Anzahl der hinzuzufügenden Kontakte sollte nicht mehr als 500 pro Upload betragen. Splitten Sie die Daten in mehrere Tabellen auf und fügen Sie danach Schritt für Schritt hinzu.',
  withCSV: 'Mit CSV-Datei',
  manually: 'Manuell',
  emailPlaceholder: 'Hier Kontakt-E-Mail eingeben',
  analysisCurrentlyActive: 'Die zuvor gestartete Analyse ist noch nicht beendet.',
  deleteOutlookData: 'Vorhandene Daten löschen',
  yourContact: 'Dein Kontakt',
  yourResults: 'Dein Ergebnisprofil',
  noCopyPaste: 'Keine Lust auf Copy & Paste?',
  installOurPlugins: 'Installiere unsere Plugins für',
  freemiumTitle1: 'Füge E-Mails von einer Person ein, die du analysieren möchtest und klicke danach auf "Analysieren"',
  freemiumTitle2: 'Füge dein Antwortschreiben ein, passe dieses auf die Person an und klicke danach auf "Analysieren"',
  freemiumTitle3: 'Erhöhe den Match, indem du ähnliche Worte benutzt wie dein Gegenüber',
  freemiumPlaceholder: 'Füge hier eine E-Mail von der Person ein, die du analysieren möchtest...',
  backToWebsite: 'Zurück zur\nWebseite',
  ecommerce: 'Ecommerce',
  welcomeUser: 'Willkommen bei 100W, {{userName}}',
  guidanceInfo: 'Klicke auf das LinkedIn Symbol und installiere Dir unsere Chrome Extension für LinkedIn in weniger als 3 Minuten.',
  guidanceLinkedin1: 'Nutze die Vorhersage von 100W – SAIA auf LinkedIn.',
  guidanceLinkedin2: 'Damit verstehst du deine Interessenten besser und wirst in der personalisierten Ansprache unterstützt.',
  guidanceOutlook1: 'Nutze die Vorhersage von 100W – SAIA in Deinem Outlook.',
  guidanceOutlook2: 'Damit verstehst Du deine Gesprächspartner besser und wirst im personalisierten Emails Schreiben unterstützt.',
  directTextOptimization: 'Direkte Textverbesserung',
  guidanceDirect1: 'Nutze die Vorhersage von 100W – SAIA für bessere Texte.',
  guidanceDirect2: 'Wir helfen Dir dabei, Motive von Menschen richtig anzusprechen.',
  linkedinTitle: 'Super, dass Du Profile auf LinkedIn besser verstehen willst.',
  linkedinSubTitle: 'Schaue Dir die Persönlichkeit von Personen auf LinkedIn an',
  linkedinInfo:
    'Unsere Chrome Extension sagt Dir genau auf welchen Typ Mensch du triffst und hilft Dir beim Schreiben von Kontakt- bis zur Terminanfrage. Schaue nach dem „100W Analyse“ – Button auf LinkedIn.',
  howItsDone: 'So geht das',
  linkedinWelcomeStep1: 'Lade bereits geöffnete LinkedIn Seiten neu, um die 100W Analyse dort zu aktivieren.',
  linkedinWelcomeStep2: 'Die Chrome Extension kann bei den Browser Extensions auf Wunsch angepinnt werden.',
  linkedinWelcomeOnlyFewSteps: 'Nur noch wenige Schritte bis zu Deiner ersten Analyse mit 100W.',
  linkedinUsageStep1: 'Installiere die Chrome Extension.',
  linkedinUsageStep2: 'Suche nach einer Person.',
  linkedinUsageStep3: 'Auf der rechten Seite findest Du in der Mitte den blauen Button. Damit identifizierst Du den Typ.',
  linkedinUsageStep4:
    'Nach dem Schreiben Deiner Nachricht im Textfeld auf LinkedIn erscheint der orange Button. Nach klick darauf matchst Du Deine Sprache zum Typ.',
  installChromeExtension: 'Installiere die Extension',
  tryItOut: 'Probiere es jetzt aus',
  outlookTitle: 'Super, dass Du Deine Ansprechpartner per Mail besser verstehen willst.',
  outlookSubTitle: 'Schaue Dir die Persönlichkeit Deiner Ansprechpartner an',
  outlookInfo:
    'Unser Outlook Add-In sagt Dir genau auf welches Profil Du dich für deinen Kontakt einstellen musst und hilft Dir beim Schreiben Deiner Emails für den perfekten „Match“. Schaue nach dem „100W Analyse“ – Button in Deinem Outlook.',
  setupInfo: 'So geht das Setup',
  authenticate: 'Authentifizieren',
  outlookUsageStep1: 'Authentifiziere das Add-in.',
  outlookUsageStep2: 'Installiere das Add-in.',
  outlookUsageStep3: 'Klicke auf den dunkelblauen Button und sage die Motive vorher.',
  outlookUsageStep4: 'Klicke nach dem Schreiben einer E-Mail auf den dunkelblauen Button und matche die Sprache.',
  noO365: 'Kein Office365, dann hier lang',
  vstoOutlookStep1: 'Download und .exe ausführen.',
  vstoOutlookStep2: 'Klicke auf „weitere Informationen“ und "trotzdem ausführen".',
  directOptimizationTitle: 'Schreibe Texte mit starker Wirkung​.',
  directOptimizationSubTitle: 'Passe Deine Texte auf die Motive Deiner Kunden an',
  directOptimizationInfo:
    'Unser Augmented Writer unterstützt Dich dabei, die Motive Deiner Profile zu „matchen“. Damit erzeugst Du einen bleibenden Eindruck.',
  directOptimizationUsageStep1: 'Wähle ein Profil aus.',
  directOptimizationUsageStep2: 'Wähle Dein Textgenre aus und füge einen Text ein.',
  directOptimizationUsageStep3: 'Klicke auf "Analysieren" und matche die Sprache Deines Profils.',
  chooseYourProfile: 'Wähle Dein Profil',
  firstSteps: 'Erste Schritte',
  does: 'Do\'s',
  donts: 'Don\'ts',
  vocabulary: 'Wortschatz',
  comparison: 'Vergleich',
  degreeOfFormality: 'Formalitätsgrad',
  userWordList: 'Worte, die bei {{contactName}} gut ankommen',
  theContact: 'dem Kontakt',
  theContact2: 'den Kontakt',
  improveCommunication: 'Kommunikation Verbessern',
  match: 'Match',
  learnMore: 'Erfahre mehr',
  aScore: 'A - gut',
  bScore: 'B - Ok',
  cScore: 'C - weniger gut',
  importantToContact: 'Das ist {{contactName}} wichtig',
  answerContactQuestions: 'Beantworte {{contactName}} folgende Fragen',
  lowComparison: 'wenig',
  dominantComparison: 'dominant',
  moreComparison: 'mehr',
  languageStyle: 'Sprachstil',
  genderScoring: 'Genderscoring',
  typeInformation: 'Information zum Typ',
  characters: 'Zeichen',
  own: 'Eigene',
  firstname: 'Vorname',
  lastname: 'Nachname',
  targetGroup: 'Zielgruppe',
  noData1: 'Füge jetzt Daten zu Deiner Zielgruppe hinzu, um diese besser zu verstehen und Texte anzupassen.',
  noData2: 'Hierzu hast Du vier Optionen',
  noData3: 'Sobald Du Daten hinzugefügt hast, erscheint Dein Ergebnis.',
  noDataOption1: 'Personen über die E-Mailadresse hinzufügen.',
  noDataOption2: 'Profil manuell einstellen.',
  noDataOption3: 'Personen über das Attribut "Tag" hinzufügen.',
  noDataOption4: 'Dem Profil direkt Texte der Zielgruppe hinzufügen.',
  toTextImprovement: 'Zur Textverbesserung',
  improveText: 'Text\nausrichten',
  profileManualCreation: 'Du kannst ein Profil manuell einstellen und jeder Ausprägung einen Wert von 1 bis 5 zuweisen.',
  addAnotherTag: 'Weiteren Tag hinzufügen',
  notOwnTextWarning: 'Diese Profil gehört einem anderen Nutzer, daher kannst du es nicht bearbeiten.',
  emailOrLinkedin: 'E-Mail/LinkedIn',
  noCopyToClipboard: 'Zwischenablage nicht verfügbar. Bitte kopiere den Text manuell.',
  chooseYourType: 'Wähle deinen Typ aus',
  productF1: 'SAIA für LinkedIn',
  productF2: 'Augmented Writing',
  productF3: 'Matchfeatures',
  productF4: '100 W für Outlook',
  productF5: 'Individuelle Performance-Analytik und Reports',
  productF6: 'Erweiterte Team-Analytik und Reports',
  productFA1P: 'Insgesamt 1000 Personen-Analysen',
  productFA1B: 'Insgesamt 2000 Personen-Analysen',
  productFA1E: 'Insgesamt 3500 Personen-Analysen',
  productFA2: 'Die freie Wahl aus 14 Motivprofilen',
  productFA3: 'Analyse von Emails, LinkedIn-Profilen, Webseiten, Blogartikeln & Stellenanzeigen',
  productFA4: 'Rechtschreibprüfung',
  productFA5: 'Sprachverbesserung',
  productFA6: 'Stilanalyse',
  productFA7: 'Prüfung von Verständlichkeit',
  productFA8: 'Features für passgenaue Ansprache',
  productFA9: 'Eigene Kontaktqualitäten über einen Zeitraum analysieren',
  productFA10: 'Gleichzeitig mehrere Kontakte automatisch analysieren',
  productFA11: 'Gruppierung mehrere Personen zu einem ultimativen Profil',
  productFA12: 'Unendliche Anzahl von Gruppenprofilen',
  productFA13: 'Kontaktqualitäten des Teams über einen Zeitraum analysieren',
  productEF1: 'Implizite und explizite Motive - Ergebnis Ihres persönlichen expliziten und impliziten Motivprofil',
  productEF2: 'Normierung - Vergleich zu anderen Führungskräften oder Expert*innen',
  productEF3: 'Ressourcen - Was sind meine Stärken, und was die Entwicklungsfelder',
  productEF4: 'Selbstreflexion und Tipps - Tipps Ihre Stärken optimal zu nutzen',
  productEF5: 'Prognose - Ableitung der Fähigkeiten und Kompetenzen aus Ihren Motiven',
  productLF1: '360-Grad-Führungsfeedback',
  productLF2: 'Management-Audit',
  productLF3: 'Persönlichkeitstest',
  productLF4: 'Individualisierbar',
  headerP1: 'Das ist enthalten:',
  userOneLicense: 'Jedem Nutzer kann nur einer Lizenz zugewiesen werden.',
  paymentRequests: 'Aufrufe',
  inDetail: 'Im Detail',
  addOn: 'Add-on',
  paymentMonthlyInfo: 'Monatliche Abrechnung',
  paymentYearlyInfo: 'Spare 15% bei jährlicher Vorauszahlung',
  paymentMonthlyGeneralInfo: 'pro Nutzer und Monat, monatliche Abrechnung',
  paymentYearlyGeneralInfo: 'pro Nutzer und Monat, jährliche Abrechnung',
  request: 'Aufruf',
  yourCurrentPlan: 'Dein aktueller Plan',
  paymentUsersInfo: 'Gesamtzahl der Nutzer: {{usersCount}}, Nutzer zugewiesen: {{usersAssignedCount}}',
  paymentAddonsInfo: 'Gesamtzahl der Add-ons: {{addonsCount}}, Add-ons zugewiesen: {{addonsAssignedCount}}',
  editAbo: 'Abo bearbeiten',
  cancelAbo: 'Abo kündigen',
  renewAbo: 'Abo erneuern',
  paymentRequestsInfo: 'Gesamtzahl der Aufrufe: {{requestsCount}}, Aufrufe genutzt: {{requestsUsedCount}}',
  sum: 'Summe',
  notPaid: 'Nicht bezahlt',
  paid: 'Bezahlt',
  goToInvoice: 'zur Rechnung',
  pay: 'bezahlen',
  renewLicense: 'Lizenz erneuern',
  licenseRenewWarning: 'Deine ausgewählte Lizenz wird erneuert.',
  licenseDelete: 'Lizenz beenden',
  licenseDeleteWarning: 'Deine ausgewählte Lizenz wird beendet! Du kannst sie jederzeit wieder erneuern.',
  dataWillRemovedNow: 'Daten sofort löschen',
  end: 'beenden',
  addUsersInfo: 'Füge Nutzer deinem Account hinzu und füge diesen Nutzern eine Lizenz hinzu.',
  manageUsersInfo: 'Lösche Nutzer aus dem Account oder bearbeite sie.',
  manageLicensesInfo: 'Verwalte deine Lizenzen.',
  costsPerYear: 'entspricht {{price}} € pro Jahr',
  tenantDetails: 'Unternehmens- und Userinformation',
  manageTenantInfo: 'Bevor Du ein Paket buchen kannst, gib bitte hier für die Rechnungsstellung Deine vollständigen Unternehmensinformationen an.',
  usersBehavior: 'Benutzerverhalten',
  freeRegistration: 'Registrierung für den\nkostenfreien Freemium Account',
  registerProceed: 'Registrieren und weiter',
  yourDesiredPassword: 'Dein gewünschtes Passwort',
  inclVat: 'inkl. Mwst.',
  plusVat: 'zzgl. Mwst.',
  netPlusVat: 'netto zzgl. Mwst.',
  startForFree: 'Jetzt kostenlos starten',
  starterDescription: 'Für Spezialisten, Single-User und kleine Sales Teams.',
  freemiumDescription: 'Die kleine Version zum testen, kennenlernen und ausprobieren. Ein Wechsel in ein kostenpflichtiges Paket ist jederzeit möglich.',
  mediumDescription: 'Für größere Vertriebs Teams.',
  productRangeInfo: 'Das Angebot ist in der Freemium Version <1>dauerhaft kostenfrei</1> nutzbar.\nEs wird für Freemium keine Kreditkarte benötigt.',
  loginGreeting: 'Danke, Deine E-Mail ist nun bestätigt.\nBitte logge dich jetzt ein.',
  yourPassword: 'Dein Passwort',
  yourEmailAddress: 'Deine E-Mail Adresse',
  extensionInstallation1: 'Installiere bitte jetzt das SAIA\nSAIA Sales Chrome Plugin',
  extensionsInstallation1: 'Installiere bitte jetzt das SAIA\nSAIA Sales Edge oder Chrome Plugin',
  extensionInstallation2: 'Dann kann es gleich losgehen',
  installPlugin: 'Plugin installieren',
  installChromePlugin: 'Chrome Plugin installieren',
  installEdgePlugin: 'Edge Plugin installieren',
  dontHaveChrome: 'Ich habe aber gar kein Chrome',
  dontHaveEdge: 'Ich habe aber gar kein Edge',
  chromeInstallation1: 'Du hast den Chrome Browser\nnoch nicht installiert?',
  chromeInstallation2: 'Kein Problem. Einfach hier klicken.',
  edgeInstallation1: 'Du hast den Edge Browser\nnoch nicht installiert?',
  edgeInstallation2: 'Kein Problem. Einfach hier klicken.',
  installChrome: 'Chrome installieren',
  installEdge: 'Edge installieren',
  installBrowserBack: 'Danach zurück zur LinkedIn AI Booster Plugin Installation',
  managementAndContract: 'Verwaltung & Vertrag',
  manuals: 'Anleitungen',
  helpAndService: 'Hilfe & Service',
  loyaltyPoints: '{{count}} Loyalty Punkte',
  congratulationsProfilesAnalyzed: 'Glückwunsch! Du hast {{countRemaining}} / {{countTotal}} Profile in diesem Monat analysiert.',
  bookServicePackage: 'Lizenzpaket\nbuchen',
  upgradeServicePackage: 'Lizenzpaket\nupgraden',
  journeyCongratulationsTitle: 'Herzlichen Glückwunsch!\nDu bist nun ein Meister in der Verwendung des LinkedIn AI Sales Boosters',
  journeyCongratulationsParagraph1: 'Du kannst Dich nun frei entscheiden - ob und wie Du das Tool weiter nutzen möchtest.\nDazu haben wir 3 Fragen.',
  journeyCongratulationsParagraph2: 'Der Vorgang dauert nur ca. 1 Minute.',
  nextPage: 'Nächste Seite',
  colleaguesCountTitle: 'Was schätzt du',
  colleaguesCountParagraph: 'Wie viele Deiner Kollegen könnten auch von diesem Tool profitieren?',
  howProceedTitle: 'Willst Du Kollegen für die Entscheidungsfindung dazu bitten?',
  howProceedParagraph: 'Du kannst jetzt Kollegen in Dein Team einladen oder einfach allein fortfahren.',
  inviteColleaguesTitle: 'Nenne uns Deine Kollegen, die Du einladen möchtest',
  inviteColleaguesParagraph: 'Du bekommst von uns zusätzliche freie Analysen, damit Du Deinen Kollegen zeigen kannst,\nwie das Plugin für Euer Team funktionieren würde.',
  function: 'Funktion z. B. Head of Sales',
  invitationSuccessTitle: 'Super, Du hast einen Kollegen erfolgreich eingeladen',
  invitationSuccessParagraph: 'Möchtest Du jetzt noch weitere Kollegen in Dein Team einladen oder fortfahren?',
  choosePackageTitle: 'Welches Paket ist das richtige für Dich?',
  choosePackageParagraph1: 'Du kannst hier eines der drei kostenpflichtigen Pakete auswählen und Deine Conversion & Umsatz erhöhen.',
  choosePackageParagraph2: 'Du bleibst erst einmal im Freemium Paket mit einer eingeschränkten Analyse-Zahl von 5 Analysen pro Monat.',
  choosePackageParagraph3: '* Jetzt sparen und bei jährlicher Zahlung effektiv\nnur 10 von 12 Monaten zahlen',
  yearlyPayment: 'Jährliche Zahlung',
  monthlyPayment: 'Monatliche Zahlung',
  stayFreemium: 'Im Freemium bleiben',
  desiredLicenses: 'Anzahl\ngewünschter\nLizenzen',
  desiredLicensesUsageLimited: 'Anzahl\ngewünschter\nAnzeigen pro\nMonat',
  sumTextYearly: 'Gesamtbetrag netto pro Monat bei jährlicher Vorauszahlung und Kündigungsoption',
  sumTextYearlySplit: 'Gesamtbetrag netto pro Monat\nbei jährlicher Vorauszahlung\nund Kündigungsoption',
  sumTextMonthly: 'Gesamtbetrag netto pro Monat bei monatlicher Zahlung und Kündigungsoption',
  sumTextMonthlySplit: 'Gesamtbetrag netto pro Monat\nbei monatlicher Zahlun\n und Kündigungsoption',
  starterDescr: 'Für Spezialisten, Single-User und kleine Sales Teams',
  mediumDescr: 'Für Vertriebs Teams, SaaS Unternehmen und Social Selling Agenturen',
  advancedDescr: 'Für größere Vertriebs Teams, SaaS Unternehmen und Social Selling Agenturen',
  starterMainFeatures: '1000 Personen-Analysen initial\nzusätzlich 150 Analysen pro Monat',
  mediumMainFeatures: '2000 Personen-Analysen initial\nzusätzlich 250 Analysen pro Monat',
  advancedMainFeatures: '3500 Personen-Analysen initial\nzusätzlich 500 Analysen pro Monat',
  freemiumMainFeatures: '10 Personen-Analysen initial\nzusätzlich 5 Analysen pro Monat',
  feature1: 'SAIA LinkedIn Booster',
  feature2: 'Augmented Writing',
  feature3: 'Matchfeatures',
  feature4: 'Individuelle Performance-Analytik und Reports',
  feature5: 'Eigene Kontaktqualitäten über einen Zeitraum analysieren',
  feature6: 'Die freie Wahl aus 14 Motivprofilen',
  feature7: 'Rechtschreibprüfung',
  feature8: 'Sprachverbesserung',
  feature9: 'Stilanalyse',
  feature10: 'Prüfung von Verständlichkeit',
  feature11: 'Features für passgenaue Ansprache',
  addColleagueSuccess: 'Einladung erfolgreich',
  addColleagueError: 'Es ist ein Fehler beim Erstellen des Nutzers aufgetreten!',
  analyticsDashboard: 'Analytics\nDashboard',
  enterUserInfoParagraph: 'Um ein Lizenzpaket buchen zu können, benötigen wir Deine vollständigen Rechnungsempfänger-Informationen.',
  conformEntries: 'Eingaben bestätigen',
  commercial: 'Gewerbliche Nutzung',
  private: 'Private Nutzung',
  nameOfInvoiceRec: 'Name des Rechnungsempfängers',
  houseNumber: 'Hausnummer',
  vatId: 'UmSt. ID',
  germany: 'Deutschland',
  austria: 'Österreich',
  switzerland: 'Schweiz',
  otherEu: 'Andere EU',
  forExampleShort: 'z.B.',
  paymentSuccess1: 'Herzlichen Glückwunsch!',
  paymentSuccess2: 'Du hast Dich erfolgreich für das {{packageName}} Paket entschieden und die Buchung ist\nnun abgeschlossen.',
  alreadyInstalledExtension: 'Ich habe das Plugin schon installiert',
  few: 'wenige',
  several: 'mehrere',
  many: 'viele',
  proceedAlone: 'allein fortfahren',
  inviteColleagues: 'Kollegen einladen',
  comesLater: 'kommt später',
  licensePackage: 'Lizenzpaket',
  userManagementInfoTitle: 'Hier kannst Du alle Nutzer in deinem Account verwalten.',
  userManagementInfoBullet1: '1. Füge Deinem Account Nutzer hinzu und weise diesen eine Lizenz zu.',
  userManagementInfoBullet2: '2. Bearbeite Nutzerinformationen oder lösche Nutzer.',
  allUsers: 'Alle Nutzer',
  basic: 'Basic',
  manager: 'Manager',
  owner: 'Owner',
  rowsPerPage: 'Reihen pro Seite',
  of: 'von',
  allLicenses: 'Alle Lizenzen',
  licenseManagementInfoTitle: 'An dieser Stelle kannst Du Deine Lizenzen verwalten und zuweisen.',
  addLicense: 'Lizenz hinzufügen',
  buyLicense: 'Lizenz kaufen',
  userEmails: 'Nutzer E-Mails',
  licensePackageInfo: 'Hier kannst Du Dein aktuell gebuchtes Lizenzpaket einsehen und upgraden.',
  upgradeNow: 'Jetzt upgraden',
  currentPackage: 'Aktuelles Paket',
  customersRecommendation: 'Kunden Empfehlung',
  accountManagementInfoTitle: 'Hier kannst Du Deine Accountinformationen verwalten.',
  userLicense: 'Nutzerlizenz',
  initialSettings: 'Grundeinstellungen',
  analyses: 'Analysen',
  optimizations: 'Optimierungen',
  analysesTitle: 'Analysen und Auswertungen',
  analysesParagraph: 'An dieser Stelle bieten wir Dir die Möglichkeit die Erfolge Deiner Arbeit\nmit dem Tool messbar zu machen und Reportings zu ziehen.',
  settingValueForOpt: 'Einstellung Conversion Werte vor Optimierung',
  pleaseEnterValueForFunnel: 'Bitte gib hier Deine Erfahrungs-Conversion Werte ein, die Du bisher\nmit LinkedIn im Sales Funnel sammeln konntest.',
  acceptContactRequest: 'Akzeptanz Kontakt Request',
  responseOfFirstEmail: 'Antwort auf erste Mail an Rezipienten',
  doNotKnowConversionValue: 'Solltest Du die genannten Conversion Werte nicht kennen, setze einfach keine\nZahl ein und drücke auf „Ergebnis anzeigen“ wir zeigen dann einen\nBranchenübergreifenden Mittelwert für Dich zur Orientierung an.',
  showResult: 'Ergebnis anzeigen',
  dataSpace: 'Datenraum',
  resultsAfterTemplatesWithYear: 'Ergebnisse nach Templates im Durchschnitt | {{year}}',
  resultsAfterTemplates: 'Ergebnisse nach Templates im Durchschnitt',
  analysesDashboard: 'Analysen &\nOptimierung',
  crPercent: 'Conversionrate in %',
  usageWeeks: 'Nutzung in Wochen',
  usageMonths: 'Nutzung in Monaten',
  userNotFound: 'Keinen Nutzer mit dieser E-Mail Adresse gefunden',
  addStandardTemplate: 'Füge hier dein Standardtemplate für alle Typen ein',
  standardTemplate: 'Standardtemplate',
  standardTemplatePlaceholder: 'Schreibe hier Dein Standardtemplate für alle Typen...',
  offerPlaceholders: 'Wir bieten folgende Platzhalter an',
  linkedinForename: 'Empfänger Vorname',
  linkedinSurname: 'Empfänger Nachname',
  ownForename: 'Dein Vorname',
  ownSurname: 'Dein Nachname',
  analyticsEventTitle: 'Analytics Event',
  analyticsEventParagraph1: 'Hast Du eine Antwort auf eine Nachricht aus dem Template: #{{templateName}} erhalten?',
  analyticsEventParagraph2: 'Wenn ja, war diese Antwort positiv?',
  closeWindow: 'Fenster schließen',
  salesHeaderTitle: 'SAIA LinkedIn Booster',
  hrHeaderTitle: 'SAIA Recruiting',
  jobDescription: 'Job-\nbeschreibung',
  germanDescription: 'Deutsche Bezeichnungen',
  englishDescription: 'Englische Bezeichnungen',
  jobDescriptionParagraph: 'Bitte gib hier den Jobtitel ein,\nfür den Du eine Jobbeschreibung anlegen willst.',
  acceptJobTitle1: 'Hier auswählen, wenn Jobtitel vorhanden\noder ausreichend übereinstimmend ist',
  acceptJobTitle2: 'Beim Bestätigen wird ein Stellenanzeigenprojekt erstellt und ist 1 Monat gültig',
  acceptJobTitleButton: 'Projekt erstellen',
  requestJobTitle: 'Hier auswählen, wenn Jobtitel\nnoch nicht verfügbar oder exakt genug ist',
  requestJobTitleButton: 'Position anfordern',
  occupationNoDataTitle: 'Keine Daten vorhanden',
  occupationNoDataBody: 'Das ausgewählte Profil hat leider noch keine Daten. Suche Dir bitte eine andere passende Jobbeschreibung aus oder gib die Entwicklung des gewünschten Profils in Auftrag.',
  requestOccupationMailSubject: 'Unterstützung für das Profil {{profileName}}',
  requestOccupationMailBody: 'Liebes SAIA Team,%0d%0a %0d%0aich benötige für meine erfolgreiche Arbeit das Profil {{profileName}}.%0d%0aEs wäre grandios, wenn Ihr das in die Entwicklung gebt.%0d%0aBitte meldet mir zurück, wann ich mit einem Ergebnis rechnen kann.%0d%0a %0d%0aViele Grüße%0d%0a{{userName}}',
  chooseDesign: 'Design auswählen',
  sales_design: 'Sales Design',
  hr_design: 'HR Design',
  product_HR: 'SAIA Recruiting\nBusiness Pakete',
  product_HR_LinkedIn: 'Sourcing\nBooster Pakete',
  optionallyBookable: 'Optional buchbar',
  selectPackage: 'Paket auswählen',
  unselectPackage: 'Paket ausgewählt',
  selectAtLeastOne: 'Bitte wähle mindestens ein Paket aus.',
  customSolutionsIndividualOffers: 'Individuelle maßgeschneiderte Angebote',
  customSolutionsContactUs: 'Kontaktiere dazu bitte unsere Customer Success Abteilung unter\ndem unten stehenden Button und wähle einen Beratungstermin aus,\noder sende uns eine Mail an:',
  getConsultingAppointment: 'Vereinbare einen Beratungstermin',
  customSolutionGenericTitle: 'SAIA Solutions',
  customSolutionGenericDescription: ' ',
  customSolutionGenericText: 'Du benötigst ein Servicepaket, dass mehr Nutzungen beinhaltet als in der Business Paket Auswahl verfügbar ist, da du eines unserer Produkte noch öfter verwenden willst? Wir freuen uns, dir eine genau auf deine Bedürfnisse zugeschnittene Lösung anbieten zu können.',
  customSolutionJobBoosterTitle: 'SAIA Recruiting\nEnterprise Solutions',
  customSolutionJobBoosterDescription: 'Für wirkungsvolle und\ngenderneutrale\nStellenanzeigen',
  customSolutionJobBoosterText: 'Du benötigst ein Servicepaket, das mehr Job Ad Analysen beinhaltet als\nin der Business Paket Auswahl verfügbar ist, da ihr eine höhere Anzahl an\nStellen pro Jahr vergebt? Wir freuen uns, dir eine genau auf deine\nBedürfnisse zugeschnittene Lösung anbieten zu können.',
  businessPacket: 'Business Paket',
  with: 'mit',
  runtimeTwelve: 'Laufzeit 12 Monate',
  shoppingCartJobBooster: 'Stellenanzeigen Optimierungen',
  recruiterLicenses: 'Recruiter Lizenzen',
  activeSourcing: 'Active\nSourcing',
  linkedinSales: 'LinkedIn\nSales',
  jobOfferProjects: 'Stellenanzeigenprojekte',
  acceptHrProject: 'Hier mit dem ausgewählten Projekt fortfahren',
  acceptHrProjectButton: 'Projekt übernehmen',
  noPackage: 'Kein Paket gebucht',
  yourJobAdvProjects: 'Deine\nStellenanzeigenprojekte',
  hrProductMainFeatures: 'Für wirkungsvolle und\ngenderneutrale\nStellenanzeigen',
  hrLinkedinMainFeatures: 'Für Active Sourcing auf\nLinkedIn pro Recruiter',
  loginWithLinkedin: 'Mit LinkedIn einloggen',
  registerWithLinkedin: 'Mit LinkedIn registrieren',
  loginWithGoogle: 'Mit Google einloggen',
  registerWithGoogle: 'Mit Google registrieren',
  loginWithMicrosoft: 'Mit Microsoft einloggen',
  activities: 'Aktivitäten',
  activitiesAccordingTemplate: 'Aktivitäten nach Templates',
  positives: 'Positive',
  lastThreeMonths: 'Letzte 3 Monate',
  ownEmail: 'Deine E-Mail',
  companyNameWarning: 'Der Name des Unternehmens darf max. 30 Zeichen lang sein',
  nameWarning: 'Der Name darf max. 30 Zeichen lang sein',
  registerWithMicrosoft: 'Mit Microsoft registrieren',
  piece: 'Stk.',
  jobAdsBoosterFeature1: 'Zielgruppenauswahl aus über 330 Berufsbildern',
  jobAdsBoosterFeature2: 'Unterstützung bei der Ausrichtung des Textes:',
  jobAdsBoosterFeature3: 'Vorschlag von wirkungsvolleren Paraphrasen',
  jobAdsBoosterFeature4: 'Vorschlag von wirkungsvolleren Worten',
  jobAdsBoosterFeature5: 'Ausgleich des Genderbias',
  activeSourcingBoosterFeature1: 'Analyse von Profilen in LinkedIn',
  activeSourcingBoosterFeature2: 'Analyse von Profilen im LinkedIn Recruiter',
  activeSourcingBoosterFeature3: 'Automatische Erstellung von Textvarianten',
  activeSourcingBoosterFeature4: 'Automatische Auswahl der wirkungsvollsten Textvarianten',
  activeSourcingBoosterFeature5: 'Verbesserung der Ansprache in LinkedIn:',
  activeSourcingBoosterFeature6: 'Vorschlag von wirkungsvolleren Paraphrasen',
  activeSourcingBoosterFeature7: 'Vorschlag von wirkungsvolleren Worten',
  createTemplates: 'Templates\nerstellen',
  togglePasswordVisibility: 'Kennwortsichtbarkeit umschalten',
  for: 'für',
  highlightWordsWith: 'Wörter hervorheben, die verbunden sind mit',
  closeSuggestion: 'Vorschlag schließen',
  sourceTemplate: 'Original Template',
  sourceTemplateText: 'Original Template Text',
  enterName: 'Gib den Namen des Templates ein',
  selectDomain: 'Wo wirst Du die Nachricht nutzen?',
  mainText: 'Haupttext',
  copyPastePlaceholder: 'Copy & Paste Platzhalter',
  textAnalyzed: 'Text analysiert',
  notAllFieldsFilledWarning: 'Nicht alle Felder sind ausgefüllt',
  insertMessage: 'Nachricht hier eingeben',
  personaMatch: 'Persona Match',
  personaMatchText1: 'Deine Ergebnisse werden hier angezeigt\nsobald die Nachricht ausgewertet wurde',
  personaMatchText2: 'Dies sind Deine tatsächlichen Ergebnisse, die sich\nim Laufe des Prozesses ändern werden',
  optimizationInProgress: 'Optimierung in\nArbeit',
  optimizationDone: 'Optimierung\nabgeschlossen',
  textVariants: 'Textvarianten',
  textVariantsInitial: 'Textvorschläge für verschiedene\nPersönlichkeitstypen werden hier angezeigt,\nsobald Du Deine Nachricht analysiert hast.',
  textVariantsAnalyzed: 'Bitte akzeptiere jede Variante, die\ninhaltlich Sinn macht. Einige Persönlichkeitstypen\nwerden von jeder Entscheidung profitieren.',
  textVariantsDone: '<strong>Herzlichen Glückwunsch!</strong>\n\nDeine Umformulierung für alle\nPersönlichkeitstypen war erfolgreich!\n\nDu hast den folgenden Templatesatz erstellt,\nder 14 individuelle Einzeltemplates enthält\n\n<strong>{{name}}</strong>\n\nSpeichere nun den Templatesatz,\n um den Vorgang abzuschließen',
  saveTemplates: 'Templatesatz speichern',
  pageLeaveWarning: 'Beim Verlassen der Seite geht Dein Fortschritt verloren. Seite trotzdem verlassen?',
  profileTextVariant: 'Profil Textvariante',
  nameAlreadyTakenError: 'Der Name ist bereits vergeben',
  optionalSentences: 'Wir haben keine weiteren Vorschläge mehr für Deinen Text.\n\nMöchtest Du noch eigene Textvarianten hinzufügen?',
  addMoreSentences: 'Dein Satz wurde erfolgreich hinzugefügt.\n\nMöchtest Du weitere Textvarianten hinzufügen?',
  addMoreSentencesSkip: 'Möchtest Du noch eigene Textvarianten hinzufügen?',
  selectASentence: 'Wähle einen Satz aus der Liste aus,\nfür den Du eine zusätzliche Variante\nhinzufügen möchtest.',
  addToSelection: 'Zur Auswahl hinzufügen',
  optimizedTemplate: 'Typoptimiertes Template',
  templateSelection: 'Template- und Typauswahl',
  selectTemplateSet: 'Wähle einen Templatesatz aus',
  templateSelectionText1: 'Wähle bitte einen Templatesatz aus',
  templateSelectionText2: 'Wähle bitte einen Kommunikationstyp aus\num das zugehörige Einzeltemplate zu bearbeiten',
  nextSteps: 'Nächste Schritte',
  createNewTemplateSet: 'Neuen Templatesatz erstellen',
  nextStepsText1: 'Erhöhe Deine Sales Conversions!',
  nextStepsText2: 'Du kannst mit den folgenden\nOptionen fortfahren',
  goToLinkedin: 'Weiter zu LinkedIn',
  renameTemplateSet: 'Templatesatz umbenennen',
  newTemplateSetName: 'Neuer Name des Templatesatz',
  deleteTemplateSet: 'Templatesatz löschen',
  deleteTemplateSetWarning: 'Soll der Templatesatz <strong>{{phaseName}}</strong> wirklich gelöscht werden?\n\nDer Vorgang ist nicht umkehrbar und der Templatesatz steht danach nicht mehr zur Verfügung.',
  cloneTemplateSet: 'Templatesatz klonen',
  clonedTemplateSetName: 'Name des geklonten Templatesatzes',
  alignTextManually: 'Text manuell ausrichten',
  noSourceAvailable: 'Kein Original Text gespeichert',
  rename: 'umbenennnen',
  repositionTemplate: 'Templatesatz Position ändern',
  changePosition: 'Position ändern',
  changePositionText: 'An welche Position soll der Templatesatz <strong>{{phaseName}}</strong> verschoben werden?',
  alternatively: 'Alternativ - Gehe direkt zu',
  editManually: 'Manuelle Bearbeitung',
  endProcess: 'Prozess beenden',
  yourConversionRating: 'Dein Conversion Rating',
  amazing: 'Fantastisch',
  linkedinOnboarding1: 'Jetzt weisst Du, für welche Persönlichkeiten von potenziellen Kunden Du deine Texte verbessern kannst.',
  linkedinOnboarding2: 'Unser Augmented Writer wird dich im nächsten Schritt übterstützen.',
  linkedinOnboarding3: 'Verwandle nun deine {{conversionMinimum}}% Conversion Rate in eine Top Conversion Rate',
  linkedinOnboarding4: 'Optimiere deine aktuellen Nachrichten Templates oder erstelle ein ganz neues!',
  startOptimizingNow: 'Beginne mit der Optimierung!',
  onboardingStep1: 'Analysiere deine Kommunikation',
  onboardingStep2: 'Verbessere deinen Text',
  onboardingStep3: 'Erstelle Templates',
  onboardingStep4: 'Sende Nachrichten an Kontakte',
  onboardingSubStep1: 'Definiere Template Namen',
  onboardingSubStep2: 'Definiere wo Du dieses Template nutzen möchtest',
  onboardingSubStep3: 'Füge dein aktuelles Nachrichten-Template ein oder schreibe ein komplett neues',
  onboardingSubStep4: 'Füge Platzhalter in deinen Text ein um das Template zu automatisieren',
  onboardingSubStep5: 'Analysiere den Text',
  onboardingSubStep6: 'Erstelle Template Variationen',
  onboardingTitle: 'In vier Schritten zum Social-Selling Professional',
  welcomeToDashboard: 'Wilkommen in deinem Dashboard!',
  welcomeToDashboardText: 'Hier wirst du Templates erstellen, Nachrichten analysieren und optimieren sowie deine Erfolgskennzahlen verfolgen.',
  continueSeeResults: 'Weiter zu den Ergebnissen',
  createNewTemplate: 'Neues Template erstellen',
  templateCreationOnboardText: 'Diese können <1>grün</1> markierte Worte für Veränderungen zum Originaltext und rot markierte Punkte <3>[…]</3> für gelöschte Worte oder Satzteile aus dem Originaltext beinhalten.',
  showExample: '> Zeige Beispiel <',
  hideExample: '> Verstecke Beispiel <',
  dataExport: 'Daten-\nexport',
  analyzedContactRequests: 'Analysierte Kontaktanfragen: <strong>{{count}}</strong>',
  estimatedProcessingTime: 'Gesamtdauer: <strong>ca. 2 Std.</strong>',
  mailContactAnalysis: 'E-Mail Kontakt Analyse',
  linkedinContactAnalysis: 'LinkedIn Kontakt Analyse',
  linkedinContactSearch: 'LinkedIn Kontakt Suche',
  createNewProject: 'Neues Projekt erstellen',
  crawlLinkedinProfiles: 'LinkedIn-Profile crawlen',
  exportEmailContacts: 'E-Mail Kontakte exportieren',
  newProjectName: 'Name des neuen Projekts',
  searchForProjects: 'Suche nach Projekten',
  createExport: 'Export erstellen',
  createNewExport: 'Neuen Export erstellen',
  uploadedEmailAddresses: 'Hochgeladene E-Mail-Adressen: {{count}}',
  uploadedLinkedinUrls: 'Hochgeladene LinkedIn URLs: {{count}}',
  connectToLinkedin: 'Mit LinkedIn verbinden',
  crawlerStarted: 'Crawler läuft',
  crawlerFinished: 'Crawler beendet',
  crawlerSuspended: 'Crawler abgebrochen',
  licenseExpired: 'Die Lizenz ist nicht mehr aktiv. Hier geht es zur Verlängerung.',
  uploadCsvEmail: 'Lade eine CSV-Datei mit E-Mail-Adressen hoch',
  uploadCsvLinkedin: 'Lade eine CSV-Datei mit LinkedIn-URLs hoch\noder füge die URLs direkt mit Hilfe einer LinkedIn-Suche-URL hinzu.',
  addWithSearchUrl: 'Hinzufügen mit Suche-URL',
  dataExportStepOne: '1. CSV hochladen',
  uploadLinkedinUrls: 'LinkedIn URLs hochladen',
  dataAnalysisExampleFile: 'So muss die CSV-Datei aussehen',
  downloadExample: 'Beispiel-Datei herunterladen',
  splitProfiles: 'Aufteilen in Einzelprojekte',
  splitProfilesInfo: 'LinkedIn erlaubt aktuell pro Account nur 150 Profile pro Tag zu besuchen.\nDaher teilen wir die Menge, wenn nötig, auf verschiedene Projekte auf.',
  splitProject: 'Projekt aufteilen & erstellen',
  saveCookies: 'Cookies speichern',
  installExtensionText: 'Extension installieren',
  cookieInfoText1: 'Für die Analyse von LinkedIn-Kontakten benötigen wir zwei Cookies, den JSESSIONID und den li_at Cookie.',
  cookieInfoText2: 'Für den LinkedIn Sales Navigator wird zusätzlich noch der li_a Cookie benötigt.',
  cookieInfoText3: 'Diese werden beim Anmelden bei LinkedIn erstellt und können bequem mit einem Klick von unserer Extension ausgelesen werden.',
  dontWantInstallExtension: 'Möchtest du die Extension nicht installieren?',
  seeHere: 'Dann siehe hier',
  cookieExpiredTitle: 'Session abgelaufen',
  cookieExpiredContent: 'Bitte melde dich erneut bei LinkedIn an und versuche es noch einmal.',
  cookieSignedOutTitle: 'Nicht angemeldet',
  cookieSignedOutContent: 'Bitte melde dich bei LinkedIn an und versuche es noch einmal.',
  cookieDailyLimitReachedTitle: 'Analyse Limit erreicht',
  cookieDailyLimitReachedContent: 'Das tägliche Limit von 150 Analysen pro LinkedIn-Account würde mit diesem Projekt überschritten.\n\nWarte entweder bis morgen oder wechsle die Cookies für das Projekt.\n\nAnzahl möglicher Analysen heute: <strong>{{count}}</strong>',
  cookieDailySearchLimitReachedTitle: 'Suchanfragen Limit erreicht',
  cookieDailySearchLimitReachedContent: 'Das tägliche Limit von 1000 Suchanfragen pro LinkedIn-Account würde mit diesem Projekt überschritten.\n\nWarte entweder bis morgen oder wechsle die Cookies für das Projekt.\n\nAnzahl möglicher Suchanfragen heute: <strong>{{count}}</strong>',
  cookieInvalidTitle: 'Ungültige Cookies angegeben',
  cookieInvalidContent: 'Einer oder mehrere der angegebenen Cookies sind keine gültigen LinkedIn Cookies.\n\nBitte prüfe diese nochmals und gib ggf. gültige LinkedIn Cookies an.',
  getCookiesManually: 'Cookies manuell bekommen',
  changeLinkedinCookies: 'LinkedIn Cookies wechseln',
  deleteProject: 'Projekt löschen',
  deleteProjectWarning: 'Soll das Projekt <strong>{{project}}</strong> wirklich gelöscht werden?\n\nDer Vorgang ist nicht umkehrbar und es steht danach nicht mehr zur Verfügung.',
  editProject: 'Projekt bearbeiten',
  downloadPersonaLists: 'Persona-Listen herunterladen',
  downloadOverallResults: 'Gesamtergebnis herunterladen',
  manualCookiesTutorialTitle: 'Wie erhalte ich meine LinkedIn Cookies manuell?',
  manualCookiesTutorialParagraph1: 'Du kannst oder möchtest unsere Chrome-Extension nicht zum Holen der LinkedIn-Cookies benutzen? Kein Problem! Es gibt auch einen manuellen weg, um die benötigten Cookies zu erhalten.',
  manualCookiesTutorialParagraph2: 'Öffne einen neuen Browser Tab und gehe dort auf <1>www.linkedin.com</1>. Falls noch nicht passiert, melde dich dort an.',
  manualCookiesTutorialParagraph3: 'Rechtsklicke dort ins Leere; damit öffnet sich ein Menü. Klicke auf diesem Menü auf „Untersuchen“, um die Entwicklertools des Browsers zu öffnen.',
  manualCookiesTutorialParagraph4: 'Im oberen Teil dieser Entwicklertools befinden sich verschiedene Tabs. Gehe zu dem „Application“-Tab (Hinweis: kann auch hinter dem Doppelpfeil „>>“ versteckt sein) und dort unter „Storage“ > „Cookies“ > „https://www.linkedin.com“ kannst du dann die gesuchten JSESSIONID und li_at Cookies finden.',
  manualCookiesTutorialParagraph5: 'Kopiere von diesen die Werte aus dem „Value“-Feld und füge sie in unserem Daten-Export-Tool in der Maske an der jeweils richtigen Stelle ein.',
  manualCookiesTutorialParagraph6: '<0>Zur Info:</0> Die Anführungszeichen des JSESSIONID-Cookies werden ebenfalls benötigt, andernfalls wird dieser nicht als gültig erkannt.',
  manualCookiesTutorialParagraph7: 'Das Tutorial wurde speziell für Chrome geschrieben und ist auch für Edge und Opera anwendbar.',
  manualCookiesTutorialParagraph8: 'Nutzt du Firefox oder den Safari Browser, dann schaue doch mal <1>hier</1>.',
  restartCrawler: 'Crawler neu starten',
  enterUrl: 'URL eingeben',
  enterUrlExample: 'Bsp. https://www.linkedin.com/search/results/people/...',
  searchRunning: 'Suche läuft',
  addUser: 'Nutzer hinzufügen',
  addUserToLicense: 'Nutzer zur Lizenz hinzufügen',
  newUserEmail: 'Wähle einen oder mehrere Nutzer aus der Liste aus und füge sie zur Lizenz hinzu.',
  removeUserFromLicense: 'Nutzer von der Lizenz entfernen',
  existingUsers: 'Wähle alle Nutzer aus, die von der Lizenz entfernt werden sollen',
  allUsersAdded: 'Alle Nutzer des Unternehmes wurden bereits zu der Lizenz hinzugefügt.',
  onlySalesNav: 'Nur für LinkedIn Sales Navigator und Linkedin Recruiter',
  linkedProject: 'LinkedIn Projekt',
  linkedSalesNavProject: 'LinkedIn Sales Navigator Projekt',
  unknownError: 'Unbekannter Fehler',
  reason: 'Grund',
  seatCookieMissing: 'li_a Cookie fehlt für Linkedin Sales Navigator Anfragen',
  validationError: 'Fehler im Format der Anfrage',
  newProfileName: 'Name des neuen Profils',
  projectInitiated: 'Projekt initiiert',
  projectType: 'Projekt-Typ',
  contacts: 'Kontakte',
  progressCount: '{{current}} von {{total}}',
  createNewGlobalProfile: 'Neues Globales Profil erstellen',
  addProjectsText: 'Wähle Deine Projekte aus, die Du zu einem Gruppenprofil zusammenfassen möchtest',
  checkProfile: 'Profil prüfen',
  includedProjects: 'Enthaltene Projekte',
  numberOfContacts: 'Gesamtzahl Kontakte',
  significancePassedText: 'Dein Ergebnis ist signifikant.',
  significanceFailedText: 'Dein Ergebnis ist nicht signifikant.',
  significanceFailedTextMissingContacts: 'Füge Projekte mit insgesamt ca. {{difference}} weiteren Kontakten hinzu.',
  significanceFailedTextAdditionalContacts: 'Entferne Projekte mit insgesamt ca. {{difference}} Kontakten.',
  saveAsGlobalProfile: 'Speichern als globales Profil',
  saveNotRecommended: 'Speichern (nicht empfohlen)',
  dataAnalysisFunctions: 'Datenanalyse-Funktionen',
  toTheFeature: 'Zum Produkt',
  toTheManagement: 'Zur Verwaltung',
  openFeature: 'Feature öffnen',
  useInFreemium: 'Im Freemium nutzen',
  freemiumCampaignLimitReached: 'Im Freemium kannst Du nur eine Kampagne erstellen.',
  setProductVisibilityAndLicenses: 'Produkt-Sichtbarkeit & Lizenzen festlegen',
  linkedinProfileCrawler: 'LinkedIn Profile Crawler',
  linkedinProfileCrawlerDescription: 'Ermöglicht das Anreichern von Daten durch die automatische Analyse von LinkedIn Profilen.',
  emailExport: 'E-Mail Export',
  emailExportDescription: 'Ermöglicht das Anreichern von analysierten E-Mail Kontakten.',
  linkedinUrlFinder: 'LinkedIn URL Finder',
  linkedinUrlFinderDescription: 'Findet für eine Liste von Personen die zugehörigen LinkedIn URLs, falls vorhanden.',
  manageCookies: 'LinkedIn Cookies Verwalten',
  manageCookiesDescription: 'Verwaltung der für die LinkedIn Features benötigten Cookies.',
  downloadEmailExportText: 'Die erstellte Datei\n<1>{{fileName}}</1> steht jetzt zum Download bereit.',
  uploadSearchContacts: 'Kontakte hochladen',
  splitSearchProjectsInfo: 'LinkedIn erlaubt aktuell pro Account ca. 1000 Suchanfragen pro Tag.\nUm die Wartezeit gering zu halten teilen wir die Menge, wenn nötig, auf verschiedene Projekte mit max. 50 Suchanfragen auf.',
  uploadedSearchContacts: 'Hochgeladene Kontakte: {{count}}',
  uploadCsvSearchContacts: 'Lade eine CSV-Datei mit zu suchenden Kontakten hoch. Das Format sollte wie folgt aussehen:\n\nVorname > Nachname > Unternehmen\n\nBitte gib hier nur die Kontaktdaten ohne Tabellenüberschriften an.',
  linkedinSearch: 'LinkedIn Suche',
  transformToCrawlingProject: 'Zu LinkedIn Crawler Projekt umwandeln',
  transformProjectsText: 'Wähle hier Deine LinkedIn Suche Projekte aus, die Du zu einem LinkedIn Crawler Projekt zusammenfassen möchtest',
  transformToGroupProfile: 'Zu Gruppenprofil umwandeln',
  info: 'Info',
  augmentedWritingError: 'Es ist ein Fehler beim Text Ausrichten aufgetreten! ',
  linkedinCookiesMissing: 'LinkedIn Cookies fehlen',
  selectUrlsText: 'Wähle hier die URLs aus, die in das neue Projekt übernommen werden sollen',
  displayed: 'Angezeigt: {{count}}',
  selected: 'Ausgewählt: {{count}}',
  showMultipleRepresented: 'Nur mehrfach vertretene anzeigen',
  noAssignment: 'Keine Zuordnung',
  filterBy: 'Filtern nach',
  later: 'Später',
  // new ui keys
  userDoneTitle: 'Glückwunsch!',
  userDoneText1: 'Du hast ein exzellentes Ergebnis erzielt',
  userDoneText2: 'Dein Text ist jetzt optimiert',
  hrBooster: 'SAIA Recruiting',
  salesBooster: 'Sales Booster',
  leadBooster: 'SAIA Sales',
  loadExistingProjects: 'Vorhandene Projekte laden',
  loadingProfile: 'Lade Profil',
  firstStep: '1. Schritt',
  secondStep: '2. Schritt',
  thirdStep: '3. Schritt',
  selectJob: 'Profil wählen',
  generateTextVariants: 'Text generieren',
  finalizeText: 'Text finalisieren',
  textGenPlaceholder: 'Hier kann Text mithilfe von Bulletpoints generiert und anschließend entweder der generierte Text oder ein eigener Text optimiert und finalisiert werden.',
  finalizeTextPlaceholder: 'Die Funktion führt Dich zur Textverbesserung, um Deine Texte zum Schluss zu finalisieren.',
  finalizeTextPlaceholderWithOccupation: 'Die Funktion führt Dich zur Textverbesserung, um Deine Texte zum Schluss zu finalisieren.\n\nIn diesem letzten Schritt optimieren wir den Match zur Persona {{occupation}}',
  nothingSuitable: 'Nichts Passendes Dabei oder nichts angezeigt?',
  requestGlobalProfile: 'Globales Profil anfordern',
  timeUntilProfileCreated: 'Wir benötigen normalerweise maximal 48 Stunden bis ein Profil für Dich erstellt wurde und zur Verfügung steht.',
  option: 'Option {{number}}',
  enterProfession: 'Gib hier einen Beruf ein, z. B. Recruiter',
  enterProjectName: 'Gib hier den Projektnamen ein',
  cancel: 'Abbrechen',
  accept: 'Akzeptieren',
  jobOfferCompanyDescriptionInstruction: 'Schreibe hier etwas über Deine Firma:',
  jobOfferCompanyDescriptionPlaceholder: 'z.B.\nSAIA, mit Sitzt in Heilbronn, bietet Lösungen für die Verbesserung von Recruiting, Marketing und Sales an. Seit dem Start in 2018 entwickelte sich die Firma kontinuierlich zu einem erfolgreichen Anbieter von AI Lösung weiter. Dabei setzt das Unternehmen auf eine Mischung aus psychologischen Targeting und Generative AI Lösungen und erschafft einzigartigen Content.',
  jobOfferResponsibilitiesInstruction: 'Liste hier die Aufgaben der Position auf:',
  jobOfferWhyYouPlaceholder: 'Du würdest aufgrund Deiner Erfahrung im Bereich Data Science und Deiner bisherigen Projekte sehr gut zu uns passen.Dein bisheriger Lebensweg zeigt, dass Du internationale Erfahrungen hast und daher sehr gut zu unserem internationalen Projektteam passen würdest. ',
  jobOfferJobTitleInstruction: 'Gib hier die Berufsbezeichnung an:',
  jobOfferJobTitlePlaceholder: 'z.B. Data Scientist (m/w/d)',
  jobOfferDivisionDescriptionInstruction: 'Schreibe hier etwas über deine Abteilung:',
  jobOfferDivisionDescriptionPlaceholder: 'z.B.\nGemeinsam mit unserem Team kümmern wir uns um Analysen zur Erfassung von Marktdaten und Verkaufschancen und liefern damit einen entscheidenden Beitrag zum Erfolg von SAIA.',
  jobOfferBenefitsInstruction: 'Schreibe hier was ihr den Kandidaten bietet:',
  jobOfferBenefitsPlaceholder: 'z.B.\nWir bieten flexibles Arbeiten von überall auf der Welt, tolle Events und das wichtigste eine Umgebung, die auf das voneinander Lernen setzt.',
  jobOfferCtaInstruction: 'Nenne hier einen Call-to-Action:',
  jobOfferCtaPlaceholder: 'z.B. Bewirb Dich jetzt unter application@secret-ai-agent.de',
  textGenDoneInstruction: 'Klicke auf "In Textfeld kopieren" oder kopiere Dir einzelne Abschnitte in das Textfeld des 3. Schritts.',
  recentProjects: 'Neueste Projekte',
  delete: 'löschen',
  toTheProject: 'Zum Projekt',
  ok: 'Ok',
  confirmDeleteProjectText: 'Soll das Projekt {{projectName}} wirklich gelöscht werden?\n\nDieser Vorgang ist nicht umkehrbar und das Projekt steht danach nicht mehr zur Verfügung.',
  result: 'Ergebnis',
  profiling: 'Profiling',
  cacheText: 'Text zwischenspeichern',
  meanings: 'Bedeutungen',
  targetValue: 'Zielwert des Persönlichkeitstyps',
  currentValue: 'Aktueller Wert Deines Textes',
  paiMatch: 'Agent-Match',
  paiMatchDetails: 'Agent-Match Details',
  motiveMatch: 'Motiv-Match',
  languageStyleMatch: 'Sprachstil-Match',
  genderMatch: 'Gender-Match',
  grammarOptimization: 'Grammatik Verbesserung',
  paiMatchOptimization: 'Agent-Match Verbesserung',
  ignoreOnce: 'einmal ignorieren',
  alwaysIgnore: 'immer ignorieren',
  suggestions: 'Vorschläge',
  plusMoreSuggestions: '+ ca. {{count}} weitere',
  congratulations: 'Glückwunsch',
  userDoneText: 'Du sprichst {{profileName}} nun erfolgreich an',
  personalityType: 'Persönlichkeitstyp',
  analyzeTextButtonText: 'Text analysieren & Vorschläge erhalten',
  analyzeTextButtonTextShort: 'Text analysieren',
  saveTextButtonText: 'Text speichern & beenden',
  saveTextButtonTextShort: 'Speichern & beenden',
  hrBoosterFinalTextTitle: 'Hier findest Du Deine fertige Stellenanzeige für {{occupation}}',
  leadBoosterFinalTextTitle: 'Hier findest Du Deinen fertigen Text für {{occupation}}',
  copyText: 'Text kopieren',
  textCopied: 'Text kopiert',
  leadBoosterProblemsInstruction: 'Liste hier die Probleme der Ansprechpartner und Ansprechpartnerinnen auf:',
  leadBoosterProblemsPlaceholder: 'z.B.\n- Zu wenige Rückmeldungen im Outbound\n- Zu wenig Zeit sich auf jeden Prospect optimal vorzubereiten\n- Zielerreichung gefährdet',
  leadBoosterFeaturesInstruction: 'Liste hier die Features Deiner Dienstleistung/Produktes auf:',
  leadBoosterFeaturesPlaceholder: 'z.B.\n- Persönlichkeitstyp automatisch erkennen\n- Texte für Persönlichkeitstyp generieren\n- Texte für Persönlichkeitstypen ausrichten',
  leadBoosterBenefitsInstruction: 'Liste hier die Benefits Deiner Dienstleistung/Produktes auf:',
  leadBoosterBenefitsPlaceholder: 'z.B.\n- Sicherheit in der Ansprache gewinnen\n- Schneller Texte erstellen und Zeit gewinnen\n- Bessere Texte formulieren und mehr Leads gewinnen',
  leadBoosterImpactInstructions: 'Liste hier den Business Impact Deiner Dienstleistung/Produktes auf:',
  leadBoosterImpactPlaceholder: 'z.B.\n- 2x mehr Leads\n- 90% mehr Zeit\n- 100% mehr Sicherheit',
  leadBoosterSocialProofInstructions: 'Nenne hier den Social Proof Deines Produktes:',
  leadBoosterSocialProofPlaceholder: 'z.B.\nPerson/Firma XYZ nutzt unser Produkt und erzielt damit 30 % höhere Conversions.',
  leadBoosterEventTitleInstructions: 'Nenne hier den Titel Deines Events:',
  leadBoosterEventTitlePlaceholder: 'z.B.\nWebinar: Höhere Conversions mit SAIA',
  leadBoosterEventDescriptionInstructions: 'Liste hier die Beschreibung Deines Events auf:',
  leadBoosterEventDescriptionPlaceholder: 'z.B.\n- Im Event lernt man wie SAIA automatisch Persona erstellt\n- Aus den Zielgruppendaten Texte erstellt\n- Und die User unterstützt diese auf die emotionalen Bedürfnisse der Zielgruppe anzupassen',
  leadBoosterDateInstructions: 'Nenne hier den Termin Deines Events:',
  leadBoosterDatePlaceholder: 'z.B.\nTag und Uhrzeit des Events',
  leadBoosterProductNameInstructions: 'Nenne hier den Namen Deines Produktes:',
  leadBoosterProductNamePlaceholder: 'z.B.\nSAIA SAIA Sales',
  leadBoosterProductInfoInstructions: 'Liste hier die Beschreibung Deines Produktes auf:',
  leadBoosterProductInfoPlaceholder: 'z.B.\n- SAIA Sales erstellt anhand von echten Zielgruppendaten Persona\n- Unterstützt in der Texterstellung mit GPT\n- Hilft beim Framen der Texte auf die Persona',
  leadBoosterTitleInstructions: 'Nenne hier den Titel Deines Blogposts:',
  leadBoosterTitlePlaceholder: 'z.B.\nKI in der Leadgeneration: 10 KI Tools zur Verbesserung der Leadgeneration',
  leadBoosterCompanyNameInstructions: 'Nenne hier den Namen Deines Unternehmens:',
  leadBoosterCompanyNamePlaceholder: 'z.B.\nSAIA',
  selectGenreText: 'Textgenre auswählen',
  product: 'Produkt',
  back: 'zurück',
  loadExistingTemplates: 'Vorhandene Templates laden',
  enterNewTemplateName: 'Gib hier den neuen Templatenamen ein',
  persona: 'Persona',
  recentTemplates: 'Aktuelle Templates',
  contactRequest: 'Kontaktanfrage',
  emailShort: 'E-Mail',
  close: 'Schließen',
  home: 'Home',
  upgrade: 'Upgrade',
  help: 'Hilfe',
  account: 'Account',
  login: 'Anmelden',
  logout: 'Abmelden',
  linkedinExtension: 'LinkedIn Erweiterung',
  appsandintegrations: 'Apps & Integrationen',
  personaGenerator: 'Ind. Profile Generator',
  personaGeneratorCardInstructionPrimary: 'Erstelle ein Persönlichkeitsprofil',
  personaGeneratorCardInstructionSecondary: 'das anhand von LinkedIn-Suchen die Zielgruppe spiegelt.',
  collapse: 'einklappen',
  expand: 'ausklappen',
  collapseSidebar: 'Sidebar Einklappen',
  urlFinder: 'LinkedIn Profile Finder',
  urlFinderCardInstructionPrimary: 'Finde LinkedIn Profile',
  urlFinderCardInstructionSecondary: 'anhand von Kontaktinformationen.',
  createOwnProfile: 'Eigenes Profil erstellen',
  profileCreationRequirements: 'Es wird ein LinkedIn Premium, Sales-Navigator oder Recruiter Account benötigt, um Profile selbst zu erstellen.',
  addProfilesToPersona: 'Füge Profile der Persona zu',
  classifyPersonalityTypes: 'Klassifiziere Persönlichkeitstypen',
  definePersonalityTypeManually: 'Persönlichkeitstyp manuell definieren',
  personaGeneratorStepTwoPlaceholder: 'Wähle hier aus den Personen aus, die wir nach Deiner Definition bei LinkedIn gefunden haben.',
  evaluationResult: 'Ergebnis der Evaluation',
  personaGeneratorStepThreePlaceholder: 'Hier wird Dir die Persona und einige Informationen zur Persona angezeigt, sobald Du den Prozess beendet hast.',
  personaSuccessfullyCreated: 'Persona erfolgreich erstellt',
  personaSuccessfullyCreatedText: 'Die Persona wurde erfolgreich erstellt und Du kannst sie nun im HR- und Leadbooster nutzen.',
  searchViaLinkedin: 'Suche direkt über LinkedIn',
  enterSearchUrl: 'Gib hier eine LinkedIn, Sales-Navigator oder Recruiter Such-Url ein',
  startSearch: 'Suche starten',
  createClassificationProjectCount: 'Klassifikationsprojekt erstellen ({{count}})',
  useUrlFinderProjects: 'Benutze Deine URL Finder Projekte',
  noUrlFinderProjectsYet: 'Noch keine LinkedIn Profile Finder Projekte?',
  selectUrlFinderProject: 'Wähle ein URL Finder Projekt',
  applyUrlFinderProject: 'URL Finder Projekt übernehmen',
  create: 'Erstellen',
  save: 'Speichern',
  peopleFoundOnLinkedin: 'Liste folgender Personen auf LinkedIn gefunden',
  personaGeneratorUrlFinderProjectsText: 'Du kannst nun entscheiden, welche der Personen für Dich für die Zielgruppe relevant sind. Danach werden die einzelnen LinkedIn-Profile klassifiziert und Du kannst diese zu einer Persona zusammenfügen.',
  createClassificationProject: 'Klassifikationsprojekt erstellen',
  manageClassificationProject: 'Hier kannst Du Dein Klassifikationsprojekt "{{projectName}}" verwalten',
  personaGeneratorClassificationProjectsText: 'Du benötigst mindestens ein abgeschlossenes Projekt, um eine Persona zu evaluieren. Wenn das Ergebnis noch nicht signifikant ist, kannst du hier weitere Persönlichkeitstypen klassifizieren.',
  evaluatePersona: 'Persona evaluieren',
  export: 'Exportieren',
  restart: 'Neu starten',
  completed: 'abgeschlossen',
  startNow: 'Jetzt starten',
  personaSignificantText: 'Gratuliere, die Persona ist signifikant und Du kannst sie jetzt speichern.',
  personaNotSignificantText: 'Die Persona ist noch nicht signifikant. Wir empfehlen Dir noch weitere Daten zu klassifizieren, damit die Persona aussagekräftig wird.',
  savePersona: 'Persona speichern',
  savePersonaAnyway: 'Persona trotzdem speichern',
  globallySavePersona: 'Persona global speichern',
  maxContactsDialogTitle: 'Wir haben Festgestellt, dass Du mehr als 150 Personen in Deiner Suche hast.',
  maxContactsDialogText: 'LinkedIn erlaubt Nutzern maximal 150 Profile pro Tag zu analysieren. Wir werden daher die Suche in einzelne Projekte aufteilen.',
  maxContactsDialogAction: 'Analyse aufteilen & starten',
  cookieDialogTitle: 'Hallo {{firstName}}, Wir haben festgestellt, dass Deine LinkedIn Cookies nicht Funktionieren.',
  connectViaExtension: 'Über unsere Extension mit LinkedIn verbinden',
  getCookies: 'Hole Cookies',
  installOurExtension: 'SAIA Extension installieren',
  manualInputCookies: 'Manuelle Eingabe der LinkedIn Cookies',
  howDoIt: 'Wie geht das?',
  enterLiAtCookie: 'Gib hier den li_at Cookie ein',
  enterJsessionIdCookie: 'Gib hier den JSESSIONID Cookie ein',
  enterLiACookie: 'Gib hier den li_a Cookie ein (Sales Navigator & Recruiter)',
  enterPersonaName: 'Gib hier den Personanamen ein',
  confirmSaveGlobalProfile: 'Die ausgewählten Projekte werden als globales Profil unter dem Namen <1>{{profileName}}</1> gespeichert.\n\nDas ist eine Adminfunktion und kann nur schwer im Nachgang korrigiert werden.',
  provideContactInformation: 'Bereitstellen der Kontaktinformationen',
  findLinkedinUrls: 'LinkedIn URLs finden',
  urlFinderPlaceholder: 'Hier werden später deine URL Finder Projekte angezeigt',
  searchLinkedinUrlsViaCsv: 'Suche LinkedIn-URLs über eine CSV- oder Excel-Datei',
  uploadCsv: 'CSV hochladen',
  profileFinderCsvFormatContacts: 'CSV-Format:\nVorname, Nachname, Firmenname, E-Mail-Adresse - ohne Header.',
  profileFinderCsvFormatWebsite: 'CSV-Format:\nFirmenname, Suchbegriffe, Land - ohne Header.',
  rowsCount: 'Suchen: {{count}}',
  manageUrlFinderProject: 'Hier kannst Du Dein URL Finder Projekt "{{projectName}}" verwalten',
  urlFinderProjectsText: 'Du benötigst mindestens ein abgeschlossenes Projekt, um aus den gefundenen LinkedIn-URLs eine Persona zu generieren oder den Persönlichkeitstyp zu klassifizieren.',
  createPersonaProject: 'Persona Projekt erstellen',
  profiles: 'Profile',
  profile: 'Profil',
  german: 'Deutsch',
  english: 'Englisch',
  italian: 'Italienisch',
  french: 'Französisch',
  spanish: 'Spanisch',
  portuguese: 'Portugiesisch',
  dutch: 'Niederländisch',
  nameOfCompany: 'Name des Unternehmens',
  zip: 'Postleitzahl',
  zipShort: 'PLZ',
  street: 'Straße',
  city: 'Stadt',
  savedIgnoredSuggestionSuccess: 'Der Vorschlag wurde erfolgreich in das Wörterbuch aufgenommen und wird künftig nicht mehr auftreten.',
  year: 'Jahr',
  month: 'Monat',
  anotherLicenseRequired: 'Du benötigst für dieses Feature eine weitere Lizenz',
  annualBilling: 'Jährliche Abrechnung',
  monthlyBilling: 'Monatliche Abrechnung',
  discountAnnualBilling: 'Spare durch jährliche Abrechnung!',
  jobOffers: 'Stellenangebote',
  jobOffer: 'Stellenangebot',
  activeSpeech: 'Aktive Ansprache',
  personaAndLeadGenerator: 'Persona & Lead\nGenerator',
  amountContacts: '{{count}} Kontakte',
  cancelableAnytime: 'jederzeit kündbar',
  cancelableAnnually: 'jährlich kündbar',
  select: 'Auswählen',
  enterNumberOfUsers: 'Gib hier die Anzahl an Nutzer ein',
  enterNumberOfProfiles: 'Gib hier die Anzahl an Profilen ein',
  enterNumberOfPackages: 'Gib hier die Anzahl an Paketen an',
  unlimitedWriting: 'unlimitiert Schreiben',
  amountProfiles: '{{count}} Profil',
  amountLanguages: '{{count}} Sprachen ({{languages}})',
  featureLinkedinExtension: 'LinkedIn Erweiterung',
  featureTemplateGeneration: 'Templates automatisch generieren',
  featureAlignTemplates: 'Templates auf verschiedene Zielgruppen ausrichten',
  featureEvaluateCommunicationQuality: 'Qualität der Kommunikation bewerten',
  featureAlignTexts: 'Texte an die Zielgruppe ausrichten',
  featureGenerateTexts: 'Texte automatisch generieren',
  featureAlignTextsWithNeeds: 'Texte an Bedürfnissen ausrichten',
  featurePersonaCreation: 'Personaerstellung',
  featureExportLeadLists: 'Export der Leadlisten zur Anreicherung für das CRM',
  warningCompanyInfoMissing: 'Unternehmensinformationen ergänzen',
  warningCompanyInfoMissingContent: 'Zur Rechnungsstellung benötigen wir die vollständigen Unternehmensinformationen. Bitte ergänze diese zuerst.',
  warningOnlyIntegers: 'Nur Ganzzahlen erlaubt',
  warningOnlyIntegersContent: 'Die eingegebene Stückzahl ist keine Ganzzahl.',
  motiveTests: 'Motive Tests',
  personalityTests: 'Persönlichkeitstests',
  leadSection: 'LEAD',
  yourInformation: 'Deine Informationen',
  accountManagement: 'Kontenverwaltung',
  licenseManagement: 'Lizenzverwaltung',
  companyInformation: 'Unternehmensinformationen',
  changePasswordSuccess: 'Glückwunsch, Dein Passwort wurde erfolgreich geändert.',
  changeUserInfoSuccess: 'Glückwunsch, Deine Nutzerinformationen wurden erfolgreich geändert.',
  data: 'Daten',
  noValidEmailError: 'Keine gültige E-Mail-Addresse',
  saveChanges: 'Änderungen speichern',
  password: 'Passwort',
  oldPassword: 'Altes Passwort',
  wrongOldPassword: 'Altes Passwort falsch',
  newPassword: 'Neues Passwort',
  currentPassword: 'Aktuelles Passwort',
  enterCurrentPasswordHere: 'Gib hier Dein aktuelles Passwort ein',
  enterNewPasswordHere: 'Gib hier Dein neues Passwort ein',
  confirmNewPassword: 'Neues Passwort wiederholen',
  confirmNewPasswordHere: 'Gib hier Dein neues Passwort erneut ein',
  passwordTooShort: 'Passwort ist zu kurz (min. 6 Zeichen)',
  passwordTooLong: 'Passwort ist zu lang (max. 50 Zeichen)',
  repeatNewPassword: 'Neues Passwort wiederholen',
  passwordsNoMatch: 'Passwörter stimmen nicht überein',
  successfullyChanged: 'Erfolgreich geändert',
  usersInSystem: 'Diese Nutzer gibt es im System',
  userName: 'Benutzername',
  edit: 'bearbeiten',
  createUser: 'Nutzer erstellen',
  editUser: 'Nutzer bearbeiten',
  deleteUser: 'Nutzer löschen',
  deleteUserWarning1: 'Soll der Nutzer <1>{{userName}}</1> wirklich gelöscht werden?',
  deleteUserWarning2: 'Dieser Vorgang ist nicht umkehrbar und der Nutzer steht danach nicht mehr zur Verfügung.',
  dataProceedQuestion: 'Was soll mit den Daten von <1>{{userName}}</1> passieren?',
  dataProceedInfo: 'Die Daten werden unwiderruflich gelöscht.',
  dataTransferQuestion: 'Auf welchen Nutzer sollen die Daten übertragen werden?',
  createAccount: 'Konto anlegen',
  company: 'Unternehmen',
  role: 'Rolle',
  language: 'Sprache',
  license: 'Lizenz',
  editAccount: 'Konto bearbeiten',
  licensesInSystem: 'Diese Lizenzen gibt es im System',
  licenseUserName: 'Name des Lizenznutzers',
  remove: 'entfernen',
  user: 'Nutzer',
  limits: 'Limits',
  expiredOn: 'Läuft aus am',
  add: 'hinzufügen',
  createLicense: 'Lizenz erstellen',
  upgradeLicense: 'Lizenz upgraden',
  bookedLicenses: 'Gebuchte Lizenzen',
  chatStatus: 'Status',
  activeUntil: 'Aktiv bis: {{expirationDate}}',
  toUpgrade: 'upgraden',
  cancelLicense: 'stornieren',
  renew: 'erneuern',
  transactions: 'transaktionen',
  removeUser: 'Nutzer entfernen',
  removeUserWarning: 'Soll der Nutzer wirklich von der Lizenz entfernt werden? Der Nutzer kann später wieder zu dieser oder einer anderen Lizenz hinzugefügt werden.',
  deleteLicense: 'Lizenz löschen',
  deleteLicenseWarning1: 'Soll die Lizenz für <1>{{licenseName}}</1> wirklich gelöscht werden?',
  deleteLicenseWarning2: 'Dieser Vorgang ist nicht umkehrbar und die Lizenz steht danach nicht mehr zu Verfügung.',
  companyNameTooLong: 'Firmenname zu lang (max. 29 Zeichen)',
  companyAddressMissing: 'Anschrift der Firma fehlt teilweise oder komplett',
  companyName: 'Name der Firma',
  companiesInSystem: 'Diese Firmen gibt es im System',
  changeCompanyInformationSuccess: 'Glückwunsch, Deine Unternehmensinformationen wurden erfolgreich geändert.',
  deleteCompany: 'Firma löschen',
  deleteCompanyWarning: 'Soll die Firma "{{companyName}}" wirklich gelöscht werden?\n\nDieser Vorgang ist nicht umkehrbar und die Firma steht danach nicht mehr zur Verfügung.',
  editCompany: 'Firma "{{companyName}}" bearbeiten',
  motiveAnalysis: 'Motiv-Analyse',
  motiveAnalysisSubText: 'Hier können Sie die Original PSE (Picture Story Exercise) durchführen und erhalten neben den impliziten Motiven ebenfalls eine Aussage zu den expliziten Motiven der Personen. Dies unterstützt Sie im Führungskräftecoaching. ',
  leadLeadershipFeedback: 'LEAD-\nFührungsfeedback',
  leadSubText: 'Erhalten Sie 360 ° Feedback Ihrer Kompetenzen über unsere komplett flexible Führungskräfteplattform. ',
  contactPartnerTitle: 'Hallo {{firstName}}, Wir Bieten den Persönlichkeitstest gemeinsam mit unserem Partner A47 Consulting an.',
  contactPartnerText: 'Wenn Du daran Interesse hast, kannst Du A47 Consulting gerne kontaktieren.',
  contactPartner: 'A47 kontaktieren',
  placeholders: 'Platzhalter',
  skip: 'überspringen',
  textImpact: 'Wirkung Deines Textes',
  selectedGlobalProfile: 'Du hast folgendes globales Profil gewählt',
  selectedOwnProfile: 'Du hast folgendes eigenes Profil gewählt',
  globalProfiles: 'Globale Profile',
  globalProfile: 'Globales Profil',
  tailoredProfiles: 'Individuelle Profile',
  addCompany: 'Firma hinzufügen',
  transfer: 'übertragen',
  createacc: 'Noch keinen Account? Hier registrieren',
  email: 'E-Mail-Adresse',
  forgotpw: 'Passwort vergessen?',
  remember: 'Benutzernamen merken',
  signin: 'Anmelden',
  signup: 'Registrieren',
  backToLogin: 'Zurück zur Anmeldung',
  signupsucces: 'Registrierung\nerfolgreich',
  signupsucces1: 'Du hast eine E-Mail erhalten',
  signupsuccesAction1: 'Bestätige über den Link Deine E-Mail Adresse',
  signupsuccesAction2: 'Prüfe auch Deinen Spam Ordner, falls die E-Mail nicht im Posteingang ist',
  signupsucces2: 'Du kannst Dich auch erst einmal anmelden und Deine E-Mail später verifizieren.',
  agreeConditionsInfo: 'Wenn Du fortfährst, erklärst Du dich mit den folgenden Bedingungen einverstanden',
  resetPassword: 'Passwort\nzurücksetzen',
  forgetPasswordTitle: 'E-Mail anfordern',
  forgetPasswordParagraph: 'Um Dein Passwort zurück setzen zu können, senden wir dir eine E-Mail an Deine im Profil hinterlegte E-Mail Adresse',
  forgetPasswordEnterNow: 'Bitte gib diese jetzt hier ein',
  forgetPasswordEmailSent1: 'Wir haben eine E-Mail an "{{email}}" gesendet.',
  forgetPasswordEmailSent2: 'Bitte klicke auf den dort hinterlegten Link, um fortzufahren.',
  requestPwMail: 'E-Mail jetzt anfordern',
  resetPasswordTitle: 'Neues Passwort eingeben',
  resetPasswordParagraph: 'Lege jetzt Dein neues Passwort fest',
  resetPasswordNow: 'Passwort jetzt zurücksetzen',
  backToRequestMail: 'Zurück zu E-Mail-Anfordern',
  passNoMatch: 'Passwörter stimmen nicht überein',
  resetPasswordTokenExpired: 'Das Token ist abgelaufen, bitte fordere erneut eine E-Mail an',
  extensionInstallationSuccessTitle: 'Erweiterung\nerfolgreich installiert',
  extensionInstallationSuccess1: 'Gratuliere! Du hast die Erweiterung erfolgreich installiert!',
  extensionInstallationSuccess2: 'Du kannst jetzt LinkedIn öffnen',
  extensionInstallationSuccess3: 'Solltest Du LinkedIn bereits geöffnet haben, lade die Seite bitte neu',
  extensionInstallationSuccess4: 'Du benötigst einen SAIA Account, um die Erweiterung nutzen zu können',
  extensionInstallationSuccess5: 'Wenn Du noch keinen SAIA Account hast, kannst Du dir kostenlos einen auf unserer Webseite erstellen',
  openLinkedIn: 'LinkedIn öffnen',
  backToDashboard: 'Zur SAIA Webseite',
  paidModels: 'Schaue dir hier auch unsere kostenpflichtigen Modelle an',
  activityChartYAxis: 'Anzahl Gesamtnutzung / KW',
  activityChartXAxis: 'KW {value}',
  activityTooltip: '<strong>{c} x</strong><br/>genutzt in KW {b}',
  clone: 'klonen',
  show: 'Anzeigen',
  boosterWords: 'Booster\nWorte',
  doesAndDonts: 'Does & Dont\'s',
  textOptimization: 'Text\nOptimierung',
  emailOptimization: 'E-Mail\nOptimierung',
  textGeneration: 'Text\nGenerierung',
  optimizedTemplates: 'Optimierte\nTemplates',
  boosterWordsInstruction: 'Diese Worte kommen bei Deinem Gegenüber besonders gut an. Nutze sie und verbessere damit Deine Ansprache.',
  doesInstruction: 'Diese Do\'s sind Deinem Gegenüber besonders wichtig. Beachte sie und verbessere damit Deine Ansprache.',
  dontsInstruction: 'Auf diese Dont\'s musst du bei Deinem Gegenüber besonders achten. Vermeide sie und verbessere damit Deine Ansprache.',
  copyTemplateInstruction: 'Kopiere Dein auf "{{personaName}}" optimiertes Template und verbessere Deine Ansprache',
  noAssessmentTitle: 'Zu wenig Daten',
  noAssessment1: 'Der ausgewählte Kontakt hat nicht genug Daten, um ein aussagekräftiges Profil zu erstellen.',
  preview: 'vorschau',
  outlookAddIn: 'Outlook Add-in',
  apiKey: 'API-Schlüssel',
  vstoNotSupportedTitle: 'COM Add-in wird nicht länger unterstützt',
  vstoNotSupportedMessage: 'Sehr geehrte Nutzerinnen und Nutzer,\n\nwir möchten Ihnen mitteilen, dass wir ab sofort die Unterstützung für COM Add-ins in Outlook einstellen werden. Bitte beachten Sie, dass dies nur ältere Versionen von Outlook betrifft und dass unser Outlook Add-in für MS Office 365 weiterhin unterstützt und weiterentwickelt wird.\n\nWir empfehlen Ihnen, wenn möglich, auf unser Outlook Add-in für MS Office 365 umzusteigen, um auch in Zukunft von unseren neuesten Funktionen und Updates profitieren zu können.\n\nWir danken Ihnen für Ihre Treue und hoffen, dass Sie weiterhin von unseren Produkten profitieren werden.\n\nMit freundlichen Grüßen\n\nSAIA',
  settings: 'Optionen',
  forbiddenDomains: 'Ignorierte Domains',
  reallyDeleteOutlookData: 'Outlook-Daten löschen',
  deleteOutlookDataWarning: 'Es werden alle Outlook Daten gelöscht.\n\nDieser Vorgang ist nicht umkehrbar und die Daten stehen danach nicht mehr zur Verfügung.',
  error: 'Fehler',
  clickToAuthenticate: 'Add-in authentifizieren',
  notAuthenticated: 'Das Add-in ist möglicherweise noch nicht authentifiziert.',
  reloadAddin: 'Starten Sie nun das Add-in neu. Falls das Problem weiterhin auftritt, kontaktieren Sie uns bitte.',
  outlookAuthTitle: 'Authentifizierung\nerfolgreich',
  outlookAuthText: 'Das Outlook Add-in von SAIA wurde erfolgreich authentifiziert.',
  connectedTo: 'Verbunden mit:\n<strong>{{domain}}</strong>',
  selectSuitableProfile: 'Wähle eine passendes Profil aus, um fortzufahren.',
  chooseContactOutlook: 'Für welchen der Empfänger soll der Text optimiert werden?',
  importText: 'Text importieren',
  textGenerationInstruction: 'Generiere einen auf den Kontakt angepassten Text. Nutze dafür ein bereits vorhandenes Projekt oder erstelle ein Neues.',
  createNewTextProject: 'Neues Textprojekt starten',
  saveContentTitle: 'Inhalt für später speichern',
  saveContent: 'Soll der aktuelle Inhalt der Textfelder in einem neuen Projekt gespeichert werden?',
  contactCharacteristics: 'Eigenschaften von {{contactName}}',
  definesContact: 'Das definiert {{contactName}}',
  checkingInbox: 'Durchsuche den Posteingang auf neue Nachrichten von {{contactEmail}}',
  job_offer: 'Stellenanzeige',
  active_sourcing: 'Active Sourcing für LinkedIn Textgenerierung',
  active_sourcing_short: 'Active Sourcing',
  sales_email: 'Sales E-Mail für LinkedIn Textgenerierung',
  sales_email_short: 'Sales E-Mail',
  connection_request: 'Kontaktanfrage für LinkedIn Textgenerierung',
  connection_request_short: 'Kontaktanfrage',
  marketing_newsletter: 'Marketing Newsletter',
  social_post: 'Social Media Post',
  social_ad: 'Social Media Ad',
  invitation: 'Einladung',
  blogpost: 'Blogpost',
  landingpage: 'Landingpage',
  product_desc: 'Produktbeschreibung',
  generateTableOfContents: 'Table of Contents generieren',
  createContent: 'Content erstellen',
  tableOfContents: 'Inhaltsverzeichnis',
  createANewProject: 'Erstelle ein <1>Neues Projekt</1>',
  yourProductLibrary: 'Deine <1>{{product}}</1> Bibliothek',
  selectProject: 'Projekt auswählen',
  selectTemplate: 'Template auswählen',
  backToLandingPage: 'Zurück zur Übersichtsseite',
  outlookWelcomeMessage: 'Willkommen bei\nSAIA',
  goToLogin: 'Zur Anmeldung',
  outlookFirstRunExperienceText1: 'Unser Add-in zeigt Dir die Persönlichkeit Deines Ansprechpartners.',
  outlookFirstRunExperienceText2: 'Damit generierst Du zukünftig maßgeschneiderte E-Mails und überzeugst mit herausragender Kommunikation.',
  outlookFirstRunExperienceText3: 'Erlebe die Wirkung von SAIA und verbessere Deine E-Mail-Kommunikation.',
  outlookFirstRunExperienceText4: 'Registriere Dich jetzt oder melde Dich mit einem bestehenden Account an und entdecke die Vorteile personalisierter, effizienter und wirkungsvoller Gespräche!',
  errorDialogTitle: 'Ein Fehler ist aufgetreten',
  errorDialogText1: 'Ein oder mehrere Fehler sind auf dem Pfad <1>{{source}}</1> aufgetreten',
  errorDialogText2: 'Wenn das Problem weiterhin auftritt, melde Dich bitte bei uns.',
  errorsOccurred: 'Welche Fehler sind aufgetreten?',
  report: 'Fehler melden',
  errorEmailSubject: 'Fehler im Dashboard',
  errorEmailBody: 'Liebes SAIA Team,\n\nfolgende Fehler sind bei mir auf dem Pfad "{{source}}" im Dashboard aufgetreten:\nZeitstempel: {{timestamp}}\nFehler: {{errors}}\n\nViele Grüße\n{{userName}}',
  timestamp: 'Zeitstempel',
  autoDetect: 'Automatisch erkennen',
  limitReachedSpecialPlan: 'Solltest Du einen speziellen Plan für dich oder dein Unternehmen benötigen, dann melde dich bitte direkt bei <1>toni.kuenzl@secret-ai-agent.de</1> und wir finden zusammen eine passende Lösung.',
  linkedinRequired: 'LinkedIn benötigt',
  leadBoosterGlobalProfilesProductDescriptionMain: 'Verbessere Deine Marketing Kampagnen',
  leadBoosterGlobalProfilesProductDescriptionSub: 'basierend auf KI-generierten globalen Berufsprofilen.',
  leadBoosterTailoredProfilesProductDescriptionMain: 'Erstelle Kampagnentexte',
  leadBoosterTailoredProfilesProductDescriptionSub: 'entsprechend Deiner Suchanforderungen.',
  personaGeneratorProductDescriptionMain: 'Erstelle Personas und verbessere Deine Ads',
  personaGeneratorProductDescriptionSub: 'entsprechend Deiner Suchanforderungen.',
  hrBoosterGlobalProfilesProductDescriptionMain: 'Verbessere Deine Stellenanzeigen',
  hrBoosterGlobalProfilesProductDescriptionSub: 'basierend auf KI-generierten globalen Berufsprofilen.',
  hrBoosterTailoredProfilesProductDescriptionMain: 'Verbessere Deine Stellenanzeigen',
  hrBoosterTailoredProfilesProductDescriptionSub: 'entsprechend Deiner Suchanforderungen.',
  linkedinSearchDurationInfoTitle: 'Das könnte etwas dauern',
  linkedinProfileSearchDurationInfo: 'Wir erstellen nun eine Liste von LinkedIn-Kontakten anhand Deiner Such-URL.',
  linkedinProfileSearchDurationTime: 'Dieser Vorgang dauert schätzungsweise 5-6 Minuten.',
  linkedinSearchDurationWarning: 'Lasse das Browserfenster geöffnet und lade die Seite nicht neu, solange das Feature läuft. Ansonsten bricht der Service ab.',
  personaGeneratorDurationInfo: 'Wir analysieren nun die LinkedIn-Profile basierend auf den zuvor bereitgestellten LinkedIn-URL\'s.',
  personaGeneratorDurationTime: 'Dieser Vorgang kann bis zu 2 Stunden dauern.',
  personaGeneratorDurationWarning: 'Du kannst die Seite nun verlassen und später vorbeischauen, wenn die Analyse beendet ist.',
  politeSpeech: 'Höfliche Sprache',
  casualSpeech: 'Lockere Sprache',
  includeEmoji: 'Emoji einfügen',
  autoOptimize: 'Auto Optimierung',
  extensionRequired: 'LinkedIn Erweiterung benötigt',
  tool: 'Tool',
  projects: 'Projekte',
  manualActiveSourcing: 'Manuelles Active Sourcing',
  jobAdsOptimization: 'Stellenanzeigen',
  manualSocialSelling: 'Manuelles Social Selling',
  marketingCampaignsOptimization: 'Marketing Kampagnen',
  newProject: 'Neues Projekt',
  startJourneyTitle: 'Steigere Deine Conversions mit den richtigen Worten.',
  startJourneySubTitle: 'In welchem Bereich möchtest Du mit der Optimierung Deines Textes beginnen?',
  startJourneyButton: 'Beginne Deine Reise!',
  startJourneyActiveSourcingCopilot: 'HR | SAIA Recruiting Co-Pilot',
  startJourneyActiveSourcing: 'HR | Manuelles Active Sourcing',
  startJourneyJobAdCampaigns: 'HR | Stellenanzeigen Kampagnen',
  startJourneySocialSellingCopilot: 'Sales | SAIA Sales Co-Pilot',
  startJourneySocialSelling: 'Sales | Manuelles Social Selling',
  startJourneyMarketingCampaigns: 'Marketing | Marketing Kampagnen',
  startJourneyNone: 'keines davon',
  similarJobTitles: 'Ähnliche Berufsbezeichnungen',
  enterLocation: 'Standort eingeben',
  enterLocationLabel: 'Wo möchtest du suchen?',
  enterLocationDescription: 'Für welche Orte oder Regionen möchtest du nach Kontakten suchen?',
  similarJobTitlesSearchText: 'Suche nach ähnlichen Berufsbezeichnungen.',
  jobTitleTableName: 'Bezeichnung',
  jobTitleTableLinkedinProfiles: '# LinkedIn Profile',
  jobTitleTableJobwareAds: '# Stellen @Jobware',
  skills: 'Skills',
  noSearchResults: 'Keine Suchergebnisse für den ausgewählten Standort',
  generalCookieError: 'Stelle sicher, dass du unsere Browser-Erweiterung installiert hast und in LinkedIn eingeloggt bist. Sollte das Problem weiterhin auftreten, dann melde dich bei uns.',
  cookieErrorTitle: 'Cookie Fehler',
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  sunday: 'Sonntag',
  sendConnectionRequest: 'Kontaktanfrage versenden',
  connectionRequestAccepted: 'Kontaktanfrage akzeptiert',
  sendConnectionRequestDescription: 'Erstellt eine personalisierte Kontaktanfrage, optimiert diese psychologisch und sendet diese an Deinen Kontakt.',
  sendMail: 'Nachricht versenden',
  sendMailDescription: 'Erstellt eine erste personalisierte Nachricht, optimiert diese psychologisch und sendet diese an Deinen Kontakt auf LinkedIn.',
  sendMailWithContext: 'Nachricht versenden\n(mit Kontext)',
  sendMailWithContextDescription: 'Erstellt eine erste personalisierte Nachricht, optimiert diese psychologisch und sendet diese an Deinen Kontakt auf LinkedIn. Hier werden bei der Texterstellung die letzten vergangenen Nachrichten mit einer Kontaktperson als Kontext berücksichtigt.',
  sendFollowUp: 'Follow-up Nachricht versenden',
  sendFollowUpDescription: 'Erstellt personalisierte Follow Up Nachrichten auf Grundlage der bisher gesendeten Texte, optimiert diese psychologisch und sendet diese an Deinen Kontakt auf LinkedIn.',
  sendInMail: 'Inmail versenden',
  sendInMailDescription: 'Erstellt eine personalisierte Inmail, optimiert diese und sendet diese an Deinen Kontakt auf LinkedIn. (Sales Navigator / Recruiter Lizenz muss vorhanden sein)',
  sendInMailWithContext: 'Inmail versenden\n(mit Kontext)',
  sendInMailWithContextDescription: 'Erstellt eine personalisierte Inmail, optimiert diese und sendet diese an Deinen Kontakt auf LinkedIn. Hier werden bei der Texterstellung die letzten vergangenen Nachrichten mit einer Kontaktperson als Kontext berücksichtigt. (Sales Navigator / Recruiter Lizenz muss vorhanden sein)',
  sendEmail: 'E-Mail versenden',
  sendEmailDescription: 'Erstellt eine erste personalisierte Nachricht, optimiert diese psychologisch und sendet diese an Deinen Kontakt per E-Mail.',
  sendEmailWithContext: 'E-Mail versenden\n(mit Kontext)',
  sendEmailWithContextDescription: 'Erstellt eine erste personalisierte Nachricht, optimiert diese psychologisch und sendet diese an Deinen Kontakt per E-Mail. Hier werden bei der Texterstellung die letzten vergangenen Nachrichten mit einer Kontaktperson als Kontext berücksichtigt.',
  sendFollowUpEmail: 'Follow-up E-Mail versenden',
  sendFollowUpEmailDescription: 'Erstellt personalisierte Follow Up Nachrichten auf Grundlage der bisher gesendeten Texte, optimiert diese psychologisch und sendet diese an Deinen Kontakt per E-Mail.',
  sendCallTranscript: 'Call Transcript versenden',
  sendcallTranscriptDescription: 'Erstellt ein Telefon-Transcript und sendet dies an an eine Person via Email.',
  coldCallTranscript: 'Adaptiertes Prompt für SPIN Selling mit optimierter Struktur und Einwänden\n\nSPIN Selling Prompt für personalisierte Kundenansprache\n\nDu bist ein SDR mit der Aufgabe, einen Cold Call durchzuführen. Ziel ist es, ein überzeugendes Gespräch zu führen, das auf der SPIN Selling Methode basiert. Bereite Dich vor, indem Du basierend auf den Informationen zur Person ein Gesprächstranskript erstellst.\n\n1. Informationen zum Profil der Person\nPosition und Branche: Beschreibe die berufliche Rolle, die Branche und relevante Verantwortlichkeiten. ({{profile}})\nVermutete Herausforderungen: Identifiziere Schmerzpunkte oder Probleme, die basierend auf Position und Branche wahrscheinlich sind. ({{problems}})\nMögliche Lösungen: Zeige auf, wie Deine Lösung die Probleme direkt adressiert. ({{features}})\nErwartete Vorteile: Definiere, welche positiven Auswirkungen Deine Lösung für die Person haben könnte. ({{benefits}})\nNachweise: Biete Beispiele oder Erfolge, die Deine Lösung untermauern und Vertrauen schaffen. ({{impact}})\n\n2. Erstelle eine kurze Profilzusammenfassung mit den Hardfacts. Schreibe nichts zu den psychologischen Eigenschaften.\n\n3. Gesprächstranskript\nErstelle ein durchgehendes Transkript basierend auf den SPIN Selling-Prinzipien und wende die Informationen zur Person an, damit du überzeugender bist:\n\nBegrüße die Person höflich und zeige, dass Du ihre Situation verstehst.\nStelle den Gesprächsrahmen vor, indem Du den Grund für Deinen Anruf erklärst. Verweise auf relevante Punkte aus dem Profil.\n\nSituationsfragen\nStelle offene Fragen, um die aktuelle Situation und Herausforderungen zu beleuchten.\nOrientiere Dich dabei an den vermuteten Problemen.\n\nProblemfragen\nVertiefe die Problemfelder, indem Du konkrete Fragen stellst, die den Schmerzpunkt klar herausstellen.\n\nImplikationsfragen\nMache die Konsequenzen der Herausforderungen deutlich, falls sie ungelöst bleiben.\n\nNeed-Payoff-Fragen\nLenke das Gespräch hin zu den Vorteilen Deiner Lösung und stimme diese auf die Bedürfnisse der Person ab.\n\nEinwände ansprechen\nAntizipiere und entkräfte Einwände flexibel. Nutze psychologische Ansätze, um Einwände empathisch zu behandeln und Vertrauen aufzubauen.\n\nAbschluss\nFühre das Gespräch auf eine nächste konkrete Handlung hin, z. B. eine Produktdemo oder einen Termin.\n\n4. Erstelle drei mögliche Einwände und Gegenargumente\nEinwand 1:\nGegenargument:\n\nEinwand 2:\nGegenargument:\n\nEinwand 3:\nGegenargument\n\nHinweis: Nutze Informationen des Profils, um es zu personalisieren und die psychologische Analyse und branchenspezifische Details, um das Gespräch dynamisch und überzeugend zu gestalten.',
  sendReply: 'Antwort versenden',
  functionWaitingTime: 'Wartezeit = {{waitingTime}} Stunde',
  functionWaitingTime_plural: 'Wartezeit = {{waitingTime}} Stunden',
  functionPrompt: '<0>Prompt:</0> {{prompt}}',
  hrBoosterAutoCampaignProduct: 'SAIA Recruiting',
  leadBoosterAutoCampaignProduct: 'SAIA Sales',
  findContactsWithJobAd: 'Finde Kontakte mit Hilfe einer Stellenanzeige',
  findContactsWithJobAdInstruction: 'Füge die Berufsbezeichnung und eine Stellenanzeige in das entsprechende Textfeld ein und wir schlagen Dir dafür passende Kandidat/innen vor.',
  enterJobTitleHere: 'Gib hier die Berufsbezeichnung ein',
  enterJobAdHere: 'Gib hier eine Stellenanzeige ein:',
  findContactsWithSearchUrl: 'Finde Kontakte mit Hilfe einer LinkedIn-Such-URL',
  findContactsWithSearchUrlInstruction: 'Definiere eine Suche direkt auf LinkedIn und kopiere die dabei entstandene URL aus der Adressleiste.',
  campaignWorkTimeTitle: 'Wann soll die Kampagne arbeiten?',
  campaignWorkTimeInstruction: 'Wähle die Tage und die vollen Stunden, an denen die Kampagne automatisiert arbeiten soll. z.B.\n0 = erste Stunde (0:00 bis 0:59)\n8 = neunte Stunde (8:00 bis 8:59)\n23 = 24. Stunde (23:00 bis 23:59)\nusw.\n\nBesonders empfehlen können wir Zeiten, bei denen Du selbst weniger aktiv auf LinkedIn bist.',
  weekday: 'Wochentag',
  time: 'Uhrzeit',
  timeZone: 'Zeitzone',
  daily: 'Täglich',
  weekdays: 'Wochentage',
  weekend: 'Wochenende',
  unselectAll: 'Alle abwählen',
  fullDay: 'Ganztags',
  workHours: '8 - 17',
  morning: 'Morgens',
  evening: 'Abends',
  instruction: 'Anleitung',
  createCampaignInstruction: 'Wähle die Prompts aus, die du für deine Kampagne benutzen möchtest.',
  salesMethod: 'Sales Methode',
  linkedinProduct: 'Wähle aus, wo die Nachrichten in LinkedIn versendet werden sollen',
  whichLinkedinProduct: 'Welches LinkedIn-Produkt nutzt du?',
  selectLinkedinProduct: 'LinkedIn Produkt auswählen',
  linkedinProductInstruction: 'An dieses LinkedIn Produkt werden die personalisierten Nachrichten versendet.',
  testCampaign: 'Kampagne testen',
  testFailedShort: 'Der Test ist fehlgeschlagen — bitte erneut starten.',
  testNoResult: 'Kein Testergebnis gefunden — Ergebnisse werden 2 Stunden aufbewahrt.',
  testGuidanceInsteadOfMessage: 'Die KI konnte aus dieser Anweisung keine Nachricht schreiben. Statt einer Nachricht steht hier ein Hinweis, wie du die Anweisung verbessern kannst.',
  testSuggestedInstruction: 'Vorschlag für die Anweisung',
  testCharacters: 'Zeichen',
  testNoteShortened: 'Von der KI gekürzt (vorher {{before}} Zeichen)',
  testNoteRegenerated: 'Neu geschrieben, weil Kürzen nicht reichte (vorher {{before}} Zeichen)',
  testNoteTooLong: 'Zu lang: {{characters}} von {{limit}} Zeichen, auch nach Kürzen und Neuschreiben. Live würde diese Kontaktanfrage nicht gesendet. Kürze die Anweisung (z. B. „2–3 kurze Sätze“) und teste erneut.',
  testSkippedSteps: 'Ohne Nachricht geblieben',
  testSourceApp: 'aus der App',
  testSourceMcp: 'per MCP',
  testShownFromSource: 'Letzter Test {{source}} · {{time}}',
  testRunningFromSource: 'Ein Test {{source}} läuft gerade …',
  testLastFailed: 'Der letzte Test ({{time}}) ist fehlgeschlagen. Starte ihn neu.',
  startCampaign: 'Kampagne starten',
  start: 'Start',
  endNoun: 'Ende',
  addFunction: 'Funktion hinzufügen',
  addWaitingTime: 'Wartezeit hinzufügen',
  waitingTime: 'Wartezeit',
  waitingTimeInstruction: 'Gib hier die Zeit in Stunden ein, wie lange gewartet werden soll, bis die nächste Aktion ausgeführt wird.',
  prompt: 'Prompt',
  promptInstruction: 'Du kannst den Prompt hier wenn nötig abändern. Die angezeigten Platzhalter im Prompt dienen dazu, individuelle Informationen einzufügen. Entferne diese nur, wenn sie im finalen Text nicht benötigt werden.',
  emailAddress: 'E-Mail des Anrufers',
  emailAddressLabel: 'E-Mail-Adresse des Anrufers (muss ein gültiges SAIA-Konto haben). Sie erhalten weitere Informationen und Anruferinnerungen per E-Mail.',
  howManyReminders: 'Wie viele Erinnerungen sollen gesendet werden, wenn der Anruf nicht erfolgreich ist?',
  numRemindersLabel: 'Anzahl der Erinnerungen',
  createNewCampaign: 'Kampagne erstellen',
  enterCampaignNameHere: 'Name der Kampagne hier eingeben...',
  findJobTitlesTableInstruction: 'Wähle den für Dich relevantesten Skill bzw. die relevanteste Kombination aus Skills aus. Wir suchen dann die passenden Kanditat/innen mit den Berufsbezeichnungen <1>{{jobTitles}}</1> entsprechend Deiner Auswahl.',
  foundContacts: 'Gefundene Kontakte',
  campaignStarted: 'Kampagne gestartet',
  campaignStartedSuccess: 'Glückwunsch, Deine Kampagne läuft nun.',
  findContactsWithProductInformation: 'Finde Kontakte mit Hilfe von Produktinformationen',
  findContactsWithProductInformationInstruction: 'Füge die Probleme, die Dein Angebot löst, sowie die Features, Vorteile & den Business Impact Deines Angebots in das entsprechende Textfeld ein und wir schlagen Dir dafür passende Personen vor.',
  generateExampleText: 'Beispieltext generieren',
  hideExampleText: 'Verstecke Beispieltext',
  next: 'Weiter',
  prev: 'Zurück',
  functionStepCounter: 'Schritt {{current}} von {{total}}',
  testCampaignTitle: 'Welche Texte generiert meine Kampagne?',
  testCampaignInstruction: 'Hier siehst Du Beispielnachrichten aus den jeweiligen Schritten in der Kampagne. Du kannst die Schritte mit "Nächster" und "Zurück" ändern und so schauen, ob die generierten Texte für Dich passen.',
  leadBoosterAutoCampaignProductDescriptionMain: 'Automatisiere Deinen Sales Outreach',
  leadBoosterAutoCampaignProductDescriptionSub: 'mit speziellen Workern, die Personen komplett individualisiert anschreiben.',
  hrBoosterAutoCampaignProductDescriptionMain: 'Automatisiere Deinen Recruiting Outreach',
  hrBoosterAutoCampaignProductDescriptionSub: 'mit speziellen Workern, die Personen komplett individualisiert anschreiben.',
  selectLinkedinContact: 'Kontakt auswählen',
  selectLinkedinContactInstruction: 'Wähle den LinkedIn Kontakt aus, mit dessen Profil die Kampagne getestet werden soll.',
  sendFollowUpNotFirstError: 'Follow-up Nachricht kann nicht an erster Stelle sein',
  deleteCampaignDialogTitle: 'Kampagne löschen',
  confirmDeleteCampaignDialogContent1: 'Soll die Kampagne <1>{{name}}</1> wirklich gelöscht werden?',
  confirmDeleteCampaignDialogContent2: 'Dieser Vorgang ist nicht umkehrbar und die Kampagne steht danach nicht mehr zur Verfügung.',
  campaignStatus: 'Kampagnen Status',
  campaignStatusInstruction: 'Hier wird der Fortschritt aller Schritte in der Kampagne und deren Conversionrates angezeigt.',
  stepCompletion: '{{stepName}} ({{sent}} / {{total}})',
  editFunction: 'Funktion bearbeiten',
  testCampaignDurationInfo: 'Wir führen nun die einzelnen Kampagnen Funktionen in der vorgegebenen Reihenfolge aus. Hierbei werden für jeden Schritt in der Kampagne Beispielnachrichten erstellt.',
  testCampaignDurationTime: 'Dieser Vorgang kann einige Minuten in Anspruch nehmen.',
  jobs: 'Berufe',
  keywords: 'Stichworte',
  topics: 'Themen',
  industries: 'Branchen',
  findLeadsTableInstruction: 'Wähle das für Dich relevanteste Ergebnis aus. Wir suchen dann die passenden Personen entsprechend Deiner Auswahl.',
  spinSellingDe: 'Spin Selling (deutsche Prompts)',
  spinSellingEn: 'Spin Selling (englische Prompts)',
  eg: 'z.B.',
  messagesPerDay: 'Nachrichten pro Tag',
  messagesPerDayInstruction: 'Gib hier an, wie viele Nachrichten pro Kampagnen-Schritt pro Tag versendet werden sollen. Wir limitieren die Anzahl an Nachrichten pro Tag, da auch LinkedIn für bestimmte Nachrichten-Typen tägl. order wöchtentl. Limits hat und wir so deinen Account schützen möchten.',
  addContactsWithProfileFinder: 'Füge Kontakte mit dem LinkedIn Profile Finder hinzu',
  addContactsWithProfileFinderInstruction: 'Nutze zuvor erstellte LinkedIn Profile Finder Projekte um eine definierte Liste an Kontakten hinzuzufügen.',
  showContacts: 'Kontakte anzeigen',
  profileList: 'Kontakte',
  profileListInstruction: 'Wähle die Kontakte aus, die der Kampagne hinzugefügt werden sollen.',
  profileListDuplicatesInstruction: 'Es werden die ausgewählten Kontakte aus dieser und der vorigen Liste hinzugefügt.',
  blacklist: 'Blacklist',
  companyBlacklists: 'Firmen Blacklisten',
  manageCompanies: 'Firmen verwalten',
  enterCompanyNameHere: 'Hier Firmennamen eingeben',
  noCompaniesOnBlacklist: 'Keine Firmen auf der Blacklist',
  createBlacklist: 'Blacklist erstellen',
  editBlacklist: 'Blacklist bearbeiten',
  enterBlacklistName: 'Name der Blacklist hier eingeben',
  setAsDefault: 'Als Standard festlegen',
  defaultBlacklistWarning: '* Die Standard Blacklist wird für alle neuen Kampagnen angewendet. Bereits existierende Kampagnen bleiben dadurch unverändert.',
  manageBlacklistsInstruction1: 'Nachdem du deine Blacklist erstellt hast, kannst du dort Firmen hinzufügen und entfernen.',
  manageBlacklistsInstruction2: 'Mitarbeiter von Firmen auf der Blacklist erhalten weder Kontaktanfragen noch Nachrichten aus der Kampagne, für die die Blacklist aktiv ist.',
  manageBlacklistsInstruction3: 'Die Standard Blacklist wird für alle neuen Kampagnen angewendet.',
  defaultBlacklist: 'standard',
  companies: 'Firmen',
  deleteBlacklist: 'Blacklist löschen',
  deleteBlacklistContent1: 'Soll die Blacklist <1>{{blacklistName}}</1> wirklich gelöscht werden?',
  deleteBlacklistContent2: 'Dieser Vorgang ist nicht umkehrbar und die Blacklist steht danach nicht mehr zur Verfügung.',
  noBlacklist: 'keine Blacklist',
  stopCampaign: 'Anhalten',
  stopCampaignFull: 'Kampagne anhalten',
  restartCampaign: 'Neu starten',
  restartCampaignFull: 'Kampagne neu starten',
  connectionRequests: 'Kontaktanfragen',
  messages: 'Nachrichten',
  inMails: 'InMails',
  editOfferInstruction: 'Du kannst die Informationen, die bei der Texterstellung genutzt werden, hier ändern.',
  campaignStatistics: 'Kampagnen Statistiken',
  selectCampaign: 'Kampagne auswählen',
  selectCampaignInstruction: 'Für welche Kampagne möchtest du die detailierten Statistiken ansehen? Es werden keine Kampagnen angezeigt, die nicht mindestens einmal gestartet wurden.',
  performance: 'Performance',
  performanceInstruction: 'Hier kannst du sehen, wie viele Nachrichten für welchen Kampagnen-Schritt in der letzten Woche generiert und versendet wurden.',
  messagesChronicle: 'Nachrichten Chronik',
  messagesChronicleInstruction: 'Hier werden sämtliche Nachrichten aufgelistet, die von der Kampagne generiert und versendet wurden. Du kannst hier nachschauen, welche Nachrichten wann an welchen Kontakt versendet wurde und wie hoch der Match der SAIA-Optimierung beim Versenden war.',
  reply: 'Antwort',
  message: 'Nachricht',
  noMessagesSent: 'Noch keine Nachrichten versendet',
  details: 'Details',
  created: 'Erstellt',
  started: 'Arbeitet',
  suspended: 'Suspendiert',
  finished: 'Beendet',
  refreshed: 'Erneuert',
  archived: 'Archiviert',
  messagesSent: 'Nachrichten versendet',
  cloneExistingCampaign: 'Kampagne {{name}} klonen',
  campaignStep: 'Kampagnen Schritt',
  overallProgress: 'Gesamtfortschritt',
  conversion: 'Konversion',
  totalContacts: 'Gesamtanzahl Kontakte',
  filteredOutFromBlacklist: 'Herausgefiltert von der Blacklist',
  cancelledForTechnicalReasons: 'Abgebrochen aus techn. Gründen',
  contactsResponse: 'Kontakt hat reagiert oder die gesamte Kampagne durchlaufen',
  removeContacts: 'Kontakte entfernen',
  savedSuccessfully: 'Erfolgreich gespeichert',
  textGenSavesSuccessfullyContent: 'Der generierte Text wurde erfolgreich in dem neuen Projekt gespeichert.',
  saveAndExit: 'Speichern & beenden',
  saveAndTitleSearch: 'Speichern & Titel suchen',
  saveAndOptimize: 'Speichern & manuell optimieren',
  selectGlobalProfile: 'Wähle ein globales Profil aus',
  selectProfileInstructions: 'Du kannst entweder einen Text für das ausgewählte Profil generieren lassen, oder mit einem eigenen Text weitermachen.',
  generateNewText: 'Neuen Text generieren',
  selectTailoredProfile: 'Wähle ein individuelles Profil aus',
  textGenerationInputs: 'Eingaben zur Textgenerierung',
  resultText: 'Ergebnistext',
  generateAndFinalizeText: 'Text generieren & finalisieren',
  useOwnText: 'Eigenen Text nutzen',
  useGeneratedText: 'Generierten Text nutzen',
  textGenerationEditorPlaceholder: 'Du kannst hier auch direkt einen Text einfügen und die Textgenerierung überspringen',
  characteristics: 'Charaktereigenschaften',
  priorities: 'Prioritäten',
  generateGenreText: 'Generiere {{genre}}',
  optimizeGenreMatch: 'Optimiere Match für {{genre}}',
  formatGenreText: 'Formatiere {{genre}}',
  generateAnalysisResults: 'Generiere Analyseergebnisse',
  useOwnToC: 'Eigenen Table of Contents nutzen',
  useGeneratedToC: 'Generierten Table of Contents nutzen',
  showAssistant: 'Assistent anzeigen',
  showSuggestions: 'Vorschläge anzeigen',
  linkedinAccountManagement: 'LinkedIn-Accounts',
  manageLinkedinAccountsInstruction1: 'Für jeden LinkedIn Account, von dem aus die Kampagne Nachrichten versenden soll, benötigen wir die entsprechenden Zugangsdaten.',
  manageLinkedinAccountsInstruction2: 'Für jeden LinkedIn Account, der hinzugefügt werden soll, wird eine Co-Pilot-Lizenz benötigt.',
  manageLinkedinAccountsInstruction3: 'Nachdem ein Account hinzugefügt wurde, musst du ihn synchronisieren, um ihn in einer Kampagne nutzen zu können.',
  noAccountsAdded: 'Keine Accounts hinzugefügt',
  addAccount: 'Account hinzufügen',
  addAccountNoSeatsLeft: 'Alle Lizenzplätze sind vergeben. Um einen weiteren LinkedIn-Account hinzuzufügen, brauchst du eine zusätzliche Lizenz — oder du entfernst einen bestehenden Account.',

  // Use-Case-Store. Die Seite war komplett unübersetzt (alle Labels, Dialoge und Meldungen
  // fest auf Englisch), obwohl die Vorlagen selbst auf Deutsch und Englisch vorliegen.
  assignLicenseFailed: 'Die Lizenz konnte nicht zugewiesen werden. Bitte prüfe, ob der Account bereits eine Lizenz dieses Typs hat.',
  licenseAssignedTo: 'Zugewiesen an',
  licenseAssignmentFree: 'Nicht zugewiesen',
  licenseAssignmentDangling: 'Account gelöscht — Platz belegt',

  useCaseStoreTitle: 'Use-Case-Store',
  useCaseStoreSubtitle_one: '{{count}} Kampagnen-Vorlage · von PAI und aus deiner Organisation',
  useCaseStoreSubtitle_other: '{{count}} Kampagnen-Vorlagen · von PAI und aus deiner Organisation',
  useCaseStoreFilterLabel: 'Filter',
  useCaseStoreSortedByLikes: 'Sortiert nach Bewertungen',
  useCaseStoreMetricConversion: 'Konversion',
  useCaseStoreMetricUses: 'Verwendungen',
  useCaseStoreMetricSteps: 'Schritte',
  useCaseStoreSearchLabel: 'Suche',
  useCaseStoreSearchPlaceholder: 'Nach Name oder Ersteller suchen',
  useCaseStoreChannels: 'Kanäle',
  useCaseStoreLinkedinProduct: 'LinkedIn-Produkt',
  useCaseStoreLanguage: 'Sprache der Vorlage',
  useCaseStoreLanguageAny: 'Alle Sprachen',
  useCaseStoreLanguageDe: 'Deutsch',
  useCaseStoreLanguageEn: 'Englisch',
  useCaseStoreAny: 'Alle',
  useCaseStoreMinLikes: 'Min. Bewertungen',
  useCaseStoreMinUses: 'Min. Verwendungen',
  useCaseStoreEmpty: 'Keine Vorlagen gefunden. Passe die Filter an oder setze die Suche zurück.',
  useCaseStorePage: 'Seite {{page}}',
  useCaseStorePrevious: 'Zurück',
  useCaseStoreNext: 'Weiter',
  useCaseStorePopular: 'Beliebt',
  useCaseStoreTopConversion: 'Beste Konversion',
  useCaseStoreLike: 'Bewerten',
  useCaseStoreUnlike: 'Bewertung entfernen',
  useCaseStoreApply: 'Übernehmen',
  useCaseStoreApplyTitle: 'Vorlage übernehmen',
  useCaseStoreCampaignName: 'Kampagnenname',
  useCaseStoreLinkedinAccount: 'LinkedIn-Account',
  useCaseStoreApplyValidation: 'Bitte gib einen Namen an und wähle einen LinkedIn-Account aus.',
  useCaseStoreApplySuccess: 'Vorlage übernommen.',
  useCaseStoreApplyFailed: 'Die Vorlage konnte nicht übernommen werden.',
  useCaseStoreLoadFailed: 'Die Vorlagen konnten nicht geladen werden.',
  useCaseStoreLikeFailed: 'Die Bewertung konnte nicht gespeichert werden.',
  useCaseStoreEditTitle: 'Vorlage bearbeiten',
  useCaseStoreDescription: 'Beschreibung',
  useCaseStoreConversionRate: 'Konversionsrate',
  useCaseStoreNameRequired: 'Bitte gib einen Namen an.',
  useCaseStoreConversionMustBeNumber: 'Die Konversionsrate muss eine Zahl sein.',
  useCaseStoreUpdateSuccess: 'Vorlage aktualisiert.',
  useCaseStoreUpdateFailed: 'Die Vorlage konnte nicht aktualisiert werden.',
  useCaseStoreDeleteTitle: 'Vorlage löschen',
  useCaseStoreDeleteConfirm: 'Soll die Vorlage „{{name}}" wirklich gelöscht werden?',
  useCaseStoreDeleteSuccess: 'Vorlage gelöscht.',
  useCaseStoreDeleteFailed: 'Die Vorlage konnte nicht gelöscht werden.',
  editLinkedinAccount: 'LinkedIn Account bearbeiten',
  removeLinkedinAccount: 'LinkedIn Account entfernen',
  removeLinkedinAccountContent1: 'Soll der Account <1>{{userName}}</1> wirklich entfernt werden?',
  removeLinkedinAccountContent2: 'Dieser Vorgang ist nicht umkehrbar und der Account muss danach neu angelegt werden, falls er wieder benötigt wird.',
  removeLinkedinAccountContent3: 'Alle aktiven Kampagnen, die mit diesem Account verbunden sind, werden mit dem Entfernen gestoppt.',
  resetLocalStorage: 'Lokalen Speicher zurücksetzen',
  accountConnections: 'Kontaktliste',
  accountConnectionsIntro: 'Alle Verbindungen ersten Grades von {{userName}}, wie sie aus der LinkedIn-App gelesen wurden. Namen erscheinen, sobald eine Verbindung einem Kontakt zugeordnet ist.',
  accountConnectionsSearchPlaceholder: 'Name, Firma oder LinkedIn-Kurzname…',
  accountConnectionsCount: '{{count}} Verbindungen',
  accountConnectionsLastRead: 'Zuletzt gelesen: {{date}}',
  accountConnectionsNeverRead: 'Noch nicht gelesen',
  accountConnectionsRefreshRunning: 'Vollständiges Einlesen läuft: Seite {{page}} von bis zu {{pages}} (jeweils im Arbeitsfenster des Kontos).',
  accountConnectionsRefresh: 'Vollständig neu einlesen',
  accountConnectionsRefreshError: 'Das Neueinlesen konnte nicht angefordert werden.',
  accountConnectionsLoadError: 'Die Kontaktliste konnte nicht geladen werden.',
  accountConnectionsEmpty: 'Keine Verbindungen gefunden.',
  accountConnectionsColumnName: 'Kontakt',
  accountConnectionsColumnCompany: 'Firma',
  accountConnectionsColumnFirstSeen: 'Erstmals gesehen',
  accountConnectionsColumnInContacts: 'In Kontakten',
  resetLocalStorageContent1: 'Soll der lokale Speicher für den Account <1>{{userName}}</1> wirklich zurückgesetzt werden?',
  resetLocalStorageContent2: 'Dies löscht zwischengespeicherte LinkedIn-Daten für diesen Account. Eine erneute Anmeldung und Verifizierung kann erforderlich sein.',
  synchronized: 'synchronisiert',
  wrongCredentials: 'falsche Zugangsdaten',
  verificationRequired: 'Verifizierung benötigt',
  verifyLinkedinAccount: 'LinkedIn Account verifizieren',
  verifyLinkedinAccountInstruction1: 'Du solltest einen LinkedIn Verifizierungscode per SMS oder E-Mail (je nach Einstellung) erhalten haben.',
  verifyLinkedinAccountInstruction2: 'Nutze immer den aktuellsten Code.',
  verifyLinkedinAccountInstruction3: 'Du wirst wahrscheinlich eine E-Mail von LinkedIn über einen Anmeldeversuch von einem neuen Gerät erhalten.',
  verifyLinkedinAccountInstruction4: 'Falls Du die Authenticator App nutzt stelle sicher, dass der Code nicht sofort abläuft, sondern gerade erst neu generiert wurde.',
  enterLinkedinVerificationCodeHere: 'Gib hier den LinkedIn Verifizierungscode ein...',
  verificationCode: 'Verifizierungscode',
  linkedinAccount: 'LinkedIn Account',
  linkedinEmail: 'LinkedIn E-Mail',
  linkedinAccountInstruction: 'Der LinkedIn Account, von dem aus die Nachrichten versendet werden.',
  synchronize: 'synchronisieren',
  paused: 'Pausiert',
  linkedinLicenseDisclaimer: 'Abhängig von der LinkedIn-Lizenz kann die tatsächliche Anzahl der auf LinkedIn gefundenen Personen niedriger sein als die angezeigte Anzahl.',
  missingPlaceholdersWarning: 'Die folgenden Platzhalter fehlen in dem Prompt: {{placeholders}}',
  duplicateProfilePlaceholderWarning: 'Der Profil-Platzhalter {{profile}} darf nur einmal im Prompt vorkommen',
  duplicateJobOfferPlaceholderWarning: 'Der Stellenangebot-Platzhalter {{jobOffer}} darf nur einmal im Prompt vorkommen',
  hrBoosterActiveSourcing: 'SAIA Recruiting für Active Sourcing',
  hrBoosterJobAds: 'SAIA Recruiting für Stellenanzeigen',
  leadBoosterSocialSelling: 'SAIA Sales für Social Selling',
  leadBoosterMarketingCampaigns: 'SAIA Sales für Kampagnentexte',
  fullyAutomated: 'Vollautomatisiert',
  semiAutomated: 'Teilautomatisiert',
  existingTargetGroups: 'Vorhandene Zielgruppen',
  ownTargetGroups: 'Eigene Zielgruppen',
  aiTextGeneration: 'KI Textgenerierung',
  matchPersonalityProfile: 'Anpassung an psych. Persönlichkeitsprofil',
  serverSmtp: 'Server (SMTP)',
  portSmtp: 'Port (SMTP)',
  security: 'Sicherheit',
  invalidSmtpServer: 'Ungültiger SMTP-Server',
  serverImap: 'Server (IMAP)',
  portImap: 'Port (IMAP)',
  invalidImapServer: 'Ungültiger IMAP-Server',
  invalidCredentials: 'Ungültige Zugangsdaten',
  none: 'Keine',
  emailCredentials: 'E-Mail Zugangsdaten',
  emailAccountCredentials: 'E-Mail-Konto Zugangsdaten',
  emailCredentialsRequired: 'E-Mail Zugangsdaten benötigt',
  createDate: 'Erstellungsdatum',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  expired: 'Abgelaufen',
  canceled: 'Abonnement beendet',
  expiredAt: 'Abgelaufen am',
  expiresAt: 'Läuft aus am',
  nextPayment: 'Nächste Zahlung',
  bookedManually: 'Manuell gebucht',
  recruiterContract: 'Recruiter Vertrag',
  selectLinkedinAccount: 'LinkedIn Account auswählen',
  selectLinkedinProductInstruction: 'Wähle das LinkedIn Produkt aus, in dem du nach Kontakten suchen möchtest.',
  selectLinkedinAccountInstruction: 'Wähle den LinkedIn Account aus, von dem aus die Kontakte gesucht werden sollen.',
  continue: 'Weiter',
  // lead i18n start
  participantLimitReachedError: 'Lizenz enthält keine weiteren Umfragen. Bitte benachrichtigen Sie den Ersteller.',
  boss: 'Führungskraft',
  colleague: 'Kolleg*in',
  employee: 'Mitarbeiter*in',
  other: 'Andere',
  leadQuestionnaireGreeting: 'Herzlich Willkommen zum <1>LEaD-Führungsfeedback</1>',
  leadQuestionnairePerspectiveText1: 'Liebe Teilnehmerin, lieber Teilnehmer,',
  leadQuestionnairePerspectiveText2: 'herzlich Willkommen zum Führungsfeedback <1>„LEaD - Leadership Effectiveness and Development“</1>. Wir freuen uns, dass Sie an der Befragung teilnehmen.',
  leadQuestionnairePerspectiveText3: 'Bitte wählen Sie zunächst aus, aus welcher Perspektive Sie das Feedback beantworten, damit wir Ihnen die passenden Fragen zuordnen können.',
  leadQuestionnaireGreetingSelfPerspectiveText1: 'Sehr geehrte Führungskraft,',
  leadQuestionnaireGreetingSelfPerspectiveText2: 'herzlich Willkommen zum Führungsfeedback <1>„LEaD - Leadership Effectiveness and Development“</1>. Wir freuen uns, dass Sie teilnehmen.',
  leadQuestionnaireGreetingSelfPerspectiveText3: 'Der LEaD-Fragebogen dient dem Ziel, Ihnen ein differenziertes Feedback zu Ihren Steuerungs- und Führungskompetenzen im Alltag zur Verfügung zu stellen.',
  leadQuestionnaireGreetingSelfPerspectiveText4: 'Das Ausfüllen des Fragebogens wird <1>etwa 15-20 Minuten</1> in Anspruch nehmen. Wir möchten Sie bitten, den Fragebogen an einem Stück auszufüllen. Bitte achten Sie darauf, Ihr Browserfenster in jedem Fall geöffnet zu lassen, auch wenn Sie eine Pause einlegen. Auf diese Weise sind kurze zeitliche Unterbrechungen bei der Bearbeitung des Fragebogens möglich.',
  leadQuestionnaireGreetingSelfPerspectiveText5: 'Ihre Antworten und Angaben werden <1>absolut vertraulich und anonym</1> behandelt und sind keiner Person außerhalb des Teams von A47-Consulting & SAIA zugänglich.',
  leadQuestionnaireGreetingSelfPerspectiveText6: 'Die Ergebnisse dieser Befragung sollen einen wichtigen Beitrag leisten, um Sie in Ihrer beruflichen und persönlichen Entwicklung zu unterstützen.',
  leadQuestionnaireGreetingOtherPerspectiveText1: 'Sehr geehrte Damen und Herren,',
  leadQuestionnaireGreetingOtherPerspectiveText2: 'herzlich Willkommen zum Führungsfeedback <1>„LEaD - Leadership Effectiveness and Development“</1>. Wir freuen uns, dass Sie teilnehmen.',
  leadQuestionnaireGreetingOtherPerspectiveText3: 'Der LEaD-Fragebogen dient dem Ziel, Ihrer Führungskraft, Ihrem/Ihrer Mitarbeiter*in oder Ihrem/Ihrer Kolleg*in ein differenziertes Feedback zu seinen/ihren Steuerungs- und Führungskompetenzen im Alltag zur Verfügung zu stellen.',
  leadQuestionnaireGreetingOtherPerspectiveText4: 'Das Ausfüllen des Fragebogens wird <1>etwa 15-20 Minuten</1> in Anspruch nehmen. Wir möchten Sie bitten, den Fragebogen an einem Stück auszufüllen. Bitte achten Sie darauf, Ihr Browserfenster in jedem Fall geöffnet zu lassen, auch wenn Sie eine Pause einlegen. Auf diese Weise sind kurze zeitliche Unterbrechungen bei der Bearbeitung des Fragebogens möglich.',
  leadQuestionnaireGreetingOtherPerspectiveText5: 'Ihre Antworten und Angaben werden <1>absolut vertraulich und anonym</1> behandelt und sind keiner Person außerhalb des Teams von A47-Consulting & SAIA zugänglich. Es ist auch im Ergebnisbericht für den Feedbackempfänger nicht möglich, Ihre Aussagen mit Ihrer Person in Verbindung zu bringen - es werden ausschließlich aggregierte und gemittelte Ergebnisse berichtet.',
  leadQuestionnaireGreetingOtherPerspectiveText6: 'Die Ergebnisse dieser Befragung sollen einen wichtigen Beitrag leisten, Ihrer Führungskraft, Ihren/Ihre Mitarbeiter*in oder Ihren/Ihre Kolleg*in in seiner/ihrer beruflichen und persönlichen Entwicklung zu unterstützen. Wir danken Ihnen daher bereits im Voraus für Ihre Teilnahme.',
  leadQuestionnaireGreetingOpenQuestions: 'Bei Fragen zum Befragungsprozess wenden Sie sich bitte an A47 Consulting (<1 href="mailto:lead@a47-consulting-team.de">lead@a47-consulting-team.de</1>)',
  leadQuestionnaireThankYouForParticipation: 'Herzlichen Dank für Ihre Teilnahme!',
  leadQuestionnaireIntroduction: 'Einführung',
  leadQuestionnaireIntroductionSelfPerspectiveText: 'Der folgende Fragebogen umfasst Fragen zu Ihrem Steuerungs- und Führungsverhalten in verschiedenen erfolgsrelevanten Steuerungs- und Führungsbereichen.',
  leadQuestionnaireIntroductionOtherPerspectiveText: 'Der folgende Fragebogen umfasst Fragen zum Steuerungs- und Führungsverhalten Ihrer Führungskraft, Ihres/Ihrer Mitarbeiter*in oder Ihres/Ihrer Kolleg*in in verschiedenen erfolgsrelevanten Steuerungs- und Führungsbereichen. Der Einfachheit halber sprechen wir im Fragebogen von Herrn/Frau X.',
  leadQuestionnaireIntroductionText1: 'Sollte Ihnen einmal die Entscheidung schwer fallen, kreuzen Sie trotzdem bitte die <1>Antwort an, welche am ehesten auf die Frage zutrifft.</1> Falls Sie einmal eine unzutreffende Einschätzung getroffen haben, klicken Sie einfach eine andere <3>Antwortalternative</3> an: die zuerst angeklickte Markierung verschwindet automatisch.',
  leadQuestionnaireIntroductionText2: 'Auf den letzten Seiten des Fragebogens haben Sie die Möglichkeit, <1>Ihre persönlichen Eindrücke</1> mitzuteilen. Erfahrungsgemäß sind gerade diese persönlichen Hinweise wichtige Indikatoren für die weitere persönliche Entwicklung. Wir bitten Sie daher, auch hier Ihre Einschätzungen anzugeben. Vielen Dank!',
  leadQuestionnaireIntroductionText3: 'Bitte wählen Sie aus, in welcher Sprache der Fragebogen angezeigt werden soll.',
  leadQuestionnaireStartSurvey: 'Umfrage beginnen',
  leadQuestionnaireErrorAlreadyCompleted: 'Der Fragebogen wurde bereits beantwortet',
  leadQuestionnaireErrorAlreadyGeneric: 'Bitte Kontaktieren Sie info@secret-ai-agent.de, falls der Fehler weiterhin auftritt.',
  leadQuestionnaireProgress: 'Fortschritt',
  leadQuestionnaireSurveyFinished: 'Fragebogen beendet',
  leadQuestionnaireSurveyFinishedText1: 'Geschafft. Herzlichen Dank für Ihre Teilnahme!',
  leadQuestionnaireSurveyFinishedText2: 'Sie können das Fenster nun schließen.',
  leadQuestionnaireSendSurvey: 'Umfrage Senden',
  never: 'nie',
  rarely: 'selten',
  partPart: 'teils/teils',
  often: 'oft',
  almostAlways: 'regelmäßig, fast immer',
  leadQuestionnaireEffectiveLead: 'Effektive Führung',
  leadQuestionnaireEffectiveLeadSelfPerspectiveText: 'Im letzten Teil des Fragebogens geht es um die <1>Auswirkungen Ihres Führungs- und Einflussverhaltens. </1> Bitte schätzen Sie ein, wie häufig folgende Aussagen zutreffen.',
  leadQuestionnaireEffectiveLeadOtherPerspectiveText: 'Im letzten Teil des Fragebogens geht es um die <1>Auswirkungen des Führungs- und Einflussverhaltens</1> von Herrn/Frau X. Bitte schätzen Sie ein, wie häufig folgende Aussagen auf Herrn/Frau X zutreffen.',
  enterYourText: 'Geben Sie Ihren Text hier ein...',
  leadQuestionnaireOpenQuestions: 'Ihre persönlichen Eindrücke',
  leadQuestionnaireOpenQuestionsSelfPerspectiveText1: 'Sicherlich sind Ihnen bei der Beantwortung der vorangegangenen Fragen viele Gedanken durch den Kopf gegangen, was in Ihren Augen Ihre klaren persönlichen Stärken sind und wo auch Entwicklungspotenziale liegen.',
  leadQuestionnaireOpenQuestionsSelfPerspectiveText2: 'Bitte tragen Sie zum Abschluss Ihre persönlichen Eindrücke in die jeweiligen Textfelder ein – gerne auch in Stichpunkten.',
  leadQuestionnaireOpenQuestionsSelfPerspectiveText3: 'Wir werden Ihre Aussagen originalgetreu im Ergebnisbericht abbilden - achten Sie daher bitte auf die Leserlichkeit und Nachvollziehbarkeit Ihrer Beschreibungen und verzichten Sie auf Formatierungselemente (wie z.B. Aufzählungszeichen oder zusätzliche Leerzeilen).',
  leadQuestionnaireOpenQuestionsOtherPerspectiveText1: 'Sicherlich sind Ihnen bei der Beantwortung der vorangegangenen Fragen viele Gedanken durch den Kopf gegangen, was in Ihren Augen klare Stärken Ihres Feedbackempfängers/ Ihrer Feedbackempfängerin sind und wo auch Entwicklungspotenziale liegen.',
  leadQuestionnaireOpenQuestionsOtherPerspectiveText2: 'Bitte tragen Sie zum Abschluss Ihre persönlichen Eindrücke in die jeweiligen Textfelder ein – gerne auch in Stichpunkten.',
  leadQuestionnaireOpenQuestionsOtherPerspectiveText3: 'Wir werden Ihre Aussagen originalgetreu im Ergebnisbericht abbilden - achten Sie daher bitte auf die Leserlichkeit und Nachvollziehbarkeit Ihrer Beschreibungen und verzichten Sie auf Formatierungselemente (wie z.B. Aufzählungszeichen oder zusätzliche Leerzeilen).',
  leadQuestionnaireOpenQuestionsThankYou: 'Vielen Dank!',
  leadQuestionnaireDemographicQuestions: 'Demographische Fragen',
  leadQuestionnaireDemographicQuestionsBranch: 'Branche',
  leadQuestionnaireDemographicQuestionsCompanySize: 'Unternehmensgröße',
  leadQuestionnaireDemographicQuestionsTeamSize: 'Teamgröße',
  leadQuestionnaireDemographicQuestionsManagementField: 'Eigene Managementfunktion',
  leadQuestionnaireDemographicQuestionsTeamType: 'Teamcharakteristik',
  leadQuestionnaireDemographicQuestionsCustomerResponsibility: 'Endkundenverantwortung',
  leadQuestionnaireDemographicQuestionsResponsibilityField: 'Verantwortungsbereich/Organisationseinheit',
  agriculture: 'Agrarwirtschaft',
  construction: 'Baugewerbe',
  chemistryRawMaterials: 'Chemie & Rohstoffe',
  industryCraftsmanship: 'Industrie & Handwerk',
  consulting: 'Beratung',
  eCommerceMailOrder: 'E-Commerce & Versandhandel',
  energyEnvironment: 'Energie & Umwelt',
  financeInsuranceRealEstate: 'Finanzen, Versicherungen & Immobilien',
  societyEducationSocialJustice: 'Gesellschaft (Bildung, Soziales, Justiz)',
  trade: 'Handel',
  consumption: 'Konsum',
  mediaMarketing: 'Medien & Marketing',
  pharmaHealth: 'Pharma & Gesundheit',
  metalElectronics: 'Metall & Elektronik',
  technologyTelecommunication: 'Technik & Telekommunikation',
  tourismHospitality: 'Tourismus & Gastronomie',
  sportsWellness: 'Sport & Wellness',
  transportLogistics: 'Verkehr & Logistik',
  administrationPublicService: 'Verwaltung & öffentlicher Dienst',
  scienceResearch: 'Wissenschaft & Forschung',
  upTo100Employees: 'bis 100 Mitarbeitende',
  to499Employees: '101 bis 499 Mitarbeitende',
  to4999Employees: '500 bis 4.999 Mitarbeitende',
  to19999Employees: '5.000 bis 19.999 Mitarbeitende',
  to50000Employees: '20.000 bis 50.000 Mitarbeitende',
  moreThan50000Employees: 'mehr als 50.000 Mitarbeitende',
  executive: 'Executive',
  departmentManagement: 'Bereichsleitung',
  divisionalManagement: 'Abteilungsleitung',
  leadQuestionnaireTeamManagement: 'Teamleitung',
  noManagementFunction: 'keine Managementfunktion',
  specialistTeam: 'Spezialistenteam',
  scienceTeam: 'Wissenschaftsteam',
  interprofessionalTeam: 'Interprofessionelles Team',
  salesTeam: 'Vertriebsteam',
  operationalTeam: 'Operatives Team',
  financeAccounting: 'Finanzen/Rechnungswesen',
  controlling: 'Controlling',
  humanResources: 'Personal',
  backOffice: 'Back Office',
  business: 'Business',
  developmentStrategy: 'Development/Strategie',
  riskManagement: 'Risikomanagement',
  informatics: 'IT',
  communicationMarketing: 'Kommunikation/Marketing',
  serviceCenter: 'Service Center',
  salesSupport: 'Vertriebsunterstützung',
  // lead i18n end
  addBlacklistedCompaniesInstruction: 'Suche Firmen, die von den Kampagnen ausgeschlossen werden sollen und füge sie der Blacklist hinzu.',
  selectLinkedinAccountForCompanyURNInstruction: 'Wähle den LinkedIn Account aus, von dem aus die Firmen gesucht werden sollen.',
  languageOptions: 'Sprachoptionen',
  perMonth: 'pro Monat',
  perYear: 'pro Jahr',
  paidAnnually: 'jährlich bezahlt',
  paidMonthly: 'monatlich bezahlt',
  enterNumberOfAccounts: 'Gib hier die Anzahl an Accounts an',
  featureAutoLinkedinCrawler: 'Automatisches Finden der relevanten Ansprechpartnern auf Linkedin',
  featureAutoLinkedinMessages: 'Automatisches Kontaktieren der Personen auf LinkedIn',
  featureAutoEmailMessages: 'Automatisches Kontaktieren via E-Mail möglich',
  featureLinkedinExtensionIncluded: 'Linkedin Erweiterung inklusive',
  copilotLicense: 'Co-Pilot Lizenz',
  inbox: 'Inbox',
  campaignInbox: 'Kampagnen Inbox',
  replyInbox: 'antworten',
  updateInbox: 'Inbox Aktualisieren',
  inboxUpdateModalTitle: 'Inbox Aktualisieren',
  inboxUpdateModalDescription: 'Neue LinkedIn-Nachrichten jetzt abrufen. Optional kann ein früheres Datum gewählt werden, um ältere Konversationen nachzuladen.',
  inboxUpdateSinceLast: 'Ab letztem Update (Standard)',
  inboxUpdateSinceCustom: 'Ab einem bestimmten Datum',
  inboxUpdateSinceDate: 'Neu laden ab',
  inboxUpdateModalConfirm: 'Jetzt aktualisieren',
  replyLinkedin: 'antworten via LinkedIn',
  replyEmail: 'antworten via E-Mail',
  campaignInboxNoUnansweredMessages: 'Keine unbeantworteten Nachrichten vorhanden',
  campaignInboxWriteMessage: 'Nachricht verfassen...',
  campaignInboxSendMessage: 'Senden',
  overwriteOfferContentTitle: '{{credential}} überschreiben',
  overwriteOfferContentContent: 'Wir haben festgestellt, dass sich die {{credential}} im Textfeld von der gespeicherten unterscheidet. Möchtest du sie überschreiben?',
  markAsRead: 'als gelesen markieren',
  markAsReadContent1: 'Die Konversation wird beendet und aus der Inbox entfernt.',
  markAsReadContent2: 'Dieser Vorgang ist nicht umkehrbar und die Konversation kann danach nur noch direkt auf LinkedIn fortgeführt werden.',
  ms_o365: 'MS Office 365',
  accountType: 'Account-Typ',
  authMsAccount: 'Microsoft-Account autorisieren',
  authMsAccountInstruction: 'Mit diesem Autorisierungsprozess erteilst du unserer Anwendung die Erlaubnis, deine Outlook-E-Mails zu lesen und zu verwalten.',
  authCode: 'Autorisierungscode',
  enterCodeHere: 'Hier den Code aus dem Autorisierungsprozess eingeben...',
  authMsAccountTitle: 'Autorisierung\nerfolgreich',
  authMsAccountContent1: 'Gratuliere! Der Autorisierungsprozess war erfolgreich.',
  authMsAccountContent2: 'kopiere jetzt den unten stehenden Code',
  authMsAccountContent3: 'gehe zurück zu dem E-Mail-Zugangsdaten-Dialog',
  authMsAccountContent4: 'und füge ihn in das Feld "Autorisierungscode" ein',
  refreshInvalidCookiesInfo: 'Cookies ungültig',
  refreshInvalidCookiesInfoContent1: 'Die Cookies von dem ausgewählten LinkedIn-Account sind nicht mehr gültig.',
  refreshInvalidCookiesInfoContent2: 'Wir synchronisieren den Account jetzt erneut.',
  refreshInvalidCookiesInfoContent3: 'Bitte wiederhole die Anfrage noch einmal in ca. 1 Min.',
  refreshCookies: 'Cookies erneuern',
  authGmailAccount: 'Gmail-Account autorisieren',
  authGmailAccountInstruction: 'Mit diesem Autorisierungsprozess erteilst du unserer Anwendung die Erlaubnis, deine Gmail-E-Mails zu lesen und zu verwalten.',
  gmail: 'Gmail',
  leadGenSearchOptions: 'Wie möchtest du suchen?',
  leadGenSearchOptionsDescription: 'Du kannst auswählen zwischen einer normalen Personensuche auf LinkedIn oder einer erweiterten Suche nach Personen anhand von LinkedIn-Postings.',
  viaLinkedinSearch: 'via allg. LinkedIn-Suche',
  viaPostingSearch: 'via LinkedIn-Postings',
  exportToExcel: 'Als Excel exportieren',
  filter: 'Filter',
  waitBeforeSyncTitle: 'Bitte warte einen Moment',
  waitBeforeSyncContent1: 'Wir haben erst vor Kurzem versucht, den Account mit LinkedIn zu synchronisieren.',
  waitBeforeSyncContent2: 'Bitte warte <1>{{minutes}} Minute(n)</1> und synchronisiere ihn dann erneut.',
  waitForAccountSyncTitle: 'LinkedIn-Verbindung unterbrochen',
  waitForAccountSyncContent1:
    'LinkedIn hat diese Sitzung beendet (z. B. Abmeldung, Sicherheitscheck oder abgelaufene Cookies). Wir verbinden deinen Account automatisch wieder.',
  waitForAccountSyncContent2: 'Solange der Prozess läuft, sind die zugehörigen Buttons und Felder vorübergehend deaktiviert.',
  waitForAccountSyncContent3: 'Sobald der Account wieder verbunden ist, setzen wir deine Aktion automatisch fort.',
  libraries: 'Bibliotheken',
  functions: 'Funktionen',
  prompts: 'Prompts',
  promptManagement: 'Prompt Verwaltung',
  addLibrary: 'Bibliothek hinzufügen',
  editLibrary: 'Bibliothek bearbeiten',
  libraryName: 'Name der Bibliothek',
  enterLibraryNameHere: 'Name der Bibliothek hier eingeben...',
  functionName: 'Name der Funktion',
  enterFunctionNameHere: 'Name der Funktion hier eingeben...',
  campaignType: 'Kampagnen Produkt Typ',
  deleteLibraryTitle: 'Bibliothek löschen',
  deleteLibraryContent1: 'Bibliothek <1>{{libraryName}}</1> und alle dazugehörigen Funktionen wirklich löschen?',
  deleteLibraryContent2: 'Dieser Vorgang ist nicht umkehrbar und die Bibliothek steht danach nicht mehr zur Verfügung.',
  enterPromptHere: 'Prompt hier eingeben...',
  deleteFunctionTitle: 'Funktion entfernen',
  deleteFunctionContent1: 'Funktion <1>{{functionName}}</1> wirklich von der Bibltiothek entfernen?',
  deleteFunctionContent2: 'Dieser Vorgang ist nicht umkehrbar und die Funktion steht danach nicht mehr zur Verfügung.',
  promptLibrariesNoPromptsFound: 'Keine Bibliotheken gefunden',
  activeSourcingDe: 'Active Sourcing (deutsche Prompts)',
  activeSourcingEn: 'Active Sourcing (englische Prompts)',
  limitReachedDialogTitle: 'Limit der Lizenz erreicht',
  limitReachedDialogContent1: 'Du hast die Anzahl der Anfragen, die mit deiner Lizenz möglich sind, überschritten.',
  limitReachedDialogContent2: 'Bitte <1>upgrade deine Lizenz</1>, oder <3>kontaktiere uns</3>, wenn du einen speziellen Plan für dich oder dein Unternehmen benötigst.',
  numberContactAnalyses: 'Anzahl Kontaktanalysen',
  crawlerOptions: 'Optionen zur Personensuche',
  includedPersonTypes: 'Enthaltene Personentypen',
  reactions: 'Reaktionen',
  comments: 'Kommentare',
  authors: 'Autoren',
  includedProfileDegrees: 'Enthaltene Profilgrade',
  profileListCheckForContacts: 'Möchtest du prüfen, ob Kontakte aus der Liste bereits anderen Kampagnen aus deinem Unternehmen hinzugefügt wurden?',
  noDuplicateContactsFound: 'Kein Kontakt aus der Liste wurde in einer anderen Kampagne gefunden.',
  contactsAlreadyInCampaign: 'Kontakte aus anderen Kampagnen',
  profileListCheckForContactsInstruction: 'Entscheide, ob du die Personen, die schon in anderen Kampagnen hinzugefügt sind, auch dieser Kampagne hinzugefügen möchtest.',
  addContacts: 'Kontakte hinzufügen',
  typeOfContactSearch: 'Art der Kontaktsuche',
  linkedinSearchURL: 'LinkedIn-Suche-URL',
  linkedinProfileFinder: 'LinkedIn Profile Finder',
  jobTitle: 'Berufsbezeichnung',
  linkedinProfileFinderProjects: 'LinkedIn Profile Finder Projekte',
  createLinkedinProfileFinderProject: 'Neues LinkedIn Profile Finder Projekt',
  selectLinkedinProfileFinderProject: 'Wähle dein LinkedIn Profile Finder Projekt aus',
  searchForContacts: 'Suche nach Kontakten',
  problems: 'Probleme',
  features: 'Features',
  benefits: 'Benefits',
  impact: 'Business Impact',
  baseTextDescription: 'Die Texte dienen dazu, die Prompts der Kampagnen Funktionen mit den benötigten Informationen anzureichern.',
  timeZoneDescription: 'Die Zeit Zone, die für die Kampagne gilt.',
  blacklistDescription: 'Kontakte von Firmen auf der Blacklist werden von der Kampagne nicht angeschrieben. Die Blacklisten können in einem separaten Menü erstellt & bearbeitet werden.',
  communicationSettings: 'Einstellungen für die Kommunikation',
  campaignLanguage: 'Kampagnen-Sprache',
  checkForDuplicates: 'Prüfung auf Duplikate',
  coPilot: 'Co-Pilot',
  editPrompt: 'Prompt bearbeiten',
  deleteFunction: 'Funktion löschen',
  editWaitingTime: 'Wartezeit bearbeiten',
  deleteWaitingTime: 'Wartezeit löschen',
  waitingTimeInHours: 'Wartezeit in Stunden',
  deleteAllFunctions: 'alle Funktionen löschen',
  dragMessageDescription: 'Du kannst diese Nachrichten in den Bereich auf der rechten Seite ziehen.',
  dragConditionsDescription: 'Du kannst diese Bedingungen in den Bereich auf der rechten Seite ziehen.',
  dragHelperFunctionsDescription: 'Du kannst diese Hilfsfunktionen in den Bereich auf der rechten Seite ziehen.',
  conditions: 'Logische Bedingungen (J/N)',
  alreadyConnected: 'Auf LinkedIn verbunden',
  hasReplied: 'Hat geantwortet',
  connected: 'verbunden',
  notConnected: 'nicht verbunden',
  connectionRequestWasAccepted: 'Kontaktanfrage akzeptiert',
  accepted: 'akzeptiert',
  notAccepted: 'nicht akzeptiert',
  replied: 'geantwortet',
  notReplied: 'nicht geantwortet',
  alreadyConnectedDescription: 'Prüfe, ob du bereits mit dem Kontakt auf LinkedIn verbunden bist. Kann nur am Anfang der Kampagne benutzt werden.',
  connectionRequestAcceptedDescription: 'Prüfe, ob die gesendete Kontaktanfrage von dem Kontakt angenommen wurde. Kann nur nach einer Kontaktanfrage benutzt werden.',
  hasRepliedDescription: 'Prüfe, ob der Kontakt auf die gesendete Nachricht geantwortet hat. Kann nach jeder Funktion, die eine Nachricht versendet, benutzt werden (außer "Kontaktanfrage versenden").',
  helperFunctions: 'Hilfsfunktionen',
  waitingTimeDescription: 'Definiere, wie lange nach einer Nachricht oder Bedingung gewartet werden soll.',
  emails: 'E-Mails',
  emailCredentialsMissing: 'E-Mail-Zugangsdaten fehlen',
  generateEmailAddress: 'Finde E-Mail-Adresse',
  emailFound: 'gefunden',
  emailNotFound: 'nicht gefunden',
  generateEmailAddressDescription: 'Wir versuchen für dich, die E-Mail-Adressen deiner Kontakte zu ermitteln. Es besteht die Möglichkeit, dass das nicht immer funktioniert. Kann nur vor einer Funktion benutzt werden, die eine E-Mail versendet.',
  newCampaign: 'Neue Kampagne erstellen',
  editCampaign: 'Kampagne bearbeiten',
  campaigns: 'Kampagnen',
  enterCampaignName: 'Kampagnenname hier eingeben...',
  removeAll: 'Alle entfernen',
  addContactsViaCSV: 'Füge Kontakte über eine CSV-Datei hinzu',
  addContactsViaFileInstruction: 'Lade eine CSV-Datei (CSV UTF-8) oder eine Excel-Datei (.xlsx, .xls) hoch.',
  contacts_search: 'Kontakte hinzufügen',
  manual_contacts: 'Kontakte manuell hinzufügen',
  manage_contacts_search: 'Verwalte deine hinzugefügten LinkedIn-Listen',
  manage_contacts: 'Verwalte deine Kontakte',
  dragFileOrClickHere: 'Ziehe die Dateien hierher, oder klicke, um Dateien auszuwählen',
  dropFileHere: 'Dateien hier ablegen',
  noContactsAdded: 'Keine Kontakte hinzugefügt',
  noSearchesAdded: 'Keine LinkedIn-Kontakt-Suchen hinzugefügt',
  onlyJobs: 'nur Berufsbezeichnungen',
  various: 'verschiedene',
  unselectAllDuplicates: 'keine Duplikate zur Kampagne hinzufügen',
  linkedinAccountInformation: 'LinkedIn-Account-Informationen',
  proxyServerInformation: 'Proxy-Server-Informationen',
  proxyServerInformationDescription: 'Das Land und die Stadt müssen dieselben sein, aus denen du aktuell auf deinen LinkedIn-Account zugreifst (meistens die Stadt in der Nähe deines Wohnortes). Wir geben dir diesen freien Proxy, um deinen LinkedIn-Account besser zu schützen. Die Proxy-Server Standorte sind aus technischen Gründen nur auf englisch verfügbar.',
  noCampaignsFound: 'Keine Kampagnen gefunden',
  addJobAd: 'Stellenanzeige einfügen',
  editJobAd: 'Stellenanzeige bearbeiten',
  addProductInformation: 'Produktinformationen einfügen',
  editProductInformation: 'Produktinformationen bearbeiten',
  basicCampaignSettings: 'Grundeinstellungen der Kampagne',
  addAndManageContacts: 'Kontakte hinzufügen & verwalten',
  enterProductInformationHere: 'Gib hier die Produktinformationen ein',
  generateUrlQuestionRecruitingBooster: 'Sollen wir für Dich relevante Kandidaten und Kandidatinnen suchen?',
  generateUrlQuestionSalesBooster: 'Sollen wir für Dich relevante Kontakte suchen?',
  addOwnUrlQuestion: 'Hast du selbst eine Suche auf LinkedIn erstellt?',
  addContactSearches: 'Füge LinkedIn-Kontakt-Suchen zur Kampagne hinzu',
  addContactSearchesDescription: 'Wir crawlen für dich im Hintergrund auf LinkedIn nach Kontakten. Dafür benötigen wir eine LinkedIn-Such-URL. Du hast zwei Möglichkeiten, die URLs hinzuzufügen. Entweder wir erstellen eine neue Suche für dich anhand deiner Bedürfnisse, oder du fügst eine bereits fertige eigene Such-URL zur Kampagne hinzu.',
  selectSuitableTalentSearchResults: 'Wähle eine oder mehrere Suchen aus',
  selectSuitableTalentSearchResultsDescription: 'Hier siehst du eine Liste von LinkedIn-Suchen. Wähle eine oder mehrere davon aus, und füge sie der Kampagne hinzu. Wir arbeiten die LinkedIn-Suche dann im Hintergrund ab und fügen die Kontakte daraus der Kampagne hinzu. Abhängig von der LinkedIn-Lizenz kann die tatsächliche Anzahl der auf LinkedIn gefundenen Personen niedriger sein als die angezeigte Anzahl.',
  selectSuitableLeadSearchResults: 'Wähle die passenden Suchergebnisse aus',
  selectSuitableLeadSearchResultsDescriptions: 'Hier siehst du eine Liste von LinkedIn-URLs mit unterschiedlichen Suchbegriffen. Wähle eine oder mehrere davon aus, und füge sie der Kampagne hinzu. Wir arbeiten die LinkedIn-Suche dann im Hintergrund ab und fügen die Kontakte aus der Suche der Kampagne hinzu. Abhängig von der LinkedIn-Lizenz kann die tatsächliche Anzahl der auf LinkedIn gefundenen Personen niedriger sein als die angezeigte Anzahl.',
  addOwnUrl: 'Füge deine Linkedin-Such-URL hier ein',
  addOwnUrlDescription: 'Kopiere die URL deiner LinkedIn-Suche aus der URL-Leiste von LinkedIn und füge sie in das untenstehende Textfeld ein.',
  enterLinkedinSearchUrlHere: 'Gib hier deine LinkedIn-Such-URL ein...',
  linkedinSearchesInCampaign: 'LinkedIn-Kontakt-Suchen in der Kampagne',
  linkedinSearchesInCampaignDescription: 'Hier siehst du alle LinkedIn-Kontakt-Suchen der Kampagne. Mit LinkedIn-URLs führen wir die Suche nach Kontakten im Hintergrund aus und fügen der Kampagne mit der Zeit immer mehr Kontakte hinzu. Die Suchen werden der Reihe nach abgearbeitet und es läuft immer nur eine Suche zeitgleich.',
  searchTerms: 'Suchbegriffe',
  locations: 'Standorte',
  moveToTop: 'An den Anfang der Liste verschieben',
  moveOneUp: 'Nach oben verschieben',
  moveOneDown: 'Nach unten verschieben',
  moveToBottom: 'An das Ende der Liste verschieben',
  deleteUrl: 'Suche löschen',
  contactsInTheCampaign: 'Kontakte in der aktuellen Kampagne',
  contactsInTheCampaignDescription: 'Hier siehst du eine Liste aller Kontakte in der Kampagne. Du kannst Kontakte jederzeit wieder aus der Kampagne entfernen, wenn sie keine Nachrichten mehr erhalten sollen.',
  contactsFromOtherCampaigns: 'Bereits in anderen Kampagnen bearbeitete Kontakte',
  contactsFromOtherCampaignsDescription: 'Kontakte in dieser Liste müssen manuell geprüft werden und werden ansonsten nicht automatisch in der aktuellen Kampagne bearbeitet. Du kannst entscheiden, ob du die Duplikate zur Kampagne hinzufügen oder von der Liste entfernen möchtest.',
  removeAllContactsFromCampaign: 'alle Kontakte von der Kampagne entfernen',
  removeAllContactsFromCampaignContent1: 'Sollen wirklich alle Kontakte von der Kampagne entfernt werden?',
  removeAllContactsFromCampaignContent2: 'Dieser Vorgang ist nicht umkehrbar. Die Kontakte stehen danach nicht mehr zur Verfügung.',
  campaign: 'Kampagne',
  deleteContactSearchDialogTitle: 'LinkedIn-Suche löschen',
  deleteContactSearchDialogContent1: 'Soll die LinkedIn-Kontakt-Suche <1>{{name}}</1> wirklich gelöscht werden?',
  deleteContactSearchDialogContent2: 'Die Suche wird dadurch abgebrochen und aus dem System entfernt. Dieser Vorgang ist nicht umkehrbar.',
  deleteContactSearchDialogContent3: 'Bereits hinzugefügte Kontakte aus dieser Suche bleiben jedoch in der Kampagne enthalten.',
  deleteContactFileDialogTitle: 'Kontakt-Datei löschen',
  deleteContactFileDialogContent: 'Soll die Datei <1>{{name}}</1> und alle damit verbundenen Kontakte wirklich gelöscht werden?',
  recruiterUrlWarningDialogTitle: 'Recruiter URL abgelaufen',
  recruiterUrlWarningDialogContent1: 'Die eingegebene Recruiter-URL ist abgelaufen und kann nicht mehr verwendet werden.',
  recruiterUrlWarningDialogContent2: 'Der LinkedIn Recruiter erlaubt immer nur eine Suche zeigleich.',
  recruiterUrlWarningDialogContent3: 'Bitte wiederhole die Suche, kopiere die URL direkt und füge sie der Kampagne hinzu.',
  noContactsFromOtherCampaignsFound: 'Keine Kontakte aus anderen Kampagnen gefunden',
  removeAllContactsFromDuplicatesList: 'alle Kontakte von der Liste entfernen',
  moveAllContactsFromDuplicatesListIntoCampaign: 'alle Kontakte zur Kampagne hinzufügen',
  removeAllContactsFromDuplicateListContent1: 'Sollen wirklich alle Kontakte von der Liste entfernt werden?',
  removeAllContactsFromDuplicateListContent2: 'Dieser Vorgang ist nicht umkehrbar. Die Kontakte stehen danach nicht mehr zur Verfügung.',
  addToCampaign: 'Auswahl zur Kampagne hinzufügen',
  csvExport: 'CSV-Export',
  salesNavOrRecruiterAccountRequired: 'Sales Navigator oder Recruiter Account benötigt',
  salesNavOrRecruiterContactsRequired: 'InMails können nur an Sales Navigator oder Recruiter Kontakte versendet werden',
  addContactsManually: 'Füge Kontakte manuell zur Kampagne hinzu',
  linkedinProfileFinderQuestion: 'Möchtest du Kontakte mit deinen LinkedIn Profile Finder Projekten hinzufügen?',
  fileUploadQuestion: 'Möchtest du Kontakte über eine CSV- oder Excel-Datei hochladen?',
  keepBoth: 'Kein Filter',
  keepFemale: 'Nur Frauen',
  keepMale: 'Nur Männer',
  waitingForChanges: 'speichere Änderungen...',
  saved: 'gespeichert',
  profileFinderSearchTypes: 'Was ist die Grundlage deiner Suche?',
  profileFinderSearchTypesDescription: 'Mit der Auswahl legst du fest, welches CSV-Format wir erwarten.',
  websiteVisitors: 'Webseitenbesucher',
  linkedinUrl: 'LinkedIn-URL',
  nameAndCompany: 'Name & Firma',
  companyAndRole: 'Firma & Rolle',
  noProjectsFound: 'Keine Projekte gefunden',
  campaignOverview: 'Kampagnen Übersicht',
  campaignSummary: 'Kampagnen-Zusammenfassung',
  reactFlowDragInfo: 'Ziehe Nachrichten, Hilfsfunktionen und Logische Bedingungen per Drag & Drop in den Bereich, und verbinde sie, um deine Kampagne zu erstellen.',
  backgroundCrawlerInfoDialogTitle: 'LinkedIn-Kontakt-Suche',
  backgroundCrawlerInfoDialogContent1: '<0>Status:</0> Die LinkedIn-Kontakt-Suche wurde erfolgreich zur Kampagne hinzugefügt. Wir arbeiten nun Schritt für Schritt, um die Kontakte nach und nach hinzuzufügen.',
  backgroundCrawlerInfoDialogContent2: '<0>Warum wird es so gemacht?</0> Wir schützen den LinkedIn-Account, indem wir die ersten beiden Seiten der Suchergebnisse schrittweise abrufen. So vermeiden wir, dass LinkedIn Maßnahmen gegen zu schnelle Datenabfrage ergreift.',
  backgroundCrawlerInfoDialogContent3: '<0>Wie Du es verwenden kannst:</0> Falls die Suche nicht wie gewünscht funktioniert, klicke auf die drei Punkte rechts und wähle "Suche fortsetzen," um eine weitere Seite zu laden.',
  backgroundCrawlerInfoDialogAction: 'Klicke hier, um die bereits hinzugefügten Kontakte anzusehen',
  backToCampaign: 'zurück zur Kampagne',
  pageNotFoundTitle: '404 - Seite nicht gefunden',
  pageNotFoundText: 'Die gesuchte Seite existiert nicht',
  routeToHomepage: 'zur Startseite',
  emailAccount: 'E-Mail Account',
  addSingleContact: 'einzelnen Kontakt zur Kampagne hinzufügen',
  addSingleContactDialogTitle: 'Kontakt hinzufügen',
  enterLinkedinUrlHere: 'LinkedIn-URL hier eingeben...',
  enterFirstNameHere: 'Gib hier den Vornamen ein...',
  enterLastNameHere: 'Gib hier den Nachnamen ein...',
  enterCompanyHere: 'Gib hier das Unternehmen ein...',
  enterEmailHere: 'Gib hier die E-Mail-Adresse ein...',
  accountAlreadySyncedDialogTitle: 'Cookies noch gültig',
  accountAlreadySyncedDialogContent1: 'Die Cookies sind noch gültig oder der Account befindet sich bereits in der Warteschlange zum Einloggen.',
  accountAlreadySyncedDialogContent2: 'Ein erneutes Synchronisieren des Accounts ist daher nicht nötig.',
  parallelLogin: 'Paralleler Login',
  pleaseResyncAccount: 'Bitte synchronisiere Deinen Account wieder',
  resyncAccount: 'account synchronisieren',
  recruiterParallelLoginDialogTitle: 'Recruiter Account bereits in Nutzung',
  recruiterParallelLoginDialogContent1: 'Der LinkedIn Recruiter erlaubt nur eine Session zeitgleich.',
  recruiterParallelLoginDialogContent2: 'Bitte melde dich im LinkedIn Recruiter ab und melde den Account danach hier neu an.',
  recruiterParallelLoginDialogContent3: 'Sobald der Account neu angemeldet ist, kannst du ihn wieder in deinen Kampagnen benutzen.',
  synchronizeNow: 'Jetzt synchronisieren',
  approveMessagesBeforeSending: 'Nachrichten vor dem Versenden genehmigen',
  messagesToApprove: 'Zu prüfende Nachrichten',
  approve: 'freigeben',
  deny: 'ablehnen',
  saveAndApprove: 'speichern & freigeben',
  leadBoosterCopilotName: 'SAIA Sales Co-Pilot',
  recruitingBoosterCopilotName: 'SAIA Recruiting Co-Pilot',
  copilotFeature1: 'Co-Pilot Lizenz für ein Jahr - jederzeit kündbar',
  copilotFeature2: 'Lizenz funktioniert in Verbindung mit einem LinkedIn Account',
  copilotFeature3: 'KI-generierte Nachrichten, die auf die Motivationen des Empfängers eingehen',
  copilotFeatureLead4: 'Vollständig automatisierte Erweiterung Ihres Business-Netzwerks',
  copilotFeatureRecruiting4: 'Vollständig automatisierte Erweiterung Ihres Kandidaten-Netzwerks',
  copilotFeature5: 'Mehrkanal-Ansprache',
  copilotFeature6: 'SAIA LinkedIn-Extension inklusive',
  copilotFeature7: 'Ansprache der Kontakte in sechs Sprachen (DE, EN, IT, FR, ES, PT)',
  leadAdsAndPersonaGeneratorName: 'Marketing Ads & Personas Generator',
  recruitingAdsAndPersonaGeneratorName: 'Job Ads & Personas Generator',
  adsAndPersonaGeneratorFeature1: 'Nutze jedes unserer vordefinierten Profile oder erstelle deine eigenen Profile',
  adsAndPersonaGeneratorFeature2: 'Ein "Credit" ermöglicht die Nutzung eines vordefinierten oder eigenen Profils für die Dauer von 30 Tagen',
  adsAndPersonaGeneratorFeature3: 'Die "Credits" sind innerhalb eines Jahres zu verwenden',
  adsAndPersonaGeneratorFeatureLead4: 'Optimiere alle deine Marketingtexte für die jeweilige Zielgruppe (Zielprofil)',
  adsAndPersonaGeneratorFeatureRecruiting4: 'Optimiere alle deine Stellenanzeigen für die jeweilige Zielgruppe (Zielprofil)',
  adsAndPersonaGeneratorFeature5: 'Analyse der Motivation und der Bedürfnisse der von Dir identifizierten oder entwickelten Zielgruppe',
  adsAndPersonaGeneratorFeature6: 'Lösung funktioniert in Verbindung mit einem LinkedIn Account',
  adsAndPersonaGeneratorFeature7: 'SAIA LinkedIn-Extension inklusive',
  adsAndPersonaGeneratorFeature8: 'Optimierung und Analyse funktioniert in sechs Sprachen (DE, EN, IT, FR, ES, PT)',
  paymentCreditsCount: 'für {{count}} Credits',
  paymentMinCredits: 'min. {{minCredits}} Credits',
  bundle: 'Bundle',
  noNamesInPromptsWarning: 'Bitte gib keine Namen in dem Prompt an. Wir fügen diese später in der fertigen Nachricht über Platzhalter ein.',
  serverErrorTitle: 'Server nicht erreichbar',
  serverTemporaryTitle: 'Gleich wieder da',
  serverTemporaryBody1: 'Alles in Ordnung — das ist nur vorübergehend. Der Dienst ist gleich zurück.',
  serverTemporaryBody2: 'Versuche es in einem Moment erneut. Wenn es bleibt, kontaktiere bitte den Support.',
  serverTemporaryBody3: 'Es wird gerade eine neue Version ausgerollt, wodurch der Dienst kurz pausiert.',
  serverTemporaryBody4: 'Deployments dauern in der Regel 3–5 Minuten. Gönn dir gerne einen Kaffee ☕.',
  serverTemporaryNextCheck: 'Nächste Prüfung in {{seconds}}s',
  serverBackOnlineTitle: 'Wir sind zurück',
  serverBackOnlineBody: 'Der Dienst ist wieder verfügbar. Du kannst weitermachen.',
  serverErrorContent1: 'Unser Server ist gerade nicht erreichbar.',
  serverErrorContent2: 'Mögliche Gründe dafür sind:',
  serverErrorReason1: 'Wir spielen gerade ein Update auf den Server auf und der Service ist gleich wieder verfügbar',
  serverErrorReason2: 'Du hast gerade kein Internet oder dein Netzwerk blockiert die Verbindung zu unserem Server',
  serverErrorReason3: 'Wir haben tatsächlich Probleme mit unserem Server und versuchen diese so schnell wie möglich zu beheben',
  serverErrorContent3: 'Bitte warte einen Moment und versuche es dann erneut.',
  tryAgain: 'Erneut versuchen',
  captchaTimedOut: 'captcha abgelaufen',
  captchaDetected: 'captcha entdeckt',
  solveNow: 'jetzt lösen',
  solveCaptchaDialogTitle: 'Löse das Captcha',
  solveCaptchaDialogContent1: 'Bitte löse das untenstehende Captcha, damit wir deinen Account synchronisieren können.',
  solveCaptchaDialogContent2: 'Beachte, dass es sich hierbei um einen Screenshot des Captchas handelt. Klicke mit der Maus in das Captcha und setze so deine Markierung. Wenn du mit der Position der Markierung zufrieden bist, klicke auf "Ok".',
  solveCaptchaDialogContent3: 'Wiederhole diesen Vorgang solange, bis der Account synchronisiert ist.',
  reloadCaptcha: 'Captcha neu laden',
  sendConnectionRequestWithoutText: 'Kontaktanfrage ohne Text versenden',
  withdrawConnectionRequest: 'Kontaktanfrage zurückziehen',
  withdrawConnectionRequestDescription: 'Ziehe bereits gesendete Kontaktanfragen wieder zurück.',
  empty: 'Leer',
  fullName: 'Name (Vor- und Nachname)',
  fileColumnDialogTitle: 'Kontakt-Eigenschaften zuordnen',
  fileColumnDialogContent: 'Ordne den Werten aus deiner Datei die passende Kontakt-Eigenschaft zu.',
  fileColumnDialogCampaignContactContent: 'Wir benötigen zumindest den Namen und die LinkedIn-URL, um einen Kontakt für die Kampagne anlegen zu können.',
  fileColumnDialogProfileFinderContactsContent: 'Wir benötigen zumindest den Vor- und Nachnamen sowie das Unternehmen, um eine Kontaktsuche starten zu können.',
  fileColumnDialogProfileFinderWebsiteVisitorsContent: 'Wir benötigen das Unternehmen, die Rolle des Kontakts sowie das Land, in dem gesucht werden soll, um eine Suche starten zu können.',
  fileHasTableHeading: 'Datei hat Tabellenüberschrift',
  columnPreview: 'Spalte (Vorschau)',
  contactProperty: 'Kontakt-Eigenschaft',
  contactsNotImportedWarning: '{{count}} Kontakt(e) wurden nicht importiert, da entweder der Name und/oder die LinkedIn-URL fehlen',
  doNotImport: 'Feld nicht importieren',
  customField: 'Benutzerdefiniertes Feld',
  customFields: 'Benutzerdefinierte Felder',
  workTimeRecommendation1: 'Stelle die Arbeitszeiten der KI am Besten zu Zeiten ein, in denen Du selbst nicht so aktiv auf Linkedin bist, damit es zu keinen Überschneidungen in den Sitzungen kommt.',
  workTimeRecommendation2: 'Am Besten ebenfalls mit Pausen zwischen den Arbeitsstunden, um einem menschlichen Nutzungsverhalten nahezukommen.',
  continueSearch: 'Suche fortsetzen',
  wrongPin: 'falscher Verifizierungscode',
  userEmail: 'Nutzer-E-Mail',
  adminEmail: 'Admin E-Mail',
  windowsUndoRedo: 'zurück: strg + z vor: strg + y',
  macUndoRedo: 'zurück: ⌘ + z vor: ⌘ + y',
  linuxUndoRedo: 'zurück: strg + z vor: strg + y',
  contactManagement: 'Kontaktverwaltung',
  contactOverview: 'Kontaktübersicht',
  postingCreation: 'Posting Erstellung',
  postingCreationDescription: 'Erstelle und verwalte deine sozialen Medien Beiträge',
  postingOverview: 'Übersicht',
  postingCreationTitle: 'Posting Erstellung',
  leadListResearch: 'Lead List Research',
  leadListResearchTitle: 'Lead List Research Agent',
  leadListResearchDescription: 'Erstelle und verfeinere Lead-Listen basierend auf einem frei formulierbaren Prompt, mit Fokus auf regionales Targeting.',
  leadListOverview: 'Übersicht',
  leadListResults: 'Lead List Ergebnisse',
  tagManagement: 'Tagverwaltung',
  campaignTags: 'Kampagnentags',
  manualTags: 'Manuelle Tags',
  contactDegree: 'Kontaktgrad',
  to: 'an',
  removeContactFromCampaign: 'Kontakt aus Kampagne entfernen',
  addLicenseToUserDialogTitle: 'Lizenzen auswählen',
  addLicenseToUserDialogContent: 'Wähle eine oder mehrere Lizenzen für den neu erstellten Nutzer aus.',
  addAccountFromExternal: 'Account von extern hinzufügen',
  editExternally: 'Extern bearbeiten (Link generieren)',
  editEmailCredentials: 'E-Mail-Zugangsdaten bearbeiten',
  copiedLinkToClipboard: 'Link in die Zwischenablage kopiert. Der Link ist jetzt für 12 Stunden gültig und sollte in diesem Zeitraum verwendet werden.',
  cloneCampaign: 'Kampagne klonen',
  tokenExpiredDialogTitle: 'Token abgelaufen',
  tokenExpiredDialogContent1: 'Das Authentifizierungs-Token deines Links ist abgelaufen.',
  tokenExpiredDialogContent2: 'Aus Sicherheitsgründen sind generierte Links nur bis zu 12 Stunden gültig und danach nicht mehr nutzbar.',
  tokenExpiredDialogContent3: 'Bitte wende dich an den Ersteller des Links und bitte um einen neuen Link.',
  checkConnectionDisabledWarning: 'Die Nutzung ist nicht empfohlen. Bitte nutze die "Kontaktanfrage akzeptiert bis"-Bedingung stattdessen.',
  connectionRequestWasAcceptedUntil: 'Kontaktanfrage akzeptiert bis',
  connectionRequestWasAcceptedUntilDescription: 'Prüfe periodisch in einem festgelegten Zeitraum, ob die gesendete Kontaktanfrage von dem Kontakt angenommen wurde. Kann nur nach einer Kontaktanfrage benutzt werden.',
  functionPeriod: 'Max. Zeit bis zur Annahme der Kontaktanfrage = {{waitingTime}} Stunde',
  functionPeriod_plural: 'Max. Zeit bis zur Annahme der Kontaktanfrage = {{waitingTime}} Stunden',
  editPeriod: 'Zeitraum bearbeiten',
  period: 'Zeitraum',
  periodInstruction: 'Gib hier die Zeit in Stunden ein, wie lange geprüft werden soll, ob die Kontaktanfrage angenommen wurde.',
  periodInHours: 'Zeitraum in Stunden',
  linkedinUser: 'LinkedIn Nutzer',
  linkedinAccountNotFoundTitle: 'LinkedIn-Account nicht gefunden',
  linkedinAccountNotFoundContent1: 'Der ausgewählte LinkedIn-Account wurde nicht gefunden.',
  linkedinAccountNotFoundContent2: 'Bitte wähle zuerst einen gültigen LinkedIn-Account aus.',
  amountSelectedContacts: '{{count}} Kontakte ausgewählt',
  refineRecruiterSearch: 'Recruiter Suche verfeinern',
  applyFilters: 'Filter anwenden',
  saveAndAddContactsAutomatically: 'Speichern & Kontakte automatisch hinzufügen',
  titles: 'Berufsbezeichnungen',
  enterTitleHere: 'Gib hier die Berufsbezeichnung ein...',
  enterSkillHere: 'Gib hier den Skill ein...',
  industry: 'Branchen',
  enterIndustryHere: 'Gib hier die Branche ein...',
  location: 'Standort',
  enterLocationHere: 'Gib hier den Standort ein...',
  enterZipHere: 'Gib hier die Postleitzahl ein...',
  searchWithinArea: 'Innerhalb eines Bereiches suchen',
  locationSearch: 'Standortsuche (nach Name)',
  areaSearch: 'Bereichssuche (PLZ oder Name + Umkreis)',
  enterKeywordsHere: 'Gib hier die Stichworte ein und drücke Enter...',
  area: 'im Bereich',
  within1Mi: 'innerhalb von 1,6 km',
  within5Mi: 'innerhalb von 8 km',
  within10Mi: 'innerhalb von 16 km',
  within25Mi: 'innerhalb von 40 km',
  within50Mi: 'innerhalb von 80 km',
  within100Mi: 'innerhalb von 160 km',
  within200Mi: 'innerhalb von 321 km',
  include: 'enthält',
  exclude: 'enthält nicht',
  addSelectedContactsToCampaign: 'ausgewählte Kontakte zur Kampagne hinzufügen',
  position: 'Position',
  contactsSuccessfullyAddedToCampaign: 'Kontakte erfolgreich zur Kampagne hinzugefügt!',
  loadingRecruiterContacts: 'Lade Kontakte vom Recruiter',
  feedback: 'Feedback',
  whatIsNew: 'Was ist neu?',
  crawlWithSeparateAccount: 'Mit separatem LinkedIn-Account crawlen',
  noContactsFound: 'Keine Kontakte gefunden',
  changeLinkedinAccountWarning: 'Der LinkedIn-Account kann für bereits gestartete Kampagnen nicht mehr geändert werden.',
  linkedinAccountCapacity: '# LinkedIn-Accounts - aktuell: {{current}} / offen: {{remaining}}',
  copilotCredits: '# Kontaktanalysen - aktuell: {{current}} / offen: {{remaining}}',
  quantity: 'Anzahl',
  creditsExhaustedDialogTitle: 'Analyselimit erreicht',
  creditsExhaustedDialogContent1: 'Das Limit für Kontaktanalysen von deiner Lizenz wurde erreicht.',
  creditsExhaustedDialogContent2: 'Bitte melde dich bei deinem SAIA Kontakt oder schreibe uns auf info@secret-ai-agent.de, damit wir dieses Problem lösen können.',
  changeCampaignFlowWarning: 'Das Verändern des Aufbaus von bereits gestarteten Kampagnen ist nicht empfohlen.',
  notAllNodesConnectedWarning: 'Nicht alle Knoten sind verbunden.',
  connectionCheckFirstNodeWarning: '"Kontaktanfrage akzeptiert bis" kann kein Startknoten sein.',
  utilityFunctionFirstNodeWarning: 'Hilfsfunktionen können keine Startknoten sein.',
  multipleConnectionRequestNodesWarning: 'Stelle sicher, dass nicht im selben Weg zwei Kontaktanfragen eingebaut sind.\nFalls dies nicht der Fall ist, ignoriere die Warnung.',
  linkedinAccountMissingWarning: 'Wähle bitte einen LinkedIn-Account aus',
  leadCampaignProductProblems: 'Beschreibe die Probleme der Personen, die Du mit der Kampagne erreichen möchtest',
  leadCampaignProductFeatures: 'Beschreibe die Features/Dienstleistungen/Angebote, die Du Personen anbietest, die Du mit der Kampagne erreichen möchtest',
  leadCampaignProductBenefits: 'Beschreibe die persönlichen Benefits der Personen, die Du mit der Kampagne erreichen möchtest',
  leadCampaignProductImpact: 'Beschreibe den geschäftlichen Nutzen/Impact (Zahlen, Daten, Fakten), die Du der Personen bringst, die Du mit der Kampagne erreichen möchtest',
  profilePlaceholderMissingWarning: 'Der Profil-Platzhalter [[{{profile}}]] fehlt, wird aber zwingend benötigt. Bitte stelle sicher, dass der Satz "Der Empfänger beschreibt sich folgendermaßen: [[{{profile}}]]." im Prompt enthalten ist.',
  editLinkedinAccountName: 'LinkedIn Account Namen ändern',
  invalidUrlForLinkedinAccountWarning: 'Die URL passt nicht zu dem ausgewählten LinkedIn-Account\n* URL benötigt von: {{product}}',
  invalidUrlForLiProductTypeWarning: 'Die URL passt nicht zu den restlichen Kontakten in der Kampagne\n* URL benötigt von: {{product}}',
  filterExplanation: 'Spezifiziere die Filter-Logik ("alle müssen zutreffen", "mind. eine muss zutreffen") und wähle die Filter-Regeln für die gewünschten Tabellen-Spalten aus. Klicke auf "Filter anwenden", wenn du zufrieden mit dem Regel-Set bist.',
  allConditionsMustBeTrue: 'alle Bedingungen müssen zutreffen (UND)',
  oneConditionMustBeTrue: 'mind. eine Bedingung muss zutreffen (ODER)',
  filterColumn: 'Spalte',
  filterOperator: 'Operator',
  filterValue: 'Filter-Wert',
  enterFilterValueHere: 'Filter-Wert hier eingeben...',
  addFilter: 'Filter hinzufügen',
  removeAllFilters: 'alle Filter entfernen ({{count}})',
  styleMatch: 'Style Match',
  motives: 'Motive',
  manualTag: 'Manueller Tag',
  createTag: 'Tag erstellen',
  enterTagNamePlaceholder: 'Name des Tags hier eingeben...',
  renameTag: 'Tag umbenennen',
  deleteTag: 'Tag löschen',
  deleteTagContent1: 'Möchtest du den Tag <1>{{tagName}}</1> wirklich löschen?',
  deleteTagContent2: 'Dieser Vorgang ist nicht umkehrbar. Der Tag steht danach nicht mehr zur Verfügung und wird zudem von allen Kontakten entfernt.',
  selectedContacts: 'ausgewählte Kontakte: {{count}}',
  addTagsToSelection: 'Tags zur Auswahl hinzufügen',
  editTags: 'Tags bearbeiten',
  is: 'ist',
  isNot: 'ist nicht',
  isAfter: 'ist nach',
  isOnOrAfter: 'ist am oder nach',
  isBefore: 'ist vor',
  isOnOrBefore: 'ist am oder vor',
  equals: 'ist gleich',
  contains: 'enthält',
  startsWith: 'beginnt mit',
  endsWith: 'endet mit',
  isEmpty: 'ist leer',
  isNotEmpty: 'ist nicht leer',
  isAnyOf: 'ist eine der folgenden',
  contactGender: 'Geschlecht',
  linkedinProfile: 'LinkedIn-Profil',
  contactPersons: 'Kontaktpersonen',
  contactPerson: 'Kontaktperson',
  firstContactOn: 'Erstkontakt am',
  addContactsToCampaign: 'Kontakte zur Kampagne hinzufügen',
  addTags: 'Tags hinzufügen',
  noTagsFound: 'Keine Tags gefunden',
  loadingContact: 'Lade Kontaktinformationen...',
  loadingHistory: 'Lade Kampagnenverlauf...',
  loadingAnalysis: 'Lade Kontaktanalyse...',
  enterContactNameHere: 'Kontaktnamen hier eingeben...',
  femaleGender: 'weiblich',
  maleGender: 'männlich',
  editGender: 'Geschlecht bearbeiten',
  pressEnterToAdd: 'Drücke Enter zum Einfügen...',
  profileInfo: '* Leider haben wir nicht genug Informationen über {{contactName}}, um ein personalisiertes Profil zu erstellen. Stattdessen schließt die KI anhand von ähnlichen Profilen des beruflichen Werdegangs auf das wahrscheinlichste Profil zurück.',
  receivedMessage: 'Erhaltene Nachricht',
  tagsSuccessfullyAdded: 'Tags erfolgreich hinzugefügt',
  editContactEmail: 'E-Mail-Adresse bearbeiten',
  enterContactEmailHere: 'E-Mail-Adresse des Kontakts hier eingeben...',
  yearsOfExperience: 'Jahre an Erfahrung',
  progressContacts: 'Fortschritt (Kontakte)',
  progressPages: 'Fortschritt (Seiten)',
  searchType: 'Art der Suche',
  peopleSearch: 'Personen',
  postingSearch: 'Postings',
  jobSearch: 'Berufe',
  project: 'Projekt',
  courseSearch: 'Kurse',
  activitySearch: 'Aktivitäten',
  groupMemberSearch: 'Gruppenmitglieder',
  eventAttendeesSearch: 'Event-Teilnehmer',
  savedSearch: 'gespeicherte Suche',
  nameSearch: 'Suche benennen',
  renameSearch: 'Suche umbenennen',
  enterSearchNamePlaceholder: 'Gib hier den Namen der Suche ein...',
  duplicates: 'Bereits kontaktiert',
  contactSearchProgress: 'Fortschritt der Kontaktsuche',
  addContactToCampaign: 'zur Kampagne hinzufügen',
  manageDuplicateContacts: 'Bereits kontaktierte Kontakte verwalten',
  viewResultsAndFineTune: 'Ergebnisse anzeigen und Feinabstimmung vornehmen',
  campaignNameFilter: 'Kampagnen-Name',
  linkedinProductFilter: 'LinkedIn-Produkt',
  linkedinAccountFilter: 'LinkedIn-Account',
  campaignStatusFilter: 'Kampagnen-Status',
  enterLinkedinAccountNameHere: 'Gib hier den LinkedIn-Account ein...',
  selectTheLinkedinProduct: 'Wähle das LinkedIn-Produkt aus...',
  selectTheCampaignStatus: 'Wähle den Kampagnen-Status aus...',
  allLinkedinProducts: 'alle LinkedIn-Produkte',
  allCampaignStatuses: 'alle Kampagnen-Status',
  proxyCountryExample: '(z.B. Germany)',
  proxyCityExample: '(z.B. Munich)',
  from: 'von',
  upTo: 'bis',
  years: 'Jahren',
  reset: 'zurücksetzen',
  lessThanOne: 'Weniger als 1',
  yourFirstSteps: 'Deine ersten Schritte',
  doThisNow: 'Erledige diese Punkte, um einen erfolgreichen Start mit unserem Tool zu garantieren.',
  addLinkedinAccount: 'Füge deinen persönlichen LinkedIn Account hinzu',
  upgradeYourLicense: 'Upgrade auf eine kostenpflichtige Lizenz',
  bookAnOnboarding: 'Buche ein Onboarding',
  addLinkedinAccountNow: 'Jetzt LinkedIn Account hinzufügen',
  addLinkedinAccountLater: 'LinkedIn-Account später hinzufügen',
  supportedSearchTypes: 'unterstützte Suchtypen',
  searchForPeople: 'Suche nach Personen',
  searchInPostings: 'Suche in Postings',
  searchForJobApplicants: 'Suche nach Jobinteressenten',
  searchInCourses: 'Suche in Kursen',
  searchByActivities: 'Suche nach Aktivitäten',
  searchInGroups: 'Suche in Gruppen',
  searchInEvents: 'Suche in Events',
  savedSearches: 'Gespeicherte Suchen',
  recruiterProjects: 'Recruiter Projekte',
  recruiterLocationSearchWarning: 'Verwende entweder die Standort- oder die Postleitzahlensuche. Du kannst nicht beides gleichzeitig verwenden.',
  archiveCampaign: 'Kampagne archivieren',
  unarchiveCampaign: 'Kampagne nicht mehr archivieren',
  titlesOnlyActiveSourcing: 'Ergebnisse basierend auf Jobtiteln',
  titlesKeywordsActiveSourcing: 'Ergebnisse basierend auf Jobtiteln und Schlüsselwörtern',
  titlesKeywordsEnglishActiveSourcing: 'Ergebnisse basierend auf Jobtiteln und Schlüsselwörtern (Englisch)',
  titlesKeywordsIndustriesActiveSourcing: 'Ergebnisse basierend auf Jobtiteln, Schlüsselwörtern und Branchen',
  titlesKeywordsIndustriesEnglishActiveSourcing: 'Ergebnisse basierend auf Jobtiteln, Schlüsselwörtern und Branchen (Englisch)',
  keywordsIndustriesActiveSourcing: 'Ergebnisse basierend auf Schlüsselwörtern und Branchen',
  titlesOnlySocialSelling: 'Ergebnisse basierend auf Jobtiteln',
  titlesKeywordsSocialSelling: 'Ergebnisse basierend auf Jobtiteln und Schlüsselwörtern',
  titlesKeywordsEnglishSocialSelling: 'Ergebnisse basierend auf Jobtiteln und Schlüsselwörtern (Englisch)',
  titlesKeywordsIndustriesSocialSelling: 'Ergebnisse basierend auf Jobtiteln, Schlüsselwörtern und Branchen',
  keywordsIndustriesSocialSelling: 'Ergebnisse basierend auf Schlüsselwörtern und Branchen',
  smartSearches: 'Smarte Suchen',
  searchIntroduction: 'Basierend auf deinen Eingaben erstellen wir verschiedene Boolesche Suchanfragen, um die am besten passenden Kandidaten auf LinkedIn zu finden.',
  searchInstructionStep1: '1. Klicke auf jedes Suchergebnis, um es auf LinkedIn zu öffnen.',
  searchInstructionStep2: '2. Überprüfe die Ergebnisse und optimiere die Suche.',
  searchInstructionStep3: '3. Speichere die Suche, um sie deiner Kampagne hinzuzufügen.',
  selectAndFineTuneTalentSearch: 'Wähle und optimiere deine Talentsuchen',
  selectAndFineTuneLeadSearch: 'Wähle und optimiere deine Leadsuchen',
  selectAndFineTuneDescription: 'Klicke auf jedes Suchergebnis, überprüfe die LinkedIn-Ergebnisse und optimiere die Suche.',
  actions: 'Aktionen',
  viewAndFineTune: 'Ansehen und optimieren',
  redirectLinkedinSearchDialogInstruction: 'Überprüfe und optimiere deine von der KI generierte Kandidatenliste',
  redirectLinkedinSearchDialogContent1: 'Klicke auf den folgenden Button, um deine von der KI generierte Kandidatenliste direkt auf LinkedIn zu überprüfen.',
  viewCandidatesText: 'Kandidatenliste auf LinkedIn ansehen',
  redirectLinkedinSearchDialogContent2: 'Passe die Kandidatenliste nach deinen Wünschen an und optimiere sie für deine Bedürfnisse.',
  redirectLinkedinSearchDialogContent3: 'Kopiere die URL der angepassten Kandidatenliste aus der Adressleiste deines Browsers.',
  redirectLinkedinSearchDialogContent4: 'Kehre zu dieser Seite zurück und füge die kopierte URL in das untenstehende Textfeld ein.',
  redirectLinkedinSearchDialogContent5: 'Klicke auf "Speichern", um die verfeinerte Liste zu deiner Kampagne hinzuzufügen.',
  enterAlteredLinkedinSearchUrlHere: 'Gib hier die optimierte LinkedIn-Such-URL ein...',
  startYourJourney: 'Beginne Deine Reise',
  startJourneyStep1: 'Registrierung',
  startJourneyStep2: 'SAIA- und LinkedIn\nKonten synchronisieren',
  startJourneyStep3: 'Erstelle deine erste\n smarte Kampagne',
  startJourneyWelcome: 'Herzlich willkommen! Das Wichtigste zuerst...',
  startJourneyIntroduceLinkedinAccount: 'Gib deine LinkedIn-Account-Informationen ein',
  selectLinkedinProductClarification: 'Wähle das LinkedIn-Produkt aus, das dem Account entspricht, den Du synchronisieren möchtest.',
  proxyServerClarification: 'Hinweis: Alle Orte im Dropdown-Menü werden auf Englisch angezeigt.',
  linkedinAccountClarification: 'Gib die E-Mail-Adresse und das Passwort deines persönlichen LinkedIn-Accounts ein.',
  syncProcessingText: 'Warte, bis der LinkedIn-Account <1>mit unserem Tool synchronisiert ist</1>.',
  onboardingTooltipWaitTimeInfo: 'Es ist wichtig, diesen Vorgang abzuwarten, da unser Tool dadurch deine Informationen erkennen kann.\nDas wird einige Zeit in Anspruch nehmen, aber es gewährleistet eine erfolgreiche Verbindung!',
  syncSuccessfulCongratulations: 'Herzlichen Glückwunsch, {{name}}!',
  syncSuccessfulText1: 'Du hast deinen LinkedIn-Account - {{email}} - erfolgreich mit dem SAIA Tool synchronisiert!',
  syncSuccessfulText2Recruiting: 'Nutze die Vorteile des KI-gesteuerten Recruitings. Klicke auf "Weiter", um deine erste smarte Kampagne mit unserem <1>SAIA Recruiting</1> zu erstellen.',
  syncSuccessfulText2Lead: 'Nutze die Vorteile der KI-gesteuerten Lead-Gen. Klicke auf "Weiter", um deine erste smarte Kampagne mit unserem <1>SAIA Sales</1> zu erstellen.',
  syncSuccessfulText2Regular: 'Du kannst das Pop-up jetzt schließen.',
  syncErrorTitle: 'Fehler bei der Synchronisierung',
  syncErrorText: 'Wir haben ein Problem bei der Synchronisierung des LinkedIn-Accounts mit dem SAIA Tool festgestellt. Keine Sorge, wir können dir helfen!',
  syncErrorIssue: 'Problem:',
  syncErrorWrongCredentials: 'Die angegebenen Zugangsdaten des LinkedIn-Accounts sind nicht korrekt. <1>Bitte überprüfe, ob du nicht versehentlich die SAIA-Zugangsdaten anstelle der LinkedIn-Zugangsdaten verwendet hast</1>.',
  syncErrorWrongPin: 'Der angegebene Verifizierungscode ist nicht korrekt.',
  syncErrorWrongPinText: 'Bitte <1>synchronisiere den Account erneut</1> um einen neuen Verifizierungscode zu erhalten.',
  syncErrorWrongPinInfo: 'Wenn dieser Fehler weiterhin trotz korrektem Verifizierungscode angezeigt wird, <1>dann melde dich bitte bei uns</1>.',
  syncErrorTimedOutCaptcha: 'Die Zeit um das Captcha zu lösen ist abgelaufen.',
  syncErrorTimedOutCaptchaText: 'Bitte <1>synchronisiere den Account erneut</1> um ein neues Captcha zu erhalten.',
  syncErrorTimedOutCaptchaInfo: 'Wenn dieser Fehler weiterhin trotz korrekt gelöstem Captcha angezeigt wird, <1>dann melde dich bitte bei uns</1>.',
  syncErrorLinkedinOnboardingIncomplete: 'Das LinkedIn Sales Navigator Onboarding ist nicht beendet.',
  syncErrorLinkedinOnboardingIncompleteText1: 'Das Onboarding des LinkedIn Sales Navigator muss abgeschlossen sein, bevor wir deinen Account mit SAIA synchronisieren können.',
  syncErrorLinkedinOnboardingIncompleteText2: 'Bitte durchlaufe dafür die <1>Willkommensseiten beim LinkedIn Sales Navigator</1> vollständig.',
  syncErrorLinkedinOnboardingIncompleteText3: 'Wenn du den Einrichtungsprozess abgeschlossen hast, komme hierher zurück und klicke auf "Erneut Synchronisieren", um fortzufahren.',
  syncErrorUnknown: 'Die Synchronisierung ist aus einem uns unbekannten Grund fehlgeschlagen.',
  syncErrorUnknownText: 'Bitte <1>synchronisiere deinen Account erneut</1>.',
  syncErrorUnknownInfo: 'Wenn dieser Fehler weiterhin angezeigt wird, <1>dann melde dich bitte bei uns</1>.',
  syncErrorNeedHelp: '<0>Brauchst du Hilfe?</0> Klicke auf <2>Support</2> für zusätzliche Schritte zur Fehlerbehebung oder um unser Team zu kontaktieren.',
  // Betreffzeilen für das Feedback-Formular, das diese Links jetzt öffnen (176ce751).
  syncErrorSupportTitle: 'LinkedIn-Synchronisation fehlgeschlagen',
  syncErrorSupportDescription: 'Fehler bei der Synchronisation: {{reason}}',
  syncErrorSupportTitleCaptcha: 'Captcha wird trotz korrekter Lösung abgelehnt',
  syncErrorSupportTitleUnknown: 'Synchronisation schlägt mit unbekanntem Fehler fehl',
  syncErrorSupportTitleWrongPin: 'Verifizierungscode wird trotz korrekter Eingabe abgelehnt',
  inQueue: 'In der Warteschlange',
  loadingPage: 'Seite wird geladen',
  signingIn: 'Anmelden',
  extractingCookies: 'Cookies werden extrahiert',
  extractingQueryIDs: 'Query-IDs werden extrahiert',
  inQueueExplanation: 'Gleich geht es los! Du bist in der Warteschlange, um deine LinkedIn-Daten zu synchronisieren',
  loadingPageExplanation: 'Verbindung zu LinkedIn wird hergestellt... Einen Moment bitte, während wir eine sichere Verbindung aufbauen',
  signingInExplanation: 'Wir melden dich sicher an... Dies kann einen Moment dauern',
  extractingCookiesExplanation: 'Deine Informationen werden gesammelt... Wir rufen die Daten sicher ab, die du benötigst',
  extractingQueryIDsExplanation: 'Fast geschafft! Nur noch ein paar letzte Handgriffe, bevor du den Account nutzen kannst',
  restartOf: 'Neustarten der',
  appSynchronization: 'App Synchronisierung',
  complete: 'Beende',
  theLinkedinOnboarding: 'Das LinkedIn Onboarding',
  retrySynchronization: 'Erneut Synchronisieren',
  addAccountInformation: 'Eingabe der LinkedIn-Account Anmeldedaten',
  startLoginProcess: 'Start des Anmeldevorgangs',
  finishAccountSynchronization: 'Beenden der Synchronisierung',
  justAFewSteps: 'Nur ein paar Schritte um einen neuen Account zu synchronisieren',
  addNewAccountWelcome: 'Hallo {{userName}}, lass uns dein LinkedIn-Profil in die <3>{{product}}</3> einbinden!',
  addNewAccountIntroduceLoginInformation: 'Gib die Anmeldedaten für den neuen LinkedIn-Account ein',
  aiRecruiting: 'KI-Rekrutierungsrevolution',
  aiLeadGen: 'KI-Lead-Gen Revolution',
  addNewAccountSelectLinkedinProduct: 'Wähle das von dem neuen Account verwendete LinkedIn-Produkt aus',
  addNewAccountProxyServerInformation: 'Proxy-Server-Informationen des neuen Accounts',
  addNewAccountLinkedinAccountInformation: 'Anmeldedaten des neuen LinkedIn-Accounts',
  addNewAccountLinkedinAccountClarification: 'Gib die E-Mail-Adresse und das Passwort des hinzuzufügenden LinkedIn-Accounts ein.',
  addNewAccountLinkedinAccountBetterClarification: 'Gib die E-Mail-Adresse und das Passwort für dein LinkedIn-Konto ein. <1>Achte darauf</1>, dass das Passwort korrekt ist, um den Login erfolgreich abzuschließen.',
  addNewAccountSyncSuccessfulText1: 'Du hast den neuen LinkedIn-Account - {{email}} - erfolgreich mit dem SAIA Tool synchronisiert!',
  addNewAccountSyncSuccessfulText2Recruiting: '{{firstName}} kann jetzt die Vorteile des KI-gesteuerten Recruitings nutzen.',
  addNewAccountSyncSuccessfulText2Lead: '{{firstName}} kann jetzt die Vorteile der KI-gesteuerten Lead-Gen nutzen.',
  appSyncVerifyLinkedinAccount: 'Gib den erhaltenen LinkedIn-Account-Verifizierungscode ein',
  appSyncVerifyLinkedinAccountHeadsUp: 'Aufgepasst! <1>Möglicherweise hast du gerade einen Bestätigungscode von LinkedIn per SMS, Authentifizierungs-App oder E-Mail erhalten</1> (je nach Einstellungen). Hier sind ein paar Dinge, die du beachten solltest:',
  appSyncVerifyLinkedinAccountInstruction1: 'Verwende immer den neuesten Code. Verwende keine früheren Codes, die du ggf. erhalten hast.',
  appSyncVerifyLinkedinAccountInstruction2: 'Du erhältst evtl. eine Benachrichtigung von LinkedIn über einen Anmeldeversuch von einem neuen Gerät.',
  appSyncVerifyLinkedinAccountInstruction3: 'Du verwendest eine Authentifizierungs-App? Stelle sicher, dass du den Code eingibst, bevor er abläuft (vorzugsweise, wenn er gerade erst erstellt wurde)',
  appSyncSolveCaptcha: 'Lass uns schnell eine Sicherheitsüberprüfung machen! Löse das untenstehende Captcha:',
  appSyncSolveCaptchaHeadsUp: 'Löse das CAPTCHA auf der rechten Seite, um den Account zu synchronisieren.',
  appSyncSolveCaptchaInstruction1: 'Klicke in das CAPTCHA-Bild, um ein Element auszuwählen.',
  appSyncSolveCaptchaInstruction2: 'Triff deine Auswahl sorgfältig. Du kannst hineinzoomen, um es besser zu sehen.',
  appSyncSolveCaptchaInstruction3: 'Wenn du sicher bist, klicke auf "Weiter".',
  appSyncSolveCaptchaInstruction4: 'Du musst eventuell die Schritte 1-3 wiederholen, bis das CAPTCHA gelöst ist und der Synchronisationsprozess fortgesetzt wird.',
  addNewLinkedinAccount: 'Neuen LinkedIn Account hinzufügen',
  appSyncChooseContract: 'Wähle den Vertrag, der mit deinem LinkedIn-Account verknüpft ist',
  missingContract: 'Vertrag fehlt',
  onboardingIncomplete: 'Onboarding unvollständig',
  fairUsePause: 'Fair-Use Pause',
  fairUsePauseNotification1: 'Vorübergehende Login-Pause',
  fairUsePauseNotification2: 'Zum Schutz deines Kontos haben wir den Login aufgrund der Fair-Use-Richtlinien von LinkedIn für 24 Stunden pausiert.',
  fairUsePauseCampaignNotification: 'Hinweis: Vorübergehende Login-Pause\nZum Schutz deines LinkedIn-Accounts haben wir den Login aufgrund der Fair-Use-Richtlinien von LinkedIn für 24 Stunden pausiert.',
  notRecommended: 'nicht empfohlen',
  nameYourCampaign: 'Benenne deine Kampagne',
  campaignNameInstruction: 'Gib deiner Kampagne einen eindeutigen Namen',
  feedAI: 'Füttere die KI mit Informationen',
  briefDescription: 'Wir erstellen maßgeschneiderte Prompts und LinkedIn-Suchen basierend auf deinen Daten. Dazu benötigt unsere KI einige Informationen von dir.',
  autoGenerate: 'Automatisch generieren mit KI & Produkt-URL',
  manualEntry: 'Daten später manuell eingeben',
  provideURLInstruction: 'Bitte gib die URL für das Produkt oder die Stellenanzeige ein, indem du die URL (Landing Page des Produkts oder Landing Page der Stellenanzeige) kopierst.',
  enterJobOfferURL: 'Gib hier die URL der Stellenanzeige ein...',
  blockedPlatformError: 'Diese URL erlaubt uns keinen Zugriff auf ihre Daten. Klicke auf Fortfahren ohne URL und füge den Inhalt im späteren Schritt hinzu.',
  processingURL: 'Die URL wird verarbeitet, bitte warten...',
  scrapingData: 'Daten werden extrahiert...',
  summarizingResults: 'Ergebnisse werden zusammengefasst...',
  urlSuccess: 'Die URL wurde erfolgreich verarbeitet, und die KI hat das Briefing erstellt.',
  urlError: 'Beim Verarbeiten der URL ist ein Fehler aufgetreten. Bitte überprüfe die URL und versuche es erneut.',
  chooseTemplate: 'Wähle eine Kampagnenvorlage',
  templateExplanation: 'Wähle eine Vorlage, die am besten zu deinen Bedürfnissen passt.',
  internalRecruiting: 'Du arbeitest für das interne Recruiting',
  externalRecruiting: 'Du arbeitest für das externe Recruiting',
  whatToDoAfterCreation: 'Nächste Schritte nach der Erstellung deiner Kampagne',
  feedAIWithData: 'Füttere die KI mit Daten',
  selectLinkedInAccount: 'Wähle einen LinkedIn-Account',
  selectLinkedInAccountInstruction: 'Wähle den LinkedIn-Account aus, von dem die Kampagnen-Nachrichten gesendet werden sollen.',
  setCampaignDuration: 'Lege die Kampagnendauer fest',
  addContactsOrSearches: 'Füge Kontakte oder Suchen hinzu',
  createCampaignFlow: 'Erstelle den Kampagnenablauf',
  testAndStartCampaign: 'Teste und starte die Kampagne',
  continueWithoutUrl: 'Ohne URL fortfahren',
  continueWithoutTemplate: 'Ohne Vorlage fortfahren',
  createCampaignNow: 'Kampagne jetzt erstellen',
  forWhom: 'Für wen',
  leadGenerationFormalName: 'Lead Generation (Formal)',
  leadGenerationFormalDescription: 'Ein professioneller Ansatz zur Lead-Generierung, ideal für B2B- und Firmenkunden.',
  leadGenerationFormalAudience: 'SDRs, die Unternehmen und Firmenkunden ansprechen.',
  leadGenerationCasualName: 'Lead Generation (Casual)',
  leadGenerationCasualDescription: 'Ein lockerer Ansatz zur Lead-Generierung, geeignet für Startups und kleine Unternehmen.',
  leadGenerationCasualAudience: 'SDRs, die Startups und kleine Unternehmen ansprechen.',
  activeSourcingCasualFewInmailsName: 'Active Sourcing (Casual, wenige Inmails)',
  activeSourcingCasualFewInmailsDescription: 'Ein lockerer Ansatz zur Beschaffung mit begrenzten Inmails, ideal zur Ansprache junger Fachkräfte.',
  activeSourcingCasualFewInmailsAudience: 'Interne Recruiter, die junge Fachkräfte ansprechen.',
  activeSourcingFormalFewInmailsName: 'Active Sourcing (Formal, wenige Inmails)',
  activeSourcingFormalFewInmailsDescription: 'Ein formeller Ansatz zur Beschaffung mit begrenzten Inmails, geeignet für erfahrene Fachkräfte.',
  activeSourcingFormalFewInmailsAudience: 'Interne Recruiter, die erfahrene Fachkräfte ansprechen.',
  activeSourcingFormalWithInmailsName: 'Active Sourcing (Formal, mit Inmails)',
  activeSourcingFormalWithInmailsDescription: 'Ein formeller Ansatz zur Beschaffung mit Inmails, ideal zur Ansprache von Führungskräften.',
  activeSourcingFormalWithInmailsAudience: 'Interne Recruiter, die Führungskräfte ansprechen.',
  activeSourcingCasualWithInmailsName: 'Active Sourcing (Casual, mit Inmails)',
  activeSourcingCasualWithInmailsDescription: 'Ein lockerer Ansatz zur Beschaffung mit Inmails, ideal für Startups und Technologieunternehmen.',
  activeSourcingCasualWithInmailsAudience: 'Interne Recruiter, die Startups und Technologieunternehmen ansprechen.',
  activeSourcingFormalWithInmailsExternalName: 'Active Sourcing (Formal, mit Inmails, extern)',
  activeSourcingFormalWithInmailsExternalDescription: 'Ein formeller Ansatz zur Beschaffung mit Inmails, der sich an externe Kandidaten richtet.',
  activeSourcingFormalWithInmailsExternalAudience: 'Externe Recruiter, die Kandidaten außerhalb des Unternehmens ansprechen.',
  activeSourcingCasualWithInmailsExternalName: 'Active Sourcing (Casual, mit Inmails, extern)',
  activeSourcingCasualWithInmailsExternalDescription: 'Ein lockerer Ansatz zur Beschaffung mit Inmails, der sich auf externe Kandidaten in Technologie-Startups konzentriert.',
  activeSourcingCasualWithInmailsExternalAudience: 'Externe Recruiter, die Kandidaten in Technologie-Startups ansprechen.',
  activeSourcingCasualFewInmailsExternalName: 'Active Sourcing (Casual, wenige Inmails, extern)',
  activeSourcingCasualFewInmailsExternalDescription: 'Ein lockerer Ansatz zur Beschaffung mit begrenzten Inmails für verschiedene Branchen.',
  activeSourcingCasualFewInmailsExternalAudience: 'Externe Recruiter, die verschiedene Branchen ansprechen.',
  activeSourcingFormalFewInmailsExternalName: 'Active Sourcing (Formal, wenige Inmails, extern)',
  activeSourcingFormalFewInmailsExternalDescription: 'Ein formeller Ansatz zur Beschaffung mit begrenzten Inmails, geeignet für externe Kandidaten.',
  activeSourcingFormalFewInmailsExternalAudience: 'Externe Recruiter, die erfahrene Fachkräfte außerhalb des Unternehmens ansprechen.',
  unknownTemplateName: 'Unbekannte Vorlage',
  unknownTemplateDescription: 'Beschreibung nicht verfügbar.',
  unknownTemplateAudience: 'Zielgruppe nicht verfügbar.',
  feedAIWithDataTitle: 'Füttere die KI mit Daten',
  feedAIWithDataDescription: 'Gib detaillierte Daten zu deinem Produkt oder Stellenangebot an, um der KI zu helfen, maßgeschneiderte Inhalte zu erstellen.',
  selectLinkedInAccountTitle: 'LinkedIn-Konto auswählen',
  selectLinkedInAccountDescription: 'Wähle das LinkedIn-Konto aus, das du für diese Kampagne verwenden möchtest.',
  selectLinkedInAccountDescriptionHelper: 'Wird zum Versenden von Nachrichten und zum Vernetzen mit Interessenten verwendet.',
  setCampaignDurationTitle: 'Kampagnendauer festlegen',
  setCampaignDurationDescription: 'Gib die Dauer an, für die die Kampagne laufen soll. Berücksichtige dabei die Zeit, die benötigt wird, um deine Ziele zu erreichen.',
  addContactsOrSearchesTitle: 'Kontakte oder Suchparameter hinzufügen',
  addContactsOrSearchesDescription: 'Füge die Kontakte oder Suchparameter hinzu, die du in deiner Kampagne ansprechen möchtest. Du kannst eine Kontaktliste hochladen oder Suchparameter verwenden, um neue Kontakte zu finden.',
  createCampaignFlowTitle: 'Kampagnenablauf erstellen',
  createCampaignFlowDescription: 'Definiere den Ablauf deiner Kampagne, einschließlich der Reihenfolge der Nachrichten und der Aktionen, die in jedem Schritt durchgeführt werden sollen.',
  testAndStartCampaignTitle: 'Kampagne testen und starten',
  testAndStartCampaignDescription: 'Teste deine Kampagne, um sicherzustellen, dass alles korrekt eingerichtet ist. Sobald die Tests abgeschlossen sind, starte die Kampagne und überwache den Fortschritt.',
  invalidUrlError: 'Bitte gib eine gültige URL ein oder klicke auf „Ohne URL fortfahren“. In dem Fall musst du die KI nach der Kampagnenerstellung mit Informationen füttern.',
  subject: 'Betreff',
  accountAlreadyExistsDialogTitle: 'Account existiert bereits',
  accountAlreadyExistsDialogContent1: 'Das LinkedIn-Konto <1>{{accountName}}</1> existiert bereits.',
  accountAlreadyExistsDialogContent2: 'Es muss daher nicht neu angelegt werden.',
  contactPossibilityAvailable: 'Kontaktmöglichkeit vorhanden',
  notSynchronized: 'nicht synchronisiert',
  signIn: 'anmelden',
  signOut: 'abmelden',
  signInAction: 'Anmelden',
  signOutAction: 'Abmelden',
  accountLoggedIn: 'Angemeldet',
  salesNavSeatNotAnswering: 'Sales Navigator nicht verbunden',
  salesNavSeatNotAnsweringHint:
    'LinkedIn ist angemeldet, aber der Sales-Navigator-Zugang antwortet nicht. Nachrichten und Einladungen laufen weiter, Sales-Navigator-Suchen und InMails nicht. Bitte erneut anmelden und dabei die PIN für die Sales-Navigator-App eingeben.',
  salesNavSeatReLogin: 'Sales Navigator neu anmelden',
  recruiterSeatNotAnswering: 'Recruiter nicht verbunden',
  recruiterSeatNotAnsweringHint:
    'LinkedIn ist angemeldet, aber der Recruiter-Zugang antwortet nicht. Nachrichten und Einladungen laufen weiter, Recruiter-Suchen, Projekte und InMails nicht. Bitte erneut anmelden und dabei die PIN für die Recruiter-App eingeben.',
  recruiterSeatReLogin: 'Recruiter neu anmelden',
  accountLoggedOut: 'Abgemeldet',
  accountNeedsManualLogin: '🔐 Manuelle Anmeldung erforderlich',
  enter2fa: '2FA-Code eingeben',
  requestNewCode: 'Neuen 2FA-Code anfordern',
  solveCaptcha: 'Captcha lösen',
  correctAccessData: 'Zugangsdaten korrigieren',
  requestNewCaptcha: 'Neues Captcha anfordern',
  chooseContract: 'LinkedIn-Vertrag auswählen',
  incompleteOnboarding: 'LinkedIn-Onboarding abschließen',
  loggingIn: 'Verbindung zu LinkedIn wird hergestellt...',
  reopenLoginWindow: 'Anmeldefenster erneut öffnen',
  cancelConnecting: 'Abbrechen',
  cancelAndResetAccount: 'Abbrechen & zurücksetzen',
  reLoginAction: 'Neu anmelden',
  twoFaTimedOut: '2FA abgelaufen',
  convertSharpS: 'Alle ß in ss umwandeln',
  linkedinAccountSuccessfullySignedIn: 'Der LinkedIn Account wurde erfolgreich angemeldet.',
  autoSyncWarningDialogTitle: 'Status mit Handlungsbedarf',
  autoSyncWarningDialogContent1: 'Wir konnten den LinkedIn-Account <1>{{accountName}}</1> nicht erfolgreich anmelden.',
  autoSyncWarningDialogContent2: 'Bitte schaue auf der LinkedIn-Account Übersichtsseite nach und löse das dort angezeigte Problem.',
  autoSyncWarningDialogContent3: 'Folgendes Problem ist aufgetreten:',
  notSynchronizedWarning: 'Der Anmeldevorgang hat zu lange gedauert und wurde daher abgebrochen. Bitte melde dich erneut an.',
  wrongCredentialsWarning: 'Die Anmeldedaten des LinkedIn-Accounts sind nicht korrekt.',
  twoFaWarning: 'Zwei-Faktor-Authentifizierung (2FA) erforderlich.',
  appSyncApproveLinkedinPush: 'LinkedIn-Anmeldung in der App freigeben',
  appSyncApprovePushInstruction:
    'LinkedIn hat eine Push-Benachrichtigung an deine Mobile-App gesendet. Gib die Anmeldung dort zuerst frei. Falls LinkedIn stattdessen einen Code verlangt, wechsle unten in den Code-Flow.',
  appSyncApprovePushInstruction1: 'Oeffne die LinkedIn-App auf deinem Smartphone und bestaetige die Anmeldung.',
  appSyncApprovePushInstruction2: 'Komme danach hierher zurueck und klicke auf "Ich habe in der LinkedIn-App freigegeben".',
  appSyncApprovePushInstruction3: 'Falls LinkedIn stattdessen einen Verifizierungscode anzeigt oder sendet, klicke auf "Ich brauche einen Code" und gib ihn hier ein.',
  appSyncApprovedInLinkedinApp: 'Ich habe in der LinkedIn-App freigegeben',
  appSyncNeedVerificationCode: 'Ich brauche einen Code',
  appSyncBackToPushApproval: 'Zurueck zur App-Freigabe',
  wrongPinWarning: 'Der eingegebene Verifizierungscode ist nicht korrekt.',
  captchaWarning: 'Bitte löse das Captcha.',
  timedOutCaptchaWarning: 'Die Zeit zum Lösen des Captchas ist abgelaufen.',
  chooseContractWarning: 'Der LinkedIn-Vertrag konnte nicht gefunden werden.',
  onboardingIncompleteWarning: 'Das LinkedIn-Onboarding ist unvollständig.',
  recruiterParallelLoginWarning: 'Eine weitere LinkedIn Recruiter-Sitzung wurde erkannt.',
  fairUsePauseWarning: 'Aufgrund der Fair-Use-Richtlinien von LinkedIn haben wir den Login für 24 Stunden pausiert.',
  thirdPartyWarning: 'Die Anmeldemaske eines Drittanbieters oder eine uns unbekannte Seite wurde erkannt.',
  unknownErrorWarning: 'Ein unbekannter Fehler ist aufgetreten. Bitte melde dich erneut an.',
  autoSyncIndicatorText: 'LinkedIn-Account wird angemeldet',
  renameCampaign: 'Kampagne umbenennen',
  renameCampaignInstruction1: 'Ein Kampagnenname ist einzigartig und kann kein zweites mal verwendet werden.',
  renameCampaignInstruction2: 'Gib einen anderen Namen als zuvor ein und klicke auf "Ok", um deine Kampagne zu erstellen.',
  campaignName: 'Kampagnenname',
  nameClonedCampaign: 'Gib den neuen Namen der geklonten Kampagne ein',
  selectLinkedinAccountForCampaign: 'Wähle den LinkedIn Account aus, der in der Kampagne genutzt werden soll',
  selectLinkedinAccountForSearch: 'Wähle den LinkedIn Account aus, der in der Suche genutzt werden soll',
  thirdPartyLogin: 'Drittanbieter Anmeldung',
  enterText: 'Text eingeben...',
  appSyncThirdParty: 'Drittanbieter Webseite oder unbekannte LinkedIn Seite erkannt',
  appSyncThirdPartyHeadsUp: 'Folge den Anweisungen der Seite aus dem Screenshot',
  appSyncThirdPartyClickInstruction1: 'Klicke in das Bild, um ein Element (z.B. Button, Textfeld, etc.) auszuwählen.',
  appSyncThirdPartyClickInstruction2: 'Klicke auf "Weiter" um im Prozess fortzufahren.',
  appSyncThirdPartyClickInstruction3: 'Auch wenn du einen Button oder ein Textfeld im Bild auswählst, musst du die Auswahl mit "Weiter" bestätigen.',
  appSyncThirdPartyClickInstruction4: 'Möglicherweise musst du die Schritte 1 - 3 wiederholen, bis die Seite vollständig verarbeitet ist und der Synchronisationsprozess fortgesetzt wird.',
  appSyncSetThirdPartyText: 'Gib die Informationen in das Textfeld ein, die zu dem Screenshot passen',
  fileUpload: 'Datei hochladen',
  blacklistFileUploadInstruction: 'Lade eine Firmenliste als CSV- oder Excel-Datei hoch',
  selectCompanyColumnTitle: 'Unternehmens-Spalte auswählen',
  selectCompanyColumnContent: 'Ordne den Werten aus deiner Datei die passende Unternehmens-Spalte zu.',
  property: 'Eigenschaft',
  replace: 'Ersetzen',
  companiesToAdd: 'Hinzuzufügende Unternehmen: {{count}}',
  addOrReplaceCompanies: 'Möchtest du die Unternehmen zur aktuellen Liste hinzufügen, oder möchtest du die bestehende Liste mit den neuen Unternehmen ersetzen?',
  campaignStatusCreated: 'Kampagne erstellt',
  campaignStatusStarted: 'Kampagne läuft',
  campaignStatusFinished: 'Kampagne abgeschlossen',
  campaignStatusSuspended: 'Kampagne unterbrochen (Aktion erforderlich)',
  campaignStatusPaused: 'Kampagne pausiert (Nicht in Arbeitszeit)',
  campaignStatusFairUsePause: 'Kampagne pausiert (LinkedIn-Limit erreicht)',
  campaignStatusRecruiterParallelLogin: 'Kampagne pausiert (Account parallel eingeloggt)',
  campaignStatusArchived: 'Kampagne archiviert',
  linkedinAccountLoggedIn: 'Angemeldet (Arbeitsmodus aktiv)',
  linkedinAccountLoggedOut: 'Abgemeldet (Arbeitsmodus deaktiviert)',
  forThreeMonths: 'für 3 Monate',
  twoUsers: '2 Nutzer',
  automaticRenewal: 'Automatische Verlängerung',
  inclOnboardingWorkshop: 'inkl. Onboarding Workshop',
  highPrioritySupport: '3 Monate High Priority Support',
  oneUser: '1 Nutzer',
  noOnboarding: 'Kein Onboarding',
  onboardingWorkshop: 'Onboarding Workshop',
  bookableOnce: 'einmalig buchbar',
  threeMonthsMinimumTerm: '3 Monate Mindestlaufzeit',
  thereafterPricePerMonth: 'danach <1>{{price}}</1> pro Monat',
  paidAndCancelableYearly: 'jährlich bezahlt & kündbar',
  paidAndCancelableMonthly: 'monatlich bezahlt & kündbar',
  paidAndCancelableMonthlyAfterMinimumTerm: 'nach Mindestlaufzeit monatlich bezahlt & kündbar',
  onboardingForOneOffPrice: 'Onboarding für einmalig {{price}}',
  credits: 'Credits',
  billingType: 'Abrechnungsart',
  onboardingAndSupport: 'Onboarding & Support',
  toTheAccountSettings: 'Zu den Account Einstellungen',
  accountSettings: 'Accountverwaltung',
  adminMode: 'Agentur Accounts',
  managerMode: 'Eigener Account',
  viewTransactions: 'Rechnungen anzeigen',
  hideTransactions: 'Schließen',
  showPasswordChange: 'Passwort ändern',
  showApiKey: 'Api-Key anzeigen',
  processed: 'Bereits bearbeitet',
  removeUnprocessedContacts: 'unbearbeitete Kontakte entfernen',
  removeUnprocessedContactsContent1: 'Sollen wirklich alle unbearbeiteten Kontakte von deiner Kampagne entfernt werden?',
  removeUnprocessedContactsContent2: 'Dieser Vorgang ist nicht umkehrbar und die Kontakte stehen danach nicht mehr zur Verfügung.',
  normalLinkedInSearchWhyLead: 'Finde potenzielle Leads auf LinkedIn.',
  normalLinkedInSearchWhyRecruiting: 'Finde potenzielle Kandidaten auf LinkedIn.',
  normalLinkedInSearchWhenLead: 'Verwende dies, wenn du neue Leads identifizieren musst.',
  normalLinkedInSearchWhenRecruiting: 'Verwende dies, wenn du neue Kandidaten identifizieren musst.',
  normalLinkedInSearchHowLead: 'Führe eine grundlegende LinkedIn-Suche mit relevanten Schlüsselwörtern durch, um neue Leads zu entdecken. Kopiere und füge die URL der Suchergebnisse ein, um sie in deine Outreach-Kampagne zu integrieren.',
  normalLinkedInSearchHowRecruiting: 'Führe eine grundlegende LinkedIn-Suche mit relevanten Schlüsselwörtern durch, um neue Kandidaten zu entdecken. Kopiere und füge die URL der Suchergebnisse ein, um sie in deine Outreach-Kampagne zu integrieren.',
  normalSalesNavSearchWhy: 'Erhalte detaillierte Einblicke in deine Zielgruppe.',
  normalSalesNavSearchWhenLead: 'Verwende dies für einen gezielteren Ansatz bei der Lead-Generierung.',
  normalSalesNavSearchWhenRecruiting: 'Verwende dies für einen gezielteren Ansatz bei der Kandidaten-Generierung.',
  normalSalesNavSearchHowLead: 'Verwende LinkedIn Sales Navigator, um erweiterte Suchen mit detaillierten Filtern wie Jobtitel, Unternehmensgröße und Branche zu erstellen. Speichere diese Suchen und richte Benachrichtigungen ein, um über neue potenzielle Leads informiert zu bleiben. Kopiere und füge die URL ein, um sie in deiner Kampagne zu verwenden.',
  normalSalesNavSearchHowRecruiting: 'Verwende LinkedIn Sales Navigator, um erweiterte Suchen mit detaillierten Filtern wie Jobtitel, Unternehmensgröße und Branche zu erstellen. Speichere diese Suchen und richte Benachrichtigungen ein, um über neue potenzielle Kandidaten informiert zu bleiben. Kopiere und füge die URL ein, um sie in deiner Kampagne zu verwenden.',
  savedSalesNavSearchWhyLead: 'Greife schnell auf deine vordefinierten Lead-Suchen zu.',
  savedSalesNavSearchWhyRecruiting: 'Greife schnell auf deine vordefinierten Kandidaten-Suchen zu.',
  savedSalesNavSearchWhen: 'Verwende dies, wenn du deine gespeicherten Suchen erneut besuchen und nutzen musst.',
  savedSalesNavSearchHowLead: 'Greife in LinkedIn Sales Navigator auf deine gespeicherten Suchen zu, indem du zum Abschnitt "Gespeicherte Suchen" navigierst. Dies ermöglicht es dir, schnell auf vorab definierte Lead-Listen zuzugreifen und zu handeln, ohne die Suchparameter neu erstellen zu müssen. Kopiere und füge die URL für den einfachen Zugriff ein.',
  savedSalesNavSearchHowRecruiting: 'Greife in LinkedIn Sales Navigator auf deine gespeicherten Suchen zu, indem du zum Abschnitt "Gespeicherte Suchen" navigierst. Dies ermöglicht es dir, schnell auf vorab definierte Kandidaten-Listen zuzugreifen und zu handeln, ohne die Suchparameter neu erstellen zu müssen. Kopiere und füge die URL für den einfachen Zugriff ein.',
  normalRecruiterSearchWhy: 'Nutze LinkedIn Recruiter für umfassende Talent-Suchen.',
  normalRecruiterSearchWhen: 'Verwende dies, wenn du nach spezifischen Talentprofilen suchst.',
  normalRecruiterSearchHow: 'Führe eine Recruiter-Suche mit LinkedIn Recruiter durch, um spezifische Talentprofile zu finden. Verwende erweiterte Filter wie Fähigkeiten, Erfahrung und Standort, um die besten Kandidaten für deine Bedürfnisse zu identifizieren. Kopiere und füge die URL ein, um deine Rekrutierungsbemühungen zu optimieren.',
  recruiterProjectSearchWhy: 'Verwalte und suche nach Kandidaten innerhalb spezifischer Projekte.',
  recruiterProjectSearchWhen: 'Verwende dies, wenn du definierte Rekrutierungsprojekte hast.',
  recruiterProjectSearchHow: 'Suche innerhalb von Recruiter-Projekten nach relevanten Kandidaten. Navigiere zu deinem Projekt und verwende die Suchleiste, um Kandidaten zu finden, die deinen spezifischen Kriterien entsprechen. Kopiere und füge die URL ein, um sie in deinen Rekrutierungsprozess zu integrieren.',
  inMarketOutreachSearchesTitle: 'In-Market Outreach-Suchen',
  inMarketOutreachSearchesDescription: 'Diese Suchen helfen dir, potenzielle Leads zu finden und anzusprechen, die bereits Interesse an deiner Branche oder deinen Dienstleistungen gezeigt haben.',
  eventParticipants: 'Veranstaltungsteilnehmer',
  eventParticipantsWhy: 'Warum du dies verwenden solltest:',
  eventParticipantsWhyDescription: 'Zielgerichtete Teilnehmer von LinkedIn-Veranstaltungen.',
  eventParticipantsWhen: 'Wann du dies verwenden solltest:',
  eventParticipantsWhenDescription: 'Verwende es, wenn du dich mit Veranstaltungsteilnehmern austauschen möchtest.',
  eventParticipantsHow: 'Wie du dies verwenden kannst:',
  eventParticipantsHowDescription: 'Suche nach Teilnehmern von LinkedIn-Veranstaltungen, die sich auf deine Branche beziehen, indem du den Namen der Veranstaltung in die Suchleiste eingibst. Du musst Mitglied der Veranstaltung sein, um auf die Teilnehmer zuzugreifen. Kopiere und füge die URL ein, um mit Veranstaltungsteilnehmern in Kontakt zu treten.',
  linkedinPostingSearch: 'LinkedIn Posting-Suche',
  linkedinPostingSearchWhy: 'Warum du dies verwenden solltest:',
  linkedinPostingSearchWhyDescription: 'Engagiere dich mit Nutzern, die an bestimmten Inhalten interessiert sind.',
  linkedinPostingSearchWhen: 'Wann du dies verwenden solltest:',
  linkedinPostingSearchWhenDescription: 'Verwende es, wenn du Nutzer erreichen möchtest, die mit Beiträgen interagiert haben.',
  linkedinPostingSearchHow: 'Wie du dies verwenden kannst:',
  linkedinPostingSearchHowDescription: 'Finde und engagiere dich mit Nutzern, die LinkedIn-Beiträge geliked oder kommentiert haben, die mit deinem Unternehmen in Verbindung stehen. Verwende die LinkedIn-Suchfunktion, um relevante Beiträge zu finden und mit den engagierten Nutzern zu interagieren. Kopiere und füge die URL des Beitrags ein, um ihn in deine Outreach-Strategie aufzunehmen.',
  groupParticipants: 'Gruppenteilnehmer',
  groupParticipantsWhy: 'Warum du dies verwenden solltest:',
  groupParticipantsWhyDescription: 'Zielgerichtete aktive Mitglieder von LinkedIn-Gruppen.',
  groupParticipantsWhen: 'Wann du dies verwenden solltest:',
  groupParticipantsWhenDescription: 'Verwende es, wenn du dich mit Gruppenmitgliedern austauschen möchtest.',
  groupParticipantsHow: 'Wie du dies verwenden kannst:',
  groupParticipantsHowDescription: 'Identifiziere und engagiere dich mit Mitgliedern von LinkedIn-Gruppen, die sich auf deine Branche beziehen. Verwende die Gruppensuchfunktion, um aktive Gruppen zu finden, und navigiere dann zum Abschnitt "Mitglieder". Du musst Mitglied der Gruppe sein, um auf deren Teilnehmer zuzugreifen. Kopiere und füge die URL ein, um mit Gruppenmitgliedern in Kontakt zu treten.',
  jobPostings: 'Stellenanzeigen',
  jobPostingsWhy: 'Warum du dies verwenden solltest:',
  jobPostingsWhyDescription: 'Zielgerichtete Nutzer, die an Stellenanzeigen interessiert sind.',
  jobPostingsWhen: 'Wann du dies verwenden solltest:',
  jobPostingsWhenDescription: 'Verwende es, wenn du Nutzer erreichen möchtest, die aktiv nach Jobmöglichkeiten suchen.',
  jobPostingsHow: 'Wie du dies verwenden kannst:',
  jobPostingsHowDescription: 'Suche nach Nutzern, die mit Stellenanzeigen auf LinkedIn interagiert haben, indem du die Jobsuchfunktion verwendest. Wir erstellen basierend auf den Stellensuchen eine Leadliste. Kopiere und füge die URL der Stellenanzeige ein, um potenzielle Leads in deine Kampagne aufzunehmen.',
  useSeparateAccountTitle: 'Verwende ein separates LinkedIn-Konto',
  useSeparateAccountWhyDescription: 'Du kannst die Leistungsfähigkeit von Sales Navigator oder Recruiter-Suchen mit mehr Filtern nutzen und Personen mit verschiedenen Konten kontaktieren.',
  useSeparateAccountWhenDescription: 'Verwende es, wenn du das Konto mit der höheren Lizenz auswählen und direkt verwenden musst.',
  useSeparateAccountHowDescription: 'Wähle das Konto aus dem Dropdown-Menü aus, und es wird für die Suche verwendet. Kopiere und füge die URL des ausgewählten Kontos ein, um sie zu verwenden.',
  supportedSearchTypesTitle: 'Unterstützte Suchtypen',
  youHaveLinkedinList: 'Du hast eine Liste von LinkedIn-Konten oder Kontaktpersonen',
  whyUseAddContactsManually: 'Du kannst deine bestehenden Kontakte anreichern und verwalten, indem du ein Profilfinder-Projekt auswählst oder eine CSV-Datei hochlädst. Dies hilft dir, deine Kontaktliste effizient zu erweitern und in deine Kampagne zur Ansprache zu integrieren.',
  selectProfileFinder: 'Wähle ein Profilfinder-Projekt aus',
  uploadFileSheet: 'Lade dein Tabellenblatt hoch',
  whyUseThis: 'Warum du diese Option verwenden solltest:',
  whenUseThis: 'Wann du dies verwenden solltest:',
  howUseThis: 'Wie du dies verwenden kannst:',
  profileFinderWhyDescription: 'Die Verwendung eines Profilfinder-Projekts hilft dir, deine Kontaktsuchen zu organisieren und zu optimieren.',
  profileFinderWhenDescription: 'Verwende dies, wenn du ein spezifisches Projekt oder eine Kampagne im Sinn hast.',
  profileFinderHowDescription: 'Wähle das entsprechende Projekt aus dem Dropdown-Menü aus. Kopiere und füge die URL ein, um sicherzustellen, dass du die richtige Zielgruppe für deine Kampagne ansprichst.',
  uploadFileWhyDescription: 'Durch das Hochladen einer Datei kannst du schnell mehrere Kontakte gleichzeitig hinzufügen.',
  uploadFileWhenDescription: 'Verwende dies, wenn du eine Liste von Kontakten bereit hast, die hochgeladen werden sollen.',
  uploadFileHowDescription: 'Ziehe deine Datei einfach per Drag & Drop in die Dropzone oder klicke, um eine Datei auszuwählen. Stelle sicher, dass deine CSV-Datei richtig formatiert ist und alle notwendigen Kontaktinformationen für eine nahtlose Integration enthält. Kopiere und füge die URL der Datei ein, um sie hochzuladen.',
  coldOutreachTitle: 'Eigene Cold Outreach-Suchen',
  selectSeparateLinkedInAccount: 'Wähle ein separates LinkedIn-Konto aus',
  coldOutreachSearchesTitle: 'Eigene Kaltakquise-Suchen',
  coldOutreachSearchesDescriptionLead: 'Diese Suchen helfen dir, potenzielle Leads zu finden, die du gezielt ansprechen kannst.',
  coldOutreachSearchesDescriptionRecruiting: 'Diese Suchen helfen dir, potenzielle Kandidaten zu finden, die du gezielt ansprechen kannst.',
  weCanSearchForYou: 'Lass uns die Arbeit für dich übernehmen!',
  selectYourLinkedinProduct: 'Wähle dein LinkedIn-Produkt',
  specifyLocation: 'Lege deinen Zielort fest',
  generatedSearchesDescription: 'Wir erstellen angepasste LinkedIn-Suchen, um dir zu helfen, die besten Übereinstimmungen für deine Bedürfnisse zu finden.',
  useSeparateAccountWhy: 'Warum du diese Option verwenden solltest:',
  useSeparateAccountWhen: 'Wann du dies verwenden solltest:',
  useSeparateAccountHow: 'Wie du dies verwenden kannst:',
  weSearchForYou: 'Wir können für dich suchen',
  normalLinkedInSearch: 'Normale LinkedIn Suche',
  normalSalesNavSearch: 'Normale Sales Navigator Suche',
  savedSalesNavSearch: 'Gespeicherte Sales Navigator Suche',
  normalRecruiterSearch: 'Normale Recruiter Suche',
  recruiterProjectSearch: 'Recruiter Projekt Suche',
  downloadAsExcel: 'Als Excel-Datei downloaden',
  searchTypesAdditionalInfo: 'Weitere Informationen zu den Suchtypen',
  editRunningCampaignDialogTitle: 'Kampagne läuft aktuell',
  editRunningCampaignDialogContent1: 'Laufende Kampagnen werden im Bearbeitungsmodus gestoppt.',
  editRunningCampaignDialogContent2: 'Starte die Kampagne wieder nachdem Du sie bearbeitet hast.',
  copilotLicenseExpiredDialogTitle: 'Co-Pilot Lizenz abgelaufen',
  copilotLicenseExpiredDialogContent1: 'Deine Co-Pilot Lizenz ist abgelaufen. Ohne gültige Lizenz kannst du keine Kampagnen starten, erstellen oder bearbeiten.',
  copilotLicenseExpiredDialogContent2: 'Bitte <1>erneuere deine Lizenz</1> unter "Gebuchte Lizenzen", kaufe <3>hier</3> eine neue Lizenz oder <5>kontaktiere uns</5>, wenn du einen speziellen Plan für dich oder dein Unternehmen benötigst.',
  enrichmentSettings: 'Anreicherungseinstellungen',
  betterContactsApiKey: 'BetterContacts API-Schlüssel',
  apiKeyRequired: 'API-Schlüssel ist erforderlich.',
  enrichmentScope: 'Anreicherungsumfang',
  enrichFullFunnel: 'Gesamten Funnel anreichern',
  enrichLoadedContacts: 'Nur geladene Kontakte anreichern',
  submit: 'Absenden',
  assessing: 'Assessment',
  pleaseEnterAPrompt: 'Bitte geben Sie eine Eingabeaufforderung ein.',
  pleaseSelectAtLeastOneOption: 'Bitte wählen Sie mindestens eine Option aus.',
  assessmentFailed: 'Assessment fehlgeschlagen.',
  anErrorOccurred: 'Es ist ein Fehler aufgetreten.',
  assessmentProcessInitiated: 'Der Assessment-Prozess wurde gestartet.',
  submitting: 'Wird gesendet...',
  assessmentWillContinueInBackground: 'Das Assessment wird im Hintergrund fortgesetzt.',
  assessmentExplanation: 'Geben Sie spezifische Kriterien ein, anhand derer die KI Vorschläge erarbeiten soll, ob ein Kontakt potenziell Ihren Anforderungen entspricht. Unser System unterstützt Sie dabei, Kontakte automatisch in die Gruppen A, B und C einzuordnen, basierend auf diesen Kriterien. Sie können festlegen, welche Gruppen von Kontakten automatisch zur Kampagne hinzugefügt werden sollen. Zusätzlich liefert die KI eine Gesamt-Einschätzung (AI Assessment), um Ihnen dabei zu helfen, fundierte Entscheidungen zur Kontaktauswahl zu treffen.',
  whichContactsToAdd: 'Welche Kontakte hinzufügen:',
  optionALabel: 'Gruppe A – Hohe Übereinstimmung',
  optionADescription: 'Kontakte mit hoher Übereinstimmung Ihrer Kriterien.',
  optionBLabel: 'Gruppe B – Mittlere Übereinstimmung',
  optionBDescription: 'Kontakte mit mittlerer Übereinstimmung Ihrer Kriterien.',
  optionCLabel: 'Gruppe C – Niedrige Übereinstimmung',
  optionCDescription: 'Kontakte, die nur eine geringe Übereinstimmung mit den festgelegten Kriterien aufweisen. Diese Gruppe kann potenzielle Gelegenheiten bieten, erfordert jedoch möglicherweise zusätzliche Überprüfung.',
  rejudgeExistingContacts: 'Vorhandene Kontakte erneut einordnen',
  rejudgeExistingContactsDescription: 'Aktivieren Sie diese Option, um bestehende Kontakte erneut zu bewerten und sicherzustellen, dass sie den aktuellen Kriterien entsprechen. Dies kann helfen, die Genauigkeit und Relevanz Ihrer Kontaktliste zu verbessern.',
  nonMatchingContactsInfo: 'Wenn Sie diese Option auswählen, wird jeder Kontakt erneut überprüft und die vorherigen Einordnungen werden entfernt. Dies kann dazu führen, dass doppelte Kontakte in Ihrer Kampagne entstehen, aber Sie können sie bei Bedarf wieder hinzufügen.',
  enrichmentExplanation: 'Um die Anreicherungsfunktion zu nutzen, besuchen Sie bitte https://app.bettercontact.rocks, erstellen Sie ein Konto und kopieren Sie Ihren API-Schlüssel in dieses Feld, um den Dienst für diese spezifische Kampagne zu verbinden.',
  newBetaFeatures: 'Neue Beta-Funktionen',
  newBetaFeaturesExplanation: 'Wir haben diese neuen Funktionen im Beta-Status bereitgestellt, um sie mit mehr Daten und Benutzern zu testen. Dies hilft uns, ihren Nutzen zu verstehen und Verbesserungen an ihrer Funktionalität vorzunehmen.',
  aiJudgement: 'Bewertung',
  aiJudgementExplanation: 'Begründung',
  accountNotFound: 'LinkedIn Account nicht gefunden',
  editAndRestart: 'Bearbeiten & neustarten',
  editAndRestartFull: 'Kampagne bearbeiten & neustarten',
  changeLinkedinAccount: 'LinkedIn Account ändern',
  toTheSearches: 'zu den Suchen',
  duration30Minutes: '30 Minuten',
  duration1Hour: '1 Stunde',
  duration5Hours: '5 Stunden',
  durationrestOfDay: 'Rest des Tages',
  logoutModaltitle: 'LinkedIn-Konto abmelden',
  logoutModaldescription: 'Wählen Sie die Dauer, für die Sie abgemeldet bleiben möchten:',
  logoutModalcancel: 'Abbrechen',
  logoutModalconfirm: 'Abmeldung bestätigen',
  connectionsLimitWarning: 'Wir empfehlen pro Woche nicht mehr als {{count}} Kontaktanfragen zu senden.',
  messagesLimitWarning: 'Wir empfehlen pro Woche nicht mehr als {{count}} Nachrichten zu senden.',
  inmailsLimitWarning: 'Wir empfehlen pro Tag nicht mehr als {{count}} Inmails zu senden.',
  contactsLoadingLimitWarning: 'Wir empfehlen nicht mehr als {{count}} weitere Kontakte auf einmal zu laden.',
  coldCalls: 'Cold Calls',
  coldCallsLimitWarning: 'Das Tageslimit für Cold Calls wurde überschritten. Es wird empfohlen, maximal {{count}} pro Tag zu verwenden.',
  // new ui translations
  selectPromptLibrary: '1. Wähle eine Prompt-Bibliothek aus',
  selectMessageOrCondition: '2. Wähle eine Nachricht oder eine Bedingung aus',
  waiting: 'Warten',
  campaignStatusDraft: 'Entwurf',
  campaignStatusEditing: 'Bearbeitung',
  campaignStatusRunning: 'Arbeitet',
  startCampaignNow: 'Kampagne jetzt starten',
  campaignBriefing: 'Kampagnen Briefing',
  campaignContactList: 'Kontaktliste',
  campaignFlow: 'Kampagnen Flow',
  campaignSettings: 'Kampagnen Einstellungen',
  campaignTesting: 'Kampagnen Test',
  campaignBriefingDescription: 'Um die KI über Deine Outreach-Kampagne zu informieren, gib der KI das vollständige Stellenangebot.',
  campaignContactListDescription: 'Um Kontakte zu Deiner Kampagnenkontaktliste hinzuzufügen, vervollständige diese drei Abschnitte: Hinzufügen, Verwalten und Finale Talent-Shortlist erstellen.',
  sourcePreQualifiedContacts: 'Vorqualifizierte Kandidaten finden',
  searchMethod: 'Suchmethode',
  productToBeUsed: 'Verwendetes Produkt',
  searchObjective: 'Suchtyp',
  pastedUrls: 'Eingefügte URLs',
  crawlingAccount: 'Crawler-Konto',
  uploadedContacts: 'Hochgeladene Kontakte',
  searchLocation: 'Suchort',
  manageQualifyContacts: 'Kontakte verwalten & qualifizieren',
  manageSearches: 'Suchen verwalten',
  manageBlacklists: 'Blacklists verwalten',
  manageQualifiedLeads: 'Qualifizierte Leads verwalten',
  finalTalentShortList: 'Finale Talent-Shortlist',
  campaignSettingsDescription: 'Wähle den LinkedIn-Account und ob Nachrichten vorher genehmigt werden sollen. Arbeitszeiten und Limits stellst du beim Account ein.',
  approveMessages: 'Nachrichten genehmigen',
  leadSupplyMore: 'Noch {{count}} Kontakte in der Suche verfügbar – sie werden bei Bedarf automatisch nachgeladen.',
  leadSupplyMoreUnknown: 'Die Suche ist noch offen – weitere Kontakte werden bei Bedarf automatisch nachgeladen.',
  leadSupplyExhausted: 'Keine weiteren Kontakte: Die Suche ist ausgeschöpft und alle Kontakte wurden angeschrieben. Füge eine neue Suche hinzu, damit die Kampagne weiterläuft.',
  leadSupplyExhaustedWithReserve: 'Die Suche ist ausgeschöpft. Noch {{count}} Kontakte warten auf die erste Ansprache, danach kommen keine neuen hinzu.',
  timezone: 'Zeitzone',
  timeSettings: 'Zeiteinstellungen',
  dailyMessageLimits: 'Tägliche Nachrichtenlimits',
  selectedCount: '{{count}} ausgewählt',
  searchTypeCount: '{{count}} Suchtyp(en)',
  leadsCount: '{{count}} Leads',
  campaignOverviewDescription: 'Überprüfe die Details der Kampagne und starte sie, wenn alles in Ordnung ist.',
  paiSearch: 'Wir suchen für Dich',
  conductOwnSearch: 'Du führst Deine eigene Suche durch',
  existingContactList: 'Verwende Deine bestehenden Kontaktlisten',
  addContactsFromCampaign: 'Kontakte aus einer anderen Kampagne hinzufügen',
  campaignBriefingTitle: 'Kampagnen Briefing',
  campaignBriefingSubtitle: 'So funktioniert es',
  campaignBriefingExplanation:
    'Um die KI effektiv bei der Suche, Qualifikation und Ansprache der besten Talente zu unterstützen, gib eine vollständige und hochwertige Stellenbeschreibung an. Je detaillierter Deine Angaben zu Unternehmenskultur, erforderlichen Fähigkeiten und Vorteilen sind, desto besser kann die KI gezielt Talente ansprechen, qualifizieren und personalisierte Nachrichten erstellen, die Engagement und Antwortraten maximieren.',
  equipAiTitle: 'Gib der KI die richtigen Daten',
  equipAiDescription:
    'Wir erstellen maßgeschneiderte Prompts und optimierte LinkedIn-Suchen basierend auf Deinen Eingaben. Um loszulegen, füge einfach die URL des Stellenangebots ein, indem Du den Link zur Landingpage kopierst (entweder für das Produkt oder die Stellenanzeige). Diese wesentlichen Informationen ermöglichen es der KI, die passenden Talente effektiv zu identifizieren, zu qualifizieren und anzusprechen.',
  jobOfferUrlPlaceholder: 'Füge hier die URL Deines Stellenangebots ein',
  productUrlPlaceholder: 'Füge hier die URL Deines Produkts ein',
  invalidPerplexityUrlError: 'Bitte gib eine gültige URL ein',
  processingUrl: 'URL wird verarbeitet...',
  jobTitlePlaceholder: 'Gib hier Deinen Stellentitel ein',
  jobOfferPlaceholder: 'Füge hier Dein Stellenangebot ein',
  productProblemsPlaceholder: 'Füge hier die Probleme ein, die Dein Produkt löst',
  productFeaturesPlaceholder: 'Füge hier die Funktionen Deines Produkts ein',
  productBenefitsPlaceholder: 'Füge hier die Vorteile Deines Produkts ein',
  communicationStyleSettings: 'Einstellungen des Kommunikationsstils',
  aiGeneratedMessaging: 'KI-generierte Nachrichten',
  aiBriefingPlaceholders: 'KI-Briefing-Platzhalter',
  selectCampaignFlowTemplate: 'Wähle ein Kampagnen-Flow-Template (optional)',
  selectTemplateDescription: 'Wähle ein vorgefertigtes Template für einen schnellen Start. Es wird ein kompletter Kampagnen-Flow, Arbeitszeiten, Arbeitstage und die für deine Bedürfnisse am besten passenden Kommunikationseinstellungen festgelegt.',
  showTemplateOptions: 'Template-Optionen anzeigen',
  templateOverwriteWarning: 'Hinweis: Wenn du bereits ein Template ausgewählt oder einen Flow selbst erstellt hast, wird durch die Auswahl eines neuen Templates der Flow vollständig überschrieben.',
  languageDescription: 'Wähle die Sprache, die unsere KI verwenden soll, um deine Nachrichten zu erstellen.',
  languageNote: 'Hinweis: Wenn du "Automatisch erkennen" unter Sprache auswählst, wird die Nachricht in der Sprache des LinkedIn-Profils des Leads sein.',
  communicationStyle: 'Kommunikationsstil',
  communicationStyleDescription: 'Deine Wahl hier wird den Ton und die Förmlichkeit deiner Nachrichten beeinflussen. Wenn du zum Beispiel "Höfliche Sprache" auswählst, wird der Prompt die Verwendung formeller Kommunikation anzeigen.',
  noMessageNodes: 'In diesem Bereich siehst du eine Liste aller Nachrichtenknoten in deiner Kampagne, sobald du mindestens einen hinzugefügt hast.',
  usePromptGenerator: 'Nutze den integrierten Prompt-Generator, um Nachrichten für jeden Schritt zu erstellen.',
  noActionSelected: 'keine Aktion ausgewählt',
  timeUntilNextStep: 'Zeit bis zum nächsten Schritt: {{time}}',
  promptHelpText: 'Ein Prompt ist eine Eingabe oder Anweisung, die der generativen KI gegeben wird, um ihre Antwort zu steuern. Beim Schreiben eines Prompts solltest du darauf achten, dass er klar, spezifisch und präzise ist, um das gewünschte Ergebnis zu erzielen. Gib notwendige Kontextinformationen an und vermeide Unklarheiten, damit die KI genaue und relevante Ergebnisse erzeugen kann.',
  whatIsPrompt: 'Was ist ein Prompt und wie schreibt man einen?',
  testPrompt: 'Prompt testen',
  testContact: 'Testkontakt',
  testContactDescription: 'Wähle den Kontakt aus, für den der Prompt getestet werden soll.',
  startTest: 'Test starten',
  defaultContact: 'Standardkontakt',
  generatedText: 'Generierter Text',
  updateAiBriefingTitle: 'Aktualisiere die AI Briefing-Platzhalter',
  updateAiBriefingText:
    'Die Texte aus dem Kampagnen Briefing-Schritt werden für einige der Platzhalter im Prompt verwendet. Hier kannst du sie anpassen, falls z.B. die Ergebnisse aus dem Prompt-Test nicht gut genug waren.',
  productImpactPlaceholder: 'Beschreibe hier die Produktwirkungen',
  updateFieldNote:
    'Hinweis: Wenn du ein Feld hier aktualisierst, wird es auch im "Kampagnen Briefing"-Tab aktualisiert.',
  condition: 'Bedingung',
  maxTimeUntilAccepted: 'Max. Zeit bis zur Annahme',
  hours: 'Stunden',
  minutes: 'Minuten',
  seconds: 'Sekunden',
  connectedOnLinkedIn: 'Auf LinkedIn verbunden?',
  contactRequestAccepted: 'Kontaktanfrage akzeptiert?',
  hasEmailAddress: 'Hat eine E-Mail-Adresse?',
  utility: 'Hilfsknoten',
  withdrawContactRequest: 'Kontaktanfrage zurückziehen',
  thisIsHowItGoes: 'So funktioniert es',
  defineOperationalSettings: 'Hier legst du nur fest, was zu dieser Kampagne gehört. Arbeitszeiten und Limits stellst du beim LinkedIn-Account ein.',
  selectApproveMessages: 'Genehmige Nachrichten auswählen',
  approveMessagesDescription: 'Möchtest du die generierten Nachrichten genehmigen, bevor sie an deine Kontakte gesendet werden?',
  selectLinkedinAccountDescription: 'Gib an, welches LinkedIn-Konto die Outreach-Nachrichten senden soll.',
  campaignAccountLimitsHint: 'Arbeitszeit, Zeitzone und Tageslimits gelten für den LinkedIn-Account — unter LinkedIn-Accounts → Arbeitszeit.',
  recontactCooldownSidebar: 'Erneute Ansprache',
  selectTimezone: 'Zeitzone auswählen',
  selectTimezoneDescription: 'Wähle die Zeitzone aus, aus der deine Outreach-Kampagne operiert.',
  selectRecontactCooldown: 'Erneute Ansprache bereits kontaktierter Personen',
  recontactCooldownDescription:
    'Wenn eine Person bereits in einer anderen Kampagne angesprochen wurde: Ab wann darf sie in dieser Kampagne wieder angesprochen werden? So legst du selbst fest, wie oft sich jemand von euch gemeldet fühlt.',
  recontactCooldownNever: 'Gar nicht erneut ansprechen',
  recontactCooldown2Weeks: 'Nach 2 Wochen',
  recontactCooldown4Weeks: 'Nach 4 Wochen',
  recontactCooldown2Months: 'Nach 2 Monaten',
  recontactCooldown3Months: 'Nach 3 Monaten',
  recontactCooldown6Months: 'Nach 6 Monaten',
  recontactCooldownNote:
    'Hinweis: Diese Einstellung gilt nur für Personen, die in einer anderen Kampagne angesprochen wurden. Die Anzahl der Nachrichten innerhalb dieser Kampagne steuerst du weiterhin über den Flow.',
  defineCampaignWorkTime: 'Definiere die Arbeitszeiteinstellungen deiner Outreach-Kampagne',
  chooseWorkDaysHours: 'Wähle die Stunden und Tage der Woche aus, an denen dein KI-Co-Pilot aktiv sein soll.',
  applyWorkTimeSettings: 'Wende diese Einstellungen so an, dass der Co-Pilot Nachrichten außerhalb deiner Arbeitszeiten sendet und dabei einen natürlichen Zeitplan mit morgendlicher und später Nachmittagsaktivität nachahmt.',
  dailySentMessageLimits: 'Gib an, wie viele tägliche Outreach-Nachrichten gesendet werden sollen',
  defineDailyMessages: 'Definiere die Anzahl der Nachrichten, die pro Kampagnen-Schritt jeden Tag gesendet werden sollen. Um dein Konto zu schützen, begrenzen wir die täglichen Nachrichten, da LinkedIn tägliche und wöchentliche Limits für bestimmte Nachrichtentypen festlegt.',
  totalMessageLimit: 'Wenn du mehrere Kampagnen gleichzeitig laufen hast, muss das gesamte Nachrichtenlimit auf alle Kampagnen verteilt werden.',
  eligibleDays: 'Erlaubte Tage',
  selectDaysActive: 'Wähle die Tage der Woche aus, an denen deine Outreach-Kampagne aktiv sein soll.',
  eligibleHours: 'Erlaubte Stunden',
  selectHoursActive: 'Wähle die Stunden aus, in denen deine Outreach-Kampagne aktiv sein soll.',
  workHoursRuleHint: 'Bis zu {{maxBlocks}} Zeitfenster pro Tag, jedes {{minLength}}–{{maxLength}} Stunden lang, zusammen höchstens {{maxHours}} Stunden. Klick auf eine freie Stunde nimmt sie dazu, Klick auf eine belegte Stunde kürzt das Fenster ab dort. Weniger geht immer.',
  workHoursWindow: 'Fenster {{index}}: {{range}} Uhr',
  workHoursUsed: '{{used}} von {{max}} Stunden pro Tag',
  workHoursNoneSelected: 'Noch keine Stunde gewählt — solange pausiert die Automatisierung für dieses Konto.',
  workHoursBlockedMaxDaily: 'Mehr als {{max}} Stunden Automatisierung pro Tag lassen wir nicht zu. Nimm zuerst eine Stunde weg.',
  workHoursBlockedMaxBlocks: 'Höchstens {{max}} Zeitfenster pro Tag. Erweitere ein bestehendes Fenster oder kürze es weg.',
  workHoursBlockedMaxLength: 'Ein Fenster darf höchstens {{max}} Stunden am Stück laufen — ein langer Dauerlauf fällt LinkedIn auf.',
  workHoursTrimmedNotice: 'Dieses Konto hatte {{previous}} Stunden pro Tag eingestellt. Wir haben die Auswahl auf {{max}} Stunden gekürzt; mit Speichern übernimmst du die Kürzung.',
  selectMaxThreeCandidates: 'Wähle Kandidaten aus deiner Kontaktliste aus, um die Kampagne zu testen.',
  selectContactsForTest_ActiveSourcing: 'Bitte wähle bis zu 5 Kontakte aus deiner Finalen Kandidatenliste.',
  selectContactsForTest_LeadBooster: 'Bitte wähle bis zu 5 Kontakte aus deiner Finalen Leadliste.',
  runTestCampaignAgain: 'Testkampagne erneut ausführen',
  preparingTestMessages: 'Wir bereiten eine Reihe von Testnachrichten für deine ausgewählten Kandidaten vor.',
  processMayTake: 'Dieser Prozess kann einige Minuten in Anspruch nehmen. Vielen Dank für deine Geduld.',
  testYourCampaign: 'Teste deine Kampagne hier, um eine Vorschau darauf zu erhalten, wie Nachrichten in deinem gesamten Kampagnenfluss sich den Motivationen jedes Leads anpassen.',
  moreNodes: 'mehr Knoten',
  totalContactsInShortList: 'Gesamtzahl der Kontakte in der Finalen Shortlist',
  totalContactsInShortList_ActiveSourcing: 'Gesamtzahl der Kontakte in der Finalen Kandidatenliste',
  totalContactsInShortList_LeadBooster: 'Gesamtzahl der Kontakte in der Finalen Leadliste',
  moreContacts: 'mehr Kontakt(e)',
  campaignMessagesFromLinkedIn: 'LinkedIn-Konto zum Versenden von Nachrichten:',
  campaignOperatingDays: 'Kampagnen-Betriebstage:',
  campaignOperatingHours: 'Kampagnen-Betriebszeiten:',
  campaignContactListTitle: 'Kampagnen Kontaktliste',
  campaignContactListExplanation:
    'In diesem Abschnitt stellst du eine Zielgruppe von Leads zur Verfügung, die deine Kampagne unterstützt. Du hast zwei Optionen: Lass entweder unsere KI qualifizierte Leads basierend auf deinem Kampagnenbrief finden oder gib eigene Suchkriterien an, um den Prozess zu steuern.',
  aiBriefingLanguage: 'Kampagnen Briefing Sprache',
  sourcingPotentialTalentOnLinkedIn: 'Talente auf LinkedIn finden',
  identifyingQualifiedTalentSearches: 'Wir identifizieren qualifizierte Talente, die mit deiner Stellenbeschreibung übereinstimmen. Dies kann einen Moment dauern, während wir eine umfassende Suche durchführen.',
  selectLinkedInAccountForSourcing: 'Wähle das LinkedIn-Konto aus, das für das Sourcing verwendet werden soll',
  useDifferentLinkedInAccountsForSourcing: 'Du kannst verschiedene LinkedIn-Konten für das Sourcing von Kontakten und das Versenden von Nachrichten verwenden. Mit dieser Einstellung kannst du Leads von einem Konto sammeln und sie mit einem anderen erreichen, wodurch sowohl die Kontaktaufnahme als auch die Engagement-Strategien optimiert werden.',
  useDifferentLinkedInAccountsForSourcingShort: 'Du kannst verschiedene LinkedIn-Konten für das Sourcing von Kontakten und das Versenden von Nachrichten verwenden.',
  chooseContactSourcingMethod: 'Wähle deine Methode zum Sourcing von Kontakten',
  whichLinkedInProductForSourcing: 'Wähle das LinkedIn-Produkt für das Sourcing aus',
  selectLanguagesForSearch: 'Wähle die Sprachen für deine Suche aus',
  chooseLanguagesForSearch: 'Wähle die Sprachen aus, in denen du möchtest, dass wir die Suche durchführen.',
  noteSelectMultipleLanguages: 'Hinweis: Du kannst mehrere Sprachen auswählen. Du musst mindestens eine Sprache auswählen.',
  includeOwnContacts: 'Eigene Kontakte einschließen',
  includeOwnContactsLabel: 'Auch 1. Grad (alle Kontakte)',
  includeOwnContactsDescription: 'Standard sind nur 2. und 3. Grad. Wenn du das aktivierst, fällt dieser Filter weg — die Suche nimmt 1., 2. und 3. Grad mit.',
  typeInYourSearchLocation: 'Gib deinen Suchort ein',
  selectLocationForContactSearch: 'Wähle den Ort aus, an dem du möchtest, dass wir nach den Kontakten suchen.',
  addLinkedinSearchesToLeadBank: 'Füge LinkedIn-Suchen zu deinem Lead-Pool hinzu',
  reviewSearchSamplesForLeads: 'Überprüfe die Suche, um zu beurteilen, ob die generierten Leads deinen Kriterien und Erwartungen entsprechen. Wenn du zufrieden bist, füge sie deinem Lead-Pool hinzu. Wenn die Ergebnisse nicht ideal sind, nutze die Funktion zur Feinabstimmung der Suche, um das Ergebnis zu optimieren. Wiederhole diesen Prozess, bis du die gewünschte Lead-Qualität erreichst.',
  weAreAlmostThere: 'Wir sind fast fertig!',
  linkedinSearchReady: 'Deine LinkedIn-Talent-Suche ist bereit! Klicke auf "Talent-Suche starten", um eine LinkedIn-Suche zu generieren, die deinen Kriterien entspricht.',
  startTalentSearch: 'Talent-Suche starten',
  readyToQualifyYourLeads: 'Bereit, deine Leads zu qualifizieren!',
  clickButtonToAddSearch: 'Klicke auf den Button unten, um die Suche der Kampagne hinzuzufügen und den Lead-Qualifizierungsprozess zu starten.',
  addSearch: 'Suche hinzufügen',
  redoLeadSearch: 'Lead-Suche wiederholen',
  finetune: 'Anschauen und hinzufügen',
  edited: '(bearbeitet)',
  dataNotAvailable: 'Daten nicht verfügbar',
  notYetVisited: 'Noch nicht besucht',
  notYetVisitedTitle: 'Warum die Daten noch nicht angezeigt werden',
  notYetVisitedIntro: 'Dieser Kontakt wurde von unserem Crawler noch nicht besucht. Hier sind die häufigsten Gründe:',
  notYetVisitedReason_freemium: 'Du nutzt Freemium: Es können nur 5 Kontakte pro Tag analysiert werden.',
  notYetVisitedReason_limits: 'Wir haben bereits genug Kontakte, um zu starten. LinkedIn hat Limits, daher minimieren wir das Crawling, um dein Konto zu schützen.',
  notYetVisitedReason_not_reached: 'Der Crawler hat den Kontakt noch nicht erreicht, wird ihn aber in Kürze besuchen.',
  notYetVisitedFreemiumNote: 'Upgrade, um dein tägliches Analyse-Limit zu erhöhen und eine schnellere Verarbeitung freizuschalten.',
  selectContactSearchObjective: 'Wähle den Suchtyp aus',
  customizeSearchSelectOptions: 'Um deine Suche anzupassen, wähle mehr Optionen in diesem Abschnitt aus',
  linkedinLeadSearchReady: 'Deine LinkedIn-Lead-Suche ist bereit! Klicke auf \'Lead-Suche starten\', um eine qualifizierte Kontaktliste zu erstellen.',
  startLeadSearch: 'Lead-Suche starten',
  supportedSearches: 'Unterstützte Suchen',
  coldOutreach: 'Cold Outreach',
  inMarketOutreach: 'In-Market Outreach',
  yourSelectedSearches: 'Deine ausgewählten Suchen',
  kickOffLinkedinSourcing: 'Um mit der LinkedIn-Suche zu beginnen, wähle die Suchtypen aus, die du verwenden möchtest. Bestätige deine Auswahl, um mit der Identifizierung von Kandidaten zu starten. Sobald deine Suche abgeschlossen ist, kopiere die resultierende LinkedIn-Such-URL und füge sie hier ein.',
  nameYourSearch: 'Gib deiner Suche einen Namen',
  insertLinkedinUrl: 'Füge deine LinkedIn-URL ein',
  pasteLinkedinUrl: 'Füge die LinkedIn-Such-URL hier ein...',
  addNewUrlForSearch: '+ Neue URL für diesen Suchtyp hinzufügen',
  giveLinkedinSearchName: 'Gib deiner LinkedIn-Suche einen Namen...',
  linkedin_title: 'Normale LinkedIn-Suche',
  linkedin_subTitle: 'Finde potenzielle Leads auf LinkedIn',
  linkedin_whenToUseText: 'Wenn du neue Leads identifizieren musst',
  linkedin_howToUseText: 'Führe eine grundlegende LinkedIn-Suche mit relevanten Schlüsselwörtern durch',
  salesNavigator_title: 'Normale Sales Navigator-Suche',
  salesNavigator_subTitle: 'Erhalte detaillierte Einblicke in deine Zielgruppe',
  salesNavigator_whenToUseText: 'Wenn du neue Leads identifizieren musst',
  salesNavigator_howToUseText: 'Führe eine grundlegende LinkedIn-Suche mit relevanten Schlüsselwörtern durch',
  savedSalesNav_title: 'Gespeicherte Sales Navigator-Suche',
  savedSalesNav_subTitle: 'Greife schnell auf deine vordefinierten LinkedIn-Suchen zu',
  savedSalesNav_whenToUseText: 'Verwende dies, wenn du gespeicherte Suchen erneut aufrufen und nutzen möchtest.',
  savedSalesNav_howToUseText:
    'Rufe deine gespeicherten Suchen im LinkedIn Sales Navigator auf, indem du zum Abschnitt "Gespeicherte Suchen" navigierst. Dies ermöglicht dir, schnell auf vordefinierte Lead-Listen zuzugreifen, ohne die Suchparameter neu zu erstellen. Kopiere und füge die URL für einfachen Zugriff ein.',
  recruiter_title: 'LinkedIn Recruiter-Suche',
  recruiter_subTitle: 'Für umfassende Talentsuchen',
  recruiter_whenToUseText: 'Verwende dies, wenn du nach spezifischen Talenten suchst.',
  recruiter_howToUseText:
    'Führe eine Recruiter-Suche mit LinkedIn Recruiter durch, um spezifische Talente zu finden. Verwende erweiterte Filter wie Fähigkeiten, Erfahrung und Standort, um die besten Kandidaten für deine Anforderungen zu identifizieren. Kopiere und füge die URL ein, um deine Rekrutierungsbemühungen zu optimieren.',
  recruiterProjects_title: 'Recruiter-Projektsuche',
  recruiterProjects_subTitle: 'Verwalte und suche Kandidaten in spezifischen Projekten',
  recruiterProjects_whenToUseText: 'Verwende dies, wenn du definierte Rekrutierungsprojekte hast.',
  recruiterProjects_howToUseText:
    'Suche nach relevanten Kandidaten innerhalb von Recruiter-Projekten. Navigiere zu deinem Projekt und verwende die Suchleiste, um Kandidaten zu finden, die deinen spezifischen Kriterien entsprechen. Kopiere und füge die URL ein, um sie in deinen Rekrutierungsprozess zu integrieren.',
  events_title: 'Finde Veranstaltungsteilnehmer',
  events_subTitle: 'Ziele auf Teilnehmer von LinkedIn-Veranstaltungen ab',
  events_whenToUseText: 'Verwende dies, wenn du dich mit Veranstaltungsteilnehmern verbinden möchtest.',
  events_howToUseText:
    'Suche nach Teilnehmern von LinkedIn-Veranstaltungen, die mit deiner Branche zusammenhängen, indem du den Namen der Veranstaltung in die Suchleiste eingibst. Du musst Mitglied der Veranstaltung sein, um auf die Teilnehmer zuzugreifen. Kopiere und füge die URL ein, um dich mit den Veranstaltungsteilnehmern zu verbinden.',
  postings_title: 'Finde LinkedIn-Beiträge',
  postings_subTitle: 'Interagiere mit Nutzern, die an spezifischen Inhalten interessiert sind',
  postings_whenToUseText: 'Verwende dies, wenn du Nutzer erreichen möchtest, die mit Beiträgen interagiert haben.',
  postings_howToUseText:
    'Finde und interagiere mit Nutzern, die Beiträge auf LinkedIn geliked oder kommentiert haben, die mit deinem Unternehmen zusammenhängen. Verwende die LinkedIn-Suchfunktion, um relevante Beiträge zu finden, und interagiere mit den aktiven Nutzern. Kopiere und füge die URL der Beiträge ein, um sie in deine Outreach-Strategie einzubinden.',
  groups_title: 'Finde Gruppenmitglieder',
  groups_subTitle: 'Ziele auf aktive Mitglieder von LinkedIn-Gruppen ab',
  groups_whenToUseText: 'Verwende dies, wenn du dich mit Gruppenmitgliedern verbinden möchtest.',
  groups_howToUseText:
    'Identifiziere und interagiere mit Mitgliedern von LinkedIn-Gruppen, die sich auf deine Branche beziehen. Verwende die Gruppensuchfunktion, um aktive Gruppen zu finden, und navigiere dann zum Abschnitt "Mitglieder". Du musst Mitglied der Gruppe sein, um auf die Teilnehmer zuzugreifen. Kopiere und füge die URL ein, um dich mit Gruppenmitgliedern zu verbinden.',
  jobPostings_title: 'Finde Leads anhand von Stellenanzeigen',
  jobPostings_subTitle: 'Ziele auf Leads, die Stellenanzeigen veröffentlicht haben',
  jobPostings_whenToUseText: 'Verwende dies, wenn du Nutzer erreichen möchtest, die offene Jobs gepostet haben.',
  jobPostings_howToUseText:
    'Suche nach Nutzern, die Stellenanzeigen auf LinkedIn schalten, indem du die Jobsuchfunktion verwendest. Wir erstellen eine Lead-Liste basierend auf den Entscheidern (Abteilungsleitern oder Geschäftsführern), die sich hinter der Stelle verbergen. Kopiere und füge die URL der Stellenanzeige ein, um potenzielle Leads in deine Kampagne aufzunehmen.',
  whenToUse: 'Wann solltest du das nutzen',
  howToUse: 'Wie du das nutzen kannst',
  useThisLink: 'Nutze diesen Link, um die Suche durchzuführen',
  addExistingContacts: 'Füge bestehende Kontakte zur Kampagne hinzu',
  uploadInstructions:
    'Um deine bestehende Kontaktliste hochzuladen, lade bitte eine CSV- oder Excel-Datei hoch. Wenn du ein LinkedIn Profile Finder Projekt hast, lade es im gleichen Format herunter und hier hoch.',
  almostThere: 'Fast geschafft!',
  leadReadyMessage:
    'Dein LinkedIn-Lead-Pool ist bereit! Klicke auf "Leadliste hinzufügen" und beginne mit der Qualifizierung der Leads.',
  addToLeadBank: 'Leadliste hinzufügen',
  uploadMoreFiles: 'Weitere Dateien hochladen',
  deleteContacts: 'Kontakte löschen',
  open: 'Öffnen',
  manageQualifyLeads: 'Leads verwalten und qualifizieren',
  loadingContacts: 'Kontakte werden geladen',
  notStartedYet: 'Noch nicht gestartet',
  searchNumber: 'Suche {{position}}/{{total}}',
  contactsNotRelatedToSearch: 'Manuell hinzugefügte Kontakte',
  source: 'Quelle',
  typeOfSearch: 'Art der Suche',
  linkedInSearchUrl: 'LinkedIn Such-URL',
  openOnLinkedIn: 'Auf LinkedIn öffnen',
  progress: 'Fortschritt',
  fileNumber: 'Datei {{position}}/{{total}}',
  leadListPreview: 'Vorschau der Lead-Liste',
  totalBlacklists: '# Gesamt Blacklists',
  globalBlacklists: 'Globale Blacklists ({{count}})',
  campaignSpecificBlacklists: 'Kampagnen-spezifische Blacklists ({{count}})',
  activateExistingBlacklists: 'Aktiviere bestehende Blacklists',
  leads: 'Leads',
  addedToBlacklist: 'zur Blacklist hinzugefügt',
  contactLinkedInUrl: 'Kontakt LinkedIn URL',
  addNewContacts: '+ Neue Kontakte hinzufügen',
  addNewCompanies: '+ Neue Unternehmen hinzufügen',
  noCampaignSpecificBlacklist: 'Du hast noch keine für diese Kampagne spezifischen Blacklists erstellt. Um Kontakte zu blockieren, klicke auf:',
  addNewCampaignSpecificBlacklist: '+ Neue kampagnenspezifische Blacklist hinzufügen',
  addNewGlobalBlacklist: '+ Neue globale Blacklist hinzufügen',
  createNewBlacklist: '+ Neue Blacklist erstellen',
  totalFoundCandidates: 'Gesamt gefundene Kandidaten',
  topCandidates: 'A. Top-Kandidaten',
  strongContenders: 'B. Starke Kandidaten',
  backupCandidatePool: 'C. Backup-Kandidatengruppe',
  allContacts: 'Alle Kontakte',
  candidates: 'Kandidaten',
  topCandidatesAddedToCampaign: 'Top-Kandidaten zur Kampagnenliste hinzugefügt',
  strongContendersAddedToCampaign: 'Starke Mitbewerber zur Kampagnenliste hinzugefügt',
  backupCandidatesAddedToCampaign: 'Backup-Kandidaten zur Kampagnenliste hinzugefügt',
  talentsAddedToCampaign: 'Talente zur finalen Kampagnenliste hinzugefügt',
  qualificationInProgress: 'Qualifizierung läuft',
  profileAnalysisInProgress: 'Profilanalyse läuft',
  aiLeadAssessment: 'AI Lead-Bewertung',
  linkedInURL: 'LinkedIn-URL',
  duplicateCandidate: '{{contact}} ist ein doppelter Kandidat. Erscheint in der Pipeline der Kampagnen: {{campaigns}}',
  linkedInContact: 'LinkedIn-Kontakt',
  qualificationNote: 'Sobald deine Kampagne läuft, werden die Talente automatisch hinzugefügt, qualifiziert und in die engere Auswahl genommen. <2>Klicke hier, um bei Bedarf weitere Talente zu laden.</2>',
  qualificationNoteShort: 'Sobald deine Kampagne läuft, werden die Talente automatisch hinzugefügt, qualifiziert und in die engere Auswahl genommen.',
  clickHereToLoadTalents: 'Klicke hier, um bei Bedarf weitere Talente zu laden.',
  loadMoreTalents: 'Mehr Talente laden',
  loadMoreTalentsSuccessMessage: 'Die Suche nach weiteren Talenten wurde erfolgreich gestartet!',
  candidatesAddedToFinalShortList: 'Kandidaten zur finalen Talent-Shortlist hinzugefügt',
  downloadData: 'Daten herunterladen',
  shortSummary: 'Kurzzusammenfassung',
  addNewColumn: '+ Kontaktinformationen anreichern',
  provideUniqueCampaignName: 'Gib einen einzigartigen Namen für deine Kampagne an',
  createCampaign: 'Kampagne erstellen',
  setupNewCampaign: 'Neue Kampagne einrichten',
  nextStepsInCampaignCreation: 'Nächste Schritte bei der Kampagnenerstellung',
  briefTheAIOnOutreachRequirements: 'Informiere die KI über die Anforderungen deiner Outreach-Kampagne',
  aiOutreachDescription: 'Um der KI zu ermöglichen, effektiv Top-Kandidaten zu finden, zu qualifizieren und mit ihnen zu interagieren, gib eine gründliche und hochwertige Stellenbeschreibung ein oder stelle die URL der Jobangebotsseite bereit.',
  sourcePreQualifiedCandidates: 'Source vorqualifizierte Kandidaten aus LinkedIn-Suchen',
  addContactsToTalentPool: 'Füge Kontakte zu deiner Talentliste hinzu, die du in deiner Kampagne ansprechen möchtest. Du kannst entweder eine Liste vorhandener Kontakte hochladen oder unsere Suchfilter verwenden, um neue zu entdecken.',
  qualifyTalentsAndCreateShortlist: 'Qualifiziere Talente und erstelle eine Kampagnen-Shortlist',
  selectTopTalents: 'Wähle die besten Talente aus, mit denen du weiterarbeiten möchtest.',
  testAndStartYourCampaign: 'Teste und starte deine Kampagne',
  testCampaignSetup: 'Teste deine Kampagne, um sicherzustellen, dass alles korrekt eingerichtet ist. Nach dem Testen kannst du die Kampagne starten und ihren Fortschritt überwachen.',
  labelTheFieldsOfYourContactList: 'Bezeichne die Felder deiner Kontaktliste',
  mapFileValuesToContactProperties: 'Ordne die Werte aus deiner Datei den entsprechenden Kontakt-Eigenschaften zu. Wir benötigen mindestens den Namen und die LinkedIn-URL oder den Namen und das Unternehmen, um einen Kontakt zur Kampagne hinzuzufügen.',
  columnContentPreview: 'Spalteninhalt Vorschau',
  columnLabel: 'Spaltenbezeichnung',
  pleaseEnterValidLinkedinUrl: 'Bitte gib eine gültige LinkedIn-URL ein',
  recruiterSearchFineTuning: 'Feinabstimmung der Recruiter-Suche',
  initializingFieldsMessage: 'Wir initialisieren die Felder. Bitte warte einen Moment...',
  closeAndSave: 'Schließen & speichern',
  searchResults: 'Suchergebnisse',
  searchResultsDescription: 'Eine Liste von Kontakten basierend auf den Suchkriterien rechts. Die Qualifikation der einzelnen Kontakte erfolgt später im Prozess.',
  linkedInSearchFineTuner: 'Feinabstimmung der LinkedIn-Suche',
  linkedInSearchDescription: 'Überprüfe und passe die Kriterien unter jedem Abschnitt an, um deine KI-basierte LinkedIn-Suche zu verbessern',
  searchUpdatedSuccessMessage: 'Deine Suche wurde erfolgreich aktualisiert!',
  keepOrDeleteContacts: 'Kontakte behalten oder löschen',
  updateSearchMessage: 'Du bist dabei, deine Suche zu aktualisieren.',
  keepOrDeleteMessage: 'Möchtest du die mit dieser Suche verbundenen Kontakte behalten oder löschen?',
  qualifiedContactsInfo: 'Deine bereits qualifizierten Kontakte werden davon nicht betroffen sein.',
  keep: 'Behalten',
  insertSearchNamePlaceholder: 'Namen der Suche hier eingeben...',
  qualificationProcessStartedMessage: 'Der Qualifikationsprozess wurde erfolgreich gestartet!',
  manageContactsTitle: 'Kontakte verwalten',
  qualifyCandidatesIntro: 'In diesem Abschnitt kannst du Kandidaten qualifizieren und sie deiner finalen Kampagnenliste hinzufügen.',
  qualifyCandidatesStep1Title: '1. Du wirst zwei Listen sehen:',
  qualifyCandidatesStep1Description:
    '- Finale Kampagnenliste: Enthält alle Kontakte, die erreicht werden sollen, sobald deine Kampagne startet.\n- Vorauswahl-Liste: Enthält potenzielle Kandidaten, die deine Kriterien ganz oder teilweise erfüllen.',
  qualifyCandidatesStep2Title: '2. Qualifikationsoptionen:',
  qualifyCandidatesStep2Description: 'Nutze KI, um deine Stellenanzeige zu analysieren, und/oder füge benutzerdefinierte Kriterien hinzu.',
  qualifyCandidatesStep3Title: '3. Kandidaten werden wie folgt qualifiziert:',
  qualifyCandidatesStep3Description:
    'A. Passt: Die Muss-Kriterien sind erfüllt und das Profil passt zur Stelle.\nB. Möglich: Grundsätzlich geeignet für die Stelle, die Muss-Kriterien sind aber nicht (voll) belegt.\nC. Ungeeignet: Ein Ausschlusskriterium (No-Go) trifft zu oder das Profil passt klar nicht zur Stelle – wird nicht angesprochen.',
  qualifyContactsTitle: 'Kontakte qualifizieren',
  assessContactsTitle: 'Kontakte mit Hilfe von KI bewerten',
  continueWithoutQualifying: 'Weiter ohne Leads zu qualifizieren',
  startQualifying: 'Mit der Qualifizierung von Leads beginnen',
  refineSearchTitle: 'Suche und Qualifikationskriterien verfeinern',
  refineSearchDescription: 'Damit unsere KI qualitativ hochwertige Leads identifiziert, haben wir die Such- und Qualifikationskriterien aus der Kampagnenbeschreibung (Stellenanzeige) extrahiert. Bitte überprüfe und verfeinere die folgenden Bereiche für Schlüsselwörter und Eingaben. Indem Du diese optimierst, kannst Du unserer KI helfen, effektivere Ergebnisse zu liefern.',
  provideKeyCharacteristicsTitle: 'Gib der KI die Schlüsselmerkmale des Unternehmens, das die Stellenanzeige veröffentlicht hat',
  provideKeyCharacteristicsDescription: 'Hilf uns, die besten Talente zu finden, indem Du die Merkmale verfeinerst, die zu Deinem Unternehmen oder Deiner Abteilung passen. Unsere KI konzentriert sich auf Talente mit Erfahrung in ähnlichen Umfeldern.',
  contactsToAddTitle: 'Welche Kontakte sollen hinzugefügt werden',
  contactsToAddDescription: 'Bitte teile uns mit, welche Kontakte abhängig von den Qualifikationsergebnissen direkt in Deine endgültige Kontaktliste aufgenommen werden sollen.',
  aiLeadAssessmentTitle: 'KI-Bewertung von Leads',
  updateCriteriaInfo: 'Wenn Du die Qualifikationskriterien aktualisierst, bewerten wir alle aktuellen Leads neu und erstellen neue Listen von Grund auf. Um bereits qualifizierte Leads nicht zu verlieren, gib bitte an, ob Du Deine bisherige Auswahl beibehalten oder mit einer neu qualifizierten Liste beginnen möchtest.',
  retainOrResetTitle: 'Möchtest Du bestehende Leads behalten oder neu anfangen?',
  retainOrResetDescription: 'Möchtest Du Deine aktuelle Auswahl beibehalten, oder sollen wir alle Listen zurücksetzen?',
  keepExistingSelections: 'Bestehende Auswahlen beibehalten',
  startFresh: 'Nochmals komplett neu beginnen',
  reviewContactsTitle: 'Möchtest Du jeden Kontakt erneut überprüfen?',
  reviewContactsDescription: 'Alle Kontakte werden basierend auf Deinen aktualisierten Informationen erneut qualifiziert, wenn Du diese Option auswählst.',
  redoQualification: 'Qualifikation für bestehende Kontakte erneut durchführen',
  updateQualificationCriteria: 'Qualifizierungskriterien aktualisieren',
  topCandidate: 'Top-Kandidat',
  strongContender: 'Starker Bewerber',
  backupCandidate: 'Ersatzkandidat',
  notQualifiedTalent: 'Nicht qualifiziertes Talent',
  talentPreview: 'Talentvorschau',
  excludeFromContactList: 'Von der Kontaktliste ausschließen',
  addToContactList: 'Zur Kontaktliste hinzufügen',
  addedToPipeline: 'Zur Kontaktliste hinzugefügt',
  noLinkedInUrl: 'Kein LinkedIn URL',
  noEmail: 'Keine E-Mail',
  aiBasedLinkedInSearch: 'KI-basierte LinkedIn-Suche',
  manuallyAddedContact: 'Manuell hinzugefügter Kontakt',
  assessmentOverview: 'Bewertungsübersicht',
  aboutContact: 'Über Kontakt',
  aboutCompany: 'Über Unternehmen',
  qualificationReason: 'Qualifikationsgrund',
  whyIsContactQualified: 'Warum ist {{fullName}} ein {{qualification}}',
  noExplanationYet: 'Noch keine Erklärung vorhanden',
  professionSummary: 'Berufszusammenfassung von {{fullName}}',
  experience: 'Erfahrung',
  education: 'Bildung',
  na: 'N/V',
  present: 'Aktuell',
  keySkills: 'Schlüsselkompetenzen und Expertise von {{fullName}}',
  technicalSkills: 'Technische Fähigkeiten',
  industrySkills: 'Branchenfähigkeiten',
  softSkills: 'Soft-Skills',
  companyChannels: 'Unternehmenskanäle',
  companyInfo: 'Unternehmensinfo',
  noOfEmployees: 'Anzahl der Mitarbeiter',
  headquarter: 'Hauptsitz',
  companyDescription: 'Unternehmensbeschreibung',
  removalConfirmationMessage: 'Du versuchst, einen zuvor ausgewählten Suchtyp zu entfernen: <1>{{title}}</1>',
  removalLossWarning: 'Dadurch gehen alle bereits ausgefüllten Textfelder verloren.',
  removalConfirmation: 'Möchtest du fortfahren?',
  createCampaignBlacklist: 'Erstelle eine kampagnenspezifische Blacklist',
  addMoreItems: 'Füge mehr {{item}} hinzu',
  enterBlacklistTopicName: 'Gib den Namen des Blacklist-Themas ein',
  selectBlacklistType: 'Wähle, ob du basierend auf einer Liste von Unternehmen oder Kontakten eine Blacklist erstellen möchtest',
  uploadOrTypeItems: 'Wähle, ob du eine Datei hochladen oder einzelne {{item}} eingeben möchtest',
  uploadFileOption: 'CSV- oder Excel-Datei hochladen',
  typeInIndividualOption: 'Einzelne {{item}} eingeben',
  blacklistBasedOnContacts: 'Blacklist basierend auf Kontakten',
  blacklistBasedOnCompanies: 'Blacklist basierend auf Unternehmen',
  uploadContactList: 'Lade deine Kontaktliste hoch',
  uploadCompanyList: 'Lade deine Firmenliste hoch',
  typeInOrPasteContactLinkedInURL: 'Füge die LinkedIn-URL des Kontakts ein',
  typeInOrPasteCompanyNames: 'Gib den Firmennamen ein oder füge ihn ein',
  resetList: 'Liste zurücksetzen',
  itemsToBeAdded: '{{count}} {{item}} werden zur Blacklist hinzugefügt',
  closeFile: 'Datei schließen',
  selectLinkedinUrlColumn: 'Wähle die Spalte der LinkedIn-URL in deiner Datei aus',
  selectCompanyNameColumn: 'Wähle die Spalte des Firmennamens in deiner Datei aus',
  confirmSelection: 'Auswahl bestätigen',
  pressEnterOrClick: 'Drücke Enter oder klicke auf den Plus-Button, wenn du einen Wert eingibst',
  invalidLinkedInUrl: 'Bitte gib eine gültige LinkedIn-URL ein',
  deleteBlacklistTitle: 'Kampagnen-Blacklist löschen',
  deleteBlacklistConfirmation: 'Soll die Blacklist {{name}} wirklich gelöscht werden?',
  deleteBlacklistIrreversibleProcess: 'Dieser Vorgang kann nicht rückgängig gemacht werden und die Blacklist ist danach nicht mehr verfügbar.',
  changeBlacklistNameTitle: 'Blacklist-Namen ändern',
  changeBlacklistNamePlaceholder: 'Gib hier den neuen Blacklist-Namen ein',
  aiPoweredEnrichmentTitle: 'KI-gestützte Kontakt-Datenanreicherung',
  enhanceDatabaseTitle: 'Verbessere Deine Datenbank sofort',
  howItWorksTitle: 'So funktioniert es',
  enrichmentDescription: 'Nutze die KI-gestützte Kontakt-Datenanreicherung! Unsere KI scannt LinkedIn-Profile und füllt automatisch fehlende Kontaktdaten wie Telefonnummern aus, indem sie diese Informationen sofort als neue Spalten in Deiner Datenbank hinzufügt – das spart wertvolle Zeit.',
  getBetterContactsStarted: 'Beginne auf <1>https://app.bettercontact.rocks</1>. Erstelle ein Konto, kopieren Deinen API-Schlüssel und verknüpfen ihn mit Deiner Kampagne!',
  betterContactsApiKeyLabel: 'BetterContacts API-Schlüssel',
  pasteApiKeyPlaceholder: 'Füge den API-Schlüssel hier ein...',
  enrichmentScopeLabel: 'Umfang der Anreicherung',
  enrichShortList: 'Nur die Kandidaten-Liste anreichern',
  enrichFullPool: 'Gesamte Kandidaten-Datenbank anreichern',
  prospeosEnrichmentTab: 'Prospeos Anreicherung',
  customFieldEnrichmentTab: 'Custom-Field-Anreicherung',
  prospeosEnrichmentTitle: 'Prospeos Anreicherung',
  prospeosEnrichmentDescription: 'Bereichere deine Kontakte mit zusätzlichen Daten von Prospeos.',
  enrichEmail: 'E-Mail anreichern',
  enrichPhoneNumber: 'Telefonnummer anreichern',
  customFieldEnrichmentTitle: 'Custom-Field-Anreicherung',
  customFieldEnrichmentDescription: 'Fülle kampagnenspezifische Personen- und Firmeninformationen über OpenAI Web Search ins Custom Field.',
  selectDataSource: 'Datenquelle auswählen',
  contactInformation: 'Kontaktinformationen',
  customFieldPersonPromptLabel: 'Prompt für Personeninformationen',
  customFieldPersonPromptPlaceholder: 'z. B. Wofür ist diese Person vermutlich verantwortlich und warum ist sie relevant?',
  customFieldCompanyPromptLabel: 'Prompt für Firmeninformationen',
  customFieldCompanyPromptPlaceholder: 'z. B. Welche aktuellen Firmensignale machen diesen Account relevant?',
  overrideExistingResults: 'Bestehende Ergebnisse überschreiben',
  addProspeosInformation: 'Prospeos-Informationen hinzufügen',
  addCustomFieldInformation: 'Custom-Field-Informationen hinzufügen',
  addInformation: 'Informationen hinzufügen',
  sourcingPhoneNumbers: 'Telefonnummern für Deine Leads werden gesucht',
  analyzingProfilesMessage: 'Wir analysieren derzeit LinkedIn-Profile aus Deiner Kontaktliste. Kontakte mit ausreichenden Daten werden in der Ergebnisspalte angezeigt. Profile ohne die notwendigen Daten werden automatisch aus den endgültigen Ergebnissen ausgeschlossen.',
  startHereTitle: 'Fang hier an!',
  startHereSubtitle: 'Wähle aus, wie Du Deine Kampagne einrichten möchtest',
  useTemplate: 'Verwende eine Vorlage',
  setupFromScratch: 'Erstelle eine Kampagne von Grund auf',
  duplicateExisting: 'Dupliziere eine Deiner bestehenden Kampagnen',
  createFromScratchInfo: 'Wenn Du diese Option wählst, musst Du Deinen Kampagnen Flow von Grund auf erstellen. Möchtest Du fortfahren?',
  selectTemplateLater: 'Du kannst später auch eine Vorlage auswählen, wenn Du möchtest.',
  addedTemplateTitle: 'Template active Sourcing erfolgreich hinzugefügt',
  addedTemplateSubtitle: 'Dein neues Template enthält bereits eine vollständige Struktur für deine persönliche Kontaktaufnahme.',
  addedTemplateStep1: 'Struktur überprüfen',
  addedTemplateStep1Description: 'Schau dir alle Nachrichten im Template an. Du kannst die Prompts anpassen, um sie persönlicher zu gestalten.',
  addedTemplateStep2: 'Wartezeiten und Ablauf anpassen',
  addedTemplateStep2Description: 'Du kannst die Wartezeiten zwischen den Nachrichten bearbeiten, Nachrichten hinzufügen oder entfernen und neue Funktionen hinzufügen, um den Ablauf zu optimieren.',
  aiBriefingAdditionalInfoDescription: 'Beschreibe zusätzliche Anforderungen oder Eigenschaften, die deine idealen Kandidaten besitzen sollten, falls diese nicht in den vorherigen Feldern oder Suchkriterien abgedeckt wurden.',
  withdraw: 'Zurückziehen',
  noNodesMessage: 'Hier können keine Knoten hinzugefügt werden...',
  congratulationsFirstName: 'Herzlichen Glückwunsch, {{userFirstName}}!',
  campaignCreated_LeadBooster: 'Du hast Deine Lead-Outreach-Kampagne <1>{{campaignName}}</1> erfolgreich erstellt.',
  campaignCreated_ActiveSourcing: 'Du hast Deine Recruiting-Kampagne <1>{{campaignName}}</1> erfolgreich erstellt.',
  boostConversionsInfo_LeadBooster: 'Jetzt kannst du deine Conversions steigern – mit passenden Leads, personalisierten Nachrichten und automatisierten Abläufen.',
  boostConversionsInfo_ActiveSourcing: 'Jetzt kannst du deine Conversions steigern – mit passenden Kandidaten, personalisierten Nachrichten und automatisierten Abläufen.',
  keepTrackOf: 'Behalte den Überblick über...',
  campaignStatusInfo: 'Den Status und die Leistung deiner Kampagne',
  requiredActionsInfo: 'Erforderliche Aktionen (siehe Kampagnenübersicht)',
  editCampaignInfo: 'Denke daran, dass Du Deine Kampagne jederzeit bearbeiten kannst',
  continueToStatus: 'Zum Status weitergehen',
  addContact: '+ Kontakt',
  languages: 'Sprachen',
  default: 'automatisch',
  noGlobalBlacklist: 'Du hast noch keine globalen Blacklisten erstellt. Erstelle jetzt deine erste Blacklist mit einem Klick auf:',
  noBlacklistsItemsAdded: 'Aktuell hast du keine Unternehmen oder Kontakte in deiner globalen Blacklist. Um die Blacklist-Funktion zu nutzen und deine Outreach-Kampagnen besser auszurichten, klick einfach auf <1>Kontakte hinzufügen</1> oder <3>Unternehmen hinzufügen</3>, um Einträge in die passende Blacklist-Kategorie einzutragen.',
  addCompanies: 'Unternehmen hinzufügen',
  editBlacklistName: 'Blacklist Namen bearbeiten',
  manageGlobalBlacklists: 'Globale Blacklisten verwalten',
  blacklistOverview: 'Blacklist Übersicht',
  blacklistedContacts: 'Kontakte auf der Blacklist',
  blacklistedBy: 'Auf die Blacklist gesetzt von',
  activeAccounts: 'Aktive Accounts',
  remainingAccounts: 'Restliche Accounts',
  linkedinAccountTodayUsage: 'Heute: {{profiles}} Profile gecrawlt',
  riskReductionLabel: 'Profilbesuche gedrosselt bis {{date}} ({{percent}} %)',
  riskReductionHint: 'LinkedIn hat die Profilaufrufe dieses Kontos vorübergehend gedrosselt. Zum Schutz des Kontos laufen bis {{date}} die Profilbesuche mit {{percent}} % des Limits. Kontaktanfragen und Nachrichten sind davon nicht betroffen. Danach gilt automatisch wieder das normale Limit.',
  noLicense: 'Keine Lizenz',
  popular: 'Beliebt',
  featureOverviewLicenseSummary: '{{active}} von {{total}} Lizenzen aktiv',
  featureOverviewLicenseLocked: '{{products}} nicht freigeschaltet',
  assignLicense: 'Lizenz zuweisen',
  unassignLicense: 'Lizenz entfernen',
  assignLicenseTitle: 'Lizenz dem LinkedIn-Konto zuweisen',
  assignLicenseDescription: 'Wähle eine SAIA-Lizenz aus, die mit diesem LinkedIn-Konto verknüpft werden soll.',
  noUnlinkedLicenses: 'Keine freien SAIA-Lizenzen verfügbar.',
  assignLicenseStepSubtitle: 'Lizenz',
  assignLicenseStepTitle: 'Lizenz zuweisen',
  assignLicenseStepDescription: 'Jedes LinkedIn-Konto benötigt eine aktive SAIA-Lizenz. Bitte wähle eine verfügbare Lizenz aus, die diesem Konto zugewiesen werden soll, bevor du den Anmeldeprozess startest.',
  loadingLicenses: 'Verfügbare Lizenzen werden geladen...',
  availableLicenses: 'Verfügbare Lizenzen',
  noLicensesAvailable: 'Keine Lizenzen verfügbar',
  noLicensesAvailableDescription: 'Es sind keine freien SAIA-Lizenzen verfügbar. Bitte wende dich an deinen Administrator, um eine neue Lizenz hinzuzufügen, oder entferne die Zuweisung einer bestehenden Lizenz von einem anderen Konto.',
  licenseActive: 'Aktiv',
  licenseInactive: 'Inaktiv',
  saiaRecruiting: 'SAIA Recruiting',
  saiaSales: 'SAIA Sales',
  billingType_yearly: 'Jährlich',
  billingType_monthly: 'Monatlich',
  billingType_trial: 'Testversion',
  signInAnyway: 'Trotzdem anmelden',
  accountStatus: 'Status des Accounts',
  accountActive: 'Verbunden',
  accountActiveAndRunning: 'Verbunden & Automatisierung aktiv',
  accountMaintenanceRequired: 'Login-Problem - Aktion erforderlich',
  accountConnected: 'Verbunden',
  accountDisconnected: 'Getrennt',
  accountConnecting: 'Verbindung wird hergestellt...',
  linkedinNotConnectedBanner: 'LinkedIn nicht sauber verbunden',
  linkedinBannerMore: '(+{{count}} weitere)',
  accountAttentionRequired: 'Aktion erforderlich',
  accountTemporarilyRestricted: 'Kurzzeitig eingeschränkt',
  campaignLead: 'Kampagnenverantwortlicher',
  campaignSteps: 'Kampagnenschritte',
  noStepsConfigured: 'Für diese Kampagne sind keine Schritte hinterlegt.',
  noContactsOnStep: 'Aktuell keine Kontakte auf diesem Schritt.',
  noRepliesYet: 'Noch keine Antworten erfasst.',
  lastModified: 'Zuletzt geändert',
  sourced: 'Gefunden',
  inContactBank_LeadBooster: 'in der Lead-Bank',
  inContactBank_ActiveSourcing: 'im Talent-Pool',
  assessed: 'Bewertet',
  qualified: 'Qualifiziert',
  inShortList: 'in der Shortlist',
  jobsDoneInCampaignPipeline: 'Aufgaben in der Kampagnen-Pipeline',
  replies: 'Antworten',
  excluded: 'Ausgeschlossen',
  fromShortlist: 'von der Shortlist',
  contacted: 'Kontaktierte',
  contacts_LeadBooster: 'Leads',
  contacts_ActiveSourcing: 'Kandidaten',
  toMessages: 'auf Nachrichten',
  toApprove: 'Genehmige',
  campaignAlt: 'Kampagnen',
  campaignOperationalStatus: 'Betriebsstatus der Kampagne',
  approveMessages2: 'Nachrichten\nfreigeben',
  allCampaigns: 'Alle Kampagnen',
  campaignIsWorking: 'Agent am Arbeiten',
  campaignTakesBreak: 'Agent macht Pause',
  campaignPausedByAccountLock: '🔐 Pausiert – LinkedIn-Anmeldung erforderlich',
  campaignStatusPausedByAccountLockDescription: 'Diese Kampagne wurde automatisch pausiert, weil der verknüpfte LinkedIn-Account eine manuelle Anmeldung benötigt. Sie startet automatisch neu, sobald der Account wieder eingeloggt ist.',
  campaignNeedsHelp: 'Agent braucht Hilfe',
  campaignDone: 'Agent ist fertig',
  campaignArchived: 'Archiviert',
  campaignDraft: 'Entwurf',
  campaignTurnedOff: 'Agent ausgeschaltet',
  campaignStatusRunningDescription: 'Deine Kampagne ist aktiv und sendet derzeit Nachrichten. Dieser Status bestätigt auch, dass deine Kampagne innerhalb der festgelegten Arbeitszeiten läuft, die in den Kampagneneinstellungen definiert wurden. Nachrichten werden gemäß dem festgelegten Zeitplan gesendet.',
  campaignStatusPausedDescription: 'Deine Kampagne sendet vorübergehend keine Nachrichten, weil sie entweder außerhalb der festgelegten Arbeitszeiten liegt oder der LinkedIn-Account gerade angemeldet wird.',
  campaignStatusNeedsHelpDescription: 'Deine Kampagne ist nicht aktiv und benötigt Hilfe. Mögliche Gründe dafür sind:\n- Ein accountbezogenes Problem, z. B. ein paralleler Account-Login, erreichte LinkedIn-Limits oder ein nicht gefundener LinkedIn-Account.',
  campaignStatusFinishedDescription: 'Deine Kampagne wurde beendet, da sie ihr definiertes Ziel oder die Abschlusskriterien erreicht hat – etwa durch Ausschöpfen der Zielgruppe, Abschluss der Nachrichten­sequenz oder Erreichen der Kampagnenziele.',
  campaignStatusArchivedDescription: 'Deine Kampagne wurde archiviert und erscheint nicht mehr in der regulären Kampagnenübersicht.',
  campaignStatusStartedDescription: 'Deine Kampagne wurde gestartet und ist jetzt aktiv. Sie sendet derzeit Nachrichten innerhalb der in den Kampagneneinstellungen definierten Arbeitszeiten.',
  campaignStatusActuallyPausedDescription: 'Deine Kampagne sendet aktuell keine Nachrichten, da sie sich entweder außerhalb der Arbeitszeiten befindet oder dein LinkedIn-Account gerade angemeldet wird.',
  campaignStatusSuspendedDescription: 'Deine Kampagne wurde manuell pausiert. Du kannst sie bei Bedarf jederzeit neu starten.',
  campaignStatusCreatedDescription: 'Deine Kampagne wurde erstellt, aber noch nicht gestartet oder vollständig eingerichtet. Du kannst sie jederzeit starten, sobald sie vollständig konfiguriert ist.',
  campaignStatusAccountNotFoundDescription: 'Dein LinkedIn-Account wurde nicht gefunden. Bitte wähle einen existierenden Account für diese Kampagne aus. Nicht verfügbare oder gelöschte Accounts werden automatisch aus der Kampagne entfernt.',
  campaignStatusLinkedinAccountProblemDescription: 'Es liegt ein Problem mit deinem LinkedIn-Account vor. Bitte überprüfe die Details im Account Management und behebe das Problem, bevor du die Kampagne erneut startest.',
  campaignStatusCoPilotLicenseExpiredDescription: 'Deine Co-Pilot-Lizenz ist abgelaufen. Bitte aktualisiere sie, um deine Kampagne fortzusetzen.',
  campaignStatusContactsAlmostExhaustedDescription: 'Deine Kampagne nähert sich dem Ende. Überprüfe bitte, ob du weitere Kontakte hinzufügen möchtest.',
  explanation: 'Erklärung',
  declineMessage: 'Nachricht ablehnen',
  approveMessage: 'Nachricht freigeben',
  in: 'in',
  today: 'Heute',
  thisWeek: 'Diese Woche',
  thisMonth: 'Diesen Monat',
  overallStats: 'Gesamt',
  timeFrame: 'Zeitrahmen',
  campaignsPerformanceOverview: 'Kampagnen Leistungsübersicht',
  campaignOperationalOverview: 'Übersicht der Kampagnen',
  noCampaignsForLinkedinAccount: 'Keine Kampagnen für diesen LinkedIn Account',
  noCampaignStartedYet: 'Bitte wähle oben eine oder mehrer laufende Kampagne aus und klicke dann auf den Button "Statistiken laden", um die Kampagnenstatistiken zu laden.',
  loadStatistics: 'Statistiken laden',
  campaignPerformance: 'Kampagnenleistung',
  connectionRequestsSent: 'Kontaktanfragen versendet',
  newContacts: 'Neue Kontakte',
  positiveReplies: 'Positive Antworten',
  negativeReplies: 'Negative Antworten',
  conversionRate: 'Konversionsrate',
  avgLeadToConversionTime: 'Durchschnittliche Zeit bis zur Konversion',
  todaysSuccessMetrics: 'Erfolgsmetriken von <0>Heute</0>',
  thisWeeksSuccessMetrics: 'Erfolgsmetriken von <0>Dieser Woche</0>',
  thisMonthsSuccessMetrics: 'Erfolgsmetriken von <0>Diesem Monat</0>',
  marketConversionAverage: 'Durchschnitt der Marktkonversion: {{conversion}}%',
  marketBenchmark: 'Markt-Benchmark: {{avgConversion}} Wochen',
  timeFormatWeek: '{{count}} Woche',
  timeFormatWeeks: '{{count}} Wochen',
  timeFormatDay: '{{count}} Tag',
  timeFormatDays: '{{count}} Tage',
  timeFormatHour: '{{count}} Stunde',
  timeFormatHours: '{{count}} Stunden',
  timeFormatMinute: '{{count}} Minute',
  timeFormatMinutes: '{{count}} Minuten',
  timeFormatNoTime: '0 Stunden',
  campaignsPerformanceDistribution: 'Verteilung der Kampagnenleistung',
  personalityTypesDistribution: 'Verteilung der <0>Persönlichkeitstypen</0>',
  reasonsForPositiveReplies: 'Gründe für positive Antworten',
  reasonsForNegativeReplies: 'Gründe für negative Antworten',
  positiveReplyReasonsDistribution: 'Verteilung der <0>Gründe für positive Antworten</0>',
  negativeReplyReasonsDistribution: 'Verteilung der <0>Gründe für negative Antworten</0>',
  profileViews: 'Profilansichten',
  campaignLeadsProfileViewed: 'Das Profil des Kampagnenverantwortlichen wurde vor der Antwort angesehen',
  viewedProfile: 'Profil angesehen',
  didNotViewProfile: 'Profil nicht angesehen',
  professionalProfileDistribution: 'Verteilung der <0>Beruflichen Profile</0>',
  companySizes: 'Unternehmensgrößen',
  jobTitleErrorText: 'Der Jobtitel wurde nicht automatisch generiert. Bitte gib hier einen Jobtitel ein, um fortzufahren.',
  jobAdErrorText: 'Die Jobanzeige wurde nicht automatisch generiert. Bitte gib hier eine Jobanzeige ein, um fortzufahren.',
  productProblemsErrorText: 'Die Probleme wurden nicht automatisch generiert. Bitte gib hier Probleme ein, um fortzufahren.',
  productFeaturesErrorText: 'Die Funktionen wurden nicht automatisch generiert. Bitte gib hier Funktionen ein, um fortzufahren.',
  productBenefitsErrorText: 'Die Vorteile wurden nicht automatisch generiert. Bitte gib hier Vorteile ein, um fortzufahren.',
  productImpactErrorText: 'Der Einfluss wurde nicht automatisch generiert. Bitte gib hier einen Einfluss ein, um fortzufahren.',
  talentsFoundMatchingCriteria: '{{count}} gefundene Talente',
  qualifyLeadsQuestion: 'Wie möchtest du Talente qualifizieren?',
  qualifyLeadsDescription: 'Möchtest du auf eine direkte KI-basierte Qualifikation mithilfe von Stellenanzeigeninformationen setzen oder den Prozess mit zusätzlichen Talente-Kriterien verbessern, die du angibst?',
  aiBasedQualification: 'KI-basierte Qualifikation basierend auf den Angaben der Stellenanzeige',
  additionalCriteriaQualification: 'Zusätzliche Talente-Kriterien der KI zur Verfügung stellen',
  recommendedDailyMax: 'Empfohlene maximale Anzahl pro Tag: {{max}}',
  approveMessageSuccessMessage: 'Die Nachricht wurde genehmigt und wird in Kürze verschickt.',
  comparePerformanceAcrossCampaigns: 'Vergleiche die Leistung zwischen Kampagnen',
  campaignComparison: 'Kampagnenvergleich',
  statisticsSelectedCampaign: '{{count}} Kampagne',
  statisticsSelectedCampaigns: '{{count}} Kampagnen',
  statisticsNoCampaignSelected: 'Keine Kampagne ausgewählt',
  statisticsEntireRuntime: 'Gesamte Kampagnenlaufzeit',
  yourPerformance: 'Deine Leistung',
  selectMetricToCompare: 'Wähle eine Kennzahl, um die Leistung über Zeiträume hinweg zu vergleichen',
  messageHistory: 'Nachrichtenverlauf',
  compareConversionRates: 'Vergleiche Konversionsraten und Lead-to-Conversion-Zeiten über Kampagnen hinweg.',
  leadToConversionTime: 'Zeit bis zur Konversion',
  averageMarketsBenchmark: 'Durchschnittlicher Markt-Benchmark',
  weeks: 'Wochen',
  performanceForAvgSuccessMetrics: '<0>Deine Leistung</0> für <2>Durchschnittliche Erfolgsmetriken</2>',
  leadBoosterIcpTitle: 'Ideales Kundenprofil (ICP)',
  leadBoosterIcpDescription: 'Bitte gib die wichtigsten Informationen zu deinem idealen Kundenprofil an.',
  leadBoosterIcpPlaceholder: 'z. B. SaaS-Unternehmen | 50–500 Mitarbeiter | DACH-Region | Skalierungsprobleme im Vertrieb',
  leadBoosterIcpExplanation: 'Was ist ein ICP?\nEin Ideal Customer Profile (ICP) ist eine Beschreibung des Kunden, der den größten Nutzen aus deinem Produkt zieht und dir im Gegenzug den höchsten Wert bietet.',
  deleteAssociatedContacts: 'Die zugehörigen Kontakte löschen',
  activeCampaigns: 'Aktive Kampagnen',
  notActiveCampaigns: 'Nicht aktive Kampagnen',
  archivedCampaigns: 'Archivierte Kampagnen',
  messageSentSuccess: 'Deine Nachricht wurde erfolgreich gesendet.',
  searchCampaign: 'Kampagne suchen',
  campaignFilters: 'Kampagnenfilter',
  handleMultipleChats: 'Mehrere Chats verwalten:',
  manageMultipleChatsTooltip: 'Verwalte mehrere Kampagnen-Chats über alle deine LinkedIn-Konten gleichzeitig von einer einzigen Plattform aus. Wähle die LinkedIn-Konten aus, für die du Nachrichten bearbeiten möchtest.',
  selectAllAccounts: 'Alle Konten auswählen',
  unselectAllAccounts: 'Alle Konten abwählen',
  unreadMessages: 'ungelesene Nachrichten',
  campaignMessagesPlaceholder: 'Kampagnennachrichten werden angezeigt, wenn du einen Chat innerhalb der entsprechenden Kampagne auswählst.',
  fromLinkedinAccountInCampaign: 'Von <1>{{senderName}}</1> in <3>{{campaignName}}</3>',
  reviewProfile: 'Profil\nÜberprüfen',
  sendMessagePlaceholder: 'Sende deine Nachricht hier aus {{name}}s LinkedIn-Profil...',
  markAsUnread: 'Als ungelesen markieren',
  showDetailedContactView: 'Detailansicht des Kontakts anzeigen',
  inboxCampaignsColumn: 'Kampagnen',
  inboxContactsColumn: 'Kontakte',
  inboxUnreadCount: '{{count}} ungelesen',
  inboxSelectCampaignHint: 'Wähle links eine Kampagne aus, um ihre Kontakte zu sehen.',
  inboxContactDetailView: 'Detailansicht',
  addMoreCandidates: 'Füge weitere Kandidaten hinzu',
  addCandidatesToPreQualificationList: 'Füge weitere Kandidaten zu deiner Vorauswahlliste hinzu.',
  linkedinLimitsExplanation: 'Aufgrund der Einschränkungen und Sicherheitsrichtlinien von LinkedIn können wir täglich etwa 400 LinkedIn-Profile über alle Kampagnen hinweg analysieren, mit einem Maximum von 150 Profilen pro Stunde. <1>Du kannst zwar mehr Profile laden, aber das Überschreiten dieser Limits erhöht das Risiko, dass dein LinkedIn-Konto markiert oder gesperrt wird.</1>',
  leadLoadingAdvice: 'Wenn du vorhast, weitere Leads in deine Qualifikationsliste zu laden, achte darauf, die stündlichen Limits und die Gesamtzahl der verarbeiteten Profile über alle Kampagnen hinweg einzuhalten, um innerhalb sicherer Nutzungsgrenzen zu bleiben.',
  setTotalContactsTitle: 'Lege die Gesamtanzahl der Kontakte für die Vorauswahl fest.',
  setTotalContactsDescription: 'Lege die Gesamtanzahl der Kontakte für die Vorauswahl fest. Profile werden schrittweise analysiert, um dein LinkedIn-Konto zu schützen und Sperrungen zu vermeiden.',
  setTotalContactsDescriptionShort: 'Profile werden schrittweise analysiert, um dein LinkedIn-Konto zu schützen und Sperrungen zu vermeiden.',
  startLoadingContacts: 'Beginne mit dem Laden der Kontakte',
  loadMore: '+ Mehr laden',
  urlValid: 'URL valide',
  searchStatusOutOfHours: 'Außerhalb der Arbeitszeit',
  searchStatusQuotaExceeded: 'Tageslimit erreicht',
  searchQuotaExceededTooltip:
    'Das tägliche Kontakt-Limit für diesen LinkedIn-Account ist erreicht. Bitte erhöhe das Limit im Account-Management oder warte bis morgen.',
  searchQuotaExceededTooltipWithDate:
    'Das tägliche Kontakt-Limit für diesen LinkedIn-Account ist erreicht. Bitte erhöhe das Limit im Account-Management oder warte bis {{retryAt}}.',
  searchQuotaExceededHint:
    'Diese Suche wurde gestoppt, weil das Tageslimit erreicht ist. Bitte Limit erhöhen oder morgen erneut starten.',
  searchWithheldProfiles: 'Davon {{count}} ohne Namen von LinkedIn übermittelt und deshalb nicht übernommen.',
  searchWithheldProfilesTooltip:
    'LinkedIn liefert bei manchen Profilen keinen Namen aus — typischerweise, weil sie außerhalb Ihres Netzwerks liegen und Ihre Recruiter-Lizenz sie nur anonymisiert anzeigt. Ohne Namen lässt sich kein Kontakt anlegen. Diese Profile sind in der Gesamtzahl der Suchtreffer enthalten, fehlen aber in der Vorauswahlliste.',
  searchQuotaExceededModalTitle: 'Tageslimit erreicht',
  searchQuotaExceededModalContent:
    'Die Suche "{{searchName}}" wurde angehalten, weil das tägliche Kontakt-Limit des verknüpften LinkedIn-Accounts erreicht wurde.',
  searchQuotaExceededModalContentWithDate:
    'Die Suche "{{searchName}}" wurde angehalten, weil das tägliche Kontakt-Limit des verknüpften LinkedIn-Accounts erreicht wurde. Nächster Versuch ist ab {{retryAt}} möglich.',
  searchQuotaExceededModalContentActionHint:
    'Du kannst das Limit im LinkedIn-Account-Management erhöhen oder bis morgen warten.',
  searchQuotaExceededOpenAccountManagement: 'Account-Management öffnen',
  nextBatchTooltip: 'Die nächsten Kandidaten werden automatisch geladen, sobald deine Kampagne aktiv ist und das tägliche Limit für das Laden von Kandidaten noch nicht erreicht wurde.',
  candidatesAdded: 'Kandidaten zur Vorauswahlliste hinzugefügt',
  manageContacts: 'Kontakte verwalten',
  contactList: 'Kontaktliste',
  finalCampaignList: 'Finale Kampagnenliste',
  preQualifiedContactList: 'Vorqualifizierte Talentliste',
  assessedCandidatesNumber_LeadBooster: '<0>{{current}} / {{total}}</0> bewertete Leads',
  assessedCandidatesNumber_ActiveSourcing: '<0>{{current}} / {{total}}</0> bewertete Talente',
  loadedCandidatesNumber_LeadBooster: '<0>{{current}} / {{total}}</0> geladene Leads',
  loadedCandidatesNumber_ActiveSourcing: '<0>{{current}} / {{total}}</0> geladene Talente',
  campaignNoSearchesPlaceholder: 'Es wurden noch keine Suchen zur Kampagne hinzugefügt.',
  qualifiedAs: 'Bewertung',
  qualifiedAsTooltip: 'Kandidaten werden wie folgt kategorisiert:\nA. Passt: Die Muss-Kriterien sind erfüllt und das Profil passt zur Stelle.\nB. Möglich: Grundsätzlich geeignet für die Stelle, die Muss-Kriterien sind aber nicht (voll) belegt.\nC. Ungeeignet: Ein Ausschlusskriterium (No-Go) trifft zu oder das Profil passt klar nicht zur Stelle – wird nicht angesprochen.',
  aContactDescription: 'Passt: Muss-Kriterien erfüllt, passt zur Stelle.',
  bContactDescription: 'Möglich: Grundsätzlich geeignet, Muss-Kriterien nicht (voll) belegt.',
  cContactDescription: 'Ungeeignet: No-Go trifft zu oder passt klar nicht zur Stelle.',
  notJudged: 'Noch nicht bewertet',
  presentIn: 'Bereits in Kampagne(n)',
  aContactsCount: 'A: <1>{{count}}</1>',
  bContactsCount: 'B: <1>{{count}}</1>',
  cContactsCount: 'C: <1>{{count}}</1>',
  notJudgedContactsCount: 'Nicht bewertet: <1>{{count}}</1>',
  contactedOn: 'kontaktiert am',
  toContactList: 'Weiter zur Kontaktliste',
  toCampaignFlow: 'Weiter zum Flow',
  toCampaignSettings: 'Weiter zu den Einstellungen',
  toCampaignTesting: 'Weiter zum Testen',
  toCampaignOverview: 'Weiter zur Übersicht',
  autoReplySettings: 'Einstellungen für automatische Antworten',
  missingCampaignFlowNoNodes: 'Dein Kampagnen Flow hat keine Knoten.',
  messageNodeMissingType: 'Einer oder mehrere deiner Nachrichtenknoten hat keinen spezifischen Nachrichtentyp ausgewählt.',
  connectMessageTo: 'Womit soll deine Nachricht verbunden werden?',
  negativeExit: 'Bedingung\n<1>negativer</1> Ausgang',
  positiveExit: 'Bedingung\n<1>positiver</1> Ausgang',
  warningMissingMessageType: 'Eine oder mehrere Nachrichten haben keinen ausgewählten Typ.',
  warningMissingConditionType: 'Eine oder mehrere Bedingungen haben keinen ausgewählten Typ.',
  emailAccessRevoked: 'Der Zugriff auf dein E-Mail-Konto wurde widerrufen. Bitte durchlaufe den Autorisierungsprozess erneut, um den Zugriff wiederherzustellen.',
  twoFaNotEnabled: '2FA nicht aktiviert',
  syncErrorTwoFaNotEnabled: '2FA nicht aktiviert',
  syncErrorTwoFaNotEnabledText1: 'Du musst die Zwei-Faktor-Authentifizierung (2FA) in deinem {{liProductType}} Account aktivieren, um dich erfolgreich anzumelden.',
  syncErrorTwoFaNotEnabledText2: 'Bitte <1>aktiviere die 2FA in deinem {{liProductType}} Account</1>.',
  syncErrorTwoFaNotEnabledText3: 'Sobald du die 2FA aktiviert hast, kehre hierher zurück und klicke auf "Erneut Synchronisieren", um fortzufahren.',
  activate: 'Aktiviere',
  theRecruiterTwoFa: 'die Recruiter 2FA',
  theLinkedinTwoFa: 'die {{liProductType}} 2FA',
  twoFaNotEnabledWarning: 'Die Zwei-Faktor-Authentifizierung (2FA) ist in deinem LinkedIn Account nicht aktiviert.',
  contactsAlreadyInCampaignExplanation: 'Diese Kontakte sind bereits in der Kontaktliste einer anderen Kampagne aufgeführt, was bedeutet, dass sie schon angesprochen wurden oder noch angesprochen werden.',
  searchLoading: 'Wann und wie werden Kontakte von Suchen geladen?',
  noteAiDoesWork: 'Lehne dich zurück und lass die KI die Arbeit machen',
  contactsLoadAutomatically: 'Kontakte werden im Laufe der Zeit automatisch geladen. Der "+ Mehr laden"-Button ist optional.',
  searchAutomaticLoadingExplanation: '<0>Automatisches Laden:</0> Die Kontakte werden nach Bedarf für die Kampagne nachgeladen. Dieser Prozess läuft im Hintergrund ab, sobald eine Kampagne aktiv ist und das Tageslimit für das Laden von Kontakten noch nicht erreicht wurde.',
  searchSpecifiedLoadingExplanation: '<0>Spezifische Anzahl:</0> Es werden Kontakte aus der Suche geladen, bis die angegebene Anzahl erreicht ist oder die Suche beendet ist. (Die Anzahl kann je nach den verfügbaren Kontakten aus dem crawlenden LinkedIn-Account variieren)',
  optimizeAndAddSearch: 'Suche optimieren & hinzufügen',
  listPreview: 'Listen-Vorschau',
  reviewAndOptimizeSearch: 'Überprüfe und optimiere deine LinkedIn-Kandidatensuche',
  refineSearchStepsTitle: 'Optimiere deine Kandidatensuche ganz einfach mit diesen Schritten:',
  refineSearchStep1: '1. Klicke auf den Link der aktuellen Such-URL, um LinkedIn zu öffnen und deine Kandidatenliste zu überprüfen.',
  refineSearchStep2: '2. Passe die Suche auf LinkedIn an, bis sie deinen Kriterien entspricht.',
  refineSearchStep3: '3. Sobald du zufrieden bist, kopiere die LinkedIn-Such-URL und füge sie im unteren Bereich ein.',
  refineSearchStep4: '4. Klicke abschließend auf „Speichern“, um die optimierte Suche abzuschließen.',
  currentSearchUrl: 'Aktuelle Such-URL',
  reviewCurrentSearch: 'Überprüfe deine aktuellen Suchergebnisse und passe sie bei Bedarf auf LinkedIn an.',
  optimizedSearchUrl: 'Optimierte Such-URL',
  addMoreSearchesInstruction: 'Die Suche <1>{{searchName}}</1> wurde erfolgreich hinzugefügt.\nUm weitere Suchen hinzuzufügen, klicke auf den Button „Weitere Suchen hinzufügen“. Sobald du bereit bist, klicke auf „Leads überprüfen“, um fortzufahren.',
  addMoreSearches: 'Weitere Suchen hinzufügen',
  reviewContacts: 'Kontakte überprüfen',
  added: 'hinzugefügt',
  contactLoadingInProgress: 'Die Kontakte deiner Suche werden geladen',
  contactLoadingMayTakeAMoment: 'Die gefundenen Kontakte werden deiner Kandidatenliste hinzugefügt. Dies kann einen Moment dauern.',
  restructure: 'Restrukturieren',
  howItWorks: 'So funktioniert es...',
  invalidLinkedinUrl: 'Bitte gib eine valide LinkedIn-URL ein',
  copyLinkToPasswordManager: 'Link zum Passwort-Manager kopieren',
  noPhone: 'Keine Telefonnummer',
  personalityProfile: 'Persönlichkeitsprofil',
  callTranscript: 'Anruftranskript',
  callTranscriptAndPersonalityProfile: 'Anruftranskript & Persönlichkeitsprofil',
  meetingBooked: 'Meeting gebucht',
  noMeetingBooked: 'Kein Meeting gebucht',
  unsuccessful: 'Erfolglos',
  missingParameters: 'Fehlende erforderliche Parameter. Ergebnis kann nicht gesendet werden.',
  processingChoice: 'Deine Auswahl wird verarbeitet...',
  failedToRecord: 'Deine Antwort konnte nicht gespeichert werden. Bitte versuche es erneut.',
  thankYouResponse: 'Danke! Deine Antwort ({{chosenOutcome}}) wurde gespeichert.',
  missingParametersUrl: 'Fehlende erforderliche Parameter in der URL.',
  failedToLoadTranscript: 'Das Transkript konnte nicht geladen werden. Bitte versuche es später erneut.',
  noTranscriptFound: 'Kein Transkript gefunden.',
  failedToLoadContactDetails: 'Kontaktdaten konnten nicht geladen werden. Bitte versuche es später erneut.',
  noAssessmentAvailable: 'Keine Bewertung verfügbar.',
  contactBlacklistFileStructureDescription: 'Damit unsere Blacklist richtig funktioniert, füge bitte die <1>LinkedIn-URL</1> des Profils jedes einzelnen Kontakts in deiner Datei ein. Dies ermöglicht es uns, sie genau zu identifizieren. Alle anderen Felder sind optional.',
  companyBlacklistFileStructureDescription: 'Damit unsere Blacklist effektiv funktioniert, stelle sicher, dass deine Datei den <1>Namen jedes Unternehmens</1> enthält, das du auf die Blacklist setzen möchtest. Alle anderen Felder sind optional.',
  updating: 'aktualisieren',
  paymentDate: 'Bezahldatum',
  loadingTransactions: 'Lade Transaktionen',
  viewInvoice: 'Rechnung ansehen',
  usage: 'Nutzung',
  activateSetting: 'Einstellung aktivieren',
  autoReplyQuestion: 'Sollen wir automatisch auf deine erhaltenen Nachrichten antworten?',
  goalOfCommunication: 'Ziel der Kommunikation',
  goalOfCommunicationDescription: 'Definiere das Kommunikationsziel, nach dem sich die Antwortnachrichten richten sollen.',
  goalPlaceholder: 'z. B. Anruf vereinbaren, Informationen bereitstellen, etc.',
  cases: 'Fälle',
  casesDescription: 'Definiere die Fälle, für die die automatische Antwortfunktion gelten soll.',
  caseNumber: 'Fall #{{number}}',
  caseDescription: 'Fallbeschreibung',
  caseDescriptionPlaceholder: 'Was erkennen wir? z. B. Preisbedenken',
  casePrompt: 'Antwort-Prompt',
  casePromptPlaceholder: 'Wie soll geantwortet werden? z. B. Rabatt anbieten oder Preisgestaltung erklären',
  addCase: 'Fall hinzufügen',
  saveAutoReplySettings: 'Speichere Einstellungen',
  seeAll: 'Alles anzeigen',
  seeLess: 'Weniger anzeigen',
  insertPlaceholders: 'Platzhalter einfügen',
  messageContext: 'Nachrichten Kontext',
  approveMessagesNote: 'Hinweis: Wenn diese Einstellung aktiviert ist, werden die Nachrichten nicht sofort von deiner Kampagne gesendet. Überprüfe regelmäßig den Kampagnen-Tab, um sicherzustellen, dass alle erstellten Nachrichten versendet werden. Beachte außerdem, dass Nachrichten nur während der festgelegten Kampagnenlaufzeit generiert werden – plane diese daher sorgfältig.',
  campaignStartCountdown: 'Deine Kampagne startet in:',
  campaignEstimatedStart: 'Geschätzte Zeit, bis deine Kampagne Nachrichten generiert:',
  startCampaignSkipWorkTimeCheck: 'Klicke hier, um sofort Nachrichten zu generieren',
  campaignWorking: 'Die Kampagne läuft gerade.',
  campaignLinkedInWarning: '<0>Denke daran!</0> Um sofort Nachrichten zu generieren, vermeide die Nutzung von LinkedIn Recruiter. Ein doppelter Login könnte die Sicherheitsmaßnahmen von LinkedIn auslösen und dein Konto sperren.',
  campaignStartingSoon: '<1>Bleib aufmerksam!</1> In Kürze fangen wir an, Nachrichten zu generieren.',
  tooltipApproveMessages: 'Hier findest du alle Nachrichten, die zur Genehmigung anstehen.',
  startGeneratingMessagesNow: 'Nachrichten jetzt generieren',
  enterEmailForTranscripts: 'Gib die E-Mail ein, an die die Transkripte gesendet werden sollen',
  taskManager: 'Aufgaben verwalten',
  fixAccounts: 'Kontoprobleme beheben',
  replyMessages: 'Nachrichten beantworten',
  handleMultipleAccounts: 'Mehrere Accounts verwalten:',
  manageMultipleAccountsTooltip: 'Verwalte Kampagnen-Aufgaben für all deine LinkedIn-Konten von einer einzigen Plattform aus. Wähle die LinkedIn-Konten aus, für die du Aufgaben bearbeiten möchtest.',
  accountsToFix: 'Zu korrigierende Accounts',
  tasksTitle: 'Aufgaben',
  tasksSubtitle: '{{openTasks}} offene Aufgaben über {{accountCount}} LinkedIn-Accounts',
  accountStatusLabel: 'Status des Accounts',
  accountsToFixHint: 'Blockiert laufende Kampagnen',
  messagesToApproveHint: '{{messageCount}} Nachrichten warten auf Freigabe',
  replyMessagesHint: 'Antworten aus der Inbox',
  connectAccountTask: 'Konto verbinden',
  reviewTask: 'Prüfen',
  replyTask: 'Beantworten',
  task: 'Aufgabe',
  userAccount: 'Benutzerkonto',
  messagesToApproveCount: '# Zu genehmigende Nachrichten',
  messagesToReplyCount: '# Zu beantwortende Nachrichten',
  deleteContactPermanently: 'Kontakt dauerhaft löschen',
  confirmDeleteContact: 'Soll der Kontakt <1>{{contactName}}</1> wirklich dauerhaft von der Kampagne gelöscht werden?',
  deletedContactsInfo: 'Dauerhaft gelöschte Kontakte werden auch von neuen Suchen nicht wieder zur Kampagne hinzugefügt.',
  confirmDeleteMultipleContacts: 'Sollen die <1>{{contactCount}}</1> Kontakte wirklich dauerhaft von der Kampagne gelöscht werden?',
  deleteMultipleContactsPermanently: 'Kontakte dauerhaft löschen',
  pwmLinkCopiedMessage: 'Link in die Zwischenablage kopiert. Öffne einen neuen Tab und füge den Link in die URL-Leiste deines Browsers ein.',
  updateAvailable: 'Eine neue Version ist verfügbar. Bitte aktualisiere die Seite.',
  reload: 'Seite neu laden',
  deleteFunnelContact: 'Kontakt löschen',
  changeAiJudgement: 'KI-Bewertung ändern',
  changeAiJudgementFor: 'KI-Bewertung für <1>{{contactName}}</1> ändern',
  isReviewed: 'Überprüft',
  flowIncompleteDialogTitle: 'Flow unvollständig',
  flowIncompleteDialogContent: 'Der Flow ist unvollständig. Bitte stelle sicher, dass der Flow vollständig ist, bevor du die Kampagne testest oder startest.',
  exportContact: 'Kontaktprofil exportieren',
  exportContactProfile: 'Kontaktprofil exportieren',
  generateCV: 'Lebenslauf generieren',
  selectLanguage: 'Sprache auswählen',
  additionalInformation: 'Zusätzliche Informationen',
  additionalInfoPlaceholder: 'Fügen Sie alle spezifischen Informationen hinzu, die Sie in den Lebenslauf aufnehmen möchten (z.B. Projektdetails, besondere Erfolge usw.)',
  noProfileIdError: 'Keine Profil-ID für diesen Kontakt gefunden.',
  cvGenerationError: 'Beim Generieren des Lebenslaufs ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  positiveRepliesCount: 'Positive Antworten ({{count}})',
  negativeRepliesCount: 'Negative Antworten ({{count}})',
  mustHaveCriteria: 'Pflichtkriterien (Zwingend erforderlich)',
  niceToHaveCriteria: 'Wünschenswerte Kriterien (Von Vorteil, aber nicht erforderlich)',
  excludeCriteria: 'Ausschlusskriterien (Disqualifizierend)',
  mustHaveCriteriaPlaceholder: 'Muss alle diese Kriterien erfüllen, um qualifiziert zu sein',
  niceToHaveCriteriaPlaceholder: 'Diese Eigenschaften sind erwünscht, aber nicht erforderlich',
  excludeCriteriaPlaceholder: 'Schließe aus, wenn eine dieser Eigenschaften erfüllt ist',
  aiBriefingCompanyChallengesLabel: 'Unternehmensherausforderungen',
  aiBriefingCompanyCharacteristicsLabel: 'Unternehmenseigenschaften',
  aiBriefingCultureValuesLabel: 'Organisations- und Arbeitskulturwerte',
  aiBriefingAdditionalInfoLabel: 'Zusätzliche Kandidatenanforderungen',
  aiBriefingCompanyChallengesDescription: 'Beschreibe spezifische organisatorische Herausforderungen oder Kontexte, z. B. Umgebungen mit hohem Datenaufkommen oder die Verwaltung groß angelegter Automatisierungsprojekte in wachstumsorientierten Unternehmen.',
  aiBriefingCompanyCharacteristicsDescription: 'Beschreibe die Unternehmensgröße/-typ, z. B. große Unternehmen mit über 500 Mitarbeitern oder schnelllebige Startups, die skalieren.',
  aiBriefingCultureValuesDescription: 'Beschreibe kulturelle Passung/Werte, z. B. das Arbeiten in agilen, kollaborativen Teams, die Anpassungsfähigkeit und datengetriebene Entscheidungen betonen.',
  editLinkedinSignature: 'LinkedIn Signatur bearbeiten',
  linkedinSignature: 'LinkedIn Signatur',
  linkedinSignatureClarification: 'Du kannst eine Signatur festlegen, die automatisch an Nachrichten angehängt wird, die über Kampagnen gesendet werden',
  includeSignatureInPreview: 'Signatur hinzufügen',
  signatureExample: 'Beispiel: John Doe | Sales Manager | Company Name',
  enterSignature: 'Gib hier deine Signatur ein',
  addSignatureToMessage: 'Signatur hinzufügen',
  // Create Campaign Success Dialog translations
  setupNewCampaign_ActiveSourcing: 'Neue Active Sourcing Kampagne einrichten',
  nextStepsInCampaignCreation_ActiveSourcing: 'Nächste Schritte bei der Active Sourcing Kampagnenerstellung',
  briefTheAIOnOutreachRequirements_ActiveSourcing: 'Informiere die KI über die Anforderungen deiner Active Sourcing Kampagne',
  aiOutreachDescription_ActiveSourcing: 'Um der KI zu ermöglichen, effektiv Top-Kandidaten zu finden, zu qualifizieren und mit ihnen zu interagieren, gib eine gründliche und hochwertige Stellenbeschreibung ein oder stelle die URL der Stellenanzeige bereit.',
  sourcePreQualifiedCandidates_ActiveSourcing: 'Source vorqualifizierte Kandidaten aus LinkedIn-Suchen',
  addContactsToTalentPool_ActiveSourcing: 'Füge potenzielle Kandidaten zu deiner Talentliste hinzu, die du in deiner Kampagne ansprechen möchtest. Du kannst entweder eine Liste vorhandener Kontakte hochladen oder unsere Suchfilter verwenden, um neue zu entdecken.',
  qualifyTalentsAndCreateShortlist_ActiveSourcing: 'Qualifiziere Kandidaten und erstelle eine Rekrutierungs-Shortlist',
  selectTopTalents_ActiveSourcing: 'Wähle die besten Talentprofile aus, mit denen du für diese Position zusammenarbeiten möchtest.',
  testAndStartYourCampaign_ActiveSourcing: 'Teste und starte deine Active Sourcing Kampagne',
  testCampaignSetup_ActiveSourcing: 'Teste deine Kampagne, um sicherzustellen, dass alles für die Kandidatenansprache korrekt eingerichtet ist. Nach dem Testen kannst du die Kampagne starten und den Rekrutierungsprozess überwachen.',
  ok_ActiveSourcing: 'OK',

  // File Upload Dialog translations
  labelTheFieldsOfYourContactList_ActiveSourcing: 'Bezeichne die Felder deiner Kandidatenliste',
  thisIsHowItGoes_ActiveSourcing: 'Kandidateninformationen zuordnen',
  mapFileValuesToContactProperties_ActiveSourcing: 'Ordne die Werte aus deiner Datei den entsprechenden Kandidaten-Eigenschaften zu. Wir benötigen mindestens den Namen und die LinkedIn-URL oder den Namen und das Unternehmen, um einen potenziellen Kandidaten zur Kampagne hinzuzufügen.',
  fileHasTableHeading_ActiveSourcing: 'Datei hat Tabellenüberschrift',
  columnContentPreview_ActiveSourcing: 'Kandidatendaten-Vorschau',
  columnLabel_ActiveSourcing: 'Feldbezeichnung',
  continue_ActiveSourcing: 'Weiter',
  doNotImport_ActiveSourcing: 'Nicht importieren',
  firstName_ActiveSourcing: 'Vorname',
  lastName_ActiveSourcing: 'Nachname',
  linkedinUrl_ActiveSourcing: 'LinkedIn URL',
  company_ActiveSourcing: 'Unternehmen',
  email_ActiveSourcing: 'E-Mail',
  position_ActiveSourcing: 'Position',
  customField_ActiveSourcing: 'Benutzerdefiniertes Feld',
  phoneNumber_ActiveSourcing: 'Telefonnummer',
  // Create Campaign Success Dialog translations for LeadBooster

  // Brief AI translations for Active Sourcing
  campaignBriefingExplanation_ActiveSourcing: 'Informiere die KI über deine Active Sourcing Kampagnenanforderungen, indem du Stellendetails oder eine URL bereitstellst. Dies hilft, gezielte Nachrichten für ideale Kandidaten zu erstellen.',
  equipAiDescription_ActiveSourcing: 'Stelle der KI die Stellenbeschreibung und relevante Details zu der Position zur Verfügung, für die du rekrutierst. Diese Informationen helfen der KI, personalisierte Kontaktnachrichten für potenzielle Kandidaten zu erstellen.',  // AI Search Briefing translations for Active Sourcing
  topCandidates_ActiveSourcing: 'A. Top-Kandidaten',
  strongContenders_ActiveSourcing: 'B. Starke Bewerber',
  backupCandidatePool_ActiveSourcing: 'C. Backup-Kandidaten',
  qualifyLeadsQuestion_ActiveSourcing: 'Wie möchtest du deine Kandidaten qualifizieren?',
  qualifyLeadsDescription_ActiveSourcing: 'Wähle aus, wie du die Kandidaten in deinem Talentpool bewerten und qualifizieren möchtest. Du kannst KI-basierte Qualifikation oder zusätzliche Kriterien definieren.',
  aiBasedQualification_ActiveSourcing: 'KI-basierte Qualifikation',
  additionalCriteriaQualification_ActiveSourcing: 'Zusätzliche Qualifikationskriterien definieren',

  // Found LinkedIn Search translations for Active Sourcing
  talentsFoundMatchingCriteria_ActiveSourcing: 'Wir haben {{count}} Kandidaten gefunden, die deinen Kriterien entsprechen',

  // PAI Contact Search translations for Active Sourcing
  sourcingPotentialTalentOnLinkedIn_ActiveSourcing: 'Sourcing potenzieller Kandidaten auf LinkedIn...',
  identifyingQualifiedTalentSearches_ActiveSourcing: 'Identifizierung qualifizierter Kandidatensuchen...',

  // Added Template Success Dialog translations for Active Sourcing
  addedTemplateStep1_ActiveSourcing: 'Überprüfe und passe die Kampagnennachrichten an',
  addedTemplateStep1Description_ActiveSourcing: 'Die Vorlage wurde zu deinem Kampagnenablauf hinzugefügt. Du kannst nun die Nachrichten zur Kandidatenansprache überprüfen und anpassen, um sie optimal auf deine Bedürfnisse abzustimmen.',
  addedTemplateStep2_ActiveSourcing: 'Teste und starte deine Active Sourcing Kampagne',
  addedTemplateStep2Description_ActiveSourcing: 'Nach der Anpassung deiner Nachrichten kannst du deine Kampagne testen, um sicherzustellen, dass sie korrekt eingerichtet ist, bevor du sie startest, um mit Kandidaten in Kontakt zu treten.',
  // Create Campaign Success Dialog translations
  setupNewCampaign_LeadBooster: 'Neue Lead Generation Kampagne einrichten',
  nextStepsInCampaignCreation_LeadBooster: 'Nächste Schritte bei der Lead Generation Kampagne',
  briefTheAIOnOutreachRequirements_LeadBooster: 'Informiere die KI über die Anforderungen deiner Leadgenerierungskampagne.',
  aiOutreachDescription_LeadBooster: 'Um der KI zu ermöglichen, effektiv potenzielle Leads zu identifizieren, zu qualifizieren und mit ihnen zu interagieren, stelle bitte eine detaillierte Kampagnenbeschreibung oder einen Link zu deiner Landingpage bereit.',
  sourcePreQualifiedCandidates_LeadBooster: 'Führe LinkedIn-Suchen durch, um vorqualifizierte Leads zu generieren.',
  addContactsToTalentPool_LeadBooster: 'Füge Kontakte zu deiner Lead-Liste hinzu, die du in deiner Kampagne ansprechen möchtest. Du kannst entweder eine Liste bestehender Kontakte hochladen oder unsere Suchfilter verwenden, um neue potenzielle Leads zu entdecken.',
  qualifyTalentsAndCreateShortlist_LeadBooster: 'Qualifiziere Leads und erstelle eine aussagekräftige Shortlist für deine Kampagne.',
  selectTopTalents_LeadBooster: 'Wähle die vielversprechendsten Leads aus, mit denen du weiterarbeiten möchtest.',
  testAndStartYourCampaign_LeadBooster: 'Teste und starte deine Leadgenerierungskampagne.',
  testCampaignSetup_LeadBooster: 'Teste deine Kampagne, um sicherzustellen, dass alles korrekt eingerichtet ist. Nach dem Testen kannst du die Kampagne starten und ihren Fortschritt überwachen.',
  ok_LeadBooster: 'OK',

  // File Upload Dialog translations
  labelTheFieldsOfYourContactList_LeadBooster: 'Bezeichne die Felder deiner Lead-Liste',
  thisIsHowItGoes_LeadBooster: 'Lead-Informationen zuordnen',
  mapFileValuesToContactProperties_LeadBooster: 'Ordne die Werte aus deiner Datei den entsprechenden Lead-Eigenschaften zu. Wir benötigen mindestens den Namen und die LinkedIn-URL oder den Namen und das Unternehmen, um einen potenziellen Interessenten zur Kampagne hinzuzufügen.',
  fileHasTableHeading_LeadBooster: 'Datei hat Tabellenüberschrift',
  columnContentPreview_LeadBooster: 'Lead-Daten-Vorschau',
  columnLabel_LeadBooster: 'Feldbezeichnung',
  continue_LeadBooster: 'Weiter',
  doNotImport_LeadBooster: 'Nicht importieren',
  firstName_LeadBooster: 'Vorname',
  lastName_LeadBooster: 'Nachname',
  linkedinUrl_LeadBooster: 'LinkedIn URL',
  company_LeadBooster: 'Unternehmen',
  email_LeadBooster: 'E-Mail',
  position_LeadBooster: 'Position',
  customField_LeadBooster: 'Benutzerdefiniertes Feld',
  phoneNumber_LeadBooster: 'Telefonnummer',

  // Brief AI translations
  campaignBriefingExplanation_LeadBooster: 'Informiere die KI über die Anforderungen deiner Lead Generation Kampagne, indem du Details zu deiner Zielgruppe oder eine URL bereitstellst. Dies hilft, gezielte Nachrichten für potenzielle Leads zu erstellen.',
  equipAiDescription_LeadBooster: 'Stelle der KI Informationen über dein Produkt oder deine Dienstleistung sowie über deine Zielkunden zur Verfügung. Dies wird der KI helfen, personalisierte Outreach-Nachrichten für potenzielle Leads zu erstellen.',

  // AI Search Briefing translations
  topCandidates_LeadBooster: 'A. Top-Leads',
  strongContenders_LeadBooster: 'B. Starke Leads',
  backupCandidatePool_LeadBooster: 'C. Backup-Leads',
  qualifyLeadsQuestion_LeadBooster: 'Wie möchtest du deine Leads qualifizieren?',
  qualifyLeadsDescription_LeadBooster: 'Wähle aus, wie du die Leads in deinem Interessentenpool bewerten und qualifizieren möchtest. Du kannst KI-basierte Qualifikation oder zusätzliche Kriterien definieren.',
  aiBasedQualification_LeadBooster: 'KI-basierte Qualifikation',
  additionalCriteriaQualification_LeadBooster: 'Zusätzliche Qualifikationskriterien definieren',

  // Found LinkedIn Search translations
  talentsFoundMatchingCriteria_LeadBooster: 'Wir haben {{count}} Leads gefunden, die deinen Kriterien entsprechen',

  // PAI Contact Search translations
  sourcingPotentialTalentOnLinkedIn_LeadBooster: 'Sourcing potenzieller Leads auf LinkedIn...',
  identifyingQualifiedTalentSearches_LeadBooster: 'Identifizierung qualifizierter Lead-Suchen...',

  // Added Template Success Dialog translations
  addedTemplateStep1_LeadBooster: 'Überprüfe und passe die Kampagnennachrichten an',
  addedTemplateStep1Description_LeadBooster: 'Die Vorlage wurde zu deinem Kampagnenablauf hinzugefügt. Du kannst nun die Nachrichten zur Lead-Ansprache überprüfen und anpassen, um sie optimal auf deine Bedürfnisse abzustimmen.',
  addedTemplateStep2_LeadBooster: 'Teste und starte deine Lead Generation Kampagne',
  addedTemplateStep2Description_LeadBooster: 'Nach der Anpassung deiner Nachrichten kannst du deine Kampagne testen, um sicherzustellen, dass sie korrekt eingerichtet ist, bevor du sie startest, um mit potenziellen Leads in Kontakt zu treten.',

  // LeadBooster Translations
  manageContactsTitle_LeadBooster: 'Verwalte deine Leads',
  qualifyCandidatesIntro_LeadBooster: 'Unsere KI hilft dir, Leads basierend auf deinem idealen Kundenprofil zu qualifizieren. So kannst du dich auf die vielversprechendsten Leads konzentrieren.',
  qualifyCandidatesStep1Title_LeadBooster: 'Schritt 1: Beschreibe deinen idealen Kunden',
  qualifyCandidatesStep1Description_LeadBooster: 'Teile uns mit, nach wem du suchst. Je mehr Details du angibst, desto besser kann unsere KI Leads mit deinen Anforderungen abgleichen.',
  qualifyCandidatesStep2Title_LeadBooster: 'Schritt 2: KI analysiert deine Leads',
  qualifyCandidatesStep2Description_LeadBooster: 'Unsere KI durchsucht deine Leadliste und bewertet jeden Lead basierend auf deinen Kriterien.',
  qualifyCandidatesStep3Title_LeadBooster: 'Schritt 3: Erhalte qualifizierte Leads',
  qualifyCandidatesStep3Description_LeadBooster: 'Erhalte eine Liste von Leads, kategorisiert nach Qualität, damit du deine Outreach-Bemühungen priorisieren kannst.',
  qualifyContactsTitle_LeadBooster: 'LEADS QUALIFIZIEREN',
  assessContactsTitle_LeadBooster: 'LEAD-BEWERTUNGSKRITERIEN',
  continueWithoutQualifying_LeadBooster: 'Fortfahren ohne Leads zu qualifizieren',
  next_LeadBooster: 'Weiter',
  back_LeadBooster: 'Zurück',
  startQualifying_LeadBooster: 'Lead-Qualifizierung starten',

  // ActiveSourcing Translations
  manageContactsTitle_ActiveSourcing: 'Verwalte deine Kandidaten',
  qualifyCandidatesIntro_ActiveSourcing: 'Unsere KI hilft dir, Kandidaten basierend auf deinen Stellenanforderungen zu qualifizieren. So kannst du dich auf die vielversprechendsten Talente konzentrieren.',
  qualifyCandidatesStep1Title_ActiveSourcing: 'Schritt 1: Beschreibe deinen idealen Kandidaten',
  qualifyCandidatesStep1Description_ActiveSourcing: 'Teile uns mit, nach wem du suchst. Je mehr Details du angibst, desto besser kann unsere KI Kandidaten mit deinen Anforderungen abgleichen.',
  qualifyCandidatesStep2Title_ActiveSourcing: 'Schritt 2: KI analysiert deine Kandidaten',
  qualifyCandidatesStep2Description_ActiveSourcing: 'Unsere KI durchsucht deine Kandidatenliste und bewertet jeden Kandidaten basierend auf deinen Kriterien.',
  qualifyCandidatesStep3Title_ActiveSourcing: 'Schritt 3: Erhalte qualifizierte Kandidaten',
  qualifyCandidatesStep3Description_ActiveSourcing: 'Erhalte eine Liste von Kandidaten, kategorisiert nach Qualität, damit du deine Outreach-Bemühungen priorisieren kannst.',
  qualifyContactsTitle_ActiveSourcing: 'KANDIDATEN QUALIFIZIEREN',
  assessContactsTitle_ActiveSourcing: 'KANDIDATEN-BEWERTUNGSKRITERIEN',
  continueWithoutQualifying_ActiveSourcing: 'Fortfahren ohne Kandidaten zu qualifizieren',
  next_ActiveSourcing: 'Weiter',
  back_ActiveSourcing: 'Zurück',
  startQualifying_ActiveSourcing: 'Kandidaten-Qualifizierung starten',

  // LeadBooster Translations
  aiLeadAssessmentTitle_LeadBooster: 'Lead-Bewertung',
  aiLeadAssessmentSubtitle_LeadBooster: 'Überprüfe, wie deine Leads qualifiziert wurden',
  topCandidatesDescription_LeadBooster: 'Diese Leads entsprechen genau deinem idealen Kundenprofil und zeigen hohes Potenzial für Konversion.',
  strongContendersDescription_LeadBooster: 'Diese Leads erfüllen mehrere wichtige Kriterien aus deinen Anforderungen und könnten wertvolle Interessenten sein.',
  notIdealCandidates_LeadBooster: 'Weniger qualifizierte Leads',
  notIdealCandidatesDescription_LeadBooster: 'Diese Leads erfüllen weniger deiner Kriterien, könnten aber dennoch für deine Outreach-Aktivitäten interessant sein.',

  // ActiveSourcing Translations
  aiLeadAssessmentTitle_ActiveSourcing: 'Kandidatenbewertung',
  aiLeadAssessmentSubtitle_ActiveSourcing: 'Überprüfe, wie deine Kandidaten qualifiziert wurden',
  topCandidatesDescription_ActiveSourcing: 'Diese Kandidaten entsprechen genau deinen Stellenanforderungen und zeigen hohes Potenzial als qualifizierte Bewerber.',
  strongContendersDescription_ActiveSourcing: 'Diese Kandidaten erfüllen mehrere wichtige Kriterien aus deinen Anforderungen und könnten wertvolle Ergänzungen für deinen Talentpool sein.',
  notIdealCandidates_ActiveSourcing: 'Weniger qualifizierte Kandidaten',
  notIdealCandidatesDescription_ActiveSourcing: 'Diese Kandidaten erfüllen weniger deiner Kriterien, könnten aber dennoch für deine Position in Betracht gezogen werden.',

  // LeadBooster Translations
  updateAiBriefingTitle_LeadBooster: 'Aktualisiere dein Lead-Generierungs-Briefing',
  updateAiBriefingText_LeadBooster: 'Verfeinere die Informationen zu deinem Produkt oder deiner Dienstleistung, um unserer KI zu helfen, zielgerichtetere Outreach-Nachrichten zu generieren.',
  jobOfferPlaceholder_LeadBooster: 'Stellenbeschreibung...',
  productProblemsPlaceholder_LeadBooster: 'Welche Kundenprobleme löst dein Produkt?',
  productFeaturesPlaceholder_LeadBooster: 'Was sind die Hauptmerkmale deines Produkts?',
  productBenefitsPlaceholder_LeadBooster: 'Welche Vorteile bietet dein Produkt den Kunden?',
  productImpactPlaceholder_LeadBooster: 'Welchen Einfluss hat dein Produkt auf das Geschäft deiner Kunden?',
  updateFieldNote_LeadBooster: 'Aktualisiere ein beliebiges Feld, um deine Nachrichtensequenz neu zu generieren.',

  // ActiveSourcing Translations
  updateAiBriefingTitle_ActiveSourcing: 'Aktualisieren Sie Ihr Recruiting-Briefing',
  updateAiBriefingText_ActiveSourcing: 'Verfeinern Sie die Informationen zu Ihrer Stellenposition, um unserer KI zu helfen, effektivere Outreach-Nachrichten an Kandidaten zu generieren.',
  jobOfferPlaceholder_ActiveSourcing: 'Stellenbeschreibung...',
  productProblemsPlaceholder_ActiveSourcing: 'Welche Herausforderungen versucht Ihr Unternehmen mit dieser Rolle zu bewältigen?',
  productFeaturesPlaceholder_ActiveSourcing: 'Was sind die Hauptverantwortlichkeiten dieser Position?',
  productBenefitsPlaceholder_ActiveSourcing: 'Welche Vorteile bietet Ihr Unternehmen den Mitarbeitern?',
  productImpactPlaceholder_ActiveSourcing: 'Welchen Einfluss wird diese Rolle auf die Ziele Ihres Unternehmens haben?',
  updateFieldNote_ActiveSourcing: 'Aktualisieren Sie ein beliebiges Feld, um Ihre Nachrichtensequenz neu zu generieren.',
  // LeadBooster Translations
  noMessageNodes_LeadBooster: 'Keine Nachrichtenknoten verfügbar. Erstellen Sie eine Sequenz oder aktualisieren Sie Ihr Kampagnen-Briefing, um Nachrichtenknoten zu generieren.',
  usePromptGenerator_LeadBooster: 'Ihre Lead-Generierungsnachrichten',
  message_LeadBooster: 'Nachricht',

  // ActiveSourcing Translations
  noMessageNodes_ActiveSourcing: 'Keine Nachrichtenknoten verfügbar. Erstellen Sie eine Sequenz oder aktualisieren Sie Ihr Rekrutierungs-Briefing, um Nachrichtenknoten zu generieren.',
  usePromptGenerator_ActiveSourcing: 'Ihre Kandidaten-Ansprache-Nachrichten',
  message_ActiveSourcing: 'Nachricht',

  // LeadBooster Translations
  campaignContactListTitle_LeadBooster: 'Deine Lead-Quelle',
  campaignContactListExplanation_LeadBooster: 'Wähle, wie du Leads für deine Kampagne beschaffen möchtest. Du kannst unsere KI-Suche verwenden, LinkedIn-URLs einfügen oder eine vorhandene Kontaktliste hochladen.',
  chooseContactSourcingMethod_LeadBooster: 'Wie möchtest du deine Leads beschaffen?',
  paiSearch_LeadBooster: 'KI-Suche',
  ownLinkedinSearch_LeadBooster: 'LinkedIn-URL',
  uploadContactList_LeadBooster: 'Kontaktliste hochladen',

  // ActiveSourcing Translations
  campaignContactListTitle_ActiveSourcing: 'Deine Kandidatenquelle',
  campaignContactListExplanation_ActiveSourcing: 'Wähle, wie du Kandidaten für deine Kampagne beschaffen möchtest. Du kannst unsere KI-Suche verwenden, LinkedIn-URLs einfügen oder eine vorhandene Kandidatenliste hochladen.',
  chooseContactSourcingMethod_ActiveSourcing: 'Wie möchtest du deine Kandidaten beschaffen?',
  paiSearch_ActiveSourcing: 'KI-Suche',
  ownLinkedinSearch_ActiveSourcing: 'LinkedIn-URL',
  uploadContactList_ActiveSourcing: 'Kandidatenliste hochladen',

  // LeadBooster Translations
  provideKeyCharacteristicsTitle_LeadBooster: 'Gib Schlüsselmerkmale deines idealen Kunden an',
  provideKeyCharacteristicsDescription_LeadBooster: 'Hilf unserer KI zu verstehen, was einen hochwertigen Lead für dein Unternehmen ausmacht.',
  updateCriteriaInfo_LeadBooster: 'Du kannst deine Lead-Qualifizierungskriterien jederzeit aktualisieren. Unsere KI wird deine Leads basierend auf den neuen Kriterien neu bewerten.',
  contactsToAddTitle_LeadBooster: 'Welche Leads sollten Teil deiner Outreach-Kampagne sein?',
  contactsToAddDescription_LeadBooster: 'Wähle aus, welche Lead-Qualifizierungskategorien du in deine Kampagne aufnehmen möchtest.',
  reviewContactsTitle_LeadBooster: 'Bestehende Leads überprüfen',
  reviewContactsDescription_LeadBooster: 'Wähle, ob bereits qualifizierte Leads neu bewertet werden sollen.',
  redoQualification_LeadBooster: 'Bestehende Leads mit neuen Kriterien neu bewerten',
  updateQualificationCriteria_LeadBooster: 'Qualifizierungskriterien aktualisieren',

  // ActiveSourcing Translations
  provideKeyCharacteristicsTitle_ActiveSourcing: 'Gib Schlüsselmerkmale deines idealen Kandidaten an',
  provideKeyCharacteristicsDescription_ActiveSourcing: 'Hilf unserer KI zu verstehen, was einen hochwertigen Kandidaten für deine Position ausmacht.',
  updateCriteriaInfo_ActiveSourcing: 'Du kannst deine Kandidaten-Qualifizierungskriterien jederzeit aktualisieren. Unsere KI wird deine Kandidaten basierend auf den neuen Kriterien neu bewerten.',
  contactsToAddTitle_ActiveSourcing: 'Welche Kandidaten sollten Teil deiner Outreach-Kampagne sein?',
  contactsToAddDescription_ActiveSourcing: 'Wähle aus, welche Kandidaten-Qualifizierungskategorien du in deine Kampagne aufnehmen möchtest.',
  reviewContactsTitle_ActiveSourcing: 'Bestehende Kandidaten überprüfen',
  reviewContactsDescription_ActiveSourcing: 'Wähle, ob bereits qualifizierte Kandidaten neu bewertet werden sollen.',
  redoQualification_ActiveSourcing: 'Bestehende Kandidaten mit neuen Kriterien neu bewerten',
  updateQualificationCriteria_ActiveSourcing: 'Qualifizierungskriterien aktualisieren',
  // LeadBooster Translations
  // LeadBooster Translations
  talentsAddedToCampaign_LeadBooster: 'Zur Shortlist hinzugefügte Leads',
  qualificationInProgress_LeadBooster: 'Lead-Qualifizierung läuft',
  aiLeadAssessment_LeadBooster: 'KI-Lead-Bewertung',
  search_LeadBooster: 'Leads suchen...',
  contactLoadingInProgress_LeadBooster: 'Leads werden geladen...',
  contactLoadingMayTakeAMoment_LeadBooster: 'Dies kann einen Moment dauern',
  name_LeadBooster: 'Lead-Name',
  qualifiedAs_LeadBooster: 'Qualifiziert als',
  qualifiedAsTooltip_LeadBooster: 'KI-Klassifizierung von Leads basierend auf Ihren Qualifizierungskriterien',
  reason_LeadBooster: 'Qualifizierungsgrund',
  jobTitle_LeadBooster: 'Stellentitel',
  location_LeadBooster: 'Standort',
  linkedInURL_LeadBooster: 'LinkedIn-URL',
  addContact_LeadBooster: 'Lead manuell hinzufügen',
  nextBatchTooltip_LeadBooster: 'Laden Sie weitere Leads aus Ihren Suchen, um sie zu Ihrer Kampagne hinzuzufügen',
  loadMore_LeadBooster: 'Mehr laden',
  aiJudgementExplanation_LeadBooster: 'Qualifizierungserklärung',
  personalityType_LeadBooster: 'Persönlichkeitstyp',
  shortSummary_LeadBooster: 'Zusammenfassung',
  linkedInContact_LeadBooster: 'LinkedIn-Lead',
  open_LeadBooster: 'Öffnen',
  downloadData_LeadBooster: 'Leads herunterladen',
  addNewColumn_LeadBooster: 'Neue Spalte hinzufügen',

  // ActiveSourcing Translations
  talentsAddedToCampaign_ActiveSourcing: 'Zur Shortlist hinzugefügte Talente',
  qualificationInProgress_ActiveSourcing: 'Kandidatenqualifizierung läuft',
  aiLeadAssessment_ActiveSourcing: 'KI-Kandidatenbewertung',
  search_ActiveSourcing: 'Kandidaten suchen...',
  contactLoadingInProgress_ActiveSourcing: 'Kandidaten werden geladen...',
  contactLoadingMayTakeAMoment_ActiveSourcing: 'Dies kann einen Moment dauern',
  name_ActiveSourcing: 'Kandidatenname',
  qualifiedAs_ActiveSourcing: 'Qualifiziert als',
  qualifiedAsTooltip_ActiveSourcing: 'KI-Klassifizierung von Kandidaten basierend auf Ihren Qualifizierungskriterien',
  reason_ActiveSourcing: 'Qualifizierungsgrund',
  jobTitle_ActiveSourcing: 'Aktuelle Stellenbezeichnung',
  location_ActiveSourcing: 'Standort',
  linkedInURL_ActiveSourcing: 'LinkedIn-URL',
  addContact_ActiveSourcing: 'Kandidat manuell hinzufügen',
  nextBatchTooltip_ActiveSourcing: 'Laden Sie weitere Kandidaten aus Ihren Suchen, um sie zu Ihrer Kampagne hinzuzufügen',
  loadMore_ActiveSourcing: 'Mehr laden',
  aiJudgementExplanation_ActiveSourcing: 'Qualifizierungserklärung',
  personalityType_ActiveSourcing: 'Persönlichkeitstyp',
  shortSummary_ActiveSourcing: 'Zusammenfassung',
  linkedInContact_ActiveSourcing: 'LinkedIn-Kandidat',
  open_ActiveSourcing: 'Öffnen',
  downloadData_ActiveSourcing: 'Kandidaten herunterladen',
  addNewColumn_ActiveSourcing: 'Neue Spalte hinzufügen',
  // Campaign Structure
  campaignBriefingDescription_LeadBooster: 'Hier kannst du deine Vertriebskampagnenstrategie erstellen und konfigurieren.',
  campaignBriefingDescription_ActiveSourcing: 'Hier kannst du deine Recruiting-Kampagnenstrategie erstellen und konfigurieren.',
  campaignContactListDescription_LeadBooster: 'Definiere die Zielgruppe für deine Vertriebskampagne.',
  campaignContactListDescription_ActiveSourcing: 'Definiere die Zielkandidaten für deine Recruiting-Kampagne.',
  campaignSettingsDescription_LeadBooster: 'Account, Genehmigung und erneute Ansprache — Arbeitszeiten stellst du beim LinkedIn-Account ein.',
  campaignSettingsDescription_ActiveSourcing: 'Account, Genehmigung und erneute Ansprache — Arbeitszeiten stellst du beim LinkedIn-Account ein.',
  campaignOverviewDescription_LeadBooster: 'Überprüfe und starte deine Vertriebskampagne.',
  campaignOverviewDescription_ActiveSourcing: 'Überprüfe und starte deine Recruiting-Kampagne.',

  // Main Steps
  sourcePreQualifiedContacts_LeadBooster: 'Vorqualifizierte Leads beschaffen',
  sourcePreQualifiedContacts_ActiveSourcing: 'Vorqualifizierte Kandidaten beschaffen',
  manageSearches_LeadBooster: 'Lead-Suchen verwalten',
  manageSearches_ActiveSourcing: 'Kandidatensuchen verwalten',
  manageContacts_LeadBooster: 'Leads verwalten',
  manageContacts_ActiveSourcing: 'Kandidaten verwalten',

  // Contact Management Tabs
  preQualifiedContactList_LeadBooster: 'Lead-Bank',
  preQualifiedContactList_ActiveSourcing: 'Talent-Pool',
  manageDuplicateContacts_LeadBooster: 'In vorherigen Kampagnen gesucht',
  manageDuplicateContacts_ActiveSourcing: 'In vorherigen Kampagnen gesucht',
  manageBlacklists_LeadBooster: 'Blacklists verwalten',
  manageBlacklists_ActiveSourcing: 'Blacklists verwalten',
  finalCampaignList_LeadBooster: 'Endgültige Kampagnen-Shortlist',
  finalCampaignList_ActiveSourcing: 'Endgültige Kampagnen-Shortlist',

  // Setting Fields
  searchObjective_LeadBooster: 'Vertriebssuchziel',
  searchObjective_ActiveSourcing: 'Recruiting-Suchziel',
  approveMessages_LeadBooster: 'Vertriebsnachrichten genehmigen',
  approveMessages_ActiveSourcing: 'Recruiting-Nachrichten genehmigen',
  linkedinAccount_LeadBooster: 'LinkedIn-Konto für Vertrieb',
  linkedinAccount_ActiveSourcing: 'LinkedIn-Konto für Recruiting',
  timeSettings_LeadBooster: 'Zeiteinstellungen für Vertriebskontakte',
  timeSettings_ActiveSourcing: 'Zeiteinstellungen für Recruiting-Kontakte',
  dailyMessageLimits_LeadBooster: 'Tägliche Limits für Vertriebsnachrichten',
  dailyMessageLimits_ActiveSourcing: 'Tägliche Limits für Recruiting-Nachrichten',

  // Candidate/Lead Status
  topCandidate_LeadBooster: 'Top Lead',
  topCandidate_ActiveSourcing: 'Top Kandidat',
  strongContender_LeadBooster: 'Starker Lead',
  strongContender_ActiveSourcing: 'Starker Kandidat',
  backupCandidate_LeadBooster: 'Backup Lead',
  backupCandidate_ActiveSourcing: 'Backup Kandidat',

  // Drawer UI
  talentPreview_LeadBooster: 'Lead-Vorschau',
  talentPreview_ActiveSourcing: 'Talent-Vorschau',
  exportContact_LeadBooster: 'Lead exportieren',
  exportContact_ActiveSourcing: 'Kandidat exportieren',
  pushContactDataToCrm_LeadBooster: 'Lead-Daten an CRM senden',
  pushContactDataToCrm_ActiveSourcing: 'Kandidaten-Daten an CRM senden',
  pushToCRM_LeadBooster: 'Lead an CRM senden',
  pushToCRM_ActiveSourcing: 'Kandidat an CRM senden',

  // Tab Names
  assessmentOverview_LeadBooster: 'Lead-Bewertungsübersicht',
  assessmentOverview_ActiveSourcing: 'Kandidaten-Bewertungsübersicht',
  aboutContact_LeadBooster: 'Über Lead',
  aboutContact_ActiveSourcing: 'Über Kandidat',
  aboutCompany_LeadBooster: 'Über Unternehmen',
  aboutCompany_ActiveSourcing: 'Über Unternehmen',
  // German (de.ts)

  duplicates_LeadBooster: 'Bereits kontaktierte Leads',
  duplicates_ActiveSourcing: 'Bereits kontaktierte Kandidaten',

  blacklist_LeadBooster: 'Gesperrte Unternehmen',
  blacklist_ActiveSourcing: 'Gesperrte Organisationen',

  enterLinkedinUrl: 'Gib deine LinkedIn-Profil-URL ein und erfahre deinen Persönlichkeitstyp!',
  readyTo: 'Bereit für die',
  automateLinkedinOutreach_LeadBooster: 'Automatisierung deines gesamten LinkedIn Outreach',
  automateLinkedinOutreach_ActiveSourcing: 'Automatisierung deines gesamten LinkedIn Recruiting',
  aiPoweredOutreach_LeadBooster: 'mit unserem KI-gestützten LinkedIn SAIA Sales?',
  aiPoweredOutreach_ActiveSourcing: 'mit unserem KI-gestützten LinkedIn SAIA Recruiting?',
  whatToExpect: 'Was kannst du erwarten, wenn du deine Kampagne einrichtest?',
  youThePilot: 'Du – Der Pilot',
  defineWork: 'Bestimme, welche Aufgaben die KI übernehmen soll.',
  aiTheCoPilot: 'Die KI – Der Co-Pilot',
  aiDoesHeavyLifting: 'Übernimmt die schwere Arbeit, während du nur noch überprüfst und freigibst.',
  superchargeOutreach_LeadBooster: 'Bereit, dein LinkedIn Outreach auf das nächste Level zu bringen?',
  superchargeOutreach_ActiveSourcing: 'Bereit, dein LinkedIn Recruiting auf das nächste Level zu bringen?',
  aiHandlesDetails_LeadBooster: 'Lass die KI die Details übernehmen, während du dich darauf konzentrierst, Verbindungen aufzubauen!',
  aiHandlesDetails_ActiveSourcing: 'Lass die KI die Details übernehmen, während du dich darauf konzentrierst, Verbindungen aufzubauen!',
  createCampaignHere: 'Kampagne hier erstellen',
  automateOutreach_LeadBooster: 'Automatisiere dein gesamtes LinkedIn-Outreach',
  automateOutreach_ActiveSourcing: 'Automatisiere dein gesamtes LinkedIn-Recruiting',
  aiOutreachTool: 'Mit unserem KI-gestützten LinkedIn-Automatisierungstool kannst du:',
  youThePilotStrong: '<0>Du</0> – Der Pilot',
  aiTheCoPilotStrong: '<0>Die KI</0> – Der Co-Pilot',
  stage1Title_LeadBooster: '1. Leads finden',
  stage1Title_ActiveSourcing: '1. Kandidaten finden',
  stage1Primary_LeadBooster: 'Briefe die KI über deine Outreach-Kampagne ein. Wen möchtest du kontaktieren?',
  stage1Primary_ActiveSourcing: 'Briefe die KI über deine Recruiting-Kampagne ein. Wen möchtest du kontaktieren?',
  stage1Secondary_LeadBooster: 'Findet relevante LinkedIn-Profile basierend auf deinen Kriterien.',
  stage1Secondary_ActiveSourcing: 'Findet relevante LinkedIn-Profile basierend auf deinen Kriterien.',
  stage2Title_LeadBooster: '2. Leads qualifizieren',
  stage2Title_ActiveSourcing: '2. Kandidaten qualifizieren',
  stage2Primary_LeadBooster: 'Definiere deine idealen Lead-Kriterien (Must-haves, Ausschlüsse, Nice-to-haves)\nÜberprüfe und passe die Shortlist an.',
  stage2Primary_ActiveSourcing: 'Definiere deine idealen Kandidaten-Kriterien (Must-haves, Ausschlüsse, Nice-to-haves)\nÜberprüfe und passe die Shortlist an.',
  stage2Secondary_LeadBooster: 'Bewertet Leads vorab und liefert eine Begründung für jede Entscheidung.',
  stage2Secondary_ActiveSourcing: 'Bewertet Kandidaten vorab und liefert eine Begründung für jede Entscheidung.',
  stage3Title_LeadBooster: '3. Outreach-Nachrichten erstellen',
  stage3Title_ActiveSourcing: '3. Kandidaten-Nachrichten erstellen',
  stage3Primary_LeadBooster: 'Wähle eine Kampagnenvorlage und definiere deinen Nachrichtenstil.',
  stage3Primary_ActiveSourcing: 'Wähle eine Kampagnenvorlage und definiere deinen Nachrichtenstil.',
  stage3Secondary_LeadBooster: 'Generiert maßgeschneiderte Nachrichten für jede Phase der Kampagne.',
  stage3Secondary_ActiveSourcing: 'Generiert maßgeschneiderte Nachrichten für jede Phase der Kampagne.',
  stage4Title_LeadBooster: '4. 100% personalisierte Nachrichten, 100% automatisiert',
  stage4Title_ActiveSourcing: '4. 100% personalisierte Nachrichten, 100% automatisiert',
  stage4Primary_LeadBooster: 'Du → Entspann dich, überprüfe und lass die KI die Arbeit erledigen! 😉',
  stage4Primary_ActiveSourcing: 'Du → Entspann dich, überprüfe und lass die KI die Arbeit erledigen! 😉',
  stage4Secondary_LeadBooster: 'Analysiert das LinkedIn-Profil jedes Leads und erstellt hochgradig personalisierte Nachrichten.',
  stage4Secondary_ActiveSourcing: 'Analysiert das LinkedIn-Profil jedes Kandidaten und erstellt hochgradig personalisierte Nachrichten.',
  tutorialCreateAccount: 'Account erstellen',
  tutorialSynchronizeAccount: 'Account synchronisieren',
  tutorialCreateCampaign: 'Kampagne erstellen',
  tutorialCampaignBriefing: 'Kampagnenbriefing',
  tutorialCampaignContactList: 'Kampagnenkontaktliste',
  tutorialSourceContacts: 'Kontakte finden',
  tutorialSourceContacts_1_ActiveSourcing: 'Kontakte finden - KI-Suche (Suche starten)',
  tutorialSourceContacts_2_ActiveSourcing: 'Kontakte finden - KI-Suche (Ergebnisse bearbeiten)',
  tutorialSourceContacts_1_LeadBooster: 'Kontakte finden - KI-Suche',
  tutorialSourceContacts_2_LeadBooster: 'Kontakte finden - LinkedIn URL',
  tutorialSourceContacts_3: 'Kontakte finden - Kontakte hochladen',
  tutorialQualifyContacts: 'Kontakte qualifizieren',
  tutorialQualificationResults: 'Qualifikationsergebnisse',
  tutorialCampaignFlow: 'Kampagnen Flow',
  tutorialBuildFlow: 'Flow erstellen',
  tutorialMessageGenerationPrompt: 'Nachrichtenerstellungs-Prompt',
  tutorialCampaignTesting: 'Kampagnen testen',
  tutorialCampaignSettings: 'Kampagneneinstellungen',
  tutorialCampaignSummary: 'Kampagne starten',
  tutorialCampaignOverview: 'Kampagnenübersicht',
  tutorialCampaignStatistics: 'Kampagnenstatistiken',
  tutorialCampaignInbox: 'Kampagnen-Inbox',
  masterTheProductGroup: 'Meistere den {{productGroup}}',
  byGoingThroughOurOnboarding: 'indem du durch unser Onboarding gehst',
  manageTrackCampaign: 'Verwalte und verfolge den Betrieb und die Leistung deiner Kampagne',
  tutorialCampaignBriefingTitle: 'Kampagnenbriefing',
  tutorialCampaignBriefingDescription_LeadBooster: 'In diesem Schritt gibst du der KI die wichtigsten Details, um deine Vertriebskampagne effektiv durchzuführen. Du kannst deine Produktinformationen als Referenz verwenden.',
  tutorialCampaignBriefingDescription_ActiveSourcing: 'In diesem Schritt gibst du der KI die wichtigsten Details, um deine Recruiting-Kampagne effektiv durchzuführen. Du kannst deine Stellenanzeige als Referenz verwenden.',
  tutorialCampaignContactListTitle: 'Kampagnenkontaktliste - KI-Suche',
  tutorialCampaignContactListDescription_LeadBooster: 'In diesem Schritt stellst du der KI eine Auswahl an Leads bereit, die in einer späteren Phase qualifiziert und in deine Kampagnen-Shortlist aufgenommen werden. Hinweis: In diesem Schritt suchst du nur Leads für die KI, aber qualifizierst sie noch nicht.',
  tutorialCampaignContactListDescription_ActiveSourcing: 'In diesem Schritt stellst du der KI eine Auswahl an Kandidaten bereit, die in einer späteren Phase qualifiziert und in deine Kampagnen-Shortlist aufgenommen werden. Hinweis: In diesem Schritt suchst du nur Kandidaten für die KI, aber qualifizierst sie noch nicht.',
  tutorialCampaignContactListSearchTitle_LeadBooster: 'Kampagnenkontaktliste - LinkedIn URL',
  tutorialCampaignContactListSearchTitle_ActiveSourcing: 'Kampagnenkontaktliste - KI-Suche',
  tutorialCampaignContactListSearchDescription_LeadBooster: 'In diesem Schritt kannst du eine eigene LinkedIn Suche durchführen und in unserem System ausführen.',
  tutorialCampaignContactListSearchDescription_ActiveSourcing: 'In diesem Schritt führen wir eine LinkedIn-Suche basierend auf dem Briefing durch, das du zuvor bereitgestellt hast. Diese Suche dient als erste Auswahl an Kandidaten für unseren KI-Co-Piloten zur Überprüfung.',
  tutorialCampaignContactListSearchHighlight_LeadBooster: 'Keine Sorge, wenn die Liste nicht perfekt passt – dies ist nur die erste Stufe des Funnels. In den nächsten Schritten wird die KI die Leads analysieren und eine verfeinerte Shortlist erstellen.',
  tutorialCampaignContactListSearchHighlight_ActiveSourcing: 'Keine Sorge, wenn die Liste nicht perfekt passt – dies ist nur die erste Stufe des Funnels. In den nächsten Schritten wird die KI die Kandidaten analysieren und eine verfeinerte Shortlist erstellen.',
  tutorialQualifyingContactsVisualizingTitle_LeadBooster: 'Leads qualifizieren - Ergebnisse visualisieren',
  tutorialQualifyingContactsVisualizingTitle_ActiveSourcing: 'Kandidaten qualifizieren - Ergebnisse visualisieren',
  tutorialQualifyingContactsVisualizingDescription_LeadBooster: 'Überprüfe die Qualifikationsergebnisse, indem du Leads individuell oder mit KI-Unterstützung bewertest. Falls die Ergebnisse nicht den Erwartungen entsprechen, passe die Kriterien an und wiederhole den Prozess, bis du das gewünschte Ergebnis erzielst.',
  tutorialQualifyingContactsVisualizingDescription_ActiveSourcing: 'Überprüfe die Qualifikationsergebnisse, indem du Kandidaten individuell oder mit KI-Unterstützung bewertest. Falls die Ergebnisse nicht den Erwartungen entsprechen, passe die Kriterien an und wiederhole den Prozess, bis du das gewünschte Ergebnis erzielst.',
  tutorialCampaignFlowTitle: 'Kampagnenflow - Erstelle den Kommunikationsfunnel',
  tutorialCampaignFlowDescription_LeadBooster: 'In diesem Schritt gestaltest du den Flow deiner Outreach-Kampagne – die strukturierte Abfolge von Aktionen, die deine Interaktionen mit Leads steuert. Der Fokus liegt dabei ausschließlich auf der Erstellung des Prozessflusses, der Definition von Schritten und Auslösern, jedoch noch nicht auf der Formulierung spezifischer Nachrichten für die einzelnen Schritte.',
  tutorialCampaignFlowDescription_ActiveSourcing: 'In diesem Schritt gestaltest du den Flow deiner Recruiting-Kampagne – die strukturierte Abfolge von Aktionen, die deine Interaktionen mit Kandidaten steuert. Der Fokus liegt dabei ausschließlich auf der Erstellung des Prozessflusses, der Definition von Schritten und Auslösern, jedoch noch nicht auf der Formulierung spezifischer Nachrichten für die einzelnen Schritte.',
  tutorialMessageGenerationTitle: 'Kampagnenflow - Gib der KI Anweisungen zur Nachrichtenerstellung',
  tutorialMessageGenerationDescription: 'Dieser Schritt hilft der KI dabei, Nachrichten zu erstellen, indem er die Prompts verfeinert. Diese Prompts legen Tonalität, Stil und wesentliche Details für jede Phase deiner Kampagne fest. Ein Prompt ist eine Anweisung oder Richtlinie für die KI, um den Inhalt gezielt zu gestalten. In diesem Fall definieren die Prompts den Ton, den Stil und die zentralen Details jeder Nachricht in deiner Kampagne.',
  tutorialTestCampaignTitle: 'Kampagne testen',
  tutorialTestCampaignDescription: 'In diesem Abschnitt kannst du testen, wie die KI Nachrichten generiert und anpasst, indem du ihre Erstellung für verschiedene Kontakte simulierst. Überprüfe die Ergebnisse, um sicherzustellen, dass sie deinen Erwartungen entsprechen, und passe die Nachrichtenprompts bei Bedarf an.',
  tutorialCampaignSettingsTitle: 'Kampagneneinstellungen',
  tutorialCampaignSettingsDescription: 'Der Bereich Kampagneneinstellungen dient der Definition der operationellen Einstellungen der Kampagne. Dazu gehören die Zeiten sowie die Anzahl der pro Tag gesendeten Nachrichten und Anfragen.',
  tutorialCampaignOverviewStartTitle: 'Kampagnenübersicht & Start',
  tutorialCampaignOverviewStartDescription: 'Dieser Abschnitt bietet eine Übersicht über die gesamte Kampagneneinrichtung – über alle Schritte hinweg. Überprüfe vor dem Start alle Elemente, um sicherzustellen, dass alles in Ordnung ist. Falls erforderlich, nehme die notwendigen Anpassungen vor.',
  tutorialCreateCampaignTitle: 'Kampagne erstellen',
  tutorialCreateCampaignDescription: 'In diesem Schritt erstellst du ein neues Kampagnenprojekt. Achte darauf, deiner Kampagne einen klaren, aussagekräftigen Namen zu geben und das passende Konto zur Verwaltung auszuwählen.',
  tutorialShowQualificationResultsTitle: 'Qualifikationsergebnisse anzeigen',
  tutorialShowQualificationResultsDescription_LeadBooster: 'In diesem Schritt überprüfst und interpretierst du die Qualifikationsergebnisse der Kontakte. Das Tool lädt und bewertet Leads aus deiner Datenbank schrittweise basierend auf deinen Kriterien. Das Ziel ist es, eine Shortlist zu erstellen – entweder automatisch mit KI oder durch manuelles Anpassen der Kriterien.',
  tutorialShowQualificationResultsDescription_ActiveSourcing: 'In diesem Schritt überprüfst und interpretierst du die Qualifikationsergebnisse der Kontakte. Das Tool lädt und bewertet Kandidaten aus deiner Datenbank schrittweise basierend auf deinen Kriterien. Das Ziel ist es, eine Shortlist zu erstellen – entweder automatisch mit KI oder durch manuelles Anpassen der Kriterien.',
  tutorialCampaignOverviewTitle: 'Kampagnenübersicht',
  tutorialCampaignOverviewDescription: 'Diese Ansicht bietet eine Übersicht über alle Kampagnen, die du und dein Team durchführen. Du kannst den Betriebsstatus und Fortschritt jeder Kampagne leicht nachverfolgen – vom Sourcing und der Qualifizierung von Kontakten bis hin zur Überwachung abgeschlossener Aufgaben, gesendeter Nachrichten und erhaltener positiver Antworten.',
  tutorialCampaignStatisticsTitle: 'Kampagnenstatistiken',
  tutorialCampaignStatisticsDescription_LeadBooster: 'Geschwindigkeit ist wichtig, aber ebenso die Effektivität. In dieser Ansicht kannst du die wichtigsten Leistungskennzahlen in jeder Phase deines Kampagnen-Funnels verfolgen. Vergleiche Daten innerhalb und zwischen Kampagnen und erhalte Einblicke, welche Lead-Profile positiv reagieren – und warum.',
  tutorialCampaignStatisticsDescription_ActiveSourcing: 'Geschwindigkeit ist wichtig, aber ebenso die Effektivität. In dieser Ansicht kannst du die wichtigsten Leistungskennzahlen in jeder Phase deines Kampagnen-Funnels verfolgen. Vergleiche Daten innerhalb und zwischen Kampagnen und erhalte Einblicke, welche Kandidaten-Profile positiv reagieren – und warum.',
  tutorialCampaignInboxTitle: 'Inbox',
  tutorialCampaignInboxDescription: 'Verfolge ausgehende Nachrichten und plane automatische Antworten, sobald dein Co-Pilot aktiv ist. Denke daran, dass dies kein Live-Chat ist – Nachrichten werden nur während der Arbeitszeiten der Kampagne gesendet. Du kannst außerdem die Postfächer anderer Teammitglieder oder Kunden verwalten.',
  frequentlyAskedQuestions: 'Häufig gestellte Fragen',
  synchronizingYourAccount: 'LinkedIn Konto synchronisieren',
  sourcingContacts: 'Kontakte beschaffen',
  qualifyingContacts: 'Kontakte qualifizieren',
  blacklistingContacts: 'Kontakte auf die schwarze Liste setzen',
  campaignOverviewPerformance: 'Kampagnenübersicht & Leistung',
  whichAccountToSync: 'Welches Konto soll ich synchronisieren?',
  syncAccountDescription: 'Du musst das Konto synchronisieren, das für deine Kampagne mit LinkedIn verwendet wird. Das bedeutet, dass du die E-Mail-Adresse und das Passwort eingeben musst, die mit deinem LinkedIn-Profil verknüpft sind – dem Konto, von dem aus du Personen auf LinkedIn kontaktieren wirst.',
  forgotLinkedInPassword: 'Was, wenn ich mein LinkedIn-Passwort nicht mehr weiß?',
  forgotPasswordDescription: 'Falls du dein LinkedIn-Passwort vergessen hast, kannst du es mit diesen Schritten wiederherstellen:',
  stepOpenBrowser: 'Öffne deinen Browser und klicke auf das Dreipunkt-Menü oben rechts.',
  stepSelectSettings: 'Wähle „Einstellungen“ aus.',
  stepNavigateToPasswords: 'Navigiere zu „Autofill und Passwörter“ > „Passwort-Manager“.',
  stepSearchLinkedIn: 'Suche im Passwort-Manager nach „LinkedIn“.',
  stepCopyPassword: 'Wenn du es gefunden hast, klicke darauf und kopiere das gespeicherte Passwort.',
  stepPastePassword: 'Füge das Passwort in unser Dashboard ein.',
  whyAccountNotSyncing: 'Warum wird mein Konto nicht synchronisiert?',
  accountNotSyncingReasons: 'Falls dein Konto nicht synchronisiert wird, könnte es an einem der folgenden Gründe liegen:',
  reasonTemporaryBlock: 'Temporäre Sperre durch LinkedIn (Fair Use Pause): LinkedIn kann dein Konto vorübergehend sperren, wenn es automatisiertes Verhalten erkennt. Dies ist eine Sicherheitsmaßnahme zur Missbrauchsverhinderung.',
  reasonSimultaneousLogins: 'Gleichzeitige Anmeldungen: Wenn du dein LinkedIn-Konto während der aktiven Stunden der Kampagne nutzt (wie im Kampagnen-Setup festgelegt), kann LinkedIn mehrere Anmeldungen erkennen und dein Konto desynchronisieren.',
  whatIsBriefingFor: 'Wofür ist ein Briefing?',
  briefingDescription: 'Ein Briefing ist ein strukturiertes Dokument, das die wichtigsten Ziele, die Zielgruppe, die Messaging-Strategie und den Umsetzungsplan für eine bestimmte Initiative definiert. Wenn du eine KI für eine LinkedIn-Outreach-Kampagne im Social Selling oder Active Sourcing einsetzt, sollte das Briefing Details wie ideale Kandidaten- oder Kundenprofile, Messaging-Frameworks, Engagement-Taktiken, Follow-up-Sequenzen und Erfolgskriterien enthalten. Die KI nutzt diese Daten dann, um die Ansprache zu automatisieren, Antworten zu verfolgen und die Interaktion anhand von Echtzeit-Analysen zu optimieren.',
  missingBriefingInfo: 'Was, wenn ich nicht alle Informationen für das Briefing habe?',
  missingBriefingDescription: 'Falls du kein vollständiges Briefing oder nicht alle erforderlichen Details hast, kannst du trotzdem weitermachen, indem du vorhandene Ressourcen nutzt.',
  forRecruiting: 'Für Recruiting:',
  recruitingInstructions: 'Kopiere und füge deine Stellenbeschreibung ein oder gib die URL zur Stellenanzeige an.',
  forSocialSelling: 'Für Social Selling:',
  socialSellingInstructions: 'Gib die URL der Landingpage an, auf der das Produkt oder die Dienstleistung vorgestellt wird.',
  aiExtractsInformation: 'Dadurch kann die KI relevante Informationen extrahieren und automatisch effektive Nachrichten für die Ansprache generieren.',
  howAreContactsGenerated: 'Wie werden die Kontakte generiert?',
  contactsGeneratedDescription: 'Sie werden von LinkedIn bezogen, und wir können auch nach Telefonnummern und E-Mail-Adressen suchen.',
  whatIsSourcingContacts: 'Was bedeutet Kontakte beschaffen und wie funktioniert es?',
  sourcingContactsDescription_LeadBooster: 'Kontakte beschaffen bedeutet, unserem KI-Agenten eine Auswahl an Leads bereitzustellen, die er später qualifizieren und kontaktieren wird. Du hast drei Möglichkeiten:',
  sourcingContactsDescription_ActiveSourcing: 'Kontakte beschaffen bedeutet, unserem KI-Agenten eine Auswahl an Kandidaten bereitzustellen, die er später qualifizieren und kontaktieren wird. Du hast drei Möglichkeiten:',
  uploadExistingFile_LeadBooster: 'Eine vorhandene Datei mit Leads hochladen.',
  uploadExistingFile_ActiveSourcing: 'Eine vorhandene Datei mit Kandidaten hochladen.',
  aiSearchForLeads_LeadBooster: 'Die KI nach Leads suchen lassen.',
  aiSearchForLeads_ActiveSourcing: 'Die KI nach Kandidaten suchen lassen.',
  manualLinkedInSearch: 'Manuell auf LinkedIn suchen und nach passenden Ergebnissen die Such-URL in unser Dashboard einfügen.',
  supportedLinkedInSearches: 'Welche LinkedIn-Suchtypen werden von unserer KI unterstützt?',
  aiSupportsTwoSearches: 'Unser KI-Agent unterstützt zwei Arten von Suchen:',
  coldOutreachAlt: 'Kaltakquise:',
  coldOutreachDescription: 'Findet Personen, mit denen du noch keinen Kontakt hattest oder die du noch nicht vernetzt hast.',
  inMarketOutreachAlt: 'In-Market Outreach:',
  inMarketOutreachDescription_LeadBooster: 'Identifiziert Leads anhand von LinkedIn-Aktivitäten (Events, Beiträge, Gruppen etc.), sodass du gezielt mit relevanten Inhalten interagieren kannst.',
  inMarketOutreachDescription_ActiveSourcing: 'Identifiziert Kandidaten anhand von LinkedIn-Aktivitäten (Events, Beiträge, Gruppen etc.), sodass du gezielt mit relevanten Inhalten interagieren kannst.',
  requiredContactListInfo: 'Welche Informationen sind erforderlich, wenn ich eine Kontaktliste hochlade?',
  contactListDescription_LeadBooster: 'Das einzige erforderliche Feld ist die LinkedIn-Profil-URL jedes Leads, den du zu deiner Kampagne hinzufügen möchtest. Weitere Details können ergänzt werden, aber die LinkedIn-URL ist essenziell, damit die KI die Kontakte verarbeiten und mit ihnen interagieren kann.',
  contactListDescription_ActiveSourcing: 'Das einzige erforderliche Feld ist die LinkedIn-Profil-URL jedes Kandidaten, den du zu deiner Kampagne hinzufügen möchtest. Weitere Details können ergänzt werden, aber die LinkedIn-URL ist essenziell, damit die KI die Kandidaten verarbeiten und mit ihnen interagieren kann.',
  howToBestQualifyContacts: 'Wie qualifizierst du Kontakte am besten?',
  qualifyContactsDescription: 'Dieser Abschnitt behandelt die Auswahl der Kontakte, die du in deine Kampagne aufnehmen oder ausschließen möchtest. Du hast zwei Optionen:',
  aiDrivenQualificationTitle: 'KI-gestützte Qualifizierung:',
  aiDrivenQualificationDescription_LeadBooster: 'Der KI-Agent nutzt die Briefing-Informationen, um Kontakte zu bewerten und zu qualifizieren. Um die Genauigkeit zu verbessern, klicke auf "KI-Lead-Bewertung" und gib an, welche Kontakte aufgenommen oder ausgeschlossen werden sollen. Je detaillierter dein Briefing, desto besser ist die Auswahl der KI.',
  aiDrivenQualificationDescription_ActiveSourcing: 'Der KI-Agent nutzt die Briefing-Informationen, um Kandidaten zu bewerten und zu qualifizieren. Um die Genauigkeit zu verbessern, klicke auf "KI-Kandidaten-Bewertung" und gib an, welche Kandidaten aufgenommen oder ausgeschlossen werden sollen. Je detaillierter dein Briefing, desto besser ist die Auswahl der KI.',
  manualQualificationTitle: 'Manuelle Qualifizierung:',
  manualQualificationDescription_LeadBooster: 'Du kannst Kontakte für deine Kampagne persönlich überprüfen und auswählen. Klicke auf jeden Lead, um die Details zu prüfen und die Bewertung der KI zu überprüfen, bevor du sie zu deiner Liste hinzufügst.',
  manualQualificationDescription_ActiveSourcing: 'Du kannst Kandidaten für deine Kampagne persönlich überprüfen und auswählen. Klicke auf jeden Kandidaten, um die Details zu prüfen und die Bewertung der KI zu überprüfen, bevor du sie zu deiner Liste hinzufügst.',
  fewerContactsPreQualificationTitle: 'Warum habe ich in meiner Vorqualifikationsliste weniger Kontakte als insgesamt beschafft?',
  fewerContactsPreQualificationDescription_LeadBooster: 'Der KI-Agent überprüft Leads schrittweise über die Zeit, anstatt sie alle auf einmal zu verarbeiten. Jeder Lead wird basierend auf seiner Relevanz als A, B, C oder Nicht qualifiziert eingestuft. Dieser gestaffelte Ansatz ermöglicht es dir, die Genauigkeit der KI zu überprüfen, bevor du die Kampagne startest.',
  fewerContactsPreQualificationDescription_ActiveSourcing: 'Der KI-Agent überprüft Kandidaten schrittweise über die Zeit, anstatt sie alle auf einmal zu verarbeiten. Jeder Kandidat wird basierend auf seiner Relevanz als A, B, C oder Nicht qualifiziert eingestuft. Dieser gestaffelte Ansatz ermöglicht es dir, die Genauigkeit der KI zu überprüfen, bevor du die Kampagne startest.',
  dynamicLeadAssessment_LeadBooster: 'Das System bewertet Leads weiterhin dynamisch – deine Kampagne startet mit bereits qualifizierten Kontakten, und die KI verfeinert ihre Auswahl basierend auf deinem Feedback, wodurch deine endgültige Kampagnenliste schrittweise erweitert wird.',
  dynamicLeadAssessment_ActiveSourcing: 'Das System bewertet Kandidaten weiterhin dynamisch – deine Kampagne startet mit bereits qualifizierten Kandidaten, und die KI verfeinert ihre Auswahl basierend auf deinem Feedback, wodurch deine endgültige Kampagnenliste schrittweise erweitert wird.',
  whoCanIBlacklist: 'Wen kann ich auf die schwarze Liste setzen?',
  whoCanIBlacklistDescription: 'Du kannst sowohl einzelne Kontakte als auch Unternehmen auf die schwarze Liste setzen. Dies kann durch das Hochladen einer Datei oder das manuelle Eingeben von LinkedIn-URLs der Kontakte oder Unternehmen erfolgen, die du ausschließen möchtest.',
  blacklistUploadInfoTitle: 'Welche Informationen werden für das Hochladen einer schwarzen Liste benötigt?',
  blacklistUploadInfoDescription: 'Das einzige erforderliche Feld ist die LinkedIn-Profil-URL jeder Person oder der Unternehmensname, den du auf die schwarze Liste setzen möchtest. Du kannst zusätzliche Details angeben, aber die LinkedIn-URL ist entscheidend, damit die KI diese Kontakte korrekt verarbeitet und von deiner Ansprache ausschließt.',
  startBuildingCampaignFlow: 'Wie starte ich den Aufbau meines Outreach-Kampagnenflows?',
  startBuildingCampaignFlowDescription: 'Du kannst entweder von Grund auf neu beginnen oder eine vorgefertigte Vorlage verwenden. Wenn du von Grund auf neu startest, musst du Aktionen hinzufügen (z. B. LinkedIn-Kontaktanfragen, Nachrichten), Wartezeiten festlegen und Bedingungen für verschiedene Antworten definieren.',
  typesOfActionsInCampaign: 'Welche Arten von Aktionen kann ich in meinen Kampagnenflow einfügen?',
  typesOfActionsInCampaignDescription: 'Du kannst folgende Aktionen hinzufügen:',
  actionLinkedInRequest: 'LinkedIn-Kontaktanfragen (mit oder ohne Nachricht)',
  actionDirectMessages: 'Direktnachrichten (individuell oder KI-generiert)',
  actionInMails: 'InMails (für Premium-Nutzer)',
  actionEmailFollowUps: 'E-Mail-Nachfassaktionen (falls integriert)',
  actionEngagementActions: 'Engagement-Aktionen (z. B. Liken oder Kommentieren eines Beitrags)',
  setupWaitingTimes: 'Wie richte ich Wartezeiten zwischen Aktionen ein?',
  setupWaitingTimesDescription: 'Du kannst Verzögerungen zwischen den Schritten festlegen, z. B. zwei Tage nach einer Kontaktanfrage warten, bevor eine Follow-up-Nachricht gesendet wird. Dies hilft, einen natürlichen Interaktionsfluss zu bewahren.',
  whatAreConditionals: 'Was sind Bedingungen und wie funktionieren sie?',
  whatAreConditionalsDescription: 'Bedingungen ermöglichen es dir, unterschiedliche Wege im Kampagnenflow basierend auf Benutzerinteraktionen zu erstellen. Zum Beispiel:',
  conditionalAcceptConnection: 'Wenn der Kontakt eine Kontaktanfrage annimmt → Nachricht A senden',
  conditionalNoResponse: 'Falls nach 3 Tagen keine Antwort erfolgt → Nachricht B senden',
  conditionalPositiveReply: 'Falls die Antwort positiv ist → Zur manuellen Überprüfung oder zum nächsten Schritt weiterleiten',
  customizeAIMessages: 'Kann ich die KI-generierten Nachrichten anpassen?',
  customizeAIMessagesDescription: 'Ja! Das solltest du sogar. Unser KI-Agent erstellt Nachrichten basierend auf deinem Prompt und weiteren Einstellungen. Du kannst die Struktur, den Ton (z. B. formell, locker) und die wichtigsten Punkte festlegen.',
  handlingNoResponseRequests: 'Wie sollte ich Kontaktanfragen handhaben, wenn keine Antwort kommt?',
  handlingNoResponseRequestsDescription: 'Du kannst die Wartezeit festlegen, bevor eine Follow-up-Nachricht gesendet wird. So arbeitest du strukturiert und stellst sicher, dass niemand vergessen wird.',
  automaticResponsesNegativeReplies: 'Kann ich automatische Antworten für negative Rückmeldungen in der Kampagne einrichten?',
  automaticResponsesNegativeRepliesDescription: 'Ja, wir können automatische Antworten in den Kampagnenflow integrieren.',
  setupCampaignCorrectly: 'Wie richte ich meine Kampagne richtig ein?',
  setupCampaignCorrectlyDescription: 'Der wichtigste Aspekt beim Einrichten deiner Kampagne ist das Festlegen des Betriebszeitfensters. Dein KI-Agent kann die Kampagne nur ausführen, während du offline auf LinkedIn bist. Falls du dich während der aktiven Kampagnenzeiten in LinkedIn einloggst, wird die Kampagne automatisch pausiert, um dein Konto vor einer Sperrung zu schützen.',
  campaignTimesNoMessages: 'Wir haben Kampagnenzeiten festgelegt, aber das System hat nicht sofort Nachrichten gesendet. Warum?',
  campaignTimesNoMessagesReason: 'Das passiert normalerweise, wenn du die Option "Nachrichten genehmigen" aktiviert hast.',
  campaignTimesNoMessagesDescription: 'Wenn dein KI-Agent innerhalb der definierten Kampagnenzeiten arbeitet, erstellt er zunächst personalisierte Nachrichten basierend auf dem Profil jedes Kontakts. Diese Nachrichten werden jedoch nicht automatisch gesendet – du musst sie überprüfen und genehmigen. Falls du die Nachrichten nicht aktiv freigibst, bleibt deine Kampagne inaktiv.',
  dailyMessageLimit: 'Wie viele Kontakte kann ich pro Tag anschreiben?',
  dailyMessageLimitDescription: 'Du kannst theoretisch bis zu 100 Kontakte pro Tag anschreiben, aber das hängt von den Richtlinien von LinkedIn ab. Achte auf die LinkedIn-Grenzwerte, um Einschränkungen zu vermeiden. Falls du mehrere Kampagnen gleichzeitig laufen hast, wird das tägliche Nachrichtenlimit auf alle aktiven Kampagnen aufgeteilt.',
  exportCampaignResults: 'Kann ich die Ergebnisse meiner Kampagnen exportieren?',
  exportCampaignResultsDescription: 'Ja, du kannst die endgültige Kampagnenliste exportieren und die Kontakte mit zusätzlichen Informationen anreichern.',
  viewCampaignPerformance: 'Wie sehe ich die Leistung meiner Kampagnen?',
  viewCampaignPerformanceDescription: 'Du kannst die Leistung deiner Kampagnen anzeigen, indem du zum Tab "Kampagnen" im Dashboard gehst oder für mehr Details zum Tab "Statistiken".',
  videoTutorials: 'Video-Anleitungen',
  // Translation keys for Source Contacts Upload option
  tutorialCampaignContactListUploadTitle: 'Kampagne Kontaktliste - Kontakte hochladen',
  tutorialCampaignContactListUploadDescription_LeadBooster: 'Du kannst deine eigene Liste von Leads hochladen. Dies ist nützlich, wenn du bereits eine Liste von Kontakten hast, die du qualifizieren und mit deiner Kampagne engagieren möchtest.',
  tutorialCampaignContactListUploadDescription_ActiveSourcing: 'Du kannst deine eigene Liste von Kandidaten hochladen. Dies ist nützlich, wenn du bereits eine Liste von Kontakten hast, die du qualifizieren und mit deiner Kampagne engagieren möchtest.',
  tutorialCampaignContactListUploadDescription_SalesBooster: 'Du kannst deine eigene Liste von Kontakten hochladen. Dies ist nützlich, wenn du bereits eine Liste von Leads hast, die du qualifizieren und mit deiner Social Selling-Kampagne engagieren möchtest.',

  selectLinkedInAccountForSourcing_LeadBooster: 'LinkedIn-Konto für Lead-Sourcing auswählen',
  useDifferentLinkedInAccountsForSourcing_LeadBooster: 'Du kannst verschiedene LinkedIn-Konten für Lead-Sourcing verwenden',
  none_LeadBooster: 'Keines',
  whichLinkedInProductForSourcing_LeadBooster: 'Welches LinkedIn-Produkt möchtest du für Lead-Sourcing verwenden?',
  selectLanguagesForSearch_LeadBooster: 'Sprachen für deine Suche auswählen',
  chooseLanguagesForSearch_LeadBooster: 'Wähle die Sprachen aus, die du für deine Lead-Suche verwenden möchtest',
  noteSelectMultipleLanguages_LeadBooster: 'Hinweis: Du kannst mehrere Sprachen auswählen. Du musst mindestens eine Sprache auswählen.',
  includeOwnContacts_LeadBooster: 'Eigene Kontakte einschließen',
  includeOwnContactsLabel_LeadBooster: 'Auch 1. Grad (alle Kontakte)',
  includeOwnContactsDescription_LeadBooster: 'Standard sind nur 2. und 3. Grad. Wenn du das aktivierst, fällt dieser Filter weg — die Suche nimmt alle Kontakte mit.',
  aiBriefingLanguage_LeadBooster: 'AI-Briefing-Sprache',
  english_LeadBooster: 'Englisch',
  typeInYourSearchLocation_LeadBooster: 'Suchort eingeben',
  selectLocationForContactSearch_LeadBooster: 'Suchort auswählen',
  addLinkedinSearchesToLeadBank_LeadBooster: 'LinkedIn-Suchen zu deiner Lead-Bank hinzufügen',
  reviewSearchSamplesForLeads_LeadBooster: 'Suchbeispiele durchsuchen, um qualifizierte Leads für deine Kampagne zu finden',
  weAreAlmostThere_LeadBooster: 'Wir sind fast fertig!',
  linkedinSearchReady_LeadBooster: 'Deine LinkedIn-Suche ist bereit, qualifizierte Leads zu finden',
  startTalentSearch_LeadBooster: 'Starte Lead-Suche',

  selectLinkedInAccountForSourcing_ActiveSourcing: 'LinkedIn-Konto für Kandidaten-Sourcing auswählen',
  useDifferentLinkedInAccountsForSourcing_ActiveSourcing: 'Du kannst verschiedene LinkedIn-Konten für Kandidaten-Sourcing verwenden',
  none_ActiveSourcing: 'Keines',
  whichLinkedInProductForSourcing_ActiveSourcing: 'Welches LinkedIn-Produkt möchtest du für Kandidaten-Sourcing verwenden?',
  selectLanguagesForSearch_ActiveSourcing: 'Sprachen für deine Suche auswählen',
  chooseLanguagesForSearch_ActiveSourcing: 'Wähle die Sprachen aus, die du für deine Kandidaten-Suche verwenden möchtest',
  noteSelectMultipleLanguages_ActiveSourcing: 'Hinweis: Du kannst mehrere Sprachen auswählen. Du musst mindestens eine Sprache auswählen.',
  includeOwnContacts_ActiveSourcing: 'Eigene Kontakte einschließen',
  includeOwnContactsLabel_ActiveSourcing: 'Auch 1. Grad (alle Kontakte)',
  includeOwnContactsDescription_ActiveSourcing: 'Standard sind nur 2. und 3. Grad. Wenn du das aktivierst, fällt dieser Filter weg — die Suche nimmt alle Kontakte mit.',
  aiBriefingLanguage_ActiveSourcing: 'AI-Briefing-Sprache',
  english_ActiveSourcing: 'Englisch',
  typeInYourSearchLocation_ActiveSourcing: 'Suchort eingeben',
  selectLocationForContactSearch_ActiveSourcing: 'Suchort auswählen',
  addLinkedinSearchesToLeadBank_ActiveSourcing: 'LinkedIn-Suchen zu deiner Talent-Pool hinzufügen',
  reviewSearchSamplesForLeads_ActiveSourcing: 'Suchbeispiele durchsuchen, um qualifizierte Kandidaten für deine Kampagne zu finden',
  weAreAlmostThere_ActiveSourcing: 'Wir sind fast fertig!',
  linkedinSearchReady_ActiveSourcing: 'Deine LinkedIn-Suche ist bereit, qualifizierte Kandidaten zu finden',
  startTalentSearch_ActiveSourcing: 'Starte Talent-Suche',
  inMailsNotAllowed: 'Der mit der Kampagne verknüpfte LinkedIn-Account unterstützt keine Inmails. (Entferne den Inmail Knoten oder passe den LinkedIn-Account an)',
  emailsNotAllowed: 'Der mit der Kampagne verknüpfte LinkedIn-Account enthält kein hinterlegtes E-Mail-Konto. (Entferne den E-Mail Knoten oder passe den LinkedIn-Account an)',
  uncertainSexContacts: 'Kontakte mit unklarem Geschlecht',
  uncertainSexContactsDescription: 'Wir konnten das Geschlecht nicht sicher identifizieren.',
  noUncertainSexContactsFound: 'Keine Kontakte mit unklarem Geschlecht gefunden',
  updateContactSex: 'Geschlecht ändern',
  selectSex: 'Geschlecht wählen',
  updateSexDescription: 'Bitte wähle das Geschlecht des Kontakts.',
  viewContactDetails: 'Kontaktdetails anzeigen',
  updateSex: 'Geschlecht ändern',
  agentRestart: 'Agent neu starten?',
  completeCampaign: 'Kampagne vervollständigen',
  doNothing: 'Du musst nichts tun',
  messagesWaitingForApproval_one: '{{count}} Nachricht freigeben',
  messagesWaitingForApproval_other: '{{count}} Nachrichten freigeben',
  messagesWaitingForApprovalHint: 'Diese Nachrichten werden erst gesendet, wenn du sie freigibst.',
  contactsWaitingForApproval_one: '{{count}} Kontakt freigeben',
  contactsWaitingForApproval_other: '{{count}} Kontakte freigeben',
  contactsWaitingForApprovalHint: 'Diese Kontakte werden erst angesprochen, wenn du sie freigibst.',
  contactsToApprove: 'Zu prüfende Kontakte',
  contactsToApproveHint_one: '{{count}} Kontakt wartet auf Freigabe',
  contactsToApproveHint_other: '{{count}} Kontakte warten auf Freigabe',
  contactsToApproveEmpty: 'Gerade wartet kein Kontakt auf Freigabe.',
  contactsToApproveError: 'Die Kontakte konnten nicht geladen oder gespeichert werden. Bitte versuche es noch einmal.',
  approveContacts: 'Kontakte freigeben',
  approveContact: 'Freigeben',
  declineContact: 'Nicht ansprechen',
  approveAllContacts_one: '{{count}} Kontakt freigeben',
  approveAllContacts_other: 'Alle {{count}} freigeben',
  openLinkedInProfile: 'LinkedIn-Profil öffnen',
  removeContactFromCampaignDescription: 'Wenn du diese Option auswählst, wird dieser Kontakt in deiner Kampagne auf inaktiv gesetzt. Das bedeutet, dass für den Kontakt keine weiteren Nachrichten generiert werden.',
  excludedContacts: 'davon ausgeschlossen',
  generateMessageError: 'Fehler beim Generieren der Nachricht',
  generateMessageErrorDescription1: 'Dies kann verschiedene Ursachen haben.',
  generateMessageErrorDescription2: 'Bitte überprüfe deine Prompts, ob du irgendwo einen Klarnamen verwendet hast. Aus Datenschutzgründen nutzen wir im Hintergrund Platzhalter. Klarnamen können die KI verwirren und zu Fehlern in der Textgenerierung führen.',
  generateMessageErrorDescription3: 'Falls du weitere Hilfe benötigst, kontaktiere bitte unseren Support.',
  promptGuidanceUsed: 'Prompt-Optimierungsvorschlag verfügbar',
  promptSuggestionTitle: 'Vorgeschlagene Prompt-Verbesserung',
  promptSuggestionDescription: 'Nutze diesen angepassten Prompt für verlässlichere und konkretere Ergebnisse. Du kannst ihn kopieren oder direkt übernehmen.',
  copyPromptSuggestion: 'Vorschlag kopieren',
  applyPromptSuggestion: 'Vorschlag übernehmen',
  suggestedPromptCopied: 'Prompt-Vorschlag kopiert',
  suggestedPromptApplied: 'Prompt-Vorschlag übernommen',
  declineMessageAndDeactivateContact: 'Nachricht ablehnen & Kontakt deaktivieren',
  declineMessageAndGenerateAgain: 'Nachricht ablehnen & neu generieren',
  declineMessageQuestion: 'Wie möchtest du die Nachricht ablehnen?',
  deactivatedContactsNote: 'Hinweis: Für deaktivierte Kontakte werden keine neuen Nachrichten generiert.',
  declineMessageNote: 'Hinweis: Nachrichten werden nur für laufende Kampagnen generiert. Falls deine Kampagne nicht läuft, wird "{{buttonText}}" die Nachricht nur ablehnen, aber keine neue generieren.',
  confirmDeleteNode1: 'Bist du sicher, dass du den Knoten dauerhaft löschen möchtest?',
  confirmDeleteNode2: 'Diese Aktion kann nicht rückgängig gemacht werden - der Knoten und sein gesamter Inhalt gehen dabei verloren.',
  deleteEdge: 'Verbindung entfernen',
  deleteEdgeTitle: 'Verbindung entfernen',
  confirmDeleteEdge1: 'Ohne diese Verbindung hängen {{count}} Schritte an keinem Ablauf mehr.',
  confirmDeleteEdge2: 'Sie werden mit der Verbindung gelöscht. Das kann nicht rückgängig gemacht werden.',
  deleteNodeTitle: 'Knoten dauerhaft löschen',
  linkedinAccountProblem: 'Linkedin Account Problem',
  coPilotLicenseExpired: 'Co-Pilot Lizenz abgelaufen',
  coPilotLicenseExpiredDescription: 'Deine Lizenz zur Nutzung des Co-Piloten ist abgelaufen, bitte erneuere sie, um das Produkt weiter nutzen zu können.',
  contactsAlmostExhausted: 'Fast alle Kontakte bearbeitet',
  contactsAlmostExhaustedDescription: 'Der Agent hat nahezu alle Kontakte in deiner Kampagne bearbeitet.\nFüge jetzt weitere hinzu, um die Kampagne fortzusetzen, oder lass sie auslaufen.',
  flowEmptyDialogTitle: 'Keine Knoten gefunden',
  flowEmptyDialogContent: 'Dein Kampagnen-Flow enthält keine Knoten. Falls Knoten vorhanden sind, aber nicht erkannt wurden, speichere den Flow manuell und starte die Kampagne erneut. Besteht das Problem weiterhin, kontaktiere bitte unseren Support.',
  campaignNotFound: 'Kampagne nicht gefunden. Die Änderungen wurden nicht gespeichert, bitte sei vorsichtig!',
  flowNotFound: 'Flow nicht gefunden. Die Änderungen wurden nicht gespeichert, bitte sei vorsichtig!',
  cloneContactsWithCampaign: 'Kontakte mit Kampagne klonen',
  cloneContactsWithCampaignDescription: 'Wenn aktiviert, werden alle Kontakte in die neue Kampagne kopiert. Der Fortschritt der Kontakte wird dabei zurückgesetzt.',
  addContactsFromCampaignMethodTitle: 'Kontakte aus anderen Kampagnen hinzufügen',
  addContactsFromCampaignDescription: 'Kopiere Kontakte aus einer deiner anderen Kampagnen in diese. Du kannst filtern, welche Kontakte basierend auf ihrem Verbindungsgrad und Antwortstatus kopiert werden sollen.',
  addContactsFromCampaignSourceFunnelLabel: 'Quellkampagne',
  addContactsFromCampaignSourceFunnelPlaceholder: 'Kampagne auswählen, aus der Kontakte kopiert werden sollen',
  addContactsFromCampaignContactDegreeLabel: 'Filter nach Verbindungsgrad',
  addContactsFromCampaignContactDegreeDescription: 'Wähle den Verbindungsgrad, nach dem du die Kontakte filtern möchtest.',
  addContactsFromCampaignContactDegreeAll: 'Alle Kontakte',
  addContactsFromCampaignContactDegreeFirst: 'Nur 1. Grad',
  addContactsFromCampaignContactDegreeSecondPlus: '2. Grad und höher',
  addContactsFromCampaignAll: 'Alle Kontakte',
  addContactsFromCampaignHasReacted: 'Hat geantwortet oder akzeptiert',
  addContactsFromCampaignHasNotReacted: 'Hat weder geantwortet noch akzeptiert',
  addContactsFromCampaignHasReplied: 'Hat geantwortet',
  addContactsFromCampaignHasNotReplied: 'Hat nicht geantwortet',
  addContactsFromCampaignIsActiveLabel: 'Filter nach Aktiv-Status',
  addContactsFromCampaignIsActiveDescription: 'Wähle den Status, nach dem du die Kontakte filtern möchtest.',
  addContactsFromCampaignIsActiveAll: 'Alle Kontakte',
  addContactsFromCampaignIsActiveYes: 'Nur Kontakte, die sich in der finalen Liste befinden',
  addContactsFromCampaignIsActiveNo: 'Nur Kontakte, die sich nicht in der finalen Liste befinden',
  noFilter: 'Kein Filter',
  addContactsFromCampaignContactsThatRepliedLabel: 'Filter nach Antwortstatus (Beliebige auswählen)',
  addContactsFromCampaignContactsThatRepliedDescription: 'Wähle die Antwortstatus, nach denen du die Kontakte filtern möchtest.',
  addContactsFromCampaignRepliedPositive: 'Positiv geantwortet',
  addContactsFromCampaignRepliedNegative: 'Negativ geantwortet',
  addContactsFromCampaignRepliedNote: 'Wenn keine Option ausgewählt ist, werden alle Kontakte (unabhängig vom Antwortstatus), die dem Gradfilter entsprechen, kopiert.',
  addContactsFromCampaignAddButton: 'Kontakte hinzufügen',
  addContactsFromCampaignImportantNote: 'Hinweis: Bei kopierten Kontakten werden der Nachrichtenverlauf und der Schrittfortschritt zurückgesetzt. Ihr \'isActive\'-Status bleibt erhalten.',
  addContactsFromCampaignSuccessMessage: '{{count}} Kontakte erfolgreich aus der ausgewählten Kampagne hinzugefügt.',
  addContactsFromCampaignNoOtherFunnels: 'Keine anderen Kampagnen zum Kopieren von Kontakten gefunden.',
  addContactsFromCampaignErrorsFetchFunnelsError: 'Andere Kampagnen konnten nicht geladen werden. Bitte versuche es später erneut.',
  addContactsFromCampaignErrorsNoSourceSelected: 'Bitte wähle eine Quellkampagne aus.',
  addContactsFromCampaignErrorsAlreadyAddedError: 'Kontakte aus dieser Kampagne wurden möglicherweise bereits hinzugefügt oder werden gerade verarbeitet. Bitte überprüfe die Kontaktliste.',
  addContactsFromCampaignErrorsBadRequestError: 'Kontakte konnten nicht hinzugefügt werden: {{message}}',
  addContactsFromCampaignErrorsGenericAddError: 'Beim Hinzufügen von Kontakten ist ein Fehler aufgetreten. Bitte versuche es erneut.',
  noLocationsFound: 'Zu deiner Anfrage konnten wir leider keinen passenden Ort finden.',
  startingCampaignNotPossibleDialogTitle: 'Starten der Kampagne nicht möglich',
  startingCampaignNotPossibleDialogContent1: 'Deine Kampagne kann nicht gestartet werden, da einige Informationen fehlen oder nicht korrekt sind. Bitte überprüfe deine Einstellungen und versuche es erneut.',
  startingCampaignNotPossibleDialogContent2: 'Folgende Informationen fehlen oder sind nicht korrekt:',
  workDaysNotSet: 'Noch keine Betriebstage eingerichtet. Bitte unter LinkedIn-Accounts → Arbeitszeit festlegen.',
  workHoursNotSet: 'Noch keine Betriebszeiten eingerichtet. Bitte unter LinkedIn-Accounts → Arbeitszeit festlegen.',
  notAllFunctionsSet: 'Dein Kampagnen-Flow enthält keine Nachrichten-Knoten.',
  allNodesNotConnected: 'Nicht alle Knoten in deinem Kampagnen-Flow sind miteinander verbunden.',
  offerNotSet: 'Noch kein Kampagnen-Briefing eingerichtet.',
  linkedinAccountNotSelected: 'Noch kein LinkedIn-Konto ausgewählt.',
  campaignNeedsRetest: 'Bitte teste die Kampagne erneut, bevor du sie startest.',
  offerNotSetError: 'Dein Kampagnen-Briefing enthält leere Felder.',
  flowHasIssues: 'Dein Kampagnen-Flow hat Probleme.',
  notAllMessagesHaveType: 'Nicht alle Nachrichten haben einen Typ.',
  notAllConditionsHaveType: 'Nicht alle Bedingungen haben einen Typ.',
  notAllNodesConnected: 'Nicht alle Knoten sind miteinander verbunden.',
  somethingWentWrongTitle: 'Ein unerwarteter Fehler ist aufgetreten',
  somethingWentWrongDescriptionErrorSent: 'Es tut uns leid, aber ein unerwarteter Fehler ist aufgetreten. Unser technisches Team wurde automatisch informiert und wird sich schnellstmöglich um die Fehlerbehebung kümmern.',
  somethingWentWrongDescriptionErrorNotSent: 'Es tut uns leid, aber ein unerwarteter Fehler ist aufgetreten. Bitte lade die Seite neu und versuche es erneut. Falls das Problem weiterhin besteht, kontaktiere bitte unseren Support, damit wir den Fehler untersuchen können.',
  reloadPage: 'Seite neu laden',
  contactSupport: 'Support kontaktieren',
  errorInFrontend: 'Fehler im Frontend',
  expertMode: 'Experten-Modus',
  yourMessage: 'Deine Nachricht',
  noOutreachApproachSelected: 'Du hast noch keine Outreach-Methode ausgewählt',
  noConnectionMethodSelected: 'Du hast keine Verbindungsart ausgewählt',
  noMessagingLanguageSelected: 'Du hast keine Sprache für deine Nachrichten ausgewählt',
  noLinkedinAccountSelected: 'Du hast keinen LinkedIn Account ausgewählt',
  noLinkedinProductSelected: 'Du hast kein LinkedIn Produkt ausgewählt',
  noSearchSearchLanguageSelected: 'Du hast keine Suchsprache ausgewählt',
  noSearchLocationSelected: 'Du hast keinen Suchort ausgewählt',
  fillProductOffer: 'Mind. ein Feld im Produkt-Briefing ist nicht ausgefüllt',
  fillJobOffer: 'Mind. ein Feld im Job-Briefing ist nicht ausgefüllt',
  createCampaignTitle: '1. Lass uns Deine Outreach-Kampagne in 10 Minuten erstellen!',
  reviewCampaignResultsTitle: '2. Kampagne überprüfen & Ergebnisse ansehen',
  reviewResultsTitle: 'Überprüfe die Ergebnisse & starte die Kampagne',
  blacklistContactsAndStartCampaignTitle: '3. Kontakte blacklisten & Kampagne starten',
  feedAiAgent: 'Füttere den KI-Agenten',
  briefAiOnYour: 'Briefe die KI über Deine',
  outreachCampaign: 'Outreach-Kampagne',
  provideAiWithCampaignCommunicationCriteria: 'Stelle die KI auf deine <1>Kampagnen-Kommunikationskriterien</1> ein',
  provideAiWithCampaignOffer: 'Stelle die KI auf dein <1>{{offer}}</1> ein',
  productDescription: 'Produktbeschreibung',
  qualificationCriteria: 'Qualifikationskriterien',
  specifyImportantQualificationCriteria: 'Gib die <1>wichtigen Qualifikationskriterien</1> an',
  qualificationCriteriaLabel: 'Qualifikationskriterien',
  qualificationCriteriaDescription: 'Gib die wesentlichen Qualifikationen und Anforderungen an, die Kandidaten unbedingt erfüllen müssen, um für diese Rolle berücksichtigt zu werden.',
  qualificationCriteriaSpeechRecInfo: 'Tipp: Nutze die Spracherkennung für eine schnelle Eingabe - aktiviere den Schalter und erteile die Mikrofon-Zugriffsberechtigung.',
  specifyContactsToBeExcludedFromCampaign: 'Gib die <1>Kontakte an, die aus der Kampagne ausgeschlossen werden sollen</1>',
  blacklists: 'Blacklisten',
  selectBlacklists: 'Wähle die Blacklists aus, die Du für diese Kampagne aktivieren möchtest.',
  noGlobalBlacklistsFound: 'Du hast noch keine globalen Blacklists erstellt. Um Kontakte zu blockieren, klicke auf:',
  provideInformation: 'Gib Informationen an',
  toOperateYourCampaign: 'um Deine Kampagne zu betreiben',
  selectLinkedinAccountForTalentSourcing: 'Wähle LinkedIn-Konto für Talentbeschaffung',
  talentSourcingDescription: 'Du kannst verschiedene LinkedIn-Konten für Deine Talentbeschaffung nutzen.',
  craftOutreachCampaign: 'Erstelle Outreach-Kampagne',
  reviewDetailsInExpertMode: 'Überprüfe Details im Experten-Modus',
  testMessageGeneration: 'Test Nachrichtenerstellung',
  notePromptsForMessageGenerationCanBeEditedUnderExpertMode: 'Hinweis: Prompts für die Nachrichtenerstellung können im Experten-Modus bearbeitet werden.',
  contactFunnel: 'Kontakt-Funnel',
  approveMessagesAndContactsBeforeSending: 'Genehmige Nachrichten und Kontakte vor dem Senden',
  allowTheAgentToSendMessagesWithoutPriorReview: 'Erlaube, Nachrichten ohne vorherige Genehmigung zu senden',
  sourcedContactsInTalentPool: 'Kontakte im Talent-Pool',
  assessedContactsInTalentPool: 'Bewertete Kontakte im Talent-Pool',
  contactsInCampaignShortlist: 'Kontakte in der Kampagnen-Shortlist',
  contactsAssessmentNote: 'Hinweis: Kontakte werden im Laufe der Zeit schrittweise bewertet und qualifiziert, aber Du kannst Deine Kampagne sofort starten.',
  candidatesHighestMatchFirstNote: 'Hinweis: Wir sprechen zuerst die Kandidaten mit der höchsten Übereinstimmung an.',
  reviewAndFineTuneNote: 'Hinweis: Du kannst die Kontakteinstellungen im Expertenmodus überprüfen und anpassen oder die Kampagne sofort starten.',
  startCampaignOrReviewMessage: 'Möchtest Du die Kampagne sofort starten oder die Nachricht vor dem Start überprüfen und genehmigen?',
  craftingOutreachCampaign: 'Erstelle Outreach-Kampagne...',
  campaignCraftingStepCampaignBriefing: 'Kampagnenbriefing',
  campaignCraftingStepReviewBriefing: 'Überprüfung des Briefings und Extraktion der Schlüsselanforderungen für die Kampagne:',
  campaignCraftingStepDefiningCriteria: 'Festlegung der Kriterien für die Durchführung von Talent-Suchen auf LinkedIn.',
  campaignCraftingStepEstablishingRequirements: 'Festlegung der Anforderungen für die Generierung von Nachrichten.',
  campaignCraftingStepSourcingTalents: 'Talente sourcen',
  campaignCraftingStepTalentSearch: 'Durchführung einer Talent-Suche auf LinkedIn.',
  campaignCraftingStepQualifyingTalents: 'Talente qualifizieren',
  campaignCraftingStepReviewQualificationCriteria: 'Überprüfung und Extraktion der wesentlichen Kriterien für die Talent-Bewertung.',
  campaignCraftingStepEvaluatingContacts: 'Bewertung der ersten Charge an Kontakten:',
  campaignCraftingStepIdentifyingProfiles: 'Identifizierung professioneller Profile und Hintergründe.',
  campaignCraftingStepQualifyingProcessingTalents: 'Qualifiziere erste Talente.',
  campaignCraftingStepCreatingShortlist: 'Erstellung einer Shortlist qualifizierter Talente.',
  campaignCraftingStepBuildingFlow: 'Kampagnenfluss erstellen',
  campaignCraftingStepReviewRequirements: 'Überprüfung des Briefings und Extraktion der Schlüsselfunktionen für die Nachrichtengenerierung:',
  campaignCraftingStepDefiningCommunication: 'Definierung der Kommunikationsanforderungen.',
  campaignCraftingStepConstructingFlow: 'Erstellung des Kommunikationsflusses/-prozesses.',
  campaignCraftingStepCreatingPrompts: 'Erstellung von Textgenerierungsaufforderungen für jede zu versendende Nachricht.',
  campaignCraftingStepCampaignTesting: 'Kampagnentests',
  campaignCraftingStepGeneratingExampleTexts: 'Erstellung von Beispieltexten für jede Nachrichten-Node im Fluss.',
  campaignCraftingStepCalculatingMatchScores: 'Berechnung der Übereinstimmungspunkte und Personas für jeden Kontakt und jede Nachricht.',
  campaignCraftingStepEnsuringFunctionality: 'Sicherstellen, dass die Kampagne wie gewünscht funktioniert mit den generierten Ausgaben.',
  campaignCraftingStepCampaignSettings: 'Kampagneneinstellungen festlegen',
  campaignCraftingStepLinkedinAccountManagement: 'LinkedIn-Konto-Management',
  campaignCraftingStepTimeZone: 'Zeitzone',
  campaignCraftingStepWorkingDays: 'Arbeitstage und Arbeitszeiten',
  campaignCraftingStepDailyOutreachQuota: 'Tägliche Outreach-Nachrichtenquote',
  campaignCraftingStepCompleted: 'Kampagnenaufbau abgeschlossen',
  campaignCraftingStepCampaignCompleted: 'Die Kampagne wurde erfolgreich aufgebaut.',
  finish: 'Fertig',
  expressOnboardingStepBriefing: 'Super! Zuerst stelle ich sicher, dass ich alle Infos habe, um Deine Kampagne zu erstellen. Bitte fülle alle Punkte im Abschnitt „Kampagnenbriefing“ aus – das hilft mir, die Anforderungen für Kontaktsuche und Texterstellung genau zu definieren.',
  expressOnboardingStepQualifying: 'Klasse! Jetzt hilf mir, die Kriterien zur Qualifizierung der Kontakte festzulegen. Je klarer und konkreter Du bist, desto besser kann ich passende Kontakte finden – wie bei einem guten Briefing für eine Assistenz.',
  expressOnboardingStepOperationalSettings: 'Fast geschafft! Nenne mir jetzt den LinkedIn-Account, den du zum Crawlen der Kontakte verwenden möchtest, und alle weiteren Infos, die ich brauche, um Deine Kampagne zu betreiben. Danach kannst Du einfach auf „Erstelle Outreach Kampagne“ klicken. Keine Sorge – Du kannst alles vor dem Start nochmal überprüfen und anpassen.',
  expressOnboardingStepReviewAndResults: 'Alles erledigt! Ich habe Deine Kampagnendaten verarbeitet. Jetzt kannst Du die Ergebnisse prüfen, Vorschläge durchsehen und bei Bedarf anpassen.',
  expressOnboardingStepCampaignFlow: 'Kampagnenfluss – Eine visuelle Darstellung des gesamten Ablaufs Deiner Kampagne, Schritt für Schritt.',
  expressOnboardingStepMessageTesting: 'Testen der Nachrichtenerstellung – Schau Dir an, wie die KI die Nachrichten für jeden Schritt erstellt. Sie werden auf die Profile und Persönlichkeiten der Kontakte abgestimmt, um bessere Reaktionen zu erzielen.',
  expressOnboardingStepContactFunnel: 'Kontakt-Funnel – Verfolge, wie viele Kontakte bereits gefunden, bewertet und qualifiziert wurden. Du entscheidest, ob die KI automatisch arbeitet oder ob Du Nachrichten vor dem Versenden genehmigen möchtest.',
  startNewOrCloneCampaign: 'Neu erstellen oder vorhandene Kampagne klonen',
  startNewOrCloneCampaignDescription: 'Du kannst eine neue Kampagne erstellen oder eine vorhandene Kampagne klonen, um Zeit zu sparen.',
  startNew: 'Neue Kampagne erstellen',
  cloneExisting: 'Vorhandene Kampagne klonen',
  selectCampaignToClone: 'Kampagne auswählen',
  selectCampaignToCloneDescription: 'Wähle eine vorhandene Kampagne aus, um sie als Vorlage für deine neue Kampagne zu verwenden.',
  expressBuilderFormDirtyWarning: 'Du hast ungespeicherte Änderungen in der Kampagne. Wenn du die Seite verlässt, werden diese Änderungen verworfen.',
  removeFromBlacklist: 'Aus der Blackliste entfernen',
  removeFromSuspended: 'Suspendierung zurücksetzen',
  editGeneralSettings: 'Allg. Einstellungen bearbeiten',
  editLoginInformation: 'Anmeldedaten bearbeiten',
  editUsername: 'Nutzername bearbeiten',
  noTestContactsFound: 'Wir suchen noch passende Talente – manchmal dauert es etwas länger. Starte die Kampagne einfach schon jetzt, unser Agent übernimmt den Rest für Dich.',
  microphoneBlockedTitle: 'Mikrofonzugriff erforderlich',
  microphoneBlockedText1: 'Um diese Funktion zu verwenden, musst du Mikrofonzugriff in deinem Browser zulassen.',
  microphoneBlockedChromeInstructions: 'In Chrome: Klicke auf das Icon links in der Adressleiste, dann auf "Website-Einstellungen" und aktiviere den Mikrofonzugriff unter "Berechtigungen".',
  microphoneBlockedEdgeInstructions: 'In Edge: Klicke auf das Schloss-Icon in der Adressleiste, dann auf "Berechtigungen für diese Website" und aktiviere den Mikrofonzugriff unter "Mikrofon".',
  microphoneBlockedFirefoxInstructions: 'In Firefox: Klicke auf das Mikrofon-Icon in der Adressleiste, dann klicke auf "Blockiert", um die Einstellung zurückzusetzen. Beim nächsten Mal, wenn du das Feature verwendest, wirst du nun erneut aufgefordert, den Zugriff zu erlauben.',
  microphoneBlockedSafariInstructions: 'In Safari: Klicke auf Safari in der Menüleiste, wähle "Einstellungen", dann "Websites" und aktiviere den Mikrofonzugriff für diese Website.',
  microphoneBlockedGenericInstructions: 'Bitte aktiviere den Mikrofonzugriff in den Einstellungen deines Browsers, um diese Funktion zu verwenden.',
  microphoneBlockedText2: 'Nachdem du den Zugriff erlaubt hast, aktualisiere die Seite, um die Funktion zu verwenden.',
  microphoneBlockedText3: 'Alternativ kannst du die Texte weiterhin manuell eingeben, falls du das Mikrofon nicht aktivieren möchtest.',
  generateLeadList: 'Lead-Liste erstellen',
  enterYourPrompt: 'Gib Deinen Prompt ein',
  leadListPromptDescription: 'Beschreibe die Firmen, die Du suchst, z. B. Größe, Branche, Standort usw.',
  overallPromptPlaceholder: 'z. B. Kleine bis mittelgroße Softwareunternehmen in Berlin mit Fokus auf Fintech',
  productOrIndustry: 'Produkt oder Branche',
  productOrIndustryPlaceholder: 'z. B. CRM-Software, Büromöbel',
  regionOrLocation: 'Region oder Ort',
  regionOrLocationPlaceholder: 'z. B. Berlin',
  regionSplitInstructions: 'Regionale Aufteilungsanweisungen',
  regionSplitInstructionsPlaceholder: 'Wie soll die Region aufgeteilt werden? z. B. nach Stadt oder Unterregion (optional)',
  companyIdentificationInstructions: 'Anweisungen zur Unternehmensidentifikation',
  companyIdentificationInstructionsPlaceholder: 'z. B. Fokus auf Branchen wie Gesundheitswesen, Finanzen (optional)',
  peopleSearchInstructions: 'Anweisungen zur Personensuche',
  peopleSearchInstructionsPlaceholder: 'z. B. Finde den CTO, Head of Product oder Head of Engineering (optional)',
  generating: 'Wird generiert...',
  myLeadLists: 'Meine Lead-Listen',
  refresh: 'Aktualisieren',
  generateNewLeadList: 'Neue Lead-Liste erstellen',
  newLeadList: 'Neue Lead-Liste',
  leadListSummaryTotal: '{{lists}} Listen · {{leads}} Leads insgesamt',
  leadListSummaryPage: '{{lists}} Listen · {{leads}} Leads auf dieser Seite',
  searchLeadListPlaceholder: 'Suche nach Produkt, Region oder Tag...',
  deleteLeadListTitle: 'Lead-Liste löschen',
  deleteLeadListConfirmation: 'Bist Du sicher, dass Du diese Lead-Liste löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
  tableHeaderName: 'Name',
  tableHeaderProduct: 'Produkt',
  tableHeaderRegion: 'Region',
  tableHeaderLeads: 'Leads',
  tableHeaderCreated: 'Erstellt',
  tableHeaderActions: 'Aktionen',
  noLeadListsFound: 'Keine Lead-Listen gefunden.',
  generateFirstLeadList: 'Erstelle Deine erste Lead-Liste',
  unnamedLeadList: 'Unbenannte Lead-Liste',
  fullResearch: 'Vollständige Recherche',
  refineWithAi: 'Mit KI verfeinern',
  notSpecified: 'Nicht angegeben',
  region: 'Region',
  originalSearchPrompt: 'Ursprünglicher Suchbegriff',
  leadDataCount: 'Lead-Daten ({{count}} Leads)',
  exportAsCsv: 'Als CSV exportieren',
  enrichWithLinkedinUrls: 'Mit LinkedIn-URLs anreichern',
  debugData: 'Debug-Daten',
  phone: 'Telefon',
  contactLinkedin: 'LinkedIn des Kontakts',
  leadReason: 'Grund für den Lead',
  website: 'Webseite',
  companyLinkedin: 'LinkedIn des Unternehmens',
  size: 'Größe',
  address: 'Adresse',
  viewProfile: 'Profil ansehen',
  viewPage: 'Seite ansehen',
  enrichLeadList: 'Lead-Liste anreichern',
  customFieldNameOptional: 'Benutzerdefinierter Feldname (optional)',
  customFieldNamePlaceholder: 'z. B. Seniorität, Fokus, Notiz',
  customFieldPromptOptional: 'Benutzerdefinierter Feld-Prompt (optional)',
  customFieldPromptPlaceholder: 'z. B. Was ist wahrscheinlich die Seniorität dieser Person?',
  customFieldInfo: 'Wenn Du ein benutzerdefiniertes Feld und einen Prompt angibst, wird das Backend dieses Feld für jeden Lead nach Deinen Vorgaben ausfüllen.',
  enrichNow: 'Jetzt anreichern',
  generateFullLeadList: 'Vollständige Lead-Liste generieren',
  fullLeadInfoAlert: 'Dies wird eine umfassende Lead-Liste (50+ Leads) basierend auf deinem Feedback generieren. Der Vorgang kann je nach Komplexität 3–9 Minuten dauern.',
  implementationNotes: 'Hinweise zur Umsetzung:',
  regionSplitting: 'Die API führt eine intelligente Aufteilung der Regionen durch, um umfassendere Ergebnisse zu erzielen',
  structuredLeads: 'Alle Leads haben eine einheitliche Struktur mit Kontakt- und Unternehmensdaten',
  qualityAssessed: 'Die Qualität der Recherche wird automatisch bewertet und ein Feedback gegeben',
  durationNote: 'Der Vorgang kann je nach Komplexität 180–540 Sekunden dauern',
  usePreviousResults: 'Du kannst previousResults verwenden, um bereits vorhandene Daten zu erweitern',
  updateInsteadOfNew: 'Wenn savedListId angegeben ist, wird die bestehende Liste aktualisiert statt eine neue zu erstellen',
  researchParameters: 'Rechercheparameter',
  searchPrompt: 'Suchanfrage',
  productPlaceholder: 'z. B. Mitarbeiter-Benefit-Programme',
  regionPlaceholder: 'z. B. Bayern, Deutschland',
  searchPromptPlaceholder: 'z. B. Finde Programme für Mitarbeiter-Benefits in Bayern, Deutschland',
  leadTypePrompt: 'Welche Art von Leads möchtest du sehen?',
  researchFeedback: 'Recherche-Feedback',
  researchFeedbackPlaceholder: 'z. B. Fokus auf HR-Abteilungen und Unternehmen mit mehr als 100 Mitarbeitern. Wenn möglich, direkte Telefonnummern einfügen.',
  advancedSettings: 'Erweiterte Einstellungen',
  regionSplitInstruction: 'Anweisungen zur Regionsteilung',
  regionSplitPlaceholder: 'z. B. Teile Bayern in Industriegebiete mit Fokus auf Großstädte wie München, Nürnberg und Ingolstadt',
  numSubregions: 'Anzahl der Teilregionen: {{count}}',
  subregionInfo: 'Höhere Werte liefern eine umfassendere Abdeckung, benötigen jedoch mehr Zeit zur Verarbeitung',
  companyInstructions: 'Anweisungen zur Unternehmensidentifikation',
  companySubSearchPlaceholder: 'z. B. Für jede Region, erstelle Subsuchen für Unternehmensgröße.',
  companyInstructionsDescription: 'Statt spezifischer Subsearches gib Anweisungen, wie das System Subsearches generieren soll. Dies hilft bei einer effektiveren Recherche.',
  subsearchInstructions: 'Subsearch-Anweisungen',
  subsearchPlaceholder: 'z. B. Subsearches auf verschiedene Rollen fokussieren wie HR-Direktoren, Abteilungsleiter und C-Level-Führungskräfte.',
  numSubsearches: 'Anzahl der Subsearches: {{count}}',
  subsearchInfo: 'Höhere Werte sorgen für vielfältigere Recherchestrategien, verlängern aber die Dauer',
  peopleSearchInstruction: 'Personensuche-Anweisungen',
  peopleSearchPlaceholder: 'z. B. Finde CTO, Head of Product oder Head of Engineering für jedes Unternehmen. (optional)',
  peopleSearchCount: 'Anzahl der Personensuchen pro Unternehmen',
  updateExistingList: 'Diese Lead-Liste mit neuen Ergebnissen aktualisieren',
  autoSaveResults: 'Ergebnisse automatisch speichern',
  uploadLeadList: 'Lead-Liste hochladen',
  listName: 'Listenname',
  listNamePlaceholder: 'Gib einen Namen für Deine Liste ein',
  startEnrichment: 'Anreicherung starten',
  uploadSuccessPreview: 'Vorschau der hochgeladenen Liste',
  refineLeadInfoAlert: 'Dies wird deine vorhandene Lead-Liste mit KI basierend auf deinem Feedback verfeinern. Der Vorgang kann 30-60 Sekunden dauern.',
  refinementFeatures: 'Verfeinerungsmerkmale:',
  intelligentRefinement: 'Intelligente Verfeinerung deiner vorhandenen Lead-Liste',
  preserveOriginalData: 'Originaldaten werden beim Verfeinerungsprozess beibehalten',
  subregionalAnalysis: 'Subregionale Analyse für bessere Abdeckung',
  consistentFormatting: 'Konsistente Formatierung mit vorherigen Daten',
  autoMergeLeads: 'Neue und vorhandene Leads automatisch zusammenführen',
  refineLeadList: 'Lead-Liste verfeinern',
  refinementFeedback: 'Verfeinerungs-Feedback',
  refinementFeedbackPlaceholder: 'z. B. Fokus auf Hersteller von Produkten für die Automobilindustrie, einschließlich Unternehmen mit mehr als 100 Mitarbeitern.',
  uploadOwnLeadList: 'Eigene Lead-Liste hochladen',
  uploadOwnLeadListDescription: 'Lade eine CSV- oder Excel-Datei mit deiner Lead-Liste hoch und gib einen aussagekräftigen Namen für die Liste ein.',
  addToFunnel: 'Zu Kampagne hinzufügen',
  selectCampaignDescription: 'Wähle eine LinkedIn-Kampagne aus, um Kontakte aus der Lead-Liste hinzuzufügen (ID: {{leadListId}}).',
  loadingFunnels: 'Lade Kampagnen...',
  noActiveFunnelsFound: 'Keine aktiven Kampagne gefunden.',
  funnel: 'Funnel',
  conversions: 'Konversionen',
  campaignsOperationalOverview: 'Kampagnen Betriebsübersicht',
  campaignOverviewPlaceholder: 'Die Betriebsübersicht erscheint, sobald Du eine Kampagne auswählst.',
  qualifiedContacts_ActiveSourcing: 'Kandidaten in der Pipeline',
  contactsInShortlist_ActiveSourcing: 'Kandidaten in der Finalen Kandidatenliste',
  contactsInLeadBank_ActiveSourcing: 'Kandidaten in der Kampagne',
  contactedContacts_ActiveSourcing: 'Kontaktierte Kandidaten',
  notContactedContacts_ActiveSourcing: 'Nicht kontaktierte Kandidaten',
  connectedContacts_ActiveSourcing: 'Verbundene Kandidaten',
  contactsFinishedFunnel_ActiveSourcing: 'Kandidaten, die den Funnel abgeschlossen haben',
  contactsCompletedFunnel_ActiveSourcing: 'Abgeschlossene Kandidaten',
  qualifiedContacts_LeadBooster: 'Leads in der Pipeline',
  contactsInShortlist_LeadBooster: 'Leads in der Finalen Leadliste',
  contactsInLeadBank_LeadBooster: 'Leads in der Kampagne',
  contactedContacts_LeadBooster: 'Kontaktierte Leads',
  notContactedContacts_LeadBooster: 'Nicht kontaktierte Leads',
  connectedContacts_LeadBooster: 'Verbundene Leads',
  contactsFinishedFunnel_LeadBooster: 'Leads, die den Funnel abgeschlossen haben',
  contactsCompletedFunnel_LeadBooster: 'Abgeschlossene Leads',
  reactionsToMessages: 'Antworten auf Nachrichten',
  contactedAndReacted: 'Kontaktiert & Reagiert',
  acceptedOrReplied: 'Angenommen oder geantwortet',
  backToAllCampaigns: 'Zurück zur Kampagnenübersicht',
  step: 'Schritt',
  noContactsInThisStep: 'Keine Kontakte in diesem Schritt',
  noLinkedInURL: 'Keine LinkedIn URL',
  linkedInProfile: 'LinkedIn Profil',
  assessment: 'Bewertung',
  sentMessages: 'Gesendete Nachrichten',
  receivedMessages: 'Empfangene Nachrichten',
  stepsTaken: 'Erledigte Schritte',
  at: 'bei',
  lastCampaignUpdate: 'Letzte Aktualisierung der Kampagne: {{date}}',
  lastCampaignUpdateBy: 'Letzte Aktualisierung der Kampagne: {{date}} von {{user}}',
  conversionsAndStatistics: 'Konversionen & Statistiken',
  networkExpansion: 'Wie sehr hast Du Dein Netzwerk ausgeweitet?',
  responseRate: 'Antwortquote',
  responseRates: 'Wie viele Kontakte haben geantwortet?',
  totalReplies: 'Gesamte Antworten',
  avgConnectionRequestAcceptanceTime: 'Durchschnittliche Zeit bis zur Annahme einer Kontaktanfrage',
  contactedContacts: 'Kontaktierte Kontakte',
  sent: 'Gesendet',
  responded: 'Geantwortet',
  messageNotReached: 'Keine Nachrichten aus diesem Schritt versendet',
  avgTimeToConversion: 'Durchschnittliche Zeit bis zur Konversion',
  messageStepConversions: 'Wie gut performen meine Nachrichten?',
  messageStepConversionsTooltip: 'Welche Nachrichten führen wie schnell und in welchem Verhältnis zu einer Konversion?',
  conversionRates: 'Konversionsquoten',
  avgConversionRate: 'Durchschnittliche Konversionsrate',
  viewCampaignDetails: 'Kampagnendetails ansehen',
  connectionRequestsRate: 'Kontaktanfragenannahmequote',
  acceptedConnectionRequests: 'Angenommene Kontaktanfragen',
  sentConnectionRequests: 'Gesendete Kontaktanfragen',
  skipTutorial: 'Tutorial überspringen',
  allMessagesProcessed: 'Alle Nachrichten wurden bearbeitet',
  unsupportedPlaceholdersWarning: 'Die folgenden Platzhalter werden nicht unterstützt: {{placeholders}}',
  addContactsToCampaignDescription: 'Wähle eine LinkedIn-Kampagne aus, um Kontakte aus der Lead-Liste hinzuzufügen ({{leadListId}}).',
  selectCampaignToAddContacts: 'Such hier nach einer Kampagne...',
  testAutoReplyTitle: 'Automatische Antwort testen',
  testAutoReplyInstruction: 'Kopiere und füge hier eine LinkedIn-Konversation ein, um die automatische Antwortfunktion zu testen.',
  pasteLinkedinConversation: 'LinkedIn-Konversation hier einfügen...',
  testAutoReplyResult: 'Testergebnis',
  autoReplyGeneratedMessage: 'Generierte Antwort (wird gesendet):',
  autoReplyDetectedCase: 'Erkannter Fall:',
  autoReplyCaseExplanation: 'Erklärung zur Fallerkennung:',
  voiceInputTooltip: 'Spracherkennung aktivieren',
  manualInputTooltip: 'Manuelle Eingabe',
  autoDetectLanguage: 'Sprache automatisch erkennen',
  autoDetectLanguageDescription: 'Die Sprache wird automatisch aus der von dir bereitgestellten Stellenanzeige übernommen.',
  autoDetectLanguageAndEnglish: 'Automatisch erkannte Sprache und Englisch',
  languageSelection: 'In welchen Sprachen sollen wir suchen?',
  languageSelectionDescription: 'Wähle die Sprachen für die Suchbegriffe aus, mit denen relevante Kontakte gefunden werden sollen.',
  cloneCampaignDescription: 'Nutze eine bestehende Kampagne als Vorlage. Klone ihre Einstellungen, aktualisiere die Details und starte schneller.',
  changeCommunicationStyleTitle: 'Hinweis!',
  changeCommunicationStyleDescription1: 'Das Ändern des Kommunikationsstils kann zu Inkonsistenzen in deinen Nachrichten führen—zum Beispiel, wenn die Prompts auf formell eingestellt sind, aber der Stil auf informell geändert wird.',
  changeCommunicationStyleDescription2: 'Um dies zu vermeiden, aktualisiere bitte die Prompts manuell oder wähle ein neues Template aus.',
  briefAndCreateCampaign: 'Kampagne briefen & erstellen',
  reviewCampaignResults: 'Kampagne überprüfen und Ergebnisse ansehen',
  blacklistContactsAndStartCampaign: 'Kontakte blacklisten & Kampagne starten',
  blacklistsCaption: 'Hinweis: Globale Blacklists können jederzeit über die Dashboard-Navigationsleiste bearbeitet werden. Für kampagnenspezifische Blacklists nutze den Experten-Modus innerhalb jeder Kampagne, um Änderungen vorzunehmen.',
  addGlobalBlacklist: 'Globale Blacklist hinzufügen',
  addCampaignSpecificBlacklist: 'Kampagnenspezifische Blacklist hinzufügen',
  globalBlacklistsDescription: 'Globale Blacklists sind Blacklists, die für alle deiner Kampagnen zugänglich sind. Aktiviere mindestens eine, um Kontakte zu blockieren.',
  localBlacklistsDescription: 'Kampagnenspezifische Blacklists sind Blacklists, die nur für eine bestimmte Kampagne zugänglich sind. Aktiviere mindestens eine, um Kontakte zu blockieren.',
  blacklistName: 'Blacklist Name',
  enterBlacklistNameHere: 'Name der Blacklist hier eingeben...',
  blacklistCreationBasis: 'Auf welcher Basis soll die Blacklist erstellt werden?',
  uploadOrTypeItems2: 'Wie möchtest Du {{item}} zur Blacklist hinzufügen?',
  beforeStartingCampaignTitle: 'Bevor Du Deine Kampagne startest, denke daran',
  infoTitle: 'Hinweis',
  noActiveBlacklist: 'Du hast noch keine aktive Blacklist.',
  proceedWithoutExclusions: 'Bist Du sicher, dass Du fortfahren möchtest, ohne Kontakte auszuschließen?',
  agentFailedWarning: 'Der Agent hat die Kampagne nicht erfolgreich erstellt. Bitte fahre im Experten-Modus fort.',
  processingContacts: 'Kontakte werden für die Shortlist qualifiziert',
  countryEn: 'Land (Country)',
  cityEn: 'Stadt (City)',
  recommended: 'Empfohlen',
  flowTools: 'Flow-Tools',
  zoomIn: 'Vergrößern',
  zoomOut: 'Verkleinern',
  centerFlow: 'Zentrieren',
  mouseWheelFunctionality: 'Mausrad-Funktionalität',
  scrollMode: 'Scrollen',
  zoomMode: 'Zoomen',
  enrichedViaBetterContact: 'Über BetterContact angereichert',
  enrichedPhone: 'Angereicherte Telefonnummer',
  enrichedEmail: 'Angereicherte E-Mail',
  failed: 'Fehlgeschlagen',
  sparse: 'Profil nicht vollständig sichtbar',
  enrichmentStatus: 'Anreicherungsstatus',
  not_started: 'Nicht gestartet',
  in_progress: 'In Arbeit',
  sendAllContacts: 'Alle Kontakte senden',
  selectContactsToSend: 'Kontakte auswählen',
  addSelectedContacts: 'Ausgewählte Kontakte hinzufügen',
  onlyContactsWithLinkedinUrlCanBeSelected: 'Du kannst nur Kontakte mit einer gültigen LinkedIn-URL auswählen.',
  webmeticsIntegrationsTitle: 'Webmetics-Integrationen',
  webmeticsIntegrationsDescription: 'Verwalte Deine Webmetics-Zuordnungen und erstelle Suchanfragen, um Kontakte in Deinen Funnel zu importieren.',
  addMappingSet: 'Mapping-Set hinzufügen',
  deleteMappingTitle: 'Mapping löschen',
  deleteMappingConfirmation: 'Bist Du sicher, dass Du dieses Webmetics-Mapping löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
  createWebmeticsMappingTitle: 'Webmetics-Mapping erstellen',
  updateWebmeticsMappingTitle: 'Webmetics-Mapping aktualisieren',
  schemaName: 'Schema-Name',
  enterSchemaName: 'Gib hier den Schema-Namen ein...',
  apiKeyWebmetics: 'API-Schlüssel (Webmetics)',
  enterApiKey: 'Gib hier den API-Schlüssel ein...',
  enterDomain: 'Gib hier die Domain ein...',
  occupation: 'Beruf',
  enterOccupation: 'Gib hier einen Beruf ein und drücke Enter oder klicke auf den Hinzufügen-Button...',
  visitedWebsites: 'Besuchte Webseiten',
  visitedWebsitesCommaSeparated: 'Besuchte Webseiten (durch Kommas getrennt)',
  enterVisitedWebsites: 'Gib hier besuchte Webseiten ein...',
  saveMapping: 'Mapping speichern',
  updateMapping: 'Mapping aktualisieren',
  testMappingResultsTitle: 'Mapping-Ergebnisse testen',
  visitedWebsitesReferrer: 'Besuchte Webseiten (Referrer)',
  noVisitedWebsites: 'Keine besuchten Webseiten verfügbar.',
  funnelId: 'Funnel-ID',
  occupations: 'Berufe',
  noMappingsAvailable: 'Keine Webmetics-Mappings verfügbar. Klicken Sie auf "Mapping-Set hinzufügen", um Ihr erstes Mapping zu erstellen.',
  connectionSaved: 'Verbindung erfolgreich gespeichert!',
  invalidState: 'Ungültiger Statusparameter. Bitte versuche es erneut.',
  connectionFailed: 'Verbindung fehlgeschlagen. Bitte versuche es erneut.',
  connectToDynamics: 'Mit Microsoft Dynamics verbinden.',
  checkingAdminConsent: 'Überprüfe den Admin-Zustimmungsstatus...',
  adminConsentGivenContinueAuth: 'Admin-Zustimmung wurde erteilt. Klicke unten auf den Button, um die Benutzeranmeldung abzuschließen.',
  alreadyConnectedToDynamics: 'Du bist bereits mit Microsoft Dynamics verbunden.',
  adminConsentMissing: 'Admin-Zustimmung fehlt. Klicke hier, um sie abzuschließen.',
  integrationsTitle: 'Integrationen',
  integrationsDescription: 'Wähle eine CRM-Plattform, um Deine Kontakte, Unternehmen und Aktivitäten zu verbinden und zu verwalten.',
  microsoftDynamics: 'Microsoft Dynamics',
  hubspot: 'HubSpot',
  connectToHubspot: 'Mit HubSpot verbinden.',
  connectedToHubspot: 'Du bist bereits mit HubSpot verbunden.',
  authenticateUser: 'Nutzer authentifizieren',
  loadingMappings: 'Lade Zuordnungen...',
  disconnectCrmTitle: 'CRM-Verbindung trennen',
  disconnectCrmConfirmation: 'Bist Du sicher, dass Du die Verbindung zu {{crm}} trennen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
  thisCrm: 'diesem CRM',
  disconnect: 'Trennen',
  updateMappingSetTitle: 'Mapping-Set aktualisieren',
  createMappingSetTitle: 'Mapping-Set erstellen',
  loading: 'Lädt...',
  mappingSetNameLabel: 'Name des Mapping-Sets',
  triggerLabel: 'Auslöser',
  allowAutomaticUpdates: 'Automatische Updates von nicht erlaubten Kampagnen zulassen',
  allowedCampaignsTitle: 'Erlaubte Kampagnen',
  allowedCampaignsDescription: 'Wähle Kampagnen aus, die Kontakte in dieses CRM-Mapping übertragen dürfen. Wenn keine Kampagnen ausgewählt sind und automatische Updates deaktiviert sind, können keine Kontakte übertragen werden.',
  loadingCampaigns: 'Kampagnen werden geladen...',
  noCampaignsAvailable: 'Keine Kampagnen verfügbar',
  crmSelectionTitle: 'CRM-Auswahl',
  crmSelectionDescription: 'Wähle das CRM-System für alle Feldzuordnungen aus.',
  fieldMappingsTitle: 'Feldzuordnungen',
  fieldMappingsDescription: 'Ordne lokale Felder den CRM-Feldern zu. Das E-Mail-Feld ist erforderlich und muss zugeordnet sein.',
  tableColumnName: 'Name',
  tableColumnLocalField: 'Lokales Feld',
  tableColumnFieldType: 'Feldtyp',
  tableColumnCrmField: 'CRM-Feld',
  tableColumnActions: 'Aktionen',
  enterMappingName: 'Mapping-Namen eingeben',
  required: 'Erforderlich',
  enterCustomField: 'Eigenes Feld eingeben',
  selectFieldTypeFirst: 'Zuerst Feldtyp auswählen',
  addMapping: 'Mapping hinzufügen',
  saveMappingSet: 'Mapping-Set speichern',
  deal: 'Deal',
  dynamicsOrganizationExample: 'Dynamics Organisation (z.B. contoso)',
  regionExample: 'Region (z.B. 4 für crm4.dynamics.com)',
  regionHelperText: 'Der Regions-Parameter ändert die URL von .crm zu .crm[region]. Leer lassen für Standardregion.',
  saveSettings: 'Einstellungen speichern',
  mappingSetName: 'Mapping-Set-Name',
  createdDate: 'Erstellungsdatum',
  noCrmMappings: 'Keine CRM-Zuordnungen verfügbar. Klicke „Mapping-Set hinzufügen“, um Deine erste Zuordnung zu erstellen.',
  mappingDetails: 'Mapping Details',
  crmName: 'CRM-Name',
  fieldType: 'Feldtyp',
  localField: 'Lokales Feld',
  crmField: 'CRM-Feld',
  linkedinAccountLoginInProgress: 'LinkedIn-Account wird angemeldet',
  licenseCreatedSuccess: 'Lizenz erfolgreich erstellt!',
  licenseUpdatedSuccess: 'Lizenz erfolgreich aktualisiert!',
  globalFunnels: 'Globale Funnels',
  globalFunnel: 'Globale Funnel',
  globalFunnelDescription: 'Globale Funnels sind Funnels, die für alle deiner Kampagnen zugänglich sind. Aktiviere mindestens eine, um globale Funnels zu verwenden.',
  globalFunnelName: 'Name der globalen Funnel',
  leadListResearchPlaceholder: 'Gib hier eine Liste von Unternehmen ein...',
  leadListResearchButton: 'Leads recherchieren',
  leadListResearchResult: 'Ergebnis der Lead-Liste recherchieren',
  leadListResearchResultDescription: 'Das Ergebnis der Lead-Liste recherchieren.',
  leadListResearchResultPlaceholder: 'Gib hier eine Liste von Leads ein...',
  leadListResearchResultButton: 'Leads recherchieren',
  customPlaceholders: 'Benutzerdefinierte Platzhalter',
  placeholderKey: 'Platzhalter-Schlüssel',
  placeholderValue: 'Platzhalter-Wert',
  savePlaceholder: 'Platzhalter speichern',
  customPlaceholdersDescription: 'Erstelle hier deine eigenen Platzhalter. Du kannst sie in jeder Nachricht im Nachrichten-Prompt einfügen, indem du {{key}} eingibst, wobei "key" der Platzhalter-Schlüssel ist.',
  customPlaceholdersLockedTooltip: 'Dieser Abschnitt kann nicht geschlossen werden, während Platzhalter verwendet werden.',
  customPlaceholdersLockedDescription: 'Dieser Abschnitt kann nicht geschlossen werden, während Platzhalter verwendet werden.',
  missingCustomPlaceholders: 'Du hast diese benutzerdefinierten Platzhalter nicht verwendet: {{placeholders}}',
  customPlaceholdersLocked: 'Benutzerdefinierte Platzhalter gesperrt',
  missingCustomPlaceholdersWarning: 'Du hast diese benutzerdefinierten Platzhalter nicht in deinem Prompt verwendet: {{placeholders}}',
  missingPlaceholdersWarningPrefix: 'Die folgenden Platzhalter fehlen:',
  missingCustomPlaceholdersWarningPrefix: 'Du hast diese benutzerdefinierten Platzhalter nicht verwendet:',
  placeholderCopied: 'Platzhalter kopiert',
  saveToGlobalStore: 'In Store hinzufügen',
  saveToGlobalStoreDescription: 'Speichere den aktuellen Prompt in den globalen Store. Dies erlaubt es dir, den gleichen Prompt in anderen Kampagnen zu verwenden.',
  saveToGlobalStoreConfirmation: 'Bist Du sicher, dass Du den aktuellen Prompt in den globalen Store speichern möchtest? Dies erlaubt es dir, den gleichen Prompt in anderen Kampagnen zu verwenden.',
  saveToGlobalStoreConfirmationDescription: 'Dies erlaubt es dir, den gleichen Prompt in anderen Kampagnen zu verwenden.',
  saveToGlobalStoreConfirmationButton: 'Speichern',
  saveToGlobalStoreConfirmationCancel: 'Abbrechen',
  noValidLicense: 'Du hast keine Rechte für dieses Produkt.',
  stopProcessing: 'Wird angehalten...',
  contactSearch: 'Kontakt suchen',
  pipelineView: 'Pipeline-Ansicht',
  contactSearchPlaceholder: 'Gib hier eine Liste von Kontakten ein...',
  contactSearchButton: 'Kontakte suchen',
  contactSearchResult: 'Kontakt-Suche-Ergebnis',
  contactSearchResultDescription: 'Das Ergebnis der Kontakt-Suche.',
  contactSearchResultPlaceholder: 'Gib hier eine Liste von Kontakten ein...',
  answered: 'Geantwortet',
  bookedMeeting: 'Termin gebucht',
  qualifiedBant: 'Qualifiziert (BANT)',
  customer: 'Kunde',
  lost: 'Verloren',
  interviewStage: 'Interview-Phase',
  interviewStageInt: 'Interview-Phase (intern)',
  cvToClient: 'CV an Kunden',
  clientInterview: 'Kundeninterview',
  hired: 'Eingestellt',
  stageCounts: 'Anzahl pro Stufe',
  conversionPercent: 'Conversion in %',
  avgDuration: 'Ø Dauer',
  avgStep: 'Ø Schritt',
  velocity: 'Geschwindigkeit',
  pipelineKpis: 'Pipeline-KPIs',
  pipeline: 'Pipeline',
  searchContacts: 'Kontakt suchen',
  pipelineContactsCount_one: '{{count}} Kontakt',
  pipelineContactsCount_other: '{{count}} Kontakte',
  pipelineContactsInPipeline: 'Kontakte in der Pipeline',
  pipelineAcrossStages_one: 'über {{count}} Stufe',
  pipelineAcrossStages_other: 'über {{count}} Stufen',
  pipelineLostRate: 'Verloren-Quote',
  pipelineLostOfTotal: '{{lost}} von {{total}}',
  pipelineAnswerToClose: 'Antwort bis Abschluss',
  pipelineAvgPerStage: 'Ø pro Stufe',
  pipelineAcrossAllTransitions: 'über alle Übergänge',
  pipelineConversionsAndDurations: 'Konversionen & Dauern',
  pipelineShowDetails: 'Details anzeigen',
  pipelineHideDetails: 'Details ausblenden',
  pipelineNoKpiData: 'Keine Daten für die gewählten Filter.',
  pipelineInternal: 'Intern',
  pipelineExternal: 'Extern',
  deleteTenant: 'Mandant löschen',
  deleteTenantWarning1: 'Soll der Mandant <strong>{{tenantName}}</strong> wirklich gelöscht werden?',
  deleteTenantWarning2: 'Dieser Vorgang kann nicht rückgängig gemacht werden. Der Mandant wird unwiederruflich gelöscht.',
  createTenant: 'Mandant erstellen',
  editTenant: 'Mandant bearbeiten',
  enterTenantNameHere: 'Gib hier den Namen des Mandanten ein...',
  enterStreetHere: 'Gib hier die Straße ein...',
  enterPostalCodeHere: 'Gib hier die Postleitzahl...',
  enterCityHere: 'Gib hier die Stadt ein...',
  postalCode: 'Postleitzahl',
  adminLogin: 'Als Admin anmelden',
  adminReloginTitle: 'Mit eigenem Admin-Account anmelden',
  unlockProduct: 'Produkt freischalten',
  adminLoginAs: 'Angemeldet als: {{userEmail}}',
  backToMyAccount: 'Zurück zu meinem Account',
  myProfile: 'Mein Profil',
  myCompany: 'Mein Unternehmen',
  companyApiKeys: 'API-Schluessel',
  companyApiKeysDescription: 'API-Schluessel fuer externe Integrationen und den Log-Zugriff dieses Mandanten erstellen und verwalten.',
  createApiKey: 'API-Schluessel erstellen',
  editApiKey: 'API-Schluessel bearbeiten',
  revokeApiKey: 'API-Schluessel sperren',
  revokeApiKeyWarning: 'Dieser API-Schluessel wird sofort deaktiviert und externe Clients damit funktionieren danach nicht mehr.',
  noApiKeysCreatedYet: 'Es wurden noch keine API-Schluessel erstellt. Lege hier den ersten an.',
  apiKeyNamePlaceholder: 'z. B. Zugriff auf Log-Datenbank',
  apiKeyRateLimit: 'Rate Limit',
  apiKeyCreatedSuccessfully: 'API-Schluessel erfolgreich erstellt',
  apiKeyUpdatedSuccessfully: 'API-Schluessel erfolgreich aktualisiert',
  apiKeyRevokedSuccessfully: 'API-Schluessel erfolgreich gesperrt',
  newApiKeyCreated: 'Neuer API-Schluessel erstellt',
  apiKeyShownOnce: 'Speichere diesen API-Schluessel jetzt. Aus Sicherheitsgruenden wird er nur einmal angezeigt.',
  copyApiKeyNow: 'Kopiere den Schluessel jetzt und speichere ihn sicher.',
  myClients: 'Meine Mandanten',
  myUsers: 'Meine Nutzer',
  myLicenses: 'Meine Lizenzen',
  adminPanel: 'Admin-Panel',
  invitationStatus_pending: 'Einladung ausstehend',
  invitationStatus_expired: 'Einladung abgelaufen',
  invitationStatus_accepted: 'Einladung angenommen',
  invitationStatus_none: 'Keine Einladung',
  resendInvitation: 'Einladung erneut senden',
  resendInvitationShort: 'Erneut senden',
  invitationResentSuccessfully: 'Einladung wurde erneut gesendet',
  userInformationUpdatedSuccessfully: 'Benutzerinformationen erfolgreich aktualisiert',
  passwordUpdatedSuccessfully: 'Passwort erfolgreich aktualisiert',
  companyInformationUpdatedSuccessfully: 'Unternehmensinformationen erfolgreich aktualisiert',
  uiLanguage: 'UI-Sprache',
  searchBy: 'Suchen nach:',
  enterSearchTermHere: 'Gib hier den Suchbegriff ein...',
  searchTermsAre: 'Suchbegriffe sind:\n{{searchTerms}}',
  client: 'Mandant',
  linkedInAccount: 'LinkedIn-Account',
  addClient: 'Mandant hinzufügen',
  noUsersFound: 'Keine Nutzer gefunden',
  noTenantsFound: 'Keine Mandanten gefunden',
  userManagement: 'Benutzerverwaltung',
  tenantManagement: 'Mandantenverwaltung',
  enterUserNameOrEmailHere: 'Gib hier den Namen oder die E-Mail des Nutzers ein...',
  cancelSubscription: 'Abonnement kündigen',
  viewInvoices: 'Rechnungen ansehen',
  manageUsers: 'Nutzer verwalten',
  scopes: 'Berechtigungen',
  revoke: 'Sperren',
  lastUsed: 'Zuletzt verwendet',
  minute: 'Minute',
  copiedToClipboard: 'In die Zwischenablage kopiert!',
  linkedinAccounts: 'LinkedIn-Accounts',
  linkedinAccountOverview: 'LinkedIn-Account Übersicht',
  linkedinAccountOverviewSubtitle: 'Die folgenden LinkedIn-Accounts sind mit deiner Lizenz verknüpft:',
  researchAgent: 'Lead-Liste Recherche-Agent',
  invoiceLoadingError: 'Fehler beim Laden der Rechnungen',
  cancelSubscriptionWarning1: 'Bist Du sicher, dass Du dein Abonnement kündigen möchtest?',
  cancelSubscriptionWarning2: 'Wenn du fortfährst, wird dein Abonnement am Ende des aktuellen Abrechnungszeitraums gekündigt.',
  cancelSubscriptionWarning3: 'Gekündigte Lizenzen können nicht reaktiviert werden. Du musst eine neue Lizenz kaufen, wenn du das Produkt wieder nutzen möchtest.',
  cancelSubscriptionSuccess: 'Abonnement erfolgreich gekündigt',
  selectCompanyCountryHere: 'Wähle das Land deines Unternehmens...',
  noLicensesFound: 'Keine Lizenzen gefunden',
  view: 'Ansicht',
  researchQuantity: 'Anzahl der Recherche-Lizenzen (pro Zeitraum)',
  researchCredits: 'Recherche-Credits',
  confirm: 'Bestätigen',
  licensesAddedToUserSuccessfully: 'Lizenzen erfolgreich zu Nutzer hinzugefügt',
  licenseAddedToUsersSuccessfully: 'Lizenz erfolgreich zu Nutzern hinzugefügt',
  licenseDeletedSuccessfully: 'Lizenz erfolgreich gelöscht',
  manageLicenseUsers: 'Lizenzbenutzer verwalten',
  manageLicenseUsersFromStripe: 'Vielen Dank für den Kauf einer Lizenz!',
  manageLicenseUsersFromStripeDescription: 'Füge gleich jetzt die ersten Nutzer zu deiner neuen Lizenz hinzu und starte direkt durch mit dem {{productName}}!',
  manageLicenseUsersSubtitle: 'Verwalte die Lizenzbenutzerzuweisungen für dein Unternehmen',
  manageLicenseUsersTooltip: 'Alle Nutzer deines Unternehmens werden unten angezeigt. Aktiviere die Kontrollkästchen für Nutzer, die Zugriff auf diese Lizenz haben sollen. Deaktiviere die Kontrollkästchen für Nutzer, die keinen Zugriff auf diese Lizenz haben sollen. Nutzer mit unveränderten Kontrollkästchen behalten ihren aktuellen Zugriffsstatus.',
  searchForAUser: 'Suche nach einem Nutzer...',
  userDeletedSuccessfully: 'Nutzer erfolgreich gelöscht',
  userCreatedSuccessfully: 'Nutzer erfolgreich erstellt',
  userUpdatedSuccessfully: 'Nutzerinformationen erfolgreich aktualisiert',
  tenantDeletedSuccessfully: 'Mandant erfolgreich gelöscht',
  tenantCreatedSuccessfully: 'Mandant erfolgreich erstellt',
  tenantUpdatedSuccessfully: 'Mandantinformationen erfolgreich aktualisiert',
  licensesUpdatedForUserSuccessfully: 'Lizenzen erfolgreich für Nutzer aktualisiert',
  manageUserLicensesDialogTitle: 'Lizenzen verwalten',
  manageUserLicensesDialogContent: 'Wähle die Lizenzen, die dem Nutzer zugewiesen werden sollen.',
  invoice: 'Rechnung',
  amountOf: 'Betrag',
  showInvoice: 'Rechnung anzeigen',
  sorting: 'Sortierung',
  newestFirst: 'Neueste zuerst',
  oldestFirst: 'Älteste zuerst',
  nameAscending: 'Name aufsteigend',
  nameDescending: 'Name absteigend',
  noNumberWarningDialogTitle: 'Ungültige Eingabe',
  noNumberWarningDialogContent: 'Bitte gib eine gültige Zahl ein.',
  whatIsWrong: 'Was stimmt nicht?',
  targetJobTitles: 'Zielberufe',
  targetJobTitlesHelper: 'Komma getrennt – z.B. CTO, VP Engineering',
  enterJobTitle: 'Gib einen Beruf ein und drücke Enter',
  rememberLinkedinAccount: 'LinkedIn-Accounts merken',
  emailSenders: 'E-Mail-Senders',
  manageEmailSenders: 'E-Mail-Senders verwalten',
  alias: 'Alias / Adresse',
  type: 'Typ',
  quota: 'Tageslimit',
  noEntries: 'Noch keine Einträge',
  provider: 'Provider',
  credentials: 'Anmeldeinformationen',
  summary: 'Zusammenfassung',
  chooseProvider: 'Provider auswählen',
  addSender: 'Sender hinzufügen',
  editSender: 'Sender bearbeiten',
  providerGmail: 'Gmail (OAuth)',
  providerMicrosoft365: 'Microsoft 365 (OAuth)',
  providerSmtpImap: 'SMTP / IMAP',
  providerHint: 'Wähle den Sendemethode, mit der du deine E-Mails versenden möchtest.',
  gmailInstructions: 'Um eine Gmail-Inbox zu verbinden, gib die E-Mail-Adresse ein, klicke auf „Gmail autorisieren“ und erteile die Berechtigung. Füge dann den Code ein, der von Google angezeigt wird.',
  microsoftInstructions: 'Um eine Microsoft 365-Inbox zu verbinden, gib die E-Mail-Adresse ein, klicke auf „Microsoft autorisieren“ und erteile die Berechtigung. Füge dann den Autorisierungscode ein.',
  smtpInstructions: 'Für eine klassische SMTP / IMAP-Mailbox gib die Serverdetails und Anmeldeinformationen unten ein. Wir empfehlen die Verschlüsselung SSL/TLS.',
  politeSpeechQuestion: 'Höfliche Sprache?',
  checkIsPolite: 'Höfliche Sprache',
  aiResearchAgentTitle: 'AI Research Agent',
  aiResearchAgentDescription: 'Bereichere deine Kontakte kostenlos mit KI-gestützter Webrecherche.',
  enrichViaAIResearchAgent: 'Über AI Research Agent anreichern',
  aiResearchEnrichmentInitiatedSuccessfully: 'AI-Research-Anreicherung wurde erfolgreich gestartet.',
  aiResearchEnrichmentFailed: 'AI-Research-Anreicherung fehlgeschlagen.',
  customFieldEnrichmentInitiatedSuccessfully: 'Custom-Field-Anreicherung wurde erfolgreich gestartet.',
  customFieldEnrichmentFailed: 'Custom-Field-Anreicherung fehlgeschlagen.',
  addNewSearch: 'Neue Suche hinzufügen',
  stopRunningCampaignDialogTitle: 'Kampagne anhalten',
  stopRunningCampaignDialogContent1: 'Laufende Kampagnen können nicht bearbeitet werden.',
  stopRunningCampaignDialogContent2: 'Um die Kampagne bearbeiten zu können, musst Du sie vorher anhalten.',
  stopRunningCampaignDialogContent3: 'Denke daran, die Kampagne nach dem Bearbeiten wieder zu starten.',
  stopAndEditCampaign: 'Kampagne anhalten & bearbeiten',
  reloadSearch: 'Fehlende nachladen',
  reloadSearchTooltip:
    'Der erste Suchlauf ist vollständig durchgelaufen — es wurden alle Treffer abgerufen, die LinkedIn zu dieser Suche hatte. Ein erneuter Lauf startet nichts von vorn: Bereits übernommene Kontakte werden erkannt und übersprungen, hinzu kommen nur Profile, die beim ersten Mal nicht übernommen werden konnten.',
  retryStuckSearch: 'Erneut starten',
  retryStuckSearchTooltip:
    'Der Ladevorgang wurde unterbrochen. Starte die Suche erneut — bereits übernommene Kontakte werden erkannt und nicht doppelt angelegt.',
  loadMoreTooltip: 'Hinweis: Kontakte werden bei Bedarf automatisch im Hintergrund geladen. Lade nur mehr Kontakte manuell, wenn Du sie sofort benötigst.',
  verification: 'Verifizierung',
  orUploadCsv: 'oder CSV hochladen',
  csvLoaded: '{{count}} Zeilen aus CSV geladen',
  clickNextToImport: 'Klicken Sie auf „Weiter“, um die Sender zu importieren.',
  importResult: 'Import-Ergebnis: {{success}} erfolgreich, {{failed}} fehlgeschlagen',
  senderVerified: 'Absender erfolgreich verifiziert.',
  verificationFailed: 'Verifizierung fehlgeschlagen.',
  poorInboxHint: 'Die Posteingangsqualität ist schlecht; bitte prüfen Sie die Probleme.',
  senderVerifiedSuccessfully: 'Absender erfolgreich verifiziert.',
  csvLoadedSelected: '{{selected}} / {{count}} Zeilen ausgewählt',
  selectRowsHint: 'Wähle per Checkbox, welche Postfächer importiert werden sollen.',
  tablePreviewHint: 'Es werden die ersten {{shown}} von {{total}} Zeilen angezeigt',
  mapCsvColumns: 'CSV-Spalten zuordnen',
  completeMappingHint: 'Ordnen Sie alle benötigten Felder zu, um fortzufahren.',
  secondaryLanguage: 'Sekundäre Sprache (optional)',
  secondaryLanguageDescription:
    'Wenn leer, werden alle Nachrichten in der primären Sprache versendet. Wird hier eine Sprache gewählt, erhalten Kontakte, deren Profil­sprache nicht der primären entspricht, Nachrichten in dieser Fallback-Sprache.',
  secondaryLanguageMustDiffer: 'Primäre und sekundäre Sprache müssen unterschiedlich sein',
  wrongAccountWarningDialogTitle: 'Der ausgewählte Account existiert nicht!',
  wrongAccountWarningDialogContent1: 'Der Account mit der E-Mail-Adresse <1>{{email}}</1> existiert nicht.',
  wrongAccountWarningDialogContent2: 'Bitte stelle sicher, dass du einen Account auswählst, der bei uns registriert ist.',
  aiContactQualification: 'KI-Kontaktqualifizierung',
  finalContactList: 'Finale Kontaktliste',
  contactsInOtherCampaigns: 'Kontakte in anderen Kampagnen',
  startQualificationProcess_ActiveSourcing: 'Starte jetzt die Kandidaten-Qualifizierung',
  startQualificationProcessDescription_ActiveSourcing: 'Wir bewerten die Kandidaten und erstellen eine Shortlist anhand Deiner Kriterien.',
  startQualificationProcess_LeadBooster: 'Starte jetzt die Lead-Qualifizierung',
  startQualificationProcessDescription_LeadBooster: 'Wir bewerten die Leads und erstellen eine Shortlist anhand Deiner Kriterien.',
  aiContactQualification_ActiveSourcing: 'KI-Kandidatenqualifizierung',
  aiContactQualificationDescription_ActiveSourcing: 'Kandidatenkriterien festlegen',
  aiContactQualificationExplanation_ActiveSourcing: 'Sage der KI, welche Kandidaten für Dich besonders relevant sind.',
  aiContactQualification_LeadBooster: 'KI-Leadqualifizierung',
  aiContactQualificationDescription_LeadBooster: 'Leadkriterien festlegen',
  aiContactQualificationExplanation_LeadBooster: 'Sage der KI, welche Leads für Dich besonders relevant sind.',
  enrichContacts_ActiveSourcing: 'Kandidaten anreichern',
  enrichContacts_LeadBooster: 'Leads anreichern',
  blacklistSource: 'Blockiert von',
  unknown: 'Unbekannt',
  uncertainSex: 'Unklares Geschlecht',
  assessedContacts: 'Bewertete Kontakte',
  unassessedContacts: 'Nicht bewertete Kontakte',
  suspendedContacts: 'Suspendierte Kontakte',
  taskAccountDeleted: 'Konto gelöscht',
  deletedContacts: 'Gelöschte Kontakte',
  alreadyContactedContacts: 'Bereits kontaktierte Kontakte',
  isActiveContacts: 'Aktive Kontakte',
  isNotActiveContacts: 'Inaktive Kontakte',
  isFinishedContacts: 'Abgeschlossene Kontakte',
  stopAssessment: 'Qualifizierung abbrechen',
  deleteMultipleContacts: 'Mehrere Kontakte löschen',
  viewContactFunnel: 'Kontaktfunnel ansehen',
  noContactSearchesFound_ActiveSourcing: 'Es konnten keine Kandidaten via LinkedIn Suche gefunden werden. Bitte passe den Suchradius und/oder das Kampagen Briefing an und versuche es erneut.',
  noContactSearchesFound_LeadBooster: 'Es konnten keine Leads via LinkedIn Suche gefunden werden. Bitte passe den Suchradius und/oder das Kampagen Briefing an und versuche es erneut.',
  talentSearchFeedbackTitle: 'Vorschläge zur Suchoptimierung',
  talentSearchFeedbackAccept: 'Übernehmen',
  talentSearchFeedbackAccepted: 'Übernommen',
  talentSearchFeedbackRetry: 'Suche erneut starten',
  talentSearchFeedbackType_change_title: 'Jobtitel',
  talentSearchFeedbackType_broaden_location: 'Standort',
  talentSearchFeedbackType_general: 'Tipp',
  talentSearchViewSuggestions_ActiveSourcing: 'KI-Vorschläge anzeigen',
  talentSearchViewSuggestions_LeadBooster: 'KI-Vorschläge anzeigen',
  deleteSearchSuccessMessage: 'Suche erfolgreich gelöscht',
  searchReloadedSuccessMessage: 'Nachladen der fehlenden Kontakte gestartet',
  searchContinuedSuccessMessage: 'Laden weiterer Kontakte erfolgreich gestartet',
  localBlacklistCreatedSuccessMessage: 'Kampagnen-spezifische Blacklist erfolgreich erstellt',
  blacklistUpdatedSuccessMessage: 'Blacklist erfolgreich aktualisiert',
  blacklistDeletedSuccessMessage: 'Blacklist erfolgreich gelöscht',
  blacklistAddedSuccessMessage: 'Blacklist erfolgreich zu Kampagnen hinzugefügt',
  blacklistRemovedSuccessMessage: 'Blacklist erfolgreich von Kampagnen entfernt',
  contactAddedSuccessMessage: 'Kontakt erfolgreich hinzugefügt',
  contactDeletedSuccessMessage: 'Kontakt erfolgreich gelöscht',
  contactsDeletedSuccessMessage: '{{count}} Kontakt(e) erfolgreich gelöscht',
  contactActivatedSuccessMessage: 'Kontakt zur finalen Kontaktliste hinzugefügt',
  contactDeactivatedSuccessMessage: 'Kontakt aus finaler Kontaktliste entfernt',
  contactsActivatedSuccessMessage: '{{count}} Kontakt(e) zur finalen Kontaktliste hinzugefügt',
  contactsDeactivatedSuccessMessage: '{{count}} Kontakt(e) aus finaler Kontaktliste entfernt',
  aiJudgementUpdatedSuccessMessage: 'KI-Bewertung erfolgreich aktualisiert',
  sexUpdatedSuccessMessage: 'Geschlecht erfolgreich aktualisiert',
  contactRemovedFromBlacklistSuccessMessage: 'Kontakt erfolgreich von Blacklist entfernt',
  contactRemovedFromSuspendedSuccessMessage: 'Kontakt-Suspendierung erfolgreich zurückgesetzt',
  contactRecoveredFromDeletedSuccessMessage: 'Kontakt erfolgreich wiederhergestellt',
  recoverFromDeleted: 'Wiederherstellen',
  addContacts_ActiveSourcing: 'Kandidaten hinzufügen',
  addContacts_LeadBooster: 'Leads hinzufügen',
  contactOverview_ActiveSourcing: 'Kandidaten-Übersicht',
  contactOverview_LeadBooster: 'Lead-Übersicht',
  allContacts_ActiveSourcing: 'Alle Kandidaten',
  allContacts_LeadBooster: 'Alle Leads',
  isActiveContacts_ActiveSourcing: 'Aktive Kandidaten',
  isActiveContacts_LeadBooster: 'Aktive Leads',
  isNotActiveContacts_ActiveSourcing: 'Inaktive Kandidaten',
  isNotActiveContacts_LeadBooster: 'Inaktive Leads',
  isFinishedContacts_ActiveSourcing: 'Abgeschlossene Kandidaten',
  isFinishedContacts_LeadBooster: 'Abgeschlossene Leads',
  alreadyContactedContacts_ActiveSourcing: 'Bereits kontaktierte Kandidaten',
  alreadyContactedContacts_LeadBooster: 'Bereits kontaktierte Leads',
  uncertainSexContacts_ActiveSourcing: 'Unklares Geschlecht',
  uncertainSexContacts_LeadBooster: 'Unklares Geschlecht',
  blacklistedContacts_ActiveSourcing: 'Blockierte Kandidaten',
  blacklistedContacts_LeadBooster: 'Blockierte Leads',
  suspendedContacts_ActiveSourcing: 'Suspendierte Kandidaten',
  suspendedContacts_LeadBooster: 'Suspendierte Leads',
  deletedContacts_ActiveSourcing: 'Gelöschte Kandidaten',
  deletedContacts_LeadBooster: 'Gelöschte Leads',
  contactsInOtherCampaigns_ActiveSourcing: 'Kandidaten anderer Kampagnen',
  contactsInOtherCampaigns_LeadBooster: 'Leads anderer Kampagnen',
  finalContactList_ActiveSourcing: 'Finale Kandidatenliste',
  finalContactList_LeadBooster: 'Finale Leadliste',
  deleteMultipleContacts_ActiveSourcing: 'Mehrere Kandidaten löschen',
  deleteMultipleContacts_LeadBooster: 'Mehrere Leads löschen',
  viewContactFunnel_ActiveSourcing: 'Kandidatenfunnel ansehen',
  viewContactFunnel_LeadBooster: 'Leadfunnel ansehen',
  singleContact: 'Einzelkontakt',
  multipleContacts: 'Mehrere Kontakte',
  contactFunnelOverview: 'Kontaktfunnel Übersicht',
  generatingSankeyDiagram: 'Generiere Sankey-Diagramm...',
  manuallyAdded: 'Manuell hinzugefügt',
  crawlable: 'In LinkedIn Suche gefunden',
  crawled: 'Aus Suche hinzugefügt',
  outOfNetwork: 'Außerhalb des Netzwerks',
  notCrawled: 'Nicht hinzugefügt',
  crawlingBuffer: 'Wird später hinzugefügt',
  crawledTwice: 'Duplikat (in mehreren Suchen gefunden)',
  otherNotCrawled: 'Aus anderen Gründen nicht hinzugefügt\n(In mehreren Suchen gefunden, Out-of-Network, etc.)',
  profileVisited: 'Profil besucht & geladen',
  profileNotVisited: 'Profil nicht besucht',
  needAction: 'Erfordert Aktion',
  a: 'A',
  b: 'B',
  c: 'C',
  notJudgedYet: 'Keine KI-Bewertung',
  judgedIn: 'Als passend\nbewertet',
  judgedOut: 'Als unpassend\nbewertet',
  final: 'Final',
  contactedElsewhere: 'Anderswo kontaktiert',
  // getLocalizedText greift immer zuerst die Produktvariante ab; fehlt sie, zeigt i18next
  // den Schlüsselnamen an — beide Varianten sind also Pflicht, nicht Kür.
  contactedElsewhere_ActiveSourcing: 'Anderswo angeschrieben',
  contactedElsewhere_LeadBooster: 'Anderswo angeschrieben',
  contactedElsewhereInCampaign: 'Bereits in der Kampagne „{{campaign}}“ angeschrieben',
  deleted: 'Gelöscht',
  blacklisted: 'Blockiert (Blacklist)',
  aiJudgingError: 'KI-Bewertungsfehler',
  useableContacts: 'Nutzbare Kontakte',
  inCampaign: 'In der Kampagne',
  inFinalList: 'In der finalen Liste',
  contactPipeline_ActiveSourcing: 'Kandidaten-Pipeline',
  contactPipeline_LeadBooster: 'Lead-Pipeline',
  fromDate: 'Von',
  toDate: 'Bis',
  overallCampaignRuntime: 'Gesamte Kampagnenlaufzeit',
  searchName: 'Name der Suche/Quelle',
  newestLicenseFirst: 'Neueste Lizenz zuerst',
  oldestLicenseFirst: 'Älteste Lizenz zuerst',
  statusMessages: 'Status-Nachrichten',
  addNewMessage: 'Neue Nachricht hinzufügen',
  editMessage: 'Nachricht bearbeiten',
  englishText: 'Englische Nachricht',
  germanText: 'Deutsche Nachricht',
  updatedAt: 'Aktualisiert am',
  noStatusMessagesFound: 'Keine Status-Nachrichten gefunden',
  enterEnglishTextHere: 'Gib hier die englische Nachricht ein...',
  enterGermanTextHere: 'Gib hier die deutsche Nachricht ein...',
  englishTextRequired: 'Die englische Nachricht ist erforderlich',
  germanTextRequired: 'Die deutsche Nachricht ist erforderlich',
  deleteStatusMessageDialogTitle: 'Status-Nachricht löschen',
  deleteStatusMessageDialogContent1: 'Bist Du sicher, dass Du diese Status-Nachricht löschen möchtest?',
  deleteStatusMessageDialogContent2: 'Dieser Vorgang kann nicht rückgängig gemacht werden.',
  manageSubscriptionAndInvoices: 'Abonnement & Rechnungen verwalten',
  askForSyncDialogTitle: 'LinkedIn-Account einloggen',
  askForSyncDialogContent1: 'Wir haben festgestellt, dass dein LinkedIn-Account <1>{{userEmail}}</1> aktuell nicht eingeloggt ist.',
  askForSyncDialogContent2: 'Zum Bearbeiten der Kampagne solltest du dich mit deinem LinkedIn-Account einloggen. Zum reinen Anschauen ist kein Login nötig.',
  stayLoggedOut: 'Nur anschauen',
  loginNow: 'Jetzt einloggen',
  dontQualify: 'Weiter ohne Qualifizierung',
  addContactSearch_ActiveSourcing: 'Kandidaten-Suche hinzufügen',
  addContactSearch_LeadBooster: 'Lead-Suche hinzufügen',
  editLinkedinAccountLimits: 'LinkedIn-Account-Limits bearbeiten',
  editLinkedinAccountLimitsDescription: 'Bearbeiten Sie die Limits und den Arbeitsplan für Ihren LinkedIn-Account.',
  editLinkedinAccountLimitsWorkDays: 'Arbeitstage',
  editLinkedinAccountLimitsWorkHours: 'Arbeitszeiten',
  editLinkedinAccountLimitsTimeZone: 'Zeitzone',
  editLinkedinAccountLimitsMessageDailyLimit: 'Tagesnachrichtenlimit',
  editLinkedinAccountLimitsVisitDailyLimit: 'Tagesprofilbesuchelimit',
  editLinkedinAccountLimitsCooldownAfterMessages: 'Pause nach Nachrichten (sec)',
  editLimitsAndSchedule: 'Limits & Arbeitsplan bearbeiten',
  editAccountLimitsTitle: 'Account-Limits & Arbeitszeit',
  dailyActivityLimits: 'Tagesaktivitätslimits',
  dailyVisitLimit: 'Tagesprofilbesuchelimit',
  cooldownAfterMessages: 'Pause nach Nachrichten (sec)',
  cooldownAfterVisits: 'Pause nach Besuchen (sec)',
  profileVisits: 'Profilbesuche',
  editQuotaSplit: 'Tageslimit-Verteilung bearbeiten',
  quotaSplit: 'Tageslimit-Verteilung (optional)',
  weight: 'Gewicht',
  percentage: 'Prozent',
  visits: 'Besuche',
  connections: 'Verbindungen',
  linkedinAccountSettings: 'LinkedIn-Account-Einstellungen',
  day: 'Tag',
  defineQuotaSplitDescription: 'Dieses Feature richtet sich an erfahrene Nutzer: Hier kannst du dein Tageslimit gezielt auf verschiedene Kampagnen verteilen. Passe die Gewichtung nur an, wenn du dir sicher bist, wie sich das auf deine Kampagnen auswirkt.',
  currentSettings: 'Aktuelle Einstellungen',
  current: 'Aktuell',
  changesAreSavedAutomatically: 'Änderungen werden automatisch gespeichert',
  editLimitsAndAccountWorkingTime: 'Limits & Account-Arbeitszeit bearbeiten',
  selectLinkedinAccountToViewSettings: 'Wähle einen LinkedIn-Account, um die Einstellungen zu sehen',
  campaignWorkUnitsStatus: 'Kampagnen-Work Units Status',
  globalWorkUnitsStatus: 'Globale Work Units Status',
  systemStatus: 'Systemstatus',
  currentlyProcessing: 'Wird gerade verarbeitet',
  upNext: 'Wird als nächstes verarbeitet',
  recentFailures: 'Letzte Fehler',
  systemLoad: 'Systemlast',
  noWorkUnitsInQueue: 'Keine Work Units in der Warteschlange',
  runningFor: 'Läuft seit',
  workUnitsStatus: 'Work Units Status',
  lastUpdated: 'Zuletzt aktualisiert',
  unknownCampaign: 'Unbekannte Kampagne',
  startsIn: 'Startet in',
  workingUnits: 'Arbeitende Work Units',
  pendingUnits: 'Wartende Work Units',
  currentStep: 'Aktueller Schritt',
  selectedStep: 'Ausgewählter Schritt',
  allChangesSaved: 'alle Änderungen gespeichert',
  working: 'Arbeitet',
  noWorkUnitsProcessing: 'Keine Work Units werden gerade verarbeitet',
  workUnitSend: 'Senden',
  workUnitAnalyze: 'Analysieren',
  workUnitSearch: 'Suche',
  workUnitWrite: 'Schreiben',
  workUnitWait: 'Warten',
  workUnitJudge: 'Bewerten',
  workUnitCheckIfConnected: 'Verbindung prüfen',
  workUnitCheckIfConnectedUntil: 'Verbindung prüfen bis',
  workUnitWithdraw: 'Zurückziehen',
  workUnitCheckInbox: 'Posteingang prüfen',
  workUnitCheckConnection: 'Verbindung prüfen',
  workUnitReply: 'Antworten',
  workUnitAiSearch: 'KI-Suche',
  adjustWeights: 'Gewichtung anpassen',
  hideWeights: 'Gewichtung ausblenden',
  loadingWorkUnitsStatus: 'Lade Work Units Status...',
  stop: 'Anhalten',
  runningCampaigns: 'Laufende Kampagnen',
  namesNotFoundWarning: 'Name nicht gefunden. Bitte setze den Namen manuell unter "Nutzername bearbeiten".',
  resetTokenExpired: 'Reset Token abgelaufen',
  resetTokenExpiredParagraph: 'Das Token zum Zurücksetzen des Passworts ist abgelaufen. Bitte fordere eine neue E-Mail an und setze das Passwort innerhalb von 12 Stunden nach Erhalt der E-Mail zurück.',
  requestNewEmail: 'Neue E-Mail anfordern',
  invalidRequestUserIdOrResetTokenMissing: 'Benutzer-ID oder Reset-Token fehlt',
  tokenAlreadyUsedDialogTitle: 'Token bereits verwendet',
  tokenAlreadyUsedDialogContent1: 'Das Token zum Zurücksetzen des Passworts wurde bereits verwendet.',
  tokenAlreadyUsedDialogContent2: 'Bitte fordere eine neue E-Mail an und setze das Passwort innerhalb von 12 Stunden nach Erhalt der E-Mail zurück.',
  analysisInProgressDialogTitle: 'Analyse bereits gestartet',
  analysisInProgressDialogContent1: 'Die Profilanalyse für diese Kampagne läuft bereits im Hintergrund. Die Kontakte werden analysiert oder starten in Kürze.',
  analysisInProgressDialogContent2: 'Du musst nichts weiter tun — ein erneutes Starten ist nicht nötig.',
  jobSearchUrlRequired: 'URL einer Jobsuche (erforderlich)',
  targetJobTitlesRequired: 'Zielberufe (erforderlich)',
  pasteLinkedinJobsPageUrl: 'Kopiere die vollständige URL von der LinkedIn Jobs-Seite',
  enterJobTitlePlaceholder: 'Gib hier die Berufsbezeichnung ein und drücke Enter oder klicke auf den Hinzufügen-Button...',
  noJobTitlesAddedYetAddATitleAboveToGetStarted: 'Noch keine Berufsbezeichnungen hinzugefügt. Füge oben eine Berufsbezeichnung hinzu, um zu beginnen.',
  targetJobTitlesCount: 'Zielberufe ({{count}})',
  enableJudgingForThisCampaign: 'KI-Bewertung für diese Kampagne aktivieren',
  enableJudgingForThisCampaignDescription: 'Wenn aktiviert, werden die Profile automatisch bewertet. Fülle die Kriterien unten für eine benutzerdefinierte Bewertung oder lass sie leer für eine KI-basierte Bewertung.',

  // ============================================
  // AI CHAT ASSISTANT
  // ============================================

  // Allgemein
  aiAssistant: 'KI-Assistent',
  aiChatTitle: 'SAIA',
  aiChatSubtitle: 'Dein intelligenter Kampagnen-Helfer',

  // Willkommensbildschirm
  aiChatWelcome: 'Hallo! Wie kann ich dir heute helfen?',
  aiChatWelcomeSubtitle: 'Ich kann dir helfen, Kampagnen zu erstellen, Accounts zu verwalten und Performance zu analysieren.',

  // Schnellaktionen
  aiChatAddAccount: 'LinkedIn Account hinzufügen',
  aiChatCreateCampaign: 'Kampagne erstellen',
  aiChatViewStats: 'Statistiken anzeigen',
  aiChatGetHelp: 'Hilfe erhalten',
  aiChatTutorial: 'Erste Schritte Tutorial',
  aiChatMyCampaigns: 'Meine Kampagnen',

  // Eingabe
  aiChatInputPlaceholder: 'Nachricht eingeben...',
  aiChatSend: 'Senden',
  aiChatTyping: 'SAIA schreibt...',

  // Chat-Panel
  aiChatMinimize: 'Minimieren',
  aiChatMaximize: 'Maximieren',
  aiChatClose: 'Schließen',
  aiChatClearHistory: 'Unterhaltung löschen',
  aiChatClearHistoryConfirm: 'Bist du sicher, dass du den Gesprächsverlauf löschen möchtest?',

  // Modus-Umschalter
  chatMode: 'Chat',
  aiChatExpertMode: 'Experte',
  campaignMode: 'Kampagnenmodus',
  chatModeDescription: 'KI-geführte Kampagnenerstellung mit Schritt-für-Schritt-Anleitung',
  expertModeDescription: 'Volle manuelle Kontrolle über Kampagneneinstellungen',
  simplifiedMode: 'Vereinfachter Modus',

  // Karten
  aiChatConfirm: 'Bestätigen',
  aiChatCancel: 'Abbrechen',
  aiChatEdit: 'Bearbeiten',
  aiChatSubmit: 'Absenden',
  aiChatAutoFix: 'Auto-Fix',

  // Assistent
  campaignWizard: 'Kampagnen-Assistent',
  stepsCompleted: 'Schritte abgeschlossen',
  wizardStep: 'Schritt',
  confirmAndContinue: 'Bestätigen & Weiter',
  makeChanges: 'Änderungen vornehmen',
  wizardBack: 'Zurück',

  // Assistenten-Schritte
  type_selection: 'Kampagnentyp',
  type_selection_desc: 'Wähle zwischen Recruiting- oder Sales-Kampagne',
  name_account: 'Name & Account',
  name_account_desc: 'Kampagnenname festlegen und LinkedIn Account auswählen',
  briefing: 'Briefing',
  briefing_desc: 'Beschreibe dein Jobangebot/Produkt und die Zielgruppe',
  targeting: 'Zielgruppe',
  targeting_desc: 'Definiere, wen du erreichen möchtest',
  wizardContacts: 'Kontaktquelle',
  contacts_desc: 'Wähle, wie Kontakte zur Kampagne hinzugefügt werden',
  wizardMessages: 'Nachrichten',
  messages_desc: 'Erstelle personalisierte Nachrichtenvorlagen',
  flow: 'Kampagnenablauf',
  flow_desc: 'Gestalte deine Outreach-Sequenz',
  wizardSettings: 'Einstellungen',
  settings_desc: 'Konfiguriere Arbeitszeiten und Limits',
  review: 'Überprüfung',
  review_desc: 'Überprüfe alle Kampagneneinstellungen',
  validation: 'Qualitätsprüfung',
  validation_desc: 'KI validiert deine Kampagne vor dem Start',
  wizardComplete: 'Abgeschlossen',
  complete_desc: 'Kampagne ist startbereit',

  // Validierung
  qualityScore: 'Qualitätswert',
  readyToLaunch: 'Startbereit',
  issuesFound: 'Probleme gefunden',
  mustFix: 'Muss behoben werden',
  wizardRecommended: 'Empfohlen',
  wizardOptional: 'Optionale Verbesserungen',
  validationErrors: 'Fehler',
  validationWarnings: 'Warnungen',
  validationSuggestions: 'Vorschläge',
  revalidate: 'Erneut prüfen',
  launchCampaign: 'Kampagne starten',
  checkedAt: 'Geprüft um',

  // Validierungskategorien
  messageQuality: 'Nachrichtenqualität',
  targetingQuality: 'Targeting-Qualität',
  sequenceLogic: 'Sequenzlogik',
  accountReadiness: 'Account-Bereitschaft',
  validationCompliance: 'Compliance',
  bestPractices: 'Best Practices',

  // Account-Karten
  cardAccountStatus: 'Account-Status',
  lastSynced: 'Zuletzt synchronisiert',
  syncNow: 'Jetzt synchronisieren',
  updateCookie: 'Cookie aktualisieren',

  // Kampagnen-Karten
  cardCampaignSummary: 'Kampagnenübersicht',
  cardCampaignStatus: 'Status',
  cardCampaignType: 'Typ',
  contactsInCampaign: 'Kontakte',
  viewDetails: 'Details anzeigen',
  cardEditCampaign: 'Kampagne bearbeiten',

  // Fehlerzustände
  aiChatError: 'Etwas ist schiefgelaufen',
  aiChatRetry: 'Erneut versuchen',
  aiChatNoConnection: 'Verbindung zum KI-Assistenten nicht möglich',

  // Ladezustände
  aiChatLoading: 'Laden...',
  aiChatProcessing: 'Deine Anfrage wird verarbeitet...',
  aiChatAnalyzing: 'Analysiere...',
  chatCurrentAction: 'Was der Chat gerade macht',
  chatUnderstood: 'Was der Chat verstanden hat',
  chatMissingDetails: 'Fehlende Details',
  qualityCheck: 'Qualitätsprüfung',
  qualityStatus: 'Erfolgreich',
  chatErrors: 'Fehler',
  chatInfo: 'Info',
  status: 'Status',
  chatLiveStatusNow: 'Was der Chat gerade jetzt macht',
  chatLiveStatusPreparing: 'Antwort wird vorbereitet',
  chatLiveStatusPreparingDetail: 'Ich sammle Kontext und bereite den nächsten Schritt vor.',
  chatLiveStatusTooling: 'Prüfungen laufen',
  chatLiveStatusToolingDetail: 'Ich validiere Daten und führe die passenden Aktionen aus.',
  chatLiveStatusReasoning: 'Antwort wird strukturiert',
  chatLiveStatusReasoningDetail: 'Ich ordne deine Anfrage für die bestmögliche Antwort ein.',
  chatLiveStatusResponding: 'Antwort wird gestreamt',
  chatLiveStatusRespondingDetail: 'Ich finalisiere die Antwort und prüfe die Qualität.',

  // Live-Denkprozess (ThinkingTimeline)
  saiaWorking: 'SAIA arbeitet daran...',
  workStepUnderstanding: 'Nachricht verstehen',
  workStepAnswering: 'Antwort formulieren',
  workStepSeconds: '{{count}} s',
  workStepsEarlier: '+ {{count}} frühere Schritte',
  workStepFailed: 'fehlgeschlagen, ich korrigiere',
  saiaWorkedSteps: 'Ausgeführte Schritte',
  thinkingPlanning: 'Überlege den nächsten Schritt...',
  thinkingObserving: 'Prüfe das Ergebnis...',
  thinkingDeciding: 'Wähle das weitere Vorgehen...',
  thinkingStepFailed: 'Ein Zwischenschritt schlug fehl – ich korrigiere das',
  chatShowSteps: 'Schritte anzeigen',
  chatHideSteps: 'Schritte ausblenden',

  // Vorschlags-Chips (Proposal-Aktionen)
  proposalAccept: 'Übernehmen',
  proposalModify: 'Anpassen',
  proposalTest: 'Testen',
  proposalContinue: 'Weiter',

  // Login-Challenge-Karten (2FA / Captcha)
  twoFaChallenge: '2FA-Verifizierung',
  captchaChallenge: 'Captcha-Aufgabe',
  securityChallenge: 'Sicherheitsprüfung',
  challengeClickHint: 'Klicke direkt auf die Stelle im Bild, die die Aufgabe verlangt.',
  challengeScreenshotUnavailable: 'Screenshot noch nicht verfügbar. Versuche es gleich noch einmal.',
  challengeClickSent: 'Klick übermittelt',
  refreshScreenshot: 'Aktualisieren',
  twoFaRequired: 'Zwei-Faktor-Bestätigung erforderlich',
  twoFaHint: 'LinkedIn hat einen Bestätigungscode gesendet. Gib ihn unten ein oder bestätige die Push-Benachrichtigung in deiner LinkedIn-App.',
  twoFaHintWithEmail: 'LinkedIn hat einen Bestätigungscode für {{email}} gesendet. Gib ihn unten ein oder bestätige die Push-Benachrichtigung in deiner LinkedIn-App.',
  twoFaCodePlaceholder: 'z. B. 123456',
  submitCode: 'Code senden',
  twoFaApprovedInApp: 'Ich habe es in der LinkedIn-App bestätigt',
  twoFaSubmitted: 'Übermittelt – Verifizierung läuft...',
  contractChoiceTitle: 'LinkedIn-Vertrag wählen',
  contractChoiceHint: 'Für {{email}} gibt es mehrere LinkedIn-Verträge. Wähle aus, mit welchem sich SAIA anmelden soll – der Login wartet so lange.',
  contractChoiceHintNoEmail: 'Für dieses Konto gibt es mehrere LinkedIn-Verträge. Wähle aus, mit welchem sich SAIA anmelden soll – der Login wartet so lange.',
  contractChoiceNoneListed: 'Die Verträge werden gerade noch vom Gerät gelesen. Frag mich gleich nach dem Status, dann erscheinen sie hier.',
  contractChoiceSubmitted: 'Vertrag „{{contract}}“ gewählt – der Login geht weiter...',

  // Karten-Inhalte (noContactsFound existiert bereits weiter oben)
  noStatisticsData: 'Keine Statistikdaten verfügbar',
  unknownContact: 'Unbekannter Kontakt',
  andMoreContacts: '+ {{count}} weitere',

  // Leere Zustände
  aiChatNoMessages: 'Noch keine Nachrichten',
  aiChatStartConversation: 'Starte eine Unterhaltung, indem du unten eine Nachricht eingibst',

  // Public Chat Dashboard
  'publicChat.login': 'Anmelden',
  'publicChat.signup': 'Kostenlos registrieren',
  'publicChat.welcomeTitle': 'Willkommen beim SAIA',
  'publicChat.welcomeSubtitle': 'Ich bin dein vertraulicher KI-Agent für LinkedIn-Automatisierung. Frag mich alles darüber, wie der SAIA dir helfen kann, mehr Menschen schneller zu erreichen — mit höchster Diskretion.',
  'publicChat.inputPlaceholder': 'Frag mich alles über den SAIA...',
  'publicChat.signupTitle': 'Erstelle dein Konto',
  'publicChat.signupSubtitle': 'Starte deine kostenlose 14-Tage-Testversion',
  'publicChat.firstName': 'Vorname',
  'publicChat.lastName': 'Nachname',
  'publicChat.email': 'E-Mail',
  'publicChat.password': 'Passwort',
  'publicChat.passwordRepeat': 'Passwort wiederholen',
  'publicChat.passwordHint': 'Mindestens {{count}} Zeichen.',
  'publicChat.passwordRepeatHint': 'Zur Sicherheit noch einmal eingeben.',
  'publicChat.passwordsMatch': 'Passwörter stimmen überein',
  'publicChat.showPassword': 'Passwort anzeigen',
  'publicChat.hidePassword': 'Passwort verbergen',
  'publicChat.sectionPerson': 'Über dich',
  'publicChat.sectionPassword': 'Passwort',
  'publicChat.signupTrustLine': '14 Tage kostenlos testen · jederzeit kündbar',
  'publicChat.errorFirstName': 'Bitte gib deinen Vornamen ein.',
  'publicChat.errorLastName': 'Bitte gib deinen Nachnamen ein.',
  'publicChat.errorEmailRequired': 'Bitte gib deine E-Mail-Adresse ein.',
  'publicChat.errorEmailInvalid': 'Bitte gib eine gültige E-Mail-Adresse ein.',
  'publicChat.errorPasswordRequired': 'Bitte wähle ein Passwort.',
  'publicChat.errorPasswordShort': 'Das Passwort braucht mindestens {{count}} Zeichen.',
  'publicChat.errorPasswordLong': 'Das Passwort darf höchstens {{count}} Zeichen haben.',
  'publicChat.errorPasswordRepeatRequired': 'Bitte gib das Passwort noch einmal ein.',
  'publicChat.errorPasswordMismatch': 'Die Passwörter stimmen nicht überein.',
  'publicChat.errorTerms': 'Bitte stimme den AGB und der Datenschutzerklärung zu.',
  'publicChat.companyName': 'Firmenname (optional)',
  'publicChat.createAccount': 'Konto erstellen',
  'publicChat.alreadyHaveAccount': 'Bereits ein Konto?',
  'publicChat.loginInstead': 'Anmelden',
  'publicChat.termsNotice': 'Mit der Registrierung stimmst du unseren Nutzungsbedingungen und Datenschutzrichtlinien zu',
  'publicChat.loginTitle': 'Willkommen zurück',
  'publicChat.loginSubtitle': 'Melde dich an, um fortzufahren',
  'publicChat.loginButton': 'Anmelden',
  'publicChat.noAccount': 'Noch kein Konto?',
  'publicChat.signupInstead': 'Kostenlos registrieren',
  'publicChat.pricingTitle': 'Wähle deinen Plan',
  'publicChat.pricingSubtitle': '14 Tage kostenlos testen. Jederzeit kündbar.',
  'publicChat.featuresTitle': 'Was der SAIA für dich tun kann',
  'publicChat.safetyTitle': 'Dein Account ist geschützt',
  'publicChat.safetySubtitle': 'Branchenführende Sicherheitsmaßnahmen',
  'publicChat.safetyNote': 'Die meisten Nutzer haben nie Probleme. Wir priorisieren die Sicherheit deines Accounts über alles.',
  'publicChat.forgotPasswordLink': 'Passwort vergessen?',
  'publicChat.forgotPasswordTitle': 'Passwort zurücksetzen',
  'publicChat.forgotPasswordLead':
    'Gib die E-Mail ein, mit der du dich bei SAIA anmeldest. Wir senden dir einen Link für ein neues Passwort.',
  'publicChat.forgotPasswordButton': 'Link senden',
  'publicChat.forgotPasswordSuccessTitle': 'E-Mail prüfen',
  'publicChat.forgotPasswordSuccessBody':
    'Wir haben einen Link an {{email}} gesendet. Öffne ihn aus deinem Postfach — er ist 12 Stunden gültig.',
  'publicChat.forgotPasswordInvalidEmail': 'Bitte gib eine gültige E-Mail-Adresse ein.',
  'publicChat.forgotPasswordUserNotFound': 'Kein Konto mit dieser E-Mail gefunden.',
  'publicChat.backToLogin': 'Zurück zur Anmeldung',

  'pwaInstall.tooltip': 'App installieren',
  'pwaInstall.iosTitle': 'App zum Homescreen hinzufügen',
  'pwaInstall.iosSubtitle': 'Installiere SAIA als App auf deinem iPhone oder iPad – für schnelleren Zugriff ohne Browser.',
  'pwaInstall.iosStep1': 'Tippe auf das Teilen-Symbol (Quadrat mit Pfeil nach oben) in der Safari-Toolbar.',
  'pwaInstall.iosStep2': 'Scrolle nach unten und wähle „Zum Home-Bildschirm".',
  'pwaInstall.iosStep3': 'Bestätige mit „Hinzufügen" – fertig!',
  'pwaInstall.close': 'Verstanden',
  'pwaInstall.promptTitle': 'SAIA als App',
  'pwaInstall.promptText': 'Mit eigenem Symbol auf dem Startbildschirm, startet schneller und ohne Browserleiste.',
  'pwaInstall.promptInstall': 'Installieren',
  'pwaInstall.promptHowTo': 'So geht’s',
  'pwaInstall.promptLater': 'Später',
  'pwaInstall.inAppText': 'Im Instagram- oder Facebook-Browser lässt sich SAIA nicht installieren. Öffne die Seite in Safari bzw. Chrome: Menü (⋯) → „Im Browser öffnen“.',
  'pwaInstall.inAppCopy': 'Link kopieren',
  'pwaInstall.inAppCopied': 'Link kopiert',
  // ── Ergänzte Übersetzungen (Abgleich mit en.ts) ──
  switchTagSurvey: 'Umfrage(n) zwischen Tags wechseln',
  successEditNewRole: 'Die Rolle wurde erfolgreich bearbeitet!',
  errorEditNewRole: 'Es ist ein Fehler beim Bearbeiten der Rolle aufgetreten!',
  jobOfferResponsibilitiesPlaceholder: 'z.B.\n- Analysiere Daten aus unserem CRM, um Sales-Opportunities abzuleiten\n- Übersetze statistisches Wissen in leicht verständliche Präsentationen\n- etc.',
  jobOfferRequirementsInstruction: 'Liste hier die Anforderungen der Position auf:',
  jobOfferRequirementsPlaceholder: 'z.B.\n- Erfolgreich abgeschlossenes Studium in Data Science, Mathematik oder vergleichbaren Studienfächern\n- Neugier auf neue Erkenntnisse auf Basis eines strukturierten Vorgehens',
  jobOfferWhyYouInstruction: 'Schreibe hier, warum du die Persona für dich gewinnen möchtest:',
  generateUrlQuestion: 'Sollen wir für dich relevante Kandidaten und Kandidatinnen suchen?',
  removeAllContactsFromDuplicateList: 'alle Kontakte von der Liste entfernen',
  planningBase: 'Grundlegende Planung',
  planningStrategy: 'Strategie',
  planningGenerate: 'Content generieren',
  useSignatureInMessages: 'Signatur in Nachrichten verwenden',
  noNodesMessage_ActiveSourcing: 'Für diese Kampagne sind keine Knoten verfügbar.',
  declineMessageDescription: 'Wenn du diese Option auswählst, wird für diesen Kontakt eventuell eine neue Nachricht generiert. Du hast dann die Möglichkeit, die neue Nachricht zu genehmigen oder abzulehnen.',
  inMailsNote: '(nur für LinkedIn-Premium-Lizenzen verfügbar)',
  contactSearchResultButton: 'Kontakte suchen',
  smtpSection: 'SMTP (ausgehend)',
  imapSection: 'IMAP (eingehend)',
  fieldServer: 'Server',
  fieldPort: 'Port',
  fieldEncryption: 'Verschlüsselung',
  fieldUsername: 'Benutzername',
  fieldPassword: 'Passwort',
  fieldEmail: 'E-Mail-Adresse',
  fieldOauthCode: 'OAuth-Code',
  hintPasteOauth: 'Füge den Code ein, den du aus dem Autorisierungs-Popup erhalten hast',
  encryptionNone: 'Keine',
  encryptionSSL: 'SSL',
  encryptionTLS: 'TLS',
  encryptionSTARTTLS: 'STARTTLS',
  authorizeGmail: 'Gmail autorisieren',
  authorizeMicrosoft: 'Microsoft autorisieren',
  smtpServer: 'SMTP-Server',
  smtpUsername: 'SMTP-Benutzername',
  imapServer: 'IMAP-Server',
  imapUsername: 'IMAP-Benutzername',
  providerLabel_SMTP: 'SMTP / IMAP',
  providerLabel_GMAIL: 'Gmail',
  providerLabel_MS_O365: 'Microsoft 365',
  // ── AI-Chat-UI (Keys hatten bisher nur englische Inline-Fallbacks) ──
  confirmed: 'Bestätigt',
  compliance: 'Compliance',
  errors: 'Fehler',
  warnings: 'Warnungen',
  autoFix: 'Automatisch beheben',
  userAskSubmit: 'Auswahl senden',
  userAskAnswered: 'Beantwortet: {{answer}}',
  userAskFreeTextHint: 'Oder einfach unten eine eigene Antwort tippen.',
  importProgressRunning: 'Kontakt-Import läuft',
  importProgressDone: 'Kontakt-Import',
  importProgressNoSearches: 'Noch keine Suchen konfiguriert.',
  importProgressTotal: '{{count}} Kontakte importiert',
  importProgressJudging: 'AI-Bewertung läuft ({{done}} bewertet)',
  importProgressJudged: '{{done}} bewertet',
  paiAssistant: 'SAIA',
  closeChat: 'Chat schließen',
  openChat: 'Chat öffnen',
  scheduleTitle: 'Redaktionsplan',
  scheduleFreeNow: 'frei — sofort planbar',
  scheduleFreeFrom: 'voraussichtlich frei ab {{date}}',
  scheduleStateScheduled: 'ab {{date}}',
  scheduleStateRunning: 'läuft bis ~{{date}}',
  scheduleStateRunningOpen: 'läuft',
  scheduleStateFinished: 'beendet {{date}}',
  scheduleOpenContacts: '{{count}} offen',
  scheduleEmpty: 'Noch nichts geplant und nichts aktiv.',
  loadingConversation: 'Unterhaltung wird geladen...',
  errorOccurred: 'Ein Fehler ist aufgetreten',
  typeYourMessage: 'Schreibe deine Nachricht...',
  twoFaApproveInApp: 'Bestätige die Anmeldung in deiner LinkedIn-App',
  twoFaWaitingForPush: 'LinkedIn hat eine Benachrichtigung an deine LinkedIn-App gesendet{{forEmail}}. Öffne sie und tippe auf Bestätigen — die Anmeldung läuft dann von selbst weiter, kein Code nötig.',
  twoFaApprovalExpired: 'Die Bestätigung ist nicht rechtzeitig eingegangen, und LinkedIn bietet für diesen Account keinen Code an. Bitte mich, den Account erneut zu verbinden, und halte dein Handy bereit.',
  twoFaWaitingCountdown: 'Warte auf deine Bestätigung — noch {{seconds}}s',
  onlineReadyToHelp: 'Online • Bereit zu helfen',
  newChat: 'Neuer Chat',
  moreOptions: 'Weitere Optionen',
  exitFullscreen: 'Vollbild verlassen',
  fullscreen: 'Vollbild',
  minimize: 'Minimieren',
  newConversation: 'Neue Unterhaltung',
  clearHistory: 'Verlauf löschen',
  aiChatCheckConnection: 'Bitte prüfe deine Internetverbindung und versuche es erneut.',
  aiChatLoadError: 'Beim Laden des Chats ist ein Fehler aufgetreten. Bitte versuche es erneut.',
  aiChatRateLimited: 'Du sendest Nachrichten zu schnell. Bitte warte {{seconds}} Sekunden, bevor du es erneut versuchst.',
  credentialsSubmitFailed: 'Übermittlung fehlgeschlagen — bitte Eingaben prüfen und erneut versuchen.',
  credentialsSubmittedTitle: 'Zugangsdaten übermittelt',
  credentialsRequestTitle: 'LinkedIn-Zugangsdaten',
  credentialsRequestHint: 'Deine Zugangsdaten werden über ein sicheres Formular übermittelt und erscheinen nicht im Chatverlauf.',
  credentialsOpenForm: 'Zugangsdaten sicher eingeben',
  credentialsSubmittedHint: 'Der LinkedIn-Login läuft im Hintergrund — der Status erscheint hier im Chat.',
  credentialsDialogTitle: 'LinkedIn-Account verbinden',
  credentialsEmail: 'LinkedIn E-Mail',
  credentialsPassword: 'LinkedIn Passwort',
  credentialsCountry: 'Land (Proxy)',
  credentialsCity: 'Stadt (Proxy — wo du arbeitest)',
  credentialsProduct: 'LinkedIn-Produkt',
  credentialsSecurityNote: '🔒 Die Daten gehen direkt an den Login-Dienst und werden nicht im Chat gespeichert.',
  credentialsSubmit: 'Sicher übermitteln',
  welcomeToPAIAssistant: 'Willkommen bei SAIA',
  aiAssistantIntro: 'Ich helfe dir, LinkedIn-Kampagnen zu verwalten, Accounts hinzuzufügen und deine Kennzahlen zu verstehen. Was möchtest du heute tun?',
  profileStep1Title: 'Schritt 1: Richte deine Account-Daten ein',
  whatICanDo: 'Womit ich dir helfen kann',
  capability1: 'LinkedIn-Accounts hinzufügen und verwalten',
  capability2: 'Recruiting- und Sales-Kampagnen erstellen',
  capability3: 'Kampagnen-Statistiken ansehen und erklären',
  capability4: 'Probleme mit Accounts und Kampagnen beheben',
  capability5: 'Fragen zur Plattform beantworten',
  unknownAccount: 'Unbekannter Account',
  proxyLocation: 'Proxy',
  viewOnLinkedIn: 'Auf LinkedIn ansehen',
  noAccountData: 'Keine Account-Daten verfügbar',
  linkedInAccounts: 'LinkedIn-Accounts',
  noAccountsYet: 'Noch keine LinkedIn-Accounts hinzugefügt. Füge einen hinzu, um loszulegen!',
  noCampaignData: 'Keine Kampagnen-Daten verfügbar',
  recruiting: 'Recruiting',
  sales: 'Sales',
  unnamedCampaign: 'Unbenannte Kampagne',
  connectionRate: 'Verbindungsrate',
  replyRate: 'Antwortrate',
  askAnything: 'Frag mich alles...',
  aiDisclaimer: 'KI kann ungenaue Angaben machen. Prüfe wichtige Details.',
  yesterday: 'Gestern',
  daysAgo: 'vor {{days}} Tagen',
  expandSidebar: 'Seitenleiste ausklappen',
  noConversations: 'Noch keine Unterhaltungen',
  startNewChat: 'Starte einen neuen Chat, um loszulegen',
  copyToClipboard: 'Kopieren',
  regenerate: 'Antwort neu generieren',

  // Kampagnen-Übersicht (Karten-Layout)
  campaignCountLine: '{{shown}} von {{total}} Kampagnen · {{active}} aktiv',
  campaignCardMeta: '{{lead}} · erstellt {{date}}',
  campaignAcceptedReplied: 'Akzeptiert / geantwortet',
  searchCampaignPlaceholder: 'Kampagne suchen …',
  rememberAccounts: 'Accounts merken',
  workUnits: 'Work Units',
  newCampaignShort: 'Neue Kampagne',

  // Öffentliche Seiten (Registrierung, Passwort zurücksetzen, 404)
  authSignupSubheadline: 'Nur wenige Klicks bis zu deiner Outreach-Revolution.',
  authSignupFormTitle: 'Konto erstellen',
  authSignupFormSubtitle: 'Kostenlos starten, keine Zahlungsdaten nötig.',
  authMarketingStatBadge1: '2x',
  authMarketingStatText1: 'mehr Antworten',
  authMarketingStatBadge2: '3x',
  authMarketingStatText2: 'schneller Time-to-Hire',
  authMarketingStatBadge3: '100%',
  authMarketingStatText3: 'personalisierte Ansprache basierend auf Persönlichkeitsprofilen',
  authFieldEmailLabel: 'E-Mail-Adresse',
  authFieldEmailPlaceholder: 'name@unternehmen.de',
  authFieldCompanyPlaceholder: 'Muster GmbH',
  authFieldPasswordPlaceholder: 'Mindestens 6 Zeichen',
  authResetPasswordTitle: 'Passwort zurücksetzen',
  authResetPasswordIntro: 'Wir senden dir einen Link an die im Profil hinterlegte E-Mail-Adresse. Gib sie bitte hier ein.',
  pageNotFoundEyebrow: 'FEHLER 404',
  pageNotFoundHeadline: 'Diese Seite existiert nicht',
  pageNotFoundDescription: 'Möglicherweise wurde sie verschoben oder der Link ist veraltet.',
  pageNotFoundBack: 'Zurück',
  pageNotFoundHome: 'Zur Startseite',

  // Administration (Katalog + Monitoring-Dashboard)
  adminOverviewSubtitle: 'Nur für Rolle „Owner“',
  adminPurposePrompts: 'Systemprompts je Produkt und Funnel-Funktion pflegen',
  adminPurposeStatusMessages: 'Banner für alle Mandanten planen und veröffentlichen',
  adminPurposeMonitoring: 'Work Units, Tageslimits und Auslastung je Account',
  adminPurposeQueue: 'Hängende Einheiten prüfen, neu starten, entfernen',
  adminPurposeCampaignTimeline: 'Verlauf eines Kontakts in einer Kampagne nachvollziehen',
  adminPurposeLinkedinSession: 'Login-Fehler und Session-Abbrüche der letzten 24 Stunden',
  adminPurposeFeedbackTickets: 'Eingereichte Tickets lesen und beantworten',
  adminMonitoringUpdated: 'Aktualisiert {{time}} · alle {{seconds}} s',
  adminKpi_pending: 'Offen',
  adminKpi_processing: 'In Bearbeitung',
  adminKpi_failed: 'Fehlgeschlagen',
  adminKpi_finished: 'Abgeschlossen',
  adminKpi_interrupted: 'Unterbrochen',
  adminChartPendingByType: 'Offene Einheiten nach Typ',
  adminChartPendingByPriority: 'Offene Einheiten nach Priorität',
  adminChartWorktime: 'Innerhalb der Arbeitszeit',
  adminWorktimeIn: 'In Arbeitszeit',
  adminWorktimeOut: 'Außerhalb',
  adminWorktimeUnknown: 'Unbekannt',
  adminProcessingTitle: 'In Bearbeitung',
  adminProcessingCount: 'Live · {{units}} Einheiten',
  adminPendingTitle: 'Offen (Stichprobe)',
  adminPendingCount: '{{units}} Einheiten',
  adminColCampaign: 'Kampagne',
  adminColTenant: 'Mandant',
  adminColType: 'Typ',
  adminColPriority: 'Priorität',
  adminColStarted: 'Gestartet',
  adminColCreated: 'Erstellt',
  adminColInWorktime: 'In Arbeitszeit',
  adminActionRemove: 'Entfernen',
  adminConfirmRemovalTitle: 'Einheit entfernen',
  adminConfirmRemovalText: 'Soll diese Arbeitseinheit wirklich entfernt werden?',
  adminDailyLimitsTitle: 'Tageslimits',
  adminLimit_messages: 'Nachrichten',
  adminLimit_connections: 'Kontaktanfragen',
  adminLimit_emails: 'E-Mails',
  adminLimit_inmails: 'InMails',
  adminLimit_visits: 'Profilbesuche',
  adminNoData: 'Keine Daten',

  // Upgrade / Preise (Design 2b)
  chooseLicense: 'Lizenz wählen',
  chooseBundle: 'Bundle wählen',
  pricingVatNote: 'Alle Preise inkl. 19 % MwSt. Keine versteckten Kosten. Jederzeit kündbar.',
  billingMonthly: 'Monatlich',
  billingQuarterly: 'Quartalsweise −10%',
  billingYearly: 'Jährlich −20%',
  billedMonthly: 'Monatlich abgerechnet',
  billedQuarterly: 'Quartalsweise abgerechnet',
  billedYearly: 'Jährlich abgerechnet',
  perMonthPerLicense: '/ Monat / Lizenz',
  savedComparedToMonthly: '{{percent}} % gespart gegenüber monatlich',

  // Kontoverwaltung (Design 1b)
  myProfileSubtitle: 'Name, E-Mail-Adresse, Sprache und Passwort',
  myCompanySubtitle: 'Unternehmensdaten und Rechnungsanschrift',
  myClientsSubtitle: 'Mandanten verwalten und deren Nutzer betreuen',
  myUsersSubtitle: 'Nutzer einladen, Rollen vergeben und Lizenzen zuweisen',
  myLicensesSubtitle: 'Laufende Lizenzen, Zuweisungen und Abrechnung',
  adminPanelSubtitle: 'Alle Mandanten, Nutzer und Lizenzen der Plattform',
  personalData: 'Persönliche Daten',
  personalDataHint: 'Diese Angaben erscheinen in Kampagnen und Freigaben.',
  changePasswordHint: 'Mindestens 8 Zeichen. Nach dem Speichern bleibst du angemeldet.',

  // Text-Optimierung (Zwei-Zonen-Layout)
  lastSavedAt: 'Zuletzt gespeichert {{time}}',
  analysisUpToDate: 'Analyse aktuell',
  analysisNotRunYet: 'Noch nicht analysiert',
  analysisRunning: 'Analyse läuft …',
  applySuggestion: 'Übernehmen',
  suggestionIgnoreOnce: 'Einmal ignorieren',
  suggestionIgnoreAlways: 'Immer',

  // Kontoverwaltung – Blocktitel der Inhaltskarten
  companyDataTitle: 'Unternehmensdaten',
  companyDataHint: 'Diese Anschrift erscheint auf Rechnungen und in ausgehenden Dokumenten.',
  userListTitle: 'Nutzerübersicht',
  licenseListTitle: 'Lizenzübersicht',
  tenantListTitle: 'Mandantenübersicht',

  // App-Sync-Assistent (Konto verbinden)
  appSyncConnectLinkedinAccount: 'LinkedIn-Konto verbinden',
  appSyncLogoutHeader: 'LinkedIn-Konto abmelden',
  appSyncStepCounter: 'Schritt {{current}} von {{total}}',
  appSyncConnectedElsewhere: 'Dieses LinkedIn-Konto ist bereits in einem anderen Workspace verbunden. Wird es an zwei Stellen gleichzeitig genutzt, meldet LinkedIn die Sitzungen ab. Bitte trenne es dort oder wende dich an den Support.',
  appSyncProductLinkedin: 'LinkedIn Standard',
  appSyncProductLinkedinDescription: 'Vernetzen, Nachrichten, Postfach',
  appSyncProductRecruiter: 'Recruiter',
  appSyncProductRecruiterDescription: 'Talentsuche, InMail, Projekte',
  appSyncProductSalesNavigator: 'Sales Navigator',
  appSyncProductSalesNavigatorDescription: 'Lead-Suche, Listen, InMail',
  appSyncSelectProductTitle: 'Welches Konto richten wir ein?',
  appSyncSelectProductDescription:
    'Wir melden dich über die echte LinkedIn-App auf einem eigenen Gerät an. Das ist stabiler und braucht keine parallelen Browser-Sitzungen.',
  appSyncLicenseSeat: 'Lizenz-Sitz',
  appSyncSelectLicenseSeat: 'Sitz auswählen',
  appSyncFreeSeats: '{{seats}} freie Sitze',
  appSyncCredentialsTitle: 'Zugangsdaten von LinkedIn',
  appSyncCredentialsDescription: 'Wir speichern sie verschlüsselt und nutzen sie nur für die Anmeldung in der App.',
  appSyncCredentialsPhoneHint: 'Gleich brauchst du kurz dein Handy: LinkedIn schickt eine Bestätigung, die du einmalig freigeben musst.',
  appSyncCountry: 'Land',
  appSyncRegion: 'Region',
  appSyncRegionSelectCountryFirst: 'Wähle zuerst ein Land.',
  appSyncLocationTitle: 'Wo soll das Konto online sein?',
  appSyncLocationDescription:
    'Dein Konto bekommt eine eigene, feste IP-Adresse in dieser Region. Wähle sie dort, wo der Kontoinhaber normalerweise arbeitet — das hält die Anmeldung dauerhaft vertraut.',
  appSyncLocationHint:
    'Eine eigene, feste IP ist Voraussetzung für den App-Login — sie verhindert die täglichen 2FA-Abfragen, die bei wechselnden Adressen entstehen. Nur für dieses Konto, wird von uns beschafft.',
  appSyncStartLogin: 'Anmeldung starten',
  appSyncConnectTitle: 'Wir verbinden dein Konto',
  appSyncConnectDescription: 'Das läuft automatisch. Du musst nichts tun, bis wir dich um deinen Code bitten.',
  appSyncLogoutTitle: 'Wir melden dein Konto ab',
  appSyncConnectStageIp: 'Feste IP gesichert',
  appSyncConnectStageDevice: 'Gerät vorbereitet',
  appSyncConnectStageDeviceHint: 'LinkedIn-App startklar',
  appSyncConnectStageSignIn: 'Bei LinkedIn anmelden',
  appSyncConnectStageSignInHint: 'Wir öffnen die App und melden uns an…',
  appSyncConnectStageTwoFa: 'Bestätigung in zwei Schritten',
  appSyncConnectStageTwoFaHint: 'Wir fragen dich gleich nach dem Code',
  appSyncConnectStageContract: 'Vertrag wählen',
  appSyncConnectStageContractHint: 'Nur bei Recruiter / Sales Navigator',
  appSyncConnectStageDone: 'Fertig',
  appSyncTwoFaTitle: 'Kurz bestätigen, dass du es bist',
  appSyncTwoFaDescription:
    'Öffne deine Authenticator-App und gib den 6-stelligen Code ein. LinkedIn nutzt ihn, um dein Gerät dauerhaft zu vertrauen — danach musst du das nicht mehr tun.',
  appSyncTwoFaViaApp: 'Freigabe in der LinkedIn-App',
  appSyncTwoFaViaCode: 'Code aus deiner App',
  appSyncTwoFaSecondRoundHint: 'Danach folgt noch eine zweite Bestätigung für die {{productApp}}-App — dann bist du für beide fertig.',
  appSyncConfirm: 'Bestätigen',
  appSyncChooseContractTitle: 'Welchen Vertrag sollen wir nutzen?',
  appSyncChooseContractDescription: 'Dein Konto hat mehrere Verträge. Wähle den, mit dem wir arbeiten sollen.',
  appSyncApplyContract: 'Übernehmen',
  appSyncYourChoice: 'Kurz deine Auswahl',
  appSyncDoneTitle: 'Konto verbunden',
  appSyncDoneDescription: '{{name}} ist startklar. Ab jetzt läuft alles automatisch — kein erneutes Anmelden nötig.',
  appSyncDoneFactIp: 'Feste IP & Gerät zugewiesen',
  appSyncDoneFactTrust: 'Gerät vertraut — künftige Logins ohne 2FA',
  appSyncDoneFactProduct: '{{product}} aktiv',
  appSyncGoToAccounts: 'Zu meinen Konten',
  appSyncErrorWrongPasswordTitle: 'Das Passwort stimmt nicht',
  appSyncErrorWrongPasswordText:
    'LinkedIn hat die Anmeldung abgelehnt. Prüfe die Zugangsdaten und versuche es noch einmal — dein Konto ist nicht gesperrt.',
  appSyncErrorWrongPasswordFieldHint: 'Bitte gib das aktuelle LinkedIn-Passwort ein.',
  appSyncErrorSignInAgain: 'Erneut anmelden',
  appSyncErrorWrongPinTitle: 'Der Code wurde abgelehnt',
  appSyncErrorCaptchaTitle: 'Die Zeit ist abgelaufen',
  appSyncErrorLoginExpiredTitle: 'Die Anmeldung ist abgelaufen',
  appSyncErrorOnboardingTitle: 'Das LinkedIn-Onboarding ist nicht abgeschlossen',
  appSyncErrorTwoFaTitle: 'Zwei-Faktor-Bestätigung für {{liProductType}} aktivieren',
  appSyncErrorUnknownTitle: 'Wir kümmern uns darum',
  appSyncErrorUnknownText:
    'Bei der Anmeldung ist etwas Unerwartetes passiert. Der Fehler ist mit allen Details protokolliert — melde dich beim Support, dann sehen wir uns das an.',
  appSyncErrorUnknownRetryHint: 'Wir versuchen es in Kürze automatisch erneut.',
  appSyncErrorReference: 'Referenz',

  flowBuilderTitle: 'Ablauf erstellen',
  flowBuilderDone: 'Fertig',
  flowBuilderLoading: 'Ich schaue, was die Kampagne schon weiß …',
  flowBuilderQuestionOf: 'Frage {{n}} von {{total}}',
  flowBuilderGreeting: 'Ich baue den Ablauf für diese Kampagne. Das weiß ich schon:',
  flowBuilderIntro: '{{count}} Fragen, dann steht der Ablauf links im Canvas, mit allen Nachrichten.',
  flowBuilderKnownAccount_sales_navigator: 'Konto: Sales Navigator, InMail-Guthaben',
  flowBuilderKnownAccount_recruiter: 'Konto: Recruiter, InMail-Guthaben',
  flowBuilderKnownAccount_normal: 'Konto: LinkedIn ohne erkennbares Premium',
  flowBuilderKnownClients: 'Ihr rekrutiert als Dienstleister',
  flowBuilderKnownOwn: 'Ihr rekrutiert für das eigene Unternehmen',
  flowBuilderKnownOffer: 'Angebot aus dem Briefing',
  flowBuilderKnownLanguage: 'Sprache: {{lang}}',
  flowBuilderQAudience: 'Wen sprichst du in dieser Kampagne an?',
  flowBuilderAudience_new: 'Nur neue Kontakte',
  flowBuilderAudienceNewDesc: 'Kontaktanfrage zuerst, InMail als Fallback',
  flowBuilderAudience_existing: 'Nur bestehende Kontakte',
  flowBuilderAudienceExistingDesc: 'Direkt per Nachricht, keine InMails',
  flowBuilderAudience_both: 'Beides',
  flowBuilderAudienceBothDesc: 'Weiche pro Kontakt am Anfang',
  flowBuilderQRecruitsFor: 'Rekrutiert ihr für das eigene Unternehmen oder als Dienstleister?',
  flowBuilderRecruitsOwn: 'Eigenes Unternehmen',
  flowBuilderRecruitsClients: 'Als Dienstleister für Kunden',
  flowBuilderQInmailCredit: 'Hat dieses LinkedIn-Konto InMail-Guthaben (Premium)?',
  flowBuilderInmailYes: 'Ja, InMail-Guthaben vorhanden',
  flowBuilderInmailYesDesc: 'Eine InMail als Fallback, wenn die Anfrage nicht angenommen wird',
  flowBuilderInmailNo: 'Nein',
  flowBuilderInmailNoDesc: 'Nach dem Wartefenster wird die Anfrage zurückgezogen',
  flowBuilderQFormality: 'Du oder Sie?',
  flowBuilderCasual: 'Locker (Du)',
  flowBuilderCasualDesc: 'Vorname, wie unter Kollegen',
  flowBuilderFormal: 'Formell (Sie)',
  flowBuilderFormalDesc: 'Nachname, professionell-warm',
  flowBuilderQLanguage: 'Sprache der Nachrichten',
  flowBuilderLanguageHint: 'Aus der Kampagne vorbelegt. Ein Klick bestätigt.',
  flowBuilderLangKeep: 'Wie eingestellt: {{primary}}{{secondary}}',
  flowBuilderLangWithSecondary: ', {{secondary}} als Zweitsprache',
  flowBuilderLangPrimaryOnly: 'Nur {{primary}}',
  flowBuilderLangAuto: 'Sprache des Profils erkennen',
  flowBuilderLangDe: 'Deutsch',
  flowBuilderLangEn: 'Englisch',
  flowBuilderLangAutoShort: 'Automatisch',
  flowBuilderAnsweredKeep: 'Passt so',
  flowBuilderQReferral: 'Am Ende nach einer Empfehlung fragen, falls kein Eigeninteresse?',
  flowBuilderReferralYes: 'Ja, mit Prämie',
  flowBuilderReferralYesDesc: 'Nenn die Höhe, sie steht dann in der Nachricht.',
  flowBuilderReferralNo: 'Nein',
  flowBuilderReferralNoDesc: 'Der Ablauf endet mit der Breakup-Nachricht.',
  flowBuilderReferralBonusLabel: 'Prämie, z. B. 500 €',
  flowBuilderReferralAnswered: 'Ja, Prämie {{bonus}}',
  flowBuilderApply: 'Übernehmen',
  flowBuilderGenerating: 'Ich baue den Ablauf …',
  flowBuilderGenerated: 'Der Ablauf steht links im Canvas: {{steps}} Schritte, {{messages}} Nachrichten{{inmails}}.',
  flowBuilderGeneratedInmails: ', davon {{count}} InMails',
  flowBuilderLastQuestion: 'Letzte Frage, zu dem, was nach einer Antwort passiert.',
  flowBuilderAutoReplyYes: 'Ja, mit diesem Vorschlag',
  flowBuilderAutoReplyNo: 'Nein, ich antworte selbst',
  flowBuilderAutoReplyOff: 'Ohne automatische Antworten',
  flowBuilderCasesHint: 'Abwählen, was nicht passt. Bearbeiten geht später im Block „Einstellungen für automatische Antworten“.',
  flowBuilderFreeTextHint: 'Per Klick antworten. Alles lässt sich danach noch ändern.',
  flowBuilderDoneText: 'Alles gesetzt. Ändere, was du willst, per Klick auf eine Nachricht in der Liste oder auf einen Knoten links.',
  flowBuilderAutoReplyRow: 'Automatische Antworten: {{state}} · {{count}} Fälle',
  flowBuilderOn: 'an',
  flowBuilderOff: 'aus',
  flowBuilderEdit: 'bearbeiten',
  flowBuilderRegenerate: 'Neu erzeugen',
  flowBuilderWithoutBuilder: 'Ohne Builder: Vorlage wählen oder leer starten',
  flowBuilderChipInmails: '{{count}} InMail-Touchpoints',
  flowBuilderChipReferral: 'Empfehlung {{bonus}}',
  flowBuilderChipClients: 'im Auftrag eines Kunden',
  flowBuilderChipOwn: 'eigenes Unternehmen',
  flowBuilderWarning_referral_ignored_for_sales: 'Die Empfehlungs-Frage gibt es nur bei Recruiting und wurde übersprungen.',
  flowBuilderBlockedNotDraft: 'Die Kampagne läuft bereits. Der Builder ändert nur Entwürfe.',
  flowBuilderBlockedBriefing: 'Im Briefing fehlt noch: {{fields}}. Trag es in Schritt 1 ein, dann geht es hier weiter.',
  flowBuilderBlockedAccount: 'Der Kampagne fehlt ein LinkedIn-Konto. Wähle es in den Kampagnen-Einstellungen.',
  flowBuilderContextError: 'Der Builder konnte die Kampagne nicht laden.',
  flowBuilderRetry: 'Erneut versuchen',
  flowBuilderErrorGeneric: 'Das hat nicht geklappt: {{message}}',
  flowBuilderError_flow_builder_campaign_not_draft: 'Die Kampagne läuft bereits. Der Builder ändert nur Entwürfe.',
  flowBuilderError_flow_builder_account_missing: 'Der Kampagne fehlt ein LinkedIn-Konto.',
  flowBuilderError_flow_builder_briefing_incomplete: 'Das Briefing ist unvollständig. Bitte Schritt 1 ergänzen.',
  flowBuilderError_flow_builder_inmail_credit_unknown: 'Bitte beantworte, ob das Konto InMail-Guthaben hat.',
  flowBuilderError_flow_builder_recruits_for_unknown: 'Bitte beantworte, ob ihr für das eigene Unternehmen oder als Dienstleister rekrutiert.',
  flowBuilderError_flow_builder_referral_bonus_missing: 'Für die Empfehlungs-Frage fehlt die Prämie.',
  flowBuilderError_flow_builder_auto_reply_incomplete: 'Für automatische Antworten fehlen Ziel oder Fälle.',
  flowBuilderError_flow_builder_generator_failed: 'Der Ablauf konnte nicht erzeugt werden. Bitte noch einmal versuchen.',
  storeTemplateOwn: 'Eigene Vorlage',
  storeTemplateSteps: '{{count}} Schritte',
  storeTemplatesHint: 'Vorlagen aus dem Store. Der Ablauf-Builder in Schritt 3 stellt die passenden Fragen, hier wählst du eine fertige Vorlage von Hand.',
  storeTemplatesEmpty: 'Noch keine Vorlagen im Store.',
  storeBlocksTitle: 'Bausteine des Ablauf-Builders',
  storeBlocksIntro: 'Aus diesen Texten baut der Builder jeden Prompt. Änderungen gelten sofort für neue Abläufe deines Mandanten.',
  storeBlocksVariablesHint: '{{@name}} = Baustein-Variable (wird beim Zusammensetzen ersetzt), {{name}} = Platzhalter zur Laufzeit (Profil, Angebot).',
  storeBlocksSourceTenant: 'Eigene Fassung',
  storeBlocksSourceSystem: 'Standard',
  storeBlocksSystemVersion: 'Standardtext',
  storeBlocksSave: 'Für meinen Mandanten speichern',
  storeBlocksSaveSystem: 'Als Standard für alle speichern',
  storeBlocksReset: 'Standard wiederherstellen',
  storeBlocksSaved: 'Baustein gespeichert.',
  storeBlocksResetDone: 'Standard wiederhergestellt.',
  storeBlocksSaveFailed: 'Der Baustein konnte nicht gespeichert werden.',
  storeBlocksResetFailed: 'Der Standard konnte nicht wiederhergestellt werden.',
  storeBlocksRejected: 'Nicht gespeichert: {{message}}',
  storeBlocksPlaceholdersFound: 'Platzhalter im Text:',
  storeBlocksLoadFailed: 'Die Bausteine konnten nicht geladen werden.',
  kiSearchEyebrow: 'KI-Suche',
  kiSearchHeadline_ActiveSourcing: 'Wo sollen wir Kandidaten für dich suchen?',
  kiSearchHeadline_LeadBooster: 'Wo sollen wir Leads für dich suchen?',
  kiSearchIntro_ActiveSourcing: 'Mehr brauchen wir nicht. Die Position kennt die KI schon aus deinem Briefing, alles andere übernimmt sie.',
  kiSearchIntro_LeadBooster: 'Mehr brauchen wir nicht. Aus deinem Angebot im Briefing erkennt die KI, wer es kauft, und sucht diese Ansprechpartner.',
  kiSearchLocationLabel: 'Suchort',
  kiSearchStart_ActiveSourcing: 'Kandidaten automatisch finden',
  kiSearchStart_LeadBooster: 'Leads automatisch finden',
  kiSearchLocationMissing: 'Gib zuerst einen Suchort ein.',
  kiSearchSearchesWith: 'Sucht mit',
  kiSearchChangeSettings: 'Ändern',
  kiSearchHideSettings: 'Fertig',
  kiSearchLanguages: 'Sprache',
  kiSearchAfterTitle: 'Danach läuft alles von selbst',
  kiSearchAfter1_ActiveSourcing: 'Die KI liest Jobtitel und Stellenanzeige aus deinem Briefing',
  kiSearchAfter1_LeadBooster: 'Die KI liest dein Angebot und leitet ab, welche Positionen und Branchen es kaufen',
  kiSearchAfter2_ActiveSourcing: 'Sie baut mehrere LinkedIn-Suchen und prüft, wie viele Treffer jede bringt',
  kiSearchAfter2_LeadBooster: 'Sie baut mehrere LinkedIn-Suchen und prüft, wie viele Treffer jede bringt',
  kiSearchAfter3_ActiveSourcing: 'Die besten Suchen werden gespeichert und die Kandidaten landen in deiner Liste',
  kiSearchAfter3_LeadBooster: 'Die besten Suchen werden gespeichert und die Leads landen in deiner Liste',
  kiSearchAfter4_ActiveSourcing: 'Jeder Kandidat wird nach deinen Kriterien bewertet',
  kiSearchAfter4_LeadBooster: 'Jeder Lead wird nach deinen Kriterien bewertet',
  kiSearchBriefingMissing_ActiveSourcing: 'Für die KI-Suche braucht dein Briefing einen Jobtitel oder eine Stellenanzeige.',
  kiSearchBriefingMissing_LeadBooster: 'Für die KI-Suche braucht dein Briefing eine Beschreibung deines Angebots (Probleme, Funktionen, Nutzen oder Wirkung).',
  expertMethodsToggle_ActiveSourcing: 'Kandidaten lieber selbst hinzufügen',
  expertMethodsToggle_LeadBooster: 'Leads lieber selbst hinzufügen',
  expertMethodsIntro: 'Für alle, die ihre Zielgruppe schon genau kennen. Was du hier hinzufügst, landet in derselben Liste.',
  expertOwnSearchDescription: 'Du hast schon eine Suche in LinkedIn, Recruiter oder Sales Navigator gebaut? Link einfügen, wir übernehmen die Treffer.',
  expertUploadDescription: 'CSV oder Excel mit LinkedIn-Profil-URLs, zum Beispiel aus deinem ATS oder CRM.',
  expertFromCampaignDescription: 'Kontakte wiederverwenden, die du schon in einer früheren Kampagne hattest.',
  expertMethodSelect: 'Auswählen',
  expertMethodSelected: 'Ausgewählt',
  backToKiSearch: 'Zurück zur KI-Suche',
  titlesIndustriesSocialSelling: 'Ergebnisse basierend auf Positionen und Branchen',
  // Wizard „Neue Kampagne“ (Recruiting): Texte liegen unter features/co-pilot/campaign-wizard/locales
  ...wizardDE,
  // Mit Google anmelden
  googleSignUp: 'Mit Google registrieren',
  googleSignIn: 'Mit Google anmelden',
  googleSignInNeedsTerms: 'Bitte bestätige zuerst die AGB und die Datenschutzerklärung, dann geht es mit Google weiter.',
  googleSignInNoAccount: 'Für diese Google-Adresse gibt es noch kein Konto. Bestätige unten die AGB und registriere dich mit Google.',
  googleSignInProgress: 'Anmeldung mit Google …',
  googleSignInFailed: 'Die Anmeldung mit Google hat nicht geklappt. Bitte versuche es noch einmal.',
  googleSignInCancelled: 'Die Anmeldung mit Google wurde abgebrochen.',
  googleSignInOtherAccount: 'Diese E-Mail-Adresse ist bereits mit einem anderen Google-Konto verbunden. Melde dich mit E-Mail und Passwort an.',
  googleSignInBack: 'Zurück',
  // Engagement Center: Texte liegen unter features/engagement/locales
  ...engagementDE,
  // Einstiegsseite (/welcome): Texte unter features/public-chat/locales
  ...publicChatDE,
  // Feedback-Dialog: Texte unter features/feedback/locales
  ...feedbackDE,
};
export default localeDE;
